export const openings: { name: string; fen: string }[] = [
  {
    name: "Amar Gambit",
    fen: "rn1qkbnr/ppp2ppp/8/3p4/5p2/6PB/PPPPP2P/RNBQK2R",
  },
  {
    name: "Amar Opening",
    fen: "rnbqkbnr/pppppppp/8/8/8/7N/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Amar Opening: Gent Gambit",
    fen: "rn1qkbnr/ppp2ppp/8/3p4/8/6PB/PPPPP3/RNBQ1RK1",
  },
  {
    name: "Amar Opening: Paris Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/5P2/6PN/PPPPP2P/RNBQKB1R",
  },
  {
    name: "Amsterdam Attack",
    fen: "r1bqkb1r/ppp2ppp/2np1n2/4p3/2P5/1PN1P3/P2P1PPP/R1BQKBNR",
  },
  {
    name: "Anderssen's Opening",
    fen: "rnbqkbnr/pppppppp/8/8/8/P7/1PPPPPPP/RNBQKBNR",
  },
  {
    name: "Anderssen's Opening: Polish Gambit",
    fen: "rnbqkbnr/1ppppppp/8/p7/1P6/P7/2PPPPPP/RNBQKBNR",
  },
  {
    name: "Barnes Opening",
    fen: "rnbqkbnr/pppppppp/8/8/8/5P2/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Barnes Opening: Fool's Mate",
    fen: "rnb1kbnr/pppp1ppp/8/4p3/6Pq/5P2/PPPPP2P/RNBQKBNR",
  },
  {
    name: "Barnes Opening: Gedult Gambit",
    fen: "rnbqkbnr/ppp1pp1p/6p1/8/3Pp3/2P2P2/PP4PP/RNBQKBNR",
  },
  {
    name: "Barnes Opening: Gedult Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/8/4p3/2N2P2/PPPP2PP/R1BQKBNR",
  },
  {
    name: "Barnes Opening: Hammerschlag",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/8/5P2/PPPPPKPP/RNBQ1BNR",
  },
  {
    name: "Clemenz Opening",
    fen: "rnbqkbnr/pppppppp/8/8/8/7P/PPPPPPP1/RNBQKBNR",
  },
  {
    name: "Clemenz Opening: Spike Lee Gambit",
    fen: "rnbqkbnr/ppppppp1/8/7p/6P1/7P/PPPPPP2/RNBQKBNR",
  },
  {
    name: "Crab Opening",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/P6P/8/1PPPPPP1/RNBQKBNR",
  },
  {
    name: "Creepy Crawly Formation: Classical Defense",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/8/P6P/1PPPPPP1/RNBQKBNR",
  },
  {
    name: "Formation: Hippopotamus Attack",
    fen: "r1bq1rk1/ppp2ppp/2nb1n2/3pp3/8/PPPPPPP1/7P/RNBQKBNR",
  },
  {
    name: "Formation: Shy Attack",
    fen: "r1bq1rk1/ppp2ppp/2nb1n2/3pp3/8/P2PP1PP/1PPN1PB1/R1BQK1NR",
  },
  {
    name: "Global Opening",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/8/P6P/1PPPPPP1/RNBQKBNR",
  },
  {
    name: "Grob Opening",
    fen: "rnbqkbnr/pppppppp/8/8/6P1/8/PPPPPP1P/RNBQKBNR",
  },
  {
    name: "Grob Opening: Alessi Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/6P1/8/PPPPPP1P/RNBQKBNR",
  },
  {
    name: "Grob Opening: Double Grob",
    fen: "rnbqkbnr/pppppp1p/8/6p1/6P1/8/PPPPPP1P/RNBQKBNR",
  },
  {
    name: "Grob Opening: Double Grob, Coca-Cola Gambit",
    fen: "rnbqkbnr/pppppp1p/8/6p1/5PP1/8/PPPPP2P/RNBQKBNR",
  },
  {
    name: "Grob Opening: Grob Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/6P1/8/PPPPPPBP/RNBQK1NR",
  },
  {
    name: "Grob Opening: Grob Gambit Declined",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/6P1/8/PPPPPPBP/RNBQK1NR",
  },
  {
    name: "Grob Opening: Grob Gambit, Basman Gambit",
    fen: "rnbqkbnr/ppp1ppp1/8/3p3P/8/8/PPPPPPBP/RNBQK1NR",
  },
  {
    name: "Grob Opening: Grob Gambit, Fritz Gambit",
    fen: "rn1qkbnr/ppp1pppp/8/3p4/2P3b1/8/PP1PPPBP/RNBQK1NR",
  },
  {
    name: "Grob Opening: Grob Gambit, Fritz Gambit, Romford Countergambit",
    fen: "q3kbnr/p1pnpppp/8/8/2Pp2b1/8/PP1PPP1P/RNBQK1NR",
  },
  {
    name: "Grob Opening: Grob Gambit, Keres Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3p4/3p2P1/2P5/PP2PPBP/RNBQK1NR",
  },
  {
    name: "Grob Opening: Grob Gambit, Richter-Grob Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/8/2p3P1/1P6/P2PPPBP/RNBQK1NR",
  },
  {
    name: "Grob Opening: Keene Defense",
    fen: "rnbqkbnr/pp3ppp/2p5/3pp3/6P1/7P/PPPPPPB1/RNBQK1NR",
  },
  {
    name: "Grob Opening: Keene Defense, Main Line",
    fen: "rnbqk2r/pp2nppp/2pb4/3p4/2PPp1P1/2N4P/PP2PPB1/R1BQK1NR",
  },
  {
    name: "Grob Opening: London Defense",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/6P1/7P/PPPPPP2/RNBQKBNR",
  },
  {
    name: "Grob Opening: Romford Countergambit",
    fen: "rn1qkbnr/ppp1pppp/8/8/2Pp2b1/8/PP1PPPBP/RNBQK1NR",
  },
  {
    name: "Grob Opening: Spike Attack",
    fen: "rnbqkbnr/pp2pppp/2p5/3p2P1/8/8/PPPPPPBP/RNBQK1NR",
  },
  {
    name: "Grob Opening: Spike, Hurst Attack",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/2P3P1/8/PP1PPPBP/RNBQK1NR",
  },
  {
    name: "Grob Opening: Zilbermints Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/8/4p1P1/2N5/PPPP1P1P/R1BQKBNR",
  },
  {
    name: "Grob Opening: Zilbermints Gambit, Schiller Defense",
    fen: "rnbqkbnr/ppp1ppp1/8/7p/4p1P1/2N5/PPPP1P1P/R1BQKBNR",
  },
  {
    name: "Grob Opening: Zilbermints Gambit, Zilbermints-Hartlaub Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/4p1P1/2NP4/PPP2P1P/R1BQKBNR",
  },
  {
    name: "Hungarian Opening",
    fen: "rnbqkbnr/pppppppp/8/8/8/6P1/PPPPPP1P/RNBQKBNR",
  },
  {
    name: "Hungarian Opening: Asten Gambit",
    fen: "r1bqkbnr/ppp3pp/2n5/4Pp2/3pN3/6P1/PPP1PP1P/R1BQKBNR",
  },
  {
    name: "Hungarian Opening: Burk Gambit",
    fen: "rnbqk1nr/ppp1bppp/8/3p4/4p2N/P2P2P1/1PP1PP1P/RNBQKB1R",
  },
  {
    name: "Hungarian Opening: Bücker Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/1P6/6P1/P1PPPPBP/RNBQK1NR",
  },
  {
    name: "Hungarian Opening: Catalan Formation",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/8/6P1/PPPPPPBP/RNBQK1NR",
  },
  {
    name: "Hungarian Opening: Dutch Defense",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/8/6P1/PPPPPP1P/RNBQKBNR",
  },
  {
    name: "Hungarian Opening: Indian Defense",
    fen: "rnbqkb1r/pppppppp/5n2/8/8/6P1/PPPPPP1P/RNBQKBNR",
  },
  {
    name: "Hungarian Opening: Myers Defense",
    fen: "rnbqkbnr/pppppp1p/8/6p1/8/6P1/PPPPPP1P/RNBQKBNR",
  },
  {
    name: "Hungarian Opening: Pachman Gambit",
    fen: "rnbqkbnr/ppppp2p/6p1/7Q/4p3/6P1/PPPP1P1P/RNB1KBNR",
  },
  {
    name: "Hungarian Opening: Paris Gambit",
    fen: "rn1qkbnr/ppp2ppp/8/3p4/5p2/6PB/PPPPP2P/RNBQ1RK1",
  },
  {
    name: "Hungarian Opening: Reversed Alekhine",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/8/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "Hungarian Opening: Reversed Brooklyn Defense, Brooklyn Benko Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/8/1P2p3/6P1/P1PPPP1P/RNBQKBNR",
  },
  {
    name: "Hungarian Opening: Reversed Modern Defense",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/8/6P1/PPPPPPBP/RNBQK1NR",
  },
  {
    name: "Hungarian Opening: Reversed Norwegian Defense",
    fen: "rnbqkbnr/pppp1ppp/8/8/4p2N/6P1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "Hungarian Opening: Sicilian Invitation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/8/6P1/PPPPPP1P/RNBQKBNR",
  },
  {
    name: "Hungarian Opening: Slav Formation",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/8/6P1/PPPPPPBP/RNBQK1NR",
  },
  {
    name: "Hungarian Opening: Symmetrical Variation",
    fen: "rnbqkbnr/pppppp1p/6p1/8/8/6P1/PPPPPP1P/RNBQKBNR",
  },
  {
    name: "Hungarian Opening: Van Kuijk Gambit",
    fen: "rnbqkbnr/ppppppp1/8/8/7p/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "Hungarian Opening: Winterberg Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/2p5/1P4P1/P2PPPBP/RNBQK1NR",
  },
  {
    name: "Kádas Opening",
    fen: "rnbqkbnr/pppppppp/8/8/7P/8/PPPPPPP1/RNBQKBNR",
  },
  {
    name: "Kádas Opening: Beginner's Trap",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/7P/7R/PPPPPPP1/RNBQKBN1",
  },
  {
    name: "Kádas Opening: Kádas Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/1P5P/8/P1PPPPP1/RNBQKBNR",
  },
  {
    name: "Kádas Opening: Kádas Gambit",
    fen: "rnbqkbnr/pp2pppp/8/3p4/3p3P/2P2N2/PP2PPP1/RNBQKB1R",
  },
  {
    name: "Kádas Opening: Kádas Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/3p3P/2P5/PP2PPP1/RNBQKBNR",
  },
  {
    name: "Kádas Opening: Myers Variation",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/3PP2P/8/PPP2PP1/RNBQKBNR",
  },
  {
    name: "Kádas Opening: Schneider Gambit",
    fen: "rnbqkbnr/pppppp1p/8/6p1/7P/8/PPPPPPP1/RNBQKBNR",
  },
  {
    name: "Kádas Opening: Steinbok Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/8/4p2P/3P4/PPP2PP1/RNBQKBNR",
  },
  {
    name: "Lasker Simul Special",
    fen: "rnbqkbnr/ppppppp1/8/7p/8/6P1/PPPPPP1P/RNBQKBNR",
  },
  {
    name: "Mieses Opening",
    fen: "rnbqkbnr/pppppppp/8/8/8/3P4/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Mieses Opening: Myers Spike Attack",
    fen: "rnbqkbnr/pppppp1p/6p1/8/6P1/3P4/PPP1PP1P/RNBQKBNR",
  },
  {
    name: "Mieses Opening: Reversed Rat",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/8/3P4/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Polish Opening",
    fen: "rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Polish Opening: Baltic Defense",
    fen: "rn1qkbnr/ppp1pppp/8/3p1b2/1P6/8/PBPPPPPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: Birmingham Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/1P6/8/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Polish Opening: Bugayev Advance Variation",
    fen: "rnbqkbnr/pppp2pp/5p2/1P2p3/8/8/PBPPPPPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: Bugayev Attack",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/1P6/P7/2PPPPPP/RNBQKBNR",
  },
  {
    name: "Polish Opening: Czech Defense",
    fen: "rnbqkbnr/ppp2ppp/3p4/4p3/1P6/8/PBPPPPPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: Dutch Defense",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/1P6/8/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Polish Opening: German Defense",
    fen: "rnb1kbnr/ppp1pppp/3q4/3p4/1P6/8/PBPPPPPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: Grigorian Variation",
    fen: "r1bqkbnr/pppppppp/2n5/8/1P6/8/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Polish Opening: Karniewski Variation",
    fen: "rnbqkb1r/pppppppp/7n/8/1P6/8/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Polish Opening: King's Indian Variation",
    fen: "rnbqkb1r/pppppp1p/5np1/8/1P6/8/PBPPPPPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: King's Indian Variation, Schiffler Attack",
    fen: "rnbqkb1r/pppppp1p/5np1/8/1P2P3/8/PBPP1PPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: King's Indian Variation, Sokolsky Attack",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/1PPP4/4PN2/PB3PPP/RN1QKB1R",
  },
  {
    name: "Polish Opening: Myers Variation",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/PP6/8/1BPPPPPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: Outflank Variation",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/1P6/8/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Polish Opening: Queen's Indian Variation",
    fen: "rnbqkb1r/p1pp1ppp/1p2pn2/1P6/8/8/PBPPPPPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: Queenside Defense",
    fen: "rnbqkb1r/1ppp1ppp/p3pn2/1P6/8/8/PBPPPPPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: Rooks Swap Line",
    fen: "1nbqkb1r/1ppp1ppp/4pn2/1P6/8/8/2PPPPPP/BN1QKBNR",
  },
  {
    name: "Polish Opening: Schiffler-Sokolsky Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/1P1p4/8/4P3/PBPP1PPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: Schuehler Gambit",
    fen: "rnbqkbnr/1p1ppppp/8/pp6/4P3/8/PBPP1PPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: Symmetrical Variation",
    fen: "rnbqkbnr/p1pppppp/8/1p6/1P6/8/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Polish Opening: Tartakower Gambit",
    fen: "rnbqkbnr/pppp2pp/5p2/4p3/1P2P3/8/PBPP1PPP/RN1QKBNR",
  },
  {
    name: "Polish Opening: Wolferts Gambit",
    fen: "rnbqkbnr/pp1p1ppp/8/2p1p3/1P6/8/PBPPPPPP/RN1QKBNR",
  },
  {
    name: "Saragossa Opening",
    fen: "rnbqkbnr/pppppppp/8/8/8/2P5/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "Sodium Attack",
    fen: "rnbqkbnr/pppppppp/8/8/8/N7/PPPPPPPP/R1BQKBNR",
  },
  {
    name: "Sodium Attack: Chenoboskion Variation",
    fen: "rnbqkbnr/pppppp1p/6p1/8/6P1/N7/PPPPPP1P/R1BQKBNR",
  },
  {
    name: "Sodium Attack: Durkin Gambit",
    fen: "r1bqkbnr/pppp2pp/2n5/4pp2/2N1P3/8/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Valencia Opening",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/8/3P4/PPPNPPPP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening",
    fen: "rnbqkbnr/pppppppp/8/8/8/2N5/PPPPPPPP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Battambang Variation",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/8/P1N5/1PPPPPPP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Billockus-Johansen Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/8/2N2N2/PPPPPPPP/R1BQKB1R",
  },
  {
    name: "Van Geet Opening: Caro-Kann Variation, St. Patrick's Attack",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/4P3/2N4P/PPPP1PP1/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Damhaug Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/5P2/2N5/PPPPP1PP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Dougherty Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/8/4p3/2N2P2/PPPP2PP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Dunst-Perrenet Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/8/4p3/2NP4/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Düsseldorf Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/1P6/2N5/P1PPPPPP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Gladbacher Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/4p3/1PNP4/P1P2PPP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Hector Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/8/2B1p3/2N5/PPPP1PPP/R1BQK1NR",
  },
  {
    name: "Van Geet Opening: Hergert Gambit",
    fen: "r1bqkbnr/ppp2ppp/2np4/4P3/8/2N5/PPPPP1PP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Hulsemann Gambit",
    fen: "rn1qkbnr/ppp2ppp/4b3/3pp2Q/8/2N1P3/PPPP1PPP/R1B1KBNR",
  },
  {
    name: "Van Geet Opening: Jendrossek Gambit",
    fen: "rnbqkb1r/pp2p1pp/5n2/2p2p2/1P1p1P2/5N2/P1PPPNPP/R1BQKB1R",
  },
  {
    name: "Van Geet Opening: Kluever Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/8/4p3/2NP4/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Laroche Gambit",
    fen: "rnbqkbnr/p1pppppp/8/1p6/8/2N5/PPPPPPPP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Liebig Gambit",
    fen: "rnbqkb1r/ppp2ppp/5n2/3pp2Q/8/2N1P3/PPPP1PPP/R1B1KBNR",
  },
  {
    name: "Van Geet Opening: Melleby Gambit",
    fen: "rnbqkbnr/pp2pppp/8/2p5/3pNP2/8/PPPPP1PP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Myers Attack",
    fen: "rnbqkbnr/pppppp1p/6p1/8/7P/2N5/PPPPPPP1/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Napoleon Attack",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/3P4/2N2N2/PPP1PPPP/R1BQKB1R",
  },
  {
    name: "Van Geet Opening: Novosibirsk Variation",
    fen: "r1bqkbnr/pp1ppppp/2n5/8/7Q/2N5/PPP1PPPP/R1B1KBNR",
  },
  {
    name: "Van Geet Opening: Nowokunski Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/2N5/PPPP2PP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Pfeiffer Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/3pNP2/8/PPPPP1PP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Pfeiffer Gambit, Sleipnir Countergambit",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/3pNP2/5N2/PPPPP1PP/R1BQKB1R",
  },
  {
    name: "Van Geet Opening: Reversed Nimzowitsch",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/8/2N5/PPPPPPPP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Reversed Scandinavian",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/Q7/2N5/PPP1PPPP/R1B1KBNR",
  },
  {
    name: "Van Geet Opening: Sicilian Two Knights",
    fen: "r1bqkbnr/pp1ppppp/2n5/8/3N4/2N5/PPP1PPPP/R1BQKB1R",
  },
  {
    name: "Van Geet Opening: Sleipnir Gambit",
    fen: "rnbqk1nr/ppp2ppp/8/3pp3/1b1P4/2N1P3/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Twyble Attack",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/8/2N5/PPPPPPPP/1RBQKBNR",
  },
  {
    name: "Van Geet Opening: Tübingen Gambit",
    fen: "rnbqkb1r/pppppppp/5n2/8/6P1/2N5/PPPPPP1P/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Venezolana Variation",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/8/2NP2P1/PPP1PP1P/R1BQKBNR",
  },
  {
    name: "Van Geet Opening: Warsteiner Gambit",
    fen: "rnbqkbnr/ppp1pp1p/8/3p2p1/5P2/2N5/PPPPP1PP/R1BQKBNR",
  },
  {
    name: "Van't Kruijs Opening",
    fen: "rnbqkbnr/pppppppp/8/8/8/4P3/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Van't Kruijs Opening: Bouncing Bishop Variation",
    fen: "rnbqkbnr/p1pp1ppp/8/1p2p3/8/1B2P3/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Van't Kruijs Opening: Keoni-Hiva Gambit, Akahi Variation",
    fen: "rnbqkb1r/pppp1ppp/5n2/8/5p2/2N1PN2/PPPP2PP/R1BQKB1R",
  },
  {
    name: "Van't Kruijs Opening: Keoni-Hiva Gambit, Alua Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/5p2/2N1PN2/PPPP2PP/R1BQKB1R",
  },
  {
    name: "Van't Kruijs Opening: Keoni-Hiva Gambit, Ekolu Variation",
    fen: "rnbqkbnr/ppp2ppp/8/3p4/5p2/2N1PN2/PPPP2PP/R1BQKB1R",
  },
  {
    name: "Venezolana Opening",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/8/2NP2P1/PPP1PP1P/R1BQKBNR",
  },
  {
    name: "Ware Opening",
    fen: "rnbqkbnr/pppppppp/8/8/P7/8/1PPPPPPP/RNBQKBNR",
  },
  {
    name: "Ware Opening: Meadow Hay Trap",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/P7/R7/1PPPPPPP/1NBQKBNR",
  },
  {
    name: "Ware Opening: Ware Gambit",
    fen: "rnbqkbnr/ppp3pp/P7/3ppp2/8/4P3/1PPP1PPP/RNBQKBNR",
  },
  {
    name: "Ware Opening: Wing Gambit",
    fen: "rn1qkbnr/pbpppppp/8/1P6/8/8/1PPPPPPP/RNBQKBNR",
  },
  {
    name: "Nimzo-Larsen Attack",
    fen: "rnbqkbnr/pppppppp/8/8/8/1P6/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Classical Variation",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/8/1P6/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Dutch Variation",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/8/1P6/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: English Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/8/1P6/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Graz Attack",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/8/BP6/P1PPPPPP/RN1QKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Indian Variation",
    fen: "rnbqkb1r/pppppppp/5n2/8/8/1P6/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Modern Variation",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/8/1P6/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Modern Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/8/1P6/PBPPPPPP/RN1QKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Modern Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/8/1P2P3/PBPP1PPP/RN1QKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Pachman Gambit",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/5P2/1P6/PBPPP1PP/RN1QKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Polish Variation",
    fen: "rnbqkbnr/p1pppppp/8/1p6/8/1P6/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Ringelbach Gambit",
    fen: "rnbqkbnr/pppp2pp/4p3/5p2/4P3/1P6/PBPP1PPP/RN1QKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Spike Variation",
    fen: "rnbqkb1r/pppppp1p/5np1/8/6P1/1P6/PBPPPP1P/RN1QKBNR",
  },
  {
    name: "Nimzo-Larsen Attack: Symmetrical Variation",
    fen: "rnbqkbnr/p1pppppp/1p6/8/8/1P6/P1PPPPPP/RNBQKBNR",
  },
  {
    name: "Bird Opening",
    fen: "rnbqkbnr/pppppppp/8/8/5P2/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening",
    fen: "rnbqkb1r/pppppppp/5n2/8/5P2/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Batavo-Polish Attack",
    fen: "rnbqkb1r/pppppp1p/5np1/8/1P3P2/5N2/P1PPP1PP/RNBQKB1R",
  },
  {
    name: "Bird Opening: Double Duck Formation",
    fen: "rnbqkbnr/ppp1p1pp/8/3p1p2/3P1P2/8/PPP1P1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: From's Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/5P2/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: From's Gambit, Bahr Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/5P2/2N5/PPPPP1PP/R1BQKBNR",
  },
  {
    name: "Bird Opening: From's Gambit, Langheld Gambit",
    fen: "rnbqkb1r/ppp2ppp/3P1n2/8/8/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: From's Gambit, Lasker Variation",
    fen: "rnbqk1nr/ppp2p1p/3b4/6p1/8/5N2/PPPPP1PP/RNBQKB1R",
  },
  {
    name: "Bird Opening: From's Gambit, Lipke Variation",
    fen: "rnbqk2r/ppp2ppp/3b3n/8/3P4/5N2/PPP1P1PP/RNBQKB1R",
  },
  {
    name: "Bird Opening: Hobbs Gambit",
    fen: "rnbqkbnr/pppppp1p/8/6p1/5P2/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Hobbs-Zilbermints Gambit",
    fen: "rnbqkbnr/pppppp2/7p/6p1/5P2/5N2/PPPPP1PP/RNBQKB1R",
  },
  {
    name: "Bird Opening: Horsefly Defense",
    fen: "rnbqkb1r/pppppppp/7n/8/5P2/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Lasker Gambit",
    fen: "rnbqkbnr/pppp2pp/5p2/4P3/8/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Mujannah",
    fen: "rnbqkb1r/pppppppp/5n2/8/2P2P2/8/PP1PP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Myers Defense",
    fen: "rnbqkbnr/p1pppppp/8/1p6/5P2/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Platz Gambit",
    fen: "rnbqkb1r/ppppnppp/8/4P3/8/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Schlechter Gambit",
    fen: "r1bqkbnr/pppp1ppp/2n5/4P3/8/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Siegener Gambit",
    fen: "rnbqkbnr/pp1p1ppp/8/2p5/3p1P2/2P2N2/PP2P1PP/RNBQKB1R",
  },
  {
    name: "Bird Opening: Swiss Gambit",
    fen: "rnbqkb1r/ppppp1pp/5n2/8/4pPP1/2N5/PPPP3P/R1BQKBNR",
  },
  {
    name: "Bird Opening: Wagner-Zwitersch Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Dutch Variation",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/5P2/8/PPPPP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Dutch Variation, Dudweiler Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/5PP1/8/PPPPP2P/RNBQKBNR",
  },
  {
    name: "Bird Opening: Lasker Variation",
    fen: "rnbqkb1r/pp2pppp/5n2/2pp4/5P2/4PN2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "Bird Opening: Sturm Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/2P2P2/8/PP1PP1PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Thomas Gambit",
    fen: "rnbqkb1r/pp2pppp/5n2/2p5/3p1P2/1P2PN2/PBPP2PP/RN1QKB1R",
  },
  {
    name: "Bird Opening: Williams Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Williams Gambit",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/4pP2/2N5/PPPPQ1PP/R1B1KBNR",
  },
  {
    name: "Bird Opening: Williams-Zilbermints Gambit",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/4pP2/2N5/PPPPN1PP/R1BQKB1R",
  },
  {
    name: "Colle System: Rhamphorhynchus Variation",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1P5/8/4PN2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Modern Defense: Semi-Averbakh Variation, Polish Variation",
    fen: "rnb1k1nr/pp1pppbp/1q4p1/2p5/2PPP3/5N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Modern Defense: Semi-Averbakh Variation, Pterodactyl Variation",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/2PPP3/5N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Modern Defense: Semi-Averbakh Variation, Pterodactyl Variation Accepted",
    fen: "rnb1k1nr/pp2ppbp/3p2p1/q1P5/2P1P3/5N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Defense: Kingside Variation",
    fen: "rnbqkb1r/pppppp1p/6pn/8/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Defense: Sicilian Knight Variation",
    fen: "r1bqkbnr/pp1ppppp/n7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening",
    fen: "rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Arctic Defense",
    fen: "rnbqkbnr/ppppp1pp/5p2/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Arctic Defense, Drunken Knight Variation",
    fen: "rnbqkb1r/pppppnpp/5p2/8/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Basman Defense",
    fen: "rnbqkbnr/ppppppp1/7p/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Black Mustang Defense",
    fen: "r1bqkbnr/pppppppp/2n5/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Drunken Cavalry Variation",
    fen: "r1bqkb1r/pppppppp/n6n/8/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Dutch Variation",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Herrstrom Gambit",
    fen: "rnbqkbnr/pppppp1p/8/6p1/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Kingside Fianchetto",
    fen: "rnbqkbnr/pppppp1p/6p1/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Lisitsyn Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Lisitsyn Gambit Deferred",
    fen: "rnbqkb1r/ppppp1pp/5n2/5p2/4P3/3P1N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Pirc Invitation",
    fen: "rnbqkbnr/ppp1pppp/3p4/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Polish Defense",
    fen: "rnbqkbnr/p1pppppp/8/1p6/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Queen's Gambit Invitation",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Queenside Fianchetto Variation",
    fen: "rnbqkbnr/p1pppppp/1p6/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Ross Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Shabalov Gambit",
    fen: "rnbqkbnr/3p1ppp/p3p3/1pp5/2P5/2N2NP1/PP1PPP1P/R1BQKB1R",
  },
  {
    name: "Zukertort Opening: Sicilian Invitation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Slav Invitation",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Speelsmet Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/8/3p4/4PN2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: St. George Defense",
    fen: "rnbqkbnr/1ppppppp/p7/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: The Walrus",
    fen: "r1bqkbnr/ppp2ppp/2p5/8/8/8/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Vos Gambit",
    fen: "rnbqkbnr/ppp2ppp/3p4/4p3/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Wade Defense",
    fen: "rn1qkbnr/ppp1pppp/3p4/8/4P1b1/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Ware Defense",
    fen: "rnbqkbnr/1ppppppp/8/p7/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "King's Indian Attack",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/8/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "King's Indian Attack: Smyslov Variation",
    fen: "rnbqkb1r/pppppp1p/5np1/8/1P6/5NP1/P1PPPP1P/RNBQKB1R",
  },
  {
    name: "King's Indian Attack: Spassky Variation",
    fen: "rnbqkb1r/p1pppppp/5n2/1p6/8/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "King's Indian Attack: Symmetrical Defense",
    fen: "rnbqkb1r/pppppp1p/5np1/8/8/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "King's Indian Attack: Wahls Defense",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p4/8/3P1NP1/PPP1PPBP/RNBQ1RK1",
  },
  {
    name: "Polish Opening: Zukertort System",
    fen: "rnbqkb1r/pppppppp/5n2/8/1P6/5N2/P1PPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening",
    fen: "rnbqkb1r/pppppppp/5n2/8/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening",
    fen: "r1bqkb1r/pppppppp/2n2n2/8/8/2N2N2/PPPPPPPP/R1BQKB1R",
  },
  {
    name: "Zukertort Opening: Double Fianchetto Attack",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/8/1P3NP1/PBPPPPBP/RN1Q1RK1",
  },
  {
    name: "Zukertort Opening: Lemberger Gambit",
    fen: "rnbqkb1r/pppppppp/5n2/8/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Myers Polish Attack",
    fen: "rnbqkb1r/pppppp1p/5np1/8/PP6/5N2/2PPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Nimzo-Larsen Variation",
    fen: "rnbqkb1r/pppppppp/5n2/8/8/1P3N2/P1PPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Quiet System",
    fen: "rnbqkb1r/pppppppp/5n2/8/8/4PN2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Nimzo-Larsen Attack: Classical Variation",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/8/1P3N2/P1PPPPPP/RNBQKB1R",
  },
  {
    name: "Nimzo-Larsen Attack: Norfolk Gambit",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/4P3/1P3N2/P1PP1PPP/RNBQKB1R",
  },
  {
    name: "Nimzo-Larsen Attack: Norfolk Gambit",
    fen: "rnbqkb1r/pp2pppp/5n2/2pp4/4P3/1P3N2/PBPP1PPP/RN1QKB1R",
  },
  {
    name: "Zukertort Opening",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Ampel Variation",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKBR1",
  },
  {
    name: "Zukertort Opening: Old Indian Attack",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/8/3P1N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Pachman Gambit",
    fen: "rnbqkbnr/pp2pppp/8/2p5/2p5/1P2PN2/P2P1PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Regina-Nu Gambit",
    fen: "rnbqkbnr/pp2pppp/8/2p5/2p5/1PN2N2/P2PPPPP/R1BQKB1R",
  },
  {
    name: "Zukertort Opening: Reversed Mexican Defense",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/8/2N2N2/PPPPPPPP/R1BQKB1R",
  },
  {
    name: "Zukertort Opening: Santasiere's Folly",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/1P6/5N2/P1PPPPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Tennison Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: The Potato",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/P7/5N2/1PPPPPPP/RNBQKB1R",
  },
  {
    name: "Hungarian Opening: Wiedenhagen-Beta Gambit",
    fen: "rnbqkbnr/ppp1pp1p/8/3p2p1/8/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "King's Indian Attack",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/8/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "King's Indian Attack: Double Fianchetto",
    fen: "rnbqkbnr/ppp1pp1p/6p1/3p4/8/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "King's Indian Attack: Keres Variation",
    fen: "rn1qkbnr/ppp1pppp/8/3p4/6b1/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "King's Indian Attack: Keres Variation",
    fen: "r2qkbnr/pppnpppp/8/3p4/6b1/5NP1/PPPPPPBP/RNBQK2R",
  },
  {
    name: "King's Indian Attack: Omega-Delta Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/8/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "King's Indian Attack: Pachman System",
    fen: "rnbqk2r/ppp1npbp/6p1/3pp3/8/3P1NP1/PPP1PPBP/RNBQ1RK1",
  },
  {
    name: "King's Indian Attack: Sicilian Variation",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/8/5NP1/PPPPPP1P/RNBQKB1R",
  },
  {
    name: "King's Indian Attack: Yugoslav Variation",
    fen: "rn1qkb1r/pp2pppp/2p2n2/3p4/6b1/5NP1/PPPPPPBP/RNBQ1RK1",
  },
  {
    name: "King's Indian Attack: French Variation",
    fen: "r1bqkbnr/pp2pppp/2n5/2pp4/8/5NP1/PPPPPPBP/RNBQK2R",
  },
  {
    name: "King's Indian Attack: Sicilian Variation",
    fen: "r1bq1rk1/pp2bppp/2n1pn2/2pp4/4P3/3P1NP1/PPPN1PBP/R1BQR1K1",
  },
  {
    name: "King's Indian Attack: Sicilian Variation",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/8/5NP1/PPPPPPBP/RNBQK2R",
  },
  {
    name: "Zukertort Opening: Grünfeld Reversed",
    fen: "r1bqkbnr/pp3ppp/2n1p3/2pp4/3P4/5NP1/PPP1PPBP/RNBQ1RK1",
  },
  {
    name: "Réti Opening",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "Réti Opening: Advance Variation",
    fen: "rnbqkbnr/ppp1pppp/8/8/2Pp4/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "Réti Opening: Advance Variation, Michel Gambit",
    fen: "rnbqkbnr/pp2pppp/8/2p5/1PPp4/5N2/P2PPPPP/RNBQKB1R",
  },
  {
    name: "Réti Opening: Penguin Variation",
    fen: "rnbqkbnr/ppp1pppp/8/8/2Pp4/5N2/PP1PPPPP/RNBQKBR1",
  },
  {
    name: "Réti Opening: Reversed Blumenfeld Gambit",
    fen: "rnbqkbnr/pp2pppp/8/2p5/1PPp4/4PN2/P2P1PPP/RNBQKB1R",
  },
  {
    name: "Réti Opening: Réti Accepted",
    fen: "rnbqkbnr/ppp1pppp/8/8/2p5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "Réti Opening: Réti Gambit, Keres Variation",
    fen: "rn1qkbnr/ppp1pppp/4b3/8/2p5/4PN2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Réti Opening: Zilbermints Gambit",
    fen: "rnbqkbnr/p1p1pppp/8/1p1p4/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening",
    fen: "rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Achilles-Omega Gambit",
    fen: "rnbqkb1r/pppppppp/5n2/8/2P1P3/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "English Opening: Adorjan Defense",
    fen: "rnbqkbnr/pppp1p1p/6p1/4p3/2P1P3/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "English Opening: Anglo-Dutch Defense",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Anglo-Dutch Defense, Hickmann Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/2P1P3/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "English Opening: Anglo-Dutch Variation, Chabanon Gambit",
    fen: "rnbqkbnr/ppp1p1pp/3p4/5p2/2P1P3/5N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "English Opening: Anglo-Dutch Variation, Ferenc Gambit",
    fen: "rnbqkb1r/ppppp1pp/5n2/5p2/2P1P3/2N5/PP1P1PPP/R1BQKBNR",
  },
  {
    name: "English Opening: Anglo-Lithuanian Variation",
    fen: "r1bqkbnr/pppppppp/2n5/8/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Anglo-Scandinavian Defense",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Anglo-Scandinavian Defense, Löhn Gambit",
    fen: "rnbqkbnr/ppp2ppp/4p3/3P4/8/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Anglo-Scandinavian Defense, Malvinas Variation",
    fen: "rnb1kbnr/ppp1pppp/8/q7/8/2N5/PP1PPPPP/R1BQKBNR",
  },
  {
    name: "English Opening: Anglo-Scandinavian Defense, Schulz Gambit",
    fen: "rnbqkb1r/ppp1pppp/5n2/3P4/8/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Great Snake Variation",
    fen: "rnbqkbnr/pppppp1p/6p1/8/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Jaenisch Gambit",
    fen: "rnbqkbnr/p1pppppp/8/1p6/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Botvinnik System, Prickly Pawn Pass System",
    fen: "rnbq1rk1/1p3pbp/p1pp1np1/4p3/2P1P3/2NP2P1/PP2NPBP/R1BQ1RK1",
  },
  {
    name: "English Opening: Myers Defense",
    fen: "rnbqkbnr/pppppp1p/8/6p1/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Myers Gambit",
    fen: "rnbqk1nr/ppppppbp/8/6p1/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Porcupine Variation",
    fen: "rnbqkb1r/ppppp1pp/5n2/8/2P1p1P1/2N5/PP1P1P1P/R1BQKBNR",
  },
  {
    name: "English Opening: Wade Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/2P3P1/8/PP1PPP1P/RNBQKBNR",
  },
  {
    name: "English Opening: Zilbermints Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/4p1p1/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Caro-Kann Defensive System",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "Réti Opening: Anglo-Slav Variation, Bled Variation",
    fen: "rnbqkb1r/pp2pp1p/2p2np1/3p4/2P5/1P3N2/PB1PPPPP/RN1QKB1R",
  },
  {
    name: "Réti Opening: Anglo-Slav Variation, Bogoljubov Variation",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/2P5/1P3N2/P2PPPPP/RNBQKB1R",
  },
  {
    name: "Réti Opening: Anglo-Slav Variation, Bogoljubov Variation",
    fen: "rn1qkbnr/pp2pppp/2p5/3p4/2P3b1/1P3N2/P2PPPPP/RNBQKB1R",
  },
  {
    name: "Réti Opening: Anglo-Slav Variation, Bogoljubov Variation",
    fen: "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/1P3N2/PB1PPPPP/RN1QKB1R",
  },
  {
    name: "Réti Opening: Anglo-Slav Variation, Capablanca Variation",
    fen: "rn1qkb1r/pp2pppp/2p2n2/3p4/2P3b1/1P3N2/PB1PPPPP/RN1QKB1R",
  },
  {
    name: "Réti Opening: Anglo-Slav Variation, London Defensive System",
    fen: "rn1qkb1r/pp2pppp/2p2n2/3p1b2/2P5/1P3NP1/P2PPP1P/RNBQKB1R",
  },
  {
    name: "Réti Opening: Anglo-Slav Variation, New York System",
    fen: "rn1qkb1r/pp2pppp/2p2n2/3p1b2/2P5/1P3N2/PB1PPPPP/RN1QKB1R",
  },
  {
    name: "Réti Opening: Anglo-Slav Variation, Torre System",
    fen: "rn1qkb1r/pp2pppp/2p2n2/3p4/2P3b1/1P3NP1/P2PPP1P/RNBQKB1R",
  },
  {
    name: "English Opening: Agincourt Defense",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Agincourt Defense",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Agincourt Defense",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Agincourt Defense, Bogoljubov Defense",
    fen: "rnbqk2r/ppp2ppp/3bpn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R",
  },
  {
    name: "English Opening: Agincourt Defense, Catalan Defense",
    fen: "rn1qkbnr/pbp2ppp/1p2p3/3p4/2P5/5NP1/PP1PPPBP/RNBQ1RK1",
  },
  {
    name: "English Opening: Agincourt Defense, Catalan Defense",
    fen: "rnbqkbnr/pp3ppp/4p3/2pp4/2P5/5NP1/PP1PPP1P/RNBQKB1R",
  },
  {
    name: "English Opening: Agincourt Defense, Catalan Defense Accepted",
    fen: "rnbqkb1r/ppp2ppp/4pn2/8/2p5/5NP1/PP1PPPBP/RNBQK2R",
  },
  {
    name: "English Opening: Agincourt Defense, Catalan Defense, Semi-Slav Defense",
    fen: "rnbqkb1r/pp3ppp/2p1pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R",
  },
  {
    name: "English Opening: Agincourt Defense, Kurajica Defense",
    fen: "rnbqkbnr/pp3ppp/2p1p3/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R",
  },
  {
    name: "English Opening: Agincourt Defense, Tarrasch Defense",
    fen: "r1bqk2r/pp2bppp/2n1pn2/2pp4/2P5/1P3NP1/P2PPPBP/RNBQ1RK1",
  },
  {
    name: "English Opening: Agincourt Defense, Wimpy System",
    fen: "rnbqkb1r/pp3ppp/4pn2/2pp4/2P5/1P2PN2/PB1P1PPP/RN1QKB1R",
  },
  {
    name: "English Opening: Neo-Catalan",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R",
  },
  {
    name: "English Opening: Neo-Catalan Declined",
    fen: "rnbqk2r/ppp1bppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R",
  },
  {
    name: "English Opening: Romanishin Gambit",
    fen: "rnbqkb1r/2pp1ppp/p3pn2/1p6/2P5/5NP1/PP1PPPBP/RNBQK2R",
  },
  {
    name: "English Opening: Agincourt Defense, Keres Defense",
    fen: "r1bqk2r/pp2bppp/2n1p3/2pn4/8/2N2NP1/PP1PPPBP/R1BQ1RK1",
  },
  {
    name: "English Opening: Agincourt Defense, Neo-Catalan Declined",
    fen: "rnbqk2r/ppp1bppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQ1RK1",
  },
  {
    name: "Réti Opening: Anglo-Slav Variation, Bogoljubov Variation, Stonewall Line",
    fen: "rnbq1rk1/pp2bppp/2p1pn2/3p4/2P5/1P3NP1/PB1PPPBP/RN1Q1RK1",
  },
  {
    name: "English Opening: Anglo-Indian Defense",
    fen: "rnbqkb1r/pppppppp/5n2/8/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Anti-Anti-Grünfeld",
    fen: "rnbqk2r/ppppppbp/5np1/8/2P1P3/2N2N2/PP1P1PPP/R1BQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Grünfeld Formation",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, King's Indian Formation",
    fen: "rnbqkb1r/pppppp1p/5np1/8/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, King's Indian Formation, Double Fianchetto",
    fen: "rn1qkb1r/pbpppp1p/1p3np1/8/2P5/5NP1/PP1PPPBP/RNBQK2R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, King's Knight Variation",
    fen: "rnbqkb1r/pppppppp/5n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Old Indian Formation",
    fen: "rnbqkb1r/ppp1pppp/3p1n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Queen's Indian Formation",
    fen: "rnbqkb1r/p1pppppp/1p3n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Queen's Indian Formation",
    fen: "rn1qkb1r/pbpp1ppp/1p2pn2/8/2P5/5NP1/PP1PPPBP/RNBQK2R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Romanishin Variation",
    fen: "rnbqkb1r/1ppp1ppp/p3pn2/8/2P5/5NP1/PP1PPP1P/RNBQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Scandinavian Defense",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Scandinavian Defense, Exchange Variation",
    fen: "rnbqkb1r/ppp1pppp/8/3n4/8/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Slav Formation",
    fen: "rnbqkb1r/pp1ppp1p/2p2np1/8/2P5/5NP1/PP1PPP1P/RNBQKB1R",
  },
  {
    name: "English Orangutan",
    fen: "rnbqkb1r/pppppppp/5n2/8/1PP5/8/P2PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Anglo-Grünfeld Defense",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/2P5/2N5/PP1PPPPP/R1BQKBNR",
  },
  {
    name: "English Opening: Anglo-Grünfeld Defense, Korchnoi Variation",
    fen: "rnbqk2r/ppp2pbp/6p1/3np3/8/2N2NP1/PP1PPPBP/R1BQK2R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Anglo-Grünfeld Variation",
    fen: "rnbqkb1r/ppp1pppp/8/3n4/8/2N2N2/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Anglo-Grünfeld Variation",
    fen: "rnbqkb1r/ppp1pp1p/1n4p1/8/8/2N3P1/PP1PPPBP/R1BQK1NR",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Anglo-Grünfeld Variation",
    fen: "rnbqkb1r/ppp1pp1p/6p1/8/8/2n3P1/PP1PPPBP/R1BQK1NR",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Queen's Knight Variation",
    fen: "rnbqkb1r/pppppppp/5n2/8/2P5/2N5/PP1PPPPP/R1BQKBNR",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Hedgehog System",
    fen: "rnbqkb1r/pppp1ppp/4pn2/8/2P5/2N5/PP1PPPPP/R1BQKBNR",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Nimzo-English",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bP5/2N2N2/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Queen's Indian Formation",
    fen: "rnbqkb1r/p1pp1ppp/1p2pn2/8/2P5/2N2N2/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Queen's Indian Variation",
    fen: "rn1qkb1r/pbpp1ppp/1p2pn2/8/2P1P3/2NB1N2/PP1P1PPP/R1BQK2R",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Zvjaginsev-Krasenkow Attack",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bP3P1/2N2N2/PP1PPP1P/R1BQKB1R",
  },
  {
    name: "English Opening: Mikenas-Carls Variation",
    fen: "rnbqkb1r/pppp1ppp/4pn2/8/2P1P3/2N5/PP1P1PPP/R1BQKBNR",
  },
  {
    name: "English Opening: Mikenas-Carls Variation",
    fen: "r1bqkb1r/pppp1ppp/2n1pn2/8/2P1P3/2N5/PP1P1PPP/R1BQKBNR",
  },
  {
    name: "English Opening: Mikenas-Carls Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3pP3/2P5/2N5/PP1P1PPP/R1BQKBNR",
  },
  {
    name: "English Opening: Anglo-Indian Defense, Flohr-Mikenas-Carls Variation, Nei Gambit",
    fen: "rnbqkbnr/pp1p1ppp/4p3/2p1P3/2P5/2N5/PP1P1PPP/R1BQKBNR",
  },
  {
    name: "English Opening: Mikenas-Carls, Sicilian",
    fen: "rnbqkb1r/pp1p1ppp/4pn2/2p5/2P1P3/2N5/PP1P1PPP/R1BQKBNR",
  },
  {
    name: "English Opening: Drill Variation",
    fen: "rnbqkbnr/pppp1pp1/8/4p2p/2P5/6P1/PP1PPP1P/RNBQKBNR",
  },
  {
    name: "English Opening: King's English Variation",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Kahiko-Hula Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/8/2P2p2/4PN2/PP1P2PP/RNBQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Nimzowitsch Variation",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Nimzowitsch-Flohr Variation",
    fen: "rnbqkbnr/pppp1ppp/8/8/2P1p3/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: King's English Variation",
    fen: "rnbqkbnr/ppp2ppp/3p4/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Keres Defense",
    fen: "rnbqkbnr/pp3ppp/2pp4/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Kramnik-Shirov Counterattack",
    fen: "rnbqk1nr/pppp1ppp/8/4p3/1bP5/2N5/PP1PPPPP/R1BQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Reversed Sicilian",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Smyslov Defense",
    fen: "rn1qkbnr/ppp2ppp/3p4/4p3/2P3b1/2N2N2/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Troger Defense",
    fen: "r2qkbnr/ppp2ppp/2npb3/4p3/2P5/2N3P1/PP1PPPBP/R1BQK1NR",
  },
  {
    name: "English Opening: Carls-Bremen System",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Bellon Gambit",
    fen: "rnbqkb1r/p1pp1ppp/5n2/1p4N1/2P1p3/2N5/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Two Knights Variation",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Two Knights Variation, Reversed Dragon",
    fen: "rnbqkb1r/ppp2ppp/5n2/3pp3/2P5/2N3P1/PP1PPP1P/R1BQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Two Knights Variation, Smyslov System",
    fen: "rnbqk2r/pppp1ppp/5n2/4p3/1bP5/2N3P1/PP1PPP1P/R1BQKBNR",
  },
  {
    name: "English Opening: King's English, Erbenheimer Gambit",
    fen: "rnbqkb1r/pppp1ppp/8/6N1/2P1p1n1/2N5/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: King's English, Mazedonisch",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2P2P2/2N5/PP1PP1PP/R1BQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Two Knights Variation, Keres Variation",
    fen: "rnbqkb1r/pp1p1ppp/2p2n2/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Two Knights Variation, Fianchetto Line",
    fen: "rnbqkb1r/pppp1p1p/5np1/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR",
  },
  {
    name: "English Opening: Closed, Taimanov Variation",
    fen: "r1bqk2r/pppp1pbp/2n3pn/4p3/2P5/2N3P1/PP1PPPBP/1RBQK1NR",
  },
  {
    name: "English Opening: Closed, Taimanov Variation",
    fen: "r1bqk2r/ppp2pbp/2np2pn/4p3/2P5/2N1P1P1/PP1PNPBP/R1BQK2R",
  },
  {
    name: "English Opening: King's English Variation, Bremen-Hort Variation",
    fen: "r2qk1nr/ppp2pbp/2npb1p1/4p3/2P5/2N1P1P1/PP1PNPBP/R1BQK2R",
  },
  {
    name: "English Opening: King's English Variation, Closed System",
    fen: "r1bqk1nr/pppp1pbp/2n3p1/4p3/2P5/2NP2P1/PP2PPBP/R1BQK1NR",
  },
  {
    name: "English Opening: King's English Variation, Hungarian Attack",
    fen: "r1bqk1nr/pppp1pbp/2n3p1/4p3/2P5/2N3P1/PP1PPPBP/1RBQK1NR",
  },
  {
    name: "English Opening: King's English Variation, Reversed Closed Sicilian",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR",
  },
  {
    name: "English Opening: King's English Variation, Taimanov Variation",
    fen: "r1bqk1nr/pppp1pbp/2n3p1/4p3/2P5/2N3P1/PP1PPPBP/R1BQK1NR",
  },
  {
    name: "English Opening: King's English Variation, Botvinnik System",
    fen: "r1bqk1nr/ppp2pbp/2np2p1/4p3/2P1P3/2NP2P1/PP3PBP/R1BQK1NR",
  },
  {
    name: "English Opening: King's English Variation, Closed System, Full Symmetry",
    fen: "r1bqk1nr/ppp2pbp/2np2p1/4p3/2P5/2NP2P1/PP2PPBP/R1BQK1NR",
  },
  {
    name: "English Opening: King's English Variation, Three Knights System",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: Four Knights System, Nimzowitsch Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P1P3/2N2N2/PP1P1PPP/R1BQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Four Knights Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Four Knights Variation",
    fen: "r1bqk2r/pppp1pp1/5n1p/4n3/2PN3B/2P5/P3PPPP/R2QKB1R",
  },
  {
    name: "English Opening: King's English Variation, Four Knights Variation, Bradley Beach Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/8/2PPp3/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Four Knights Variation, Flexible Line",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2NP1N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Four Knights Variation, Korchnoi Line",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/P1N2N2/1P1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Four Knights Variation, Quiet Line",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N1PN2/PP1P1PPP/R1BQKB1R",
  },
  {
    name: "English Opening: King's English Variation, Four Knights Variation, Quiet Line",
    fen: "r1bqk2r/pppp1ppp/2n2n2/4p3/2P5/2b1PN2/PPQP1PPP/R1B1KB1R",
  },
  {
    name: "English Opening: King's English Variation, Four Knights Variation, Quiet Line",
    fen: "r1bqr1k1/pppp1ppp/2n2n2/3NpQ2/1bP5/4PN2/PP1P1PPP/R1B1KB1R",
  },
  {
    name: "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N2NP1/PP1PPP1P/R1BQKB1R",
  },
  {
    name: "English Opening: Symmetrical Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/2P5/8/PP1PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Symmetrical Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/2P5/5N2/PP1PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Symmetrical Variation, Hedgehog Defense",
    fen: "rn1qk2r/pb1pbppp/1p2pn2/2p5/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1",
  },
  {
    name: "English Opening: Symmetrical Variation, Napolitano Gambit",
    fen: "rnbqkb1r/pp1ppppp/5n2/2p5/1PP5/5N2/P2PPPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Symmetrical, Hedgehog, Flexible Formation",
    fen: "r2qk2r/1b1nbppp/pp1ppn2/8/2PQ4/1PN2NP1/P3PPBP/R1BR2K1",
  },
  {
    name: "English Opening: Wing Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/1PP5/8/P2PPPPP/RNBQKBNR",
  },
  {
    name: "English Opening: Symmetrical Variation, Anti-Benoni Variation",
    fen: "rnbqkb1r/pp1ppppp/5n2/2p5/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Symmetrical Variation, Anti-Benoni Variation, Spielmann Defense",
    fen: "rnbqkb1r/pp1p1ppp/4pn2/8/2PN4/8/PP2PPPP/RNBQKB1R",
  },
  {
    name: "English Opening: Symmetrical Variation, Anti-Benoni Variation, Geller Variation",
    fen: "r1b1kb1r/pp1p1ppp/1qn1pn2/8/2PN4/2N3P1/PP2PP1P/R1BQKB1R",
  },
  {
    name: "English Opening: Symmetrical Variation, Anti-Benoni Variation, Spielmann Defense",
    fen: "r1bqkb1r/pp1p1ppp/2n1pn2/8/2PN4/2N5/PP2PPPP/R1BQKB1R",
  },
  {
    name: "English Opening: Symmetrical Variation, Fianchetto Variation",
    fen: "rnbqkb1r/pp1ppppp/5n2/2p5/2P5/2N3P1/PP1PPP1P/R1BQKBNR",
  },
  {
    name: "English Opening: Symmetrical Variation, Normal Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/2P5/2N5/PP1PPPPP/R1BQKBNR",
  },
  {
    name: "English Opening: Symmetrical Variation, Rubinstein Variation",
    fen: "rnbqkb1r/ppn1pppp/8/2p5/8/2N3P1/PP1PPPBP/R1BQK1NR",
  },
  {
    name: "English Opening: Symmetrical Variation, Three Knights Variation",
    fen: "rnbqkb1r/pp1ppppp/5n2/2p5/2P5/2N2N2/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: Symmetrical Variation, Four Knights Variation",
    fen: "r1bqkb1r/pp1ppppp/2n2n2/2p5/2P5/2N2N2/PP1PPPPP/R1BQKB1R",
  },
  {
    name: "English Opening: Symmetrical Variation, Two Knights Variation",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/2P5/2N5/PP1PPPPP/R1BQKBNR",
  },
  {
    name: "English Opening: Symmetrical Variation, Botvinnik System",
    fen: "r1bqk1nr/pp1pppbp/2n3p1/2p5/2P1P3/2N3P1/PP1P1PBP/R1BQK1NR",
  },
  {
    name: "English Opening: Symmetrical Variation, Botvinnik System Reversed, with e3",
    fen: "r1bqk1nr/pp1p1pbp/2n3p1/2p1p3/2P5/2N1P1P1/PP1P1PBP/R1BQK1NR",
  },
  {
    name: "English Opening: Symmetrical Variation, Symmetrical Variation",
    fen: "r1bqk1nr/pp1pppbp/2n3p1/2p5/2P5/2N3P1/PP1PPPBP/R1BQK1NR",
  },
  {
    name: "English Opening: Symmetrical Variation, Two Knights, Fianchetto Variation",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/2P5/2N3P1/PP1PPP1P/R1BQKBNR",
  },
  {
    name: "English Opening: Symmetrical Variation, Botvinnik System Reversed, with Nf3",
    fen: "r1bqk1nr/pp1p1pbp/2n3p1/2p1p3/2P5/2N2NP1/PP1PPPBP/R1BQK2R",
  },
  {
    name: "English Opening: Symmetrical Variation, Three Knights, Fianchetto Variation",
    fen: "r1bqk1nr/pp1pppbp/2n3p1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQK2R",
  },
  {
    name: "English Opening: Symmetrical Variation, Double Fianchetto",
    fen: "r1bq1rk1/pp1pppbp/2n2np1/2p5/2P5/1PN2NP1/P2PPPBP/R1BQ1RK1",
  },
  {
    name: "English Opening: Symmetrical Variation, Duchamp Variation",
    fen: "r1bq1rk1/pp1pppbp/2n2np1/2p5/2P5/2NP1NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "English Opening: Symmetrical Variation, Full Symmetry Line",
    fen: "r1bqk2r/pp1pppbp/2n2np1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQK2R",
  },
  {
    name: "English Opening: Symmetrical Variation, Mecking Variation",
    fen: "r1bq1rk1/pp1pppbp/2n2np1/2p5/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Australian Defense",
    fen: "r1bqkbnr/pppppppp/n7/8/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Franco-Sicilian Hybrid",
    fen: "rnbqk2r/pp2npbp/3p2p1/2pP4/4P3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Borg Defense: Borg Gambit",
    fen: "rnbqkbnr/pppppp1p/8/6p1/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Colle System: Pterodactyl Variation",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/3P4/3BPN2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Colle System: Siroccopteryx Variation",
    fen: "rnb1k1nr/pp1pppbp/6p1/q7/3N4/3BP3/PPP2PPP/RNBQK2R",
  },
  {
    name: "Dutch Defense: Senechaud Gambit",
    fen: "rnbqkbnr/pppp2pp/4p3/5p2/3P1BP1/8/PPP1PP1P/RN1QKBNR",
  },
  {
    name: "Dutch Defense: Stonewall Variation, Modern Variation",
    fen: "rnbqk2r/pp4pp/2pbpn2/3p1p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "English Defense",
    fen: "rnbqkbnr/p1pppppp/1p6/8/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "English Defense",
    fen: "rnbqkbnr/p1pp1ppp/1p2p3/8/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "English Defense: Eastbourne Gambit",
    fen: "rn1qkbnr/pbpp1ppp/1p6/4p3/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "English Defense: Hartlaub Gambit Accepted",
    fen: "rn1qkb1r/pbpp2pp/1p2pn2/5P2/2PP4/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "English Defense: Hartlaub Gambit Declined",
    fen: "rn1qkbnr/pbpp2pp/1p2p3/3P1p2/2P1P3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "English Defense: Perrin Variation",
    fen: "r2qkbnr/pbpp1ppp/1pn1p3/8/2PPP3/3B4/PP3PPP/RNBQK1NR",
  },
  {
    name: "English Defense: Poli Gambit",
    fen: "rn1qkb1r/pbpp2pp/1p2p2n/5P2/2PP4/5P2/PP4PP/RNBQKBNR",
  },
  {
    name: "Englund Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Englund Gambit Complex Declined",
    fen: "rnbqkbnr/pppp1ppp/8/3Pp3/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Englund Gambit Complex Declined: Diemer Counterattack",
    fen: "rnb1k1nr/pppp1ppp/8/2bPp3/4P2q/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Englund Gambit Complex: Englund Gambit",
    fen: "r1b1kbnr/ppppqppp/2n5/4P3/8/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Englund Gambit Complex: Felbecker Gambit",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b1P3/8/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Englund Gambit Complex: Hartlaub-Charlick Gambit",
    fen: "rnbqkbnr/ppp2ppp/3p4/4P3/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Englund Gambit Complex: Mosquito Gambit",
    fen: "rnb1kbnr/pppp1ppp/8/4P3/7q/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Englund Gambit Complex: Soller Gambit",
    fen: "rnbqkbnr/pppp2pp/5p2/4P3/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Englund Gambit Complex: Soller Gambit Deferred",
    fen: "r1bqkbnr/pppp2pp/2n2p2/4P3/8/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Englund Gambit Complex: Stockholm Variation",
    fen: "r1b1kbnr/ppppqppp/2n5/3QP3/8/5N2/PPP1PPPP/RNB1KB1R",
  },
  {
    name: "Englund Gambit Complex: Zilbermints Gambit",
    fen: "r1bqkb1r/ppppnppp/2n5/4P3/8/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Englund Gambit Declined: Reversed Alekhine",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Englund Gambit Declined: Reversed Brooklyn",
    fen: "rnbqkbnr/pppp1ppp/8/8/3Pp3/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Englund Gambit Declined: Reversed French",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/3P4/4P3/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Englund Gambit Declined: Reversed Krebs",
    fen: "rnbqkbnr/pppp1ppp/8/8/3Pp3/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Englund Gambit Declined: Reversed Mokele Mbembe",
    fen: "rnbqkbnr/pppp1ppp/8/4N3/3Pp3/8/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Horwitz Defense",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Horwitz Defense: Zilbermints Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Kangaroo Defense",
    fen: "rnbqk1nr/pppp1ppp/4p3/8/1bPP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Kangaroo Defense: Keres Defense, Transpositional Variation",
    fen: "rnbqk1nr/pppp1ppp/4p3/8/1bPP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Mikenas Defense",
    fen: "r1bqkbnr/pppppppp/2n5/8/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Mikenas Defense: Cannstatter Variation",
    fen: "r1bqkbnr/pppp1ppp/8/3Pp3/2Pn4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Mikenas Defense: Lithuanian Variation",
    fen: "r1bqkbnr/ppppnppp/8/3Pp3/2P5/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Mikenas Defense: Pozarek Gambit",
    fen: "r1bqkbnr/pppp1ppp/8/8/2n5/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Beefeater Variation",
    fen: "rnbqk1nr/pp1pp2p/6p1/2pP1p2/2P5/2P5/P3PPPP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Lizard Defense, Pirc-Diemer Gambit",
    fen: "rnbqkb1r/pppppp1p/5np1/7P/3P4/8/PPP1PPP1/RNBQKBNR",
  },
  {
    name: "Montevideo Defense",
    fen: "rnbqkbnr/pppppppp/8/3P4/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Polish Defense",
    fen: "rnbqkbnr/p1pppppp/8/1p6/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Polish Defense: Spassky Gambit Accepted",
    fen: "rn1qkbnr/pbpppppp/8/1B6/3PP3/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Pterodactyl Defense: Central, Benoni Beefeater Pterodactyl",
    fen: "rnb1k1nr/pp2pp1p/3p2p1/q1pP4/2P1P3/2P5/P4PPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Central, Benoni Pterodactyl",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1pP4/2P1P3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Pterodactyl Defense: Fianchetto, Queen Benoni Pterodactyl",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1pP4/2P5/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Fianchetto, Queen Pteranodon",
    fen: "rnb1k1nr/pp1ppp1p/6p1/q1pP4/2P5/2P5/P3PPPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Fianchetto, Queen Pterodactyl",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/3P4/5NP1/PPP1PPBP/RNBQK2R",
  },
  {
    name: "Pterodactyl Defense: Queen Pterodactyl, Quiet Line",
    fen: "rnbqk1nr/pp1pppbp/6p1/2p5/2PP4/2N1P3/PP3PPP/R1BQKBNR",
  },
  {
    name: "Queen's Pawn Game",
    fen: "rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Pawn Game: Anglo-Slav Opening",
    fen: "rnbqkbnr/pp2pppp/2pp4/8/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Pawn Game: Modern Defense",
    fen: "rnbqkbnr/pppppp1p/6p1/8/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Slav Indian: Kudischewitsch Gambit",
    fen: "rnbqkb1r/p2ppppp/2p2n2/1p6/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Zaire Defense",
    fen: "rnbqkbnr/pppppppp/8/3PP3/8/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Modern Defense",
    fen: "rnbqk1nr/ppp1ppbp/3p2p1/8/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Neo-Modern Defense",
    fen: "rnbqk1nr/pppp1pbp/6p1/4p3/2PPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Old Indian Defense",
    fen: "rnbqkbnr/ppp1pppp/3p4/8/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Pawn Game",
    fen: "rnbqkbnr/ppp1pppp/3p4/8/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Rat Defense: English Rat",
    fen: "rnbqkbnr/ppp2ppp/3p4/4p3/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Rat Defense: English Rat, Lisbon Gambit",
    fen: "r1bqkbnr/ppp2ppp/2np4/4P3/2P5/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Rat Defense: English Rat, Pounds Gambit",
    fen: "rn1qkbnr/ppp2ppp/3pb3/4P3/2P5/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Robatsch Defense",
    fen: "rn1qk1nr/ppp1ppbp/3p2p1/8/2PPP1b1/5N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Wade Defense",
    fen: "rn1qkbnr/ppp1pppp/3p4/8/3P2b1/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Zukertort Opening: Wade Defense, Chigorin Plan",
    fen: "1r1qkbnr/pppnpppp/3p4/8/2PP2b1/1Q3N2/PP2PPPP/RNB1KB1R",
  },
  {
    name: "Modern Defense: Averbakh System",
    fen: "rnbqk1nr/ppp1ppbp/3p2p1/8/2PPP3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Averbakh Variation, Pseudo-Sämisch",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/4BP2/PP4PP/RN1QKBNR",
  },
  {
    name: "Modern Defense: Kotov Variation",
    fen: "r1bqk1nr/ppp1ppbp/2np2p1/8/2PPP3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Randspringer Variation",
    fen: "rnbqk1nr/ppp1p1bp/3p2p1/5p2/2PPP3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense",
    fen: "rnb1k1nr/pp2ppbp/3p2p1/q1p5/2PPP3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Pterodactyl Defense: Central, Bogolubovia",
    fen: "rnb1k1nr/pp2ppbp/3p2p1/q1p5/2PPP3/2N5/PP2NPPP/R1BQKB1R",
  },
  {
    name: "Benoni Defense: Benoni Gambit Accepted",
    fen: "rnbqkbnr/pp1ppppp/8/2P5/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Benoni Gambit, Schlenker Defense",
    fen: "r1bqkbnr/pp1ppppp/n7/2P5/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Benoni-Indian Defense",
    fen: "rnbqkb1r/pp1ppppp/5n2/2pP4/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Benoni-Indian Defense, Kingside Move Order",
    fen: "rnbqkb1r/pp1ppppp/5n2/2pP4/8/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Benoni Defense: Benoni-Staunton Gambit",
    fen: "rnbqkbnr/pp1pp1pp/8/2pP1p2/4P3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Cormorant Gambit",
    fen: "rnbqkbnr/p2ppppp/1p6/2P5/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: French Benoni",
    fen: "rnbqkbnr/pp1p1ppp/4p3/2pP4/4P3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Hawk Variation",
    fen: "rnbqkb1r/pp1ppppp/5n2/3P4/2p5/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Benoni Defense: Old Benoni",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Old Benoni",
    fen: "rnbqkbnr/pp1ppppp/8/2pP4/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Old Benoni",
    fen: "rnbqkbnr/pp2pppp/3p4/2pP4/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Old Benoni, Mujannah Formation",
    fen: "rnbqkbnr/pp1pp1pp/8/2pP1p2/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Old Benoni, Schmid Variation",
    fen: "rnbqkbnr/pp2pp1p/3p2p1/2pP4/8/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Benoni Defense: Snail Variation",
    fen: "r1bqkbnr/pp1ppppp/n7/2pP4/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Woozle",
    fen: "rnb1kb1r/pp1ppppp/5n2/q1pP4/8/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Benoni Defense: Zilbermints-Benoni Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/1P1P4/8/P1P1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Zilbermints-Benoni Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/8/1P1p4/5N2/P1P1PPPP/RNBQKB1R",
  },
  {
    name: "Benoni Defense: Zilbermints-Benoni Gambit, Tamarkin Countergambit",
    fen: "rnbqkbnr/pp1p1ppp/8/4p3/1P1p4/5N2/P1P1PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Pseudo-Benko",
    fen: "rnbqkb1r/p2ppppp/5n2/1ppP4/8/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Liedmann Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/8/2Pp4/4P3/PP3PPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Old Benoni",
    fen: "rnbqkbnr/pp1p1ppp/8/2pPp3/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Semi-Benoni",
    fen: "rnbqkbnr/pp3ppp/3p4/2pPp3/4P3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Amazon Attack: Siberian Attack",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/2NQ4/PPP1PPPP/R1B1KBNR",
  },
  {
    name: "Canard Opening",
    fen: "rnbqkb1r/pppppppp/5n2/8/3P1P2/8/PPP1P1PP/RNBQKBNR",
  },
  {
    name: "Indian Defense",
    fen: "rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Gedult Attack, Gedult Attack",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P2P1/5P2/PPP1P2P/RNBQKBNR",
  },
  {
    name: "Indian Defense: Gibbins-Weidenhagen Gambit",
    fen: "rnbqkb1r/pppppppp/5n2/8/3P2P1/8/PPP1PP1P/RNBQKBNR",
  },
  {
    name: "Indian Defense: Gibbins-Weidenhagen Gambit Accepted",
    fen: "rnbqkb1r/pppppppp/8/8/3P2n1/8/PPP1PP1P/RNBQKBNR",
  },
  {
    name: "Indian Defense: Gibbins-Weidenhagen Gambit, Maltese Falcon",
    fen: "rnbqkb1r/pppppppp/5n2/8/3PP3/5P2/PPP4P/RNBQKBNR",
  },
  {
    name: "Indian Defense: Gibbins-Weidenhagen Gambit, Oshima Defense",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/3P2P1/8/PPP1PP1P/RNBQKBNR",
  },
  {
    name: "Indian Defense: Gibbins-Weidenhagen Gambit, Stummer Gambit",
    fen: "rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/2N5/PPP1BP1P/R1BQK1NR",
  },
  {
    name: "Indian Defense: Lazard Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/3P4/8/PPPNPPPP/R1BQKBNR",
  },
  {
    name: "Indian Defense: Maddigan Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/3P4/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Indian Defense: Omega Gambit",
    fen: "rnbqkb1r/pppppppp/5n2/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Omega Gambit, Arafat Gambit",
    fen: "rnbqkb1r/pppppppp/5n2/6B1/3P4/3B4/PPP2PPP/RN1QK1NR",
  },
  {
    name: "Indian Defense: Paleface Attack, Blackmar-Diemer Gambit Deferred",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3PP3/5P2/PPP3PP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Pawn Push Variation",
    fen: "rnbqkb1r/pppppppp/5n2/3P4/8/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Reversed Chigorin Defense",
    fen: "rnbqkb1r/pp1ppppp/5n2/2p5/3P4/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Indian Defense: Tartakower Attack",
    fen: "rnbqkb1r/pppppppp/5n2/8/3P4/6P1/PPP1PP1P/RNBQKBNR",
  },
  {
    name: "Paleface Attack",
    fen: "rnbqkb1r/pppppppp/5n2/8/3P4/5P2/PPP1P1PP/RNBQKBNR",
  },
  {
    name: "Queen's Pawn Game: Chigorin Variation",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Pawn Game: Veresov, Richter Attack",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/2N2P2/PPP1P1PP/R1BQKBNR",
  },
  {
    name: "Trompowsky Attack",
    fen: "rnbqkb1r/pppppppp/5n2/6B1/3P4/8/PPP1PPPP/RN1QKBNR",
  },
  {
    name: "Trompowsky Attack: Borg Variation",
    fen: "rnbqkb1r/pppppp1p/8/6p1/3PnB2/8/PPP1PPPP/RN1QKBNR",
  },
  {
    name: "Trompowsky Attack: Classical Defense",
    fen: "rnbqkb1r/pppp1ppp/4pn2/6B1/3P4/8/PPP1PPPP/RN1QKBNR",
  },
  {
    name: "Trompowsky Attack: Classical Defense, Big Center Variation",
    fen: "rnbqkb1r/pppp1ppp/4pn2/6B1/3PP3/8/PPP2PPP/RN1QKBNR",
  },
  {
    name: "Trompowsky Attack: Edge Variation",
    fen: "rnbqkb1r/pppppppp/8/8/3Pn2B/8/PPP1PPPP/RN1QKBNR",
  },
  {
    name: "Trompowsky Attack: Edge Variation, Hergert Gambit",
    fen: "rnb1kb1r/pp2pppp/2p5/q2p4/3PP2B/2P5/PP1Q1PPP/R3KBNR",
  },
  {
    name: "Trompowsky Attack: Edge Variation, Hergert Gambit",
    fen: "rn1qkb1r/ppp1pppp/5n2/3p1b2/3PP2B/2N2P2/PPP3PP/R2QKBNR",
  },
  {
    name: "Trompowsky Attack: Poisoned Pawn Variation",
    fen: "rnb1kb1r/pp1ppppp/1q3n2/2pP2B1/8/2N5/PPP1PPPP/R2QKBNR",
  },
  {
    name: "Trompowsky Attack: Raptor Variation",
    fen: "rnbqkb1r/pppppppp/8/6B1/3Pn2P/8/PPP1PPP1/RN1QKBNR",
  },
  {
    name: "Trompowsky Attack: Raptor Variation, Hergert Gambit",
    fen: "rnbqkb1r/pppp1ppp/8/4p1P1/3P4/8/PPP1PPP1/RN1QKBNR",
  },
  {
    name: "Döry Defense",
    fen: "rnbqkb1r/pppppppp/8/8/3Pn3/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Czech-Indian",
    fen: "rnbqkb1r/pp1ppppp/2p2n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Knights Variation",
    fen: "rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Knights Variation, Alburt-Miles Variation",
    fen: "rnbqkb1r/1ppppppp/p4n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: London System",
    fen: "rnbqkb1r/pppp1ppp/4pn2/8/3P1B2/5N2/PPP1PPPP/RN1QKB1R",
  },
  {
    name: "Indian Defense: Polish Variation",
    fen: "rnbqkb1r/p1pppppp/5n2/1p6/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Spielmann-Indian",
    fen: "rnbqkb1r/pp1ppppp/5n2/2p5/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Wade-Tartakower Defense",
    fen: "rnbqkb1r/ppp1pppp/3p1n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Torre Attack, Breyer Variation",
    fen: "rnb1kb1r/pp3ppp/1q2pn2/2pp2B1/3P4/2P1PN2/PP3PPP/RN1QKB1R",
  },
  {
    name: "Queen's Pawn Game: Veresov Attack, Classical Defense",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p2B1/3P4/2N2N2/PPP1PPPP/R2QKB1R",
  },
  {
    name: "Torre Attack: Classical Defense",
    fen: "rnbqkb1r/pppp1ppp/4pn2/6B1/3P4/5N2/PPP1PPPP/RN1QKB1R",
  },
  {
    name: "Torre Attack: Classical Defense, Nimzowitsch Variation",
    fen: "rnbqkb1r/pppp1pp1/4pn1p/6B1/3P4/5N2/PPP1PPPP/RN1QKB1R",
  },
  {
    name: "Torre Attack: Classical Defense, Petrosian Gambit",
    fen: "rnbqkb1r/p2p1ppp/1p2pn2/2pP2B1/8/4PN2/PPP2PPP/RN1QKB1R",
  },
  {
    name: "Torre Attack: Wagner Gambit",
    fen: "rnbqkb1r/pp1p1ppp/4pn2/2p3B1/3PP3/5N2/PPP2PPP/RN1QKB1R",
  },
  {
    name: "Yusupov-Rubinstein System",
    fen: "rnbqkb1r/pppp1ppp/4pn2/8/3P4/4PN2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Schnepper Gambit",
    fen: "rnbqkb1r/p1pp1ppp/1p3n2/4p3/3P4/2P2N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Marienbad System",
    fen: "rn1qkb1r/pb1ppppp/1p3n2/2p5/3P4/5NP1/PPP1PPBP/RNBQK2R",
  },
  {
    name: "Marienbad System: Berg Variation",
    fen: "rn1qkb1r/pb1ppppp/1p3n2/8/2PQ4/5NP1/PP2PPBP/RNB1K2R",
  },
  {
    name: "Pseudo Queen's Indian Defense",
    fen: "rnbqkb1r/p1pppppp/1p3n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "East Indian Defense",
    fen: "rnbqkb1r/pppppp1p/5np1/8/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Colle System, King's Indian Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/3P4/3BPN2/PPP2PPP/RNBQK2R",
  },
  {
    name: "London System",
    fen: "rnbqkb1r/pppppp1p/5np1/8/3P1B2/5N2/PPP1PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Pawn Game: Barry Attack, Grünfeld Variation",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p4/3P1B2/2N1PN2/PPP1BPPP/R2QK2R",
  },
  {
    name: "Queen's Pawn Game: Torre Attack, Grünfeld Variation, Main Line",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p2B1/3P4/4PN2/PPPN1PPP/R2QKB1R",
  },
  {
    name: "Torre Attack: Fianchetto Defense",
    fen: "rnbqkb1r/pppppp1p/5np1/6B1/3P4/5N2/PPP1PPPP/RN1QKB1R",
  },
  {
    name: "Torre Attack: Fianchetto Defense, Euwe Variation",
    fen: "rnbqk2r/pp1pppbp/5np1/2p3B1/3P4/5N2/PPPNPPPP/R2QKB1R",
  },
  {
    name: "Indian Defense: Przepiorka Variation",
    fen: "rnbqkb1r/pppppp1p/5np1/8/3P4/5NP1/PPP1PP1P/RNBQKB1R",
  },
  {
    name: "Indian Defense: Medusa Gambit",
    fen: "rnbqkb1r/pppppp1p/5n2/6p1/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Normal Variation",
    fen: "rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Pyrenees Gambit",
    fen: "rnbqkb1r/p1pppppp/5n2/1p6/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Mexican Defense",
    fen: "r1bqkb1r/pppppppp/2n2n2/8/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Mexican Defense: Horsefly Gambit",
    fen: "r1bqkb1r/pppppppp/5n2/3Pn3/2P2P2/8/PP2P1PP/RNBQKBNR",
  },
  {
    name: "Queen's Indian Accelerated",
    fen: "rnbqkb1r/p1pppppp/1p3n2/8/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Slav Indian",
    fen: "rnbqkb1r/pp1ppppp/2p2n2/8/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Budapest Defense",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Budapest Defense, Fajarowicz Defense, Bonsdorf Variation",
    fen: "rnbqkb1r/p1pp1ppp/1p6/4P3/2P1n3/P7/1P2PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Budapest Defense, Fajarowicz Variation",
    fen: "rnbqkb1r/pppp1ppp/8/4P3/2P1n3/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Budapest Defense, Fajarowicz-Steiner Variation",
    fen: "rnbqkb1r/pppp1ppp/8/4P3/2P1n3/8/PPQ1PPPP/RNB1KBNR",
  },
  {
    name: "Indian Defense: Budapest Defense",
    fen: "rnbqkb1r/pppp1ppp/8/4P3/2P3n1/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Budapest Defense, Adler Variation",
    fen: "rnbqkb1r/pppp1ppp/8/4P3/2P3n1/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Budapest Defense, Alekhine Variation",
    fen: "rnbqkb1r/pppp1ppp/8/4P3/2P1P1n1/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Budapest Defense, Alekhine Variation, Abonyi Variation",
    fen: "rnbqkb1r/pppp1ppp/2n5/8/2P1PP2/8/PP4PP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Budapest Defense, Alekhine Variation, Tartakower Defense",
    fen: "rnbqkb1r/ppp2ppp/3p4/4P3/2P1P1n1/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Budapest Defense, Rubinstein Variation",
    fen: "rnbqkb1r/pppp1ppp/8/4P3/2P2Bn1/8/PP2PPPP/RN1QKBNR",
  },
  {
    name: "Old Indian Defense",
    fen: "rnbqkb1r/ppp1pppp/3p1n2/8/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Old Indian Defense: Aged Gibbon Gambit",
    fen: "rnbqkb1r/ppp1pppp/3p1n2/8/2PP2P1/8/PP2PP1P/RNBQKBNR",
  },
  {
    name: "Old Indian Defense: Czech Variation, with Nc3",
    fen: "rnbqkb1r/pp2pppp/2pp1n2/8/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Old Indian Defense: Czech Variation, with Nf3",
    fen: "rnbqkb1r/pp2pppp/2pp1n2/8/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Old Indian Defense: Janowski Variation",
    fen: "rn1qkb1r/ppp1pppp/3p1n2/5b2/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Old Indian Defense: Janowski Variation, Fianchetto Variation",
    fen: "rn1qkb1r/ppp1pppp/3p1n2/5b2/2PP4/2N3P1/PP2PP1P/R1BQKBNR",
  },
  {
    name: "Old Indian Defense: Janowski Variation, Grinberg Gambit",
    fen: "rn1qkb1r/ppp1pppp/3p1n2/5b2/2PPP3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Old Indian Defense: Janowski Variation, Main Line",
    fen: "rn1qkb1r/ppp1pppp/3p1n2/5b2/2PP4/2N2P2/PP2P1PP/R1BQKBNR",
  },
  {
    name: "Old Indian Defense: Dus-Khotimirsky Variation",
    fen: "r1bqkb1r/pppn1ppp/3p1n2/4p3/2PP4/2NBP3/PP3PPP/R1BQK1NR",
  },
  {
    name: "Old Indian Defense: Tartakower-Indian",
    fen: "rn1qkb1r/ppp1pppp/3p1n2/8/2PP2b1/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Old Indian Defense: Two Knights Variation",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/4p3/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Old Indian Defense: Ukrainian Variation",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/4p3/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Old Indian Defense: Normal Variation",
    fen: "r1bqkb1r/pppn1ppp/3p1n2/4p3/2PPP3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Benoni Defense",
    fen: "rnbqkb1r/pp1ppppp/5n2/2p5/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Czech Benoni Defense",
    fen: "rnbqkb1r/pp1p1ppp/5n2/2pPp3/2P5/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Hromádka System",
    fen: "rnbqkb1r/pp2pppp/3p1n2/2pP4/2P5/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: King's Indian System",
    fen: "rnbqkb1r/pp3p1p/3p1np1/2pPp3/2P1P3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Benoni Defense: Weenink Variation",
    fen: "rnbqkb1r/pp1p1ppp/4pn2/2P5/2P5/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Grünfeld Defense: Three Knights Variation, Burille Variation, Reversed Tarrasch",
    fen: "r1bq1rk1/pp2ppbp/2n2np1/3p4/2PP4/2N2N2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "Vulture Defense",
    fen: "rnbqkb1r/pp1ppppp/8/2pP4/2P1n3/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Benko Gambit",
    fen: "rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Benko Gambit Accepted",
    fen: "rnbqkb1r/3ppppp/p4n2/1PpP4/8/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Benko Gambit Accepted: Dlugy Variation",
    fen: "rnbqkb1r/3ppppp/p4n2/1PpP4/8/5P2/PP2P1PP/RNBQKBNR",
  },
  {
    name: "Benko Gambit Accepted: Modern Variation",
    fen: "rnbqkb1r/3ppppp/p4n2/1PpP4/8/4P3/PP3PPP/RNBQKBNR",
  },
  {
    name: "Benko Gambit Accepted: Pawn Return Variation",
    fen: "rnbqkb1r/3ppppp/pP3n2/2pP4/8/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Benko Gambit Declined: Bishop Attack",
    fen: "rnbqkb1r/p2ppppp/5n2/1ppP2B1/2P5/8/PP2PPPP/RN1QKBNR",
  },
  {
    name: "Benko Gambit Declined: Hjørring Countergambit",
    fen: "rnbqkb1r/p2ppppp/5n2/1ppP4/2P1P3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Benko Gambit Declined: Main Line",
    fen: "rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Benko Gambit Declined: Pseudo-Sämisch",
    fen: "rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/5P2/PP2P1PP/RNBQKBNR",
  },
  {
    name: "Benko Gambit Declined: Quiet Line",
    fen: "rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/8/PP1NPPPP/R1BQKBNR",
  },
  {
    name: "Benko Gambit Declined: Sosonko Variation",
    fen: "rnbqkb1r/p2ppppp/5n2/1ppP4/P1P5/8/1P2PPPP/RNBQKBNR",
  },
  {
    name: "Benko Gambit: Mutkin Countergambit",
    fen: "rnbqkb1r/p2ppppp/5n2/1ppP4/2P3P1/8/PP2PP1P/RNBQKBNR",
  },
  {
    name: "Benko Gambit: Nescafe Frappe Attack",
    fen: "rnbqkb1r/4pppp/3p1n2/1NpP4/1pB1P3/8/PP3PPP/R1BQK1NR",
  },
  {
    name: "Benko Gambit: Zaitsev System",
    fen: "rnbqkb1r/3ppppp/p4n2/1PpP4/8/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Benko Gambit: Zaitsev Variation, Nescafe Frappe Attack",
    fen: "rnbqkb1r/3ppppp/5n2/1NpP4/1p2P3/8/PP3PPP/R1BQKBNR",
  },
  {
    name: "Benko Gambit Accepted: Central Storming Variation",
    fen: "rn1qkb1r/3ppp1p/b4np1/2pP4/5P2/2N5/PP2P1PP/R1BQKBNR",
  },
  {
    name: "Benko Gambit Accepted: Fianchetto Variation",
    fen: "rn1qk2r/4ppbp/b2p1np1/2pP4/8/2N2NP1/PP2PPBP/R1BQK2R",
  },
  {
    name: "Benko Gambit Accepted: Fully Accepted Variation",
    fen: "rnbqkb1r/3ppppp/P4n2/2pP4/8/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Benko Gambit: Fianchetto Variation",
    fen: "rn1qkb1r/4pp1p/b2p1np1/2pP4/8/2N2NP1/PP2PP1P/R1BQKB1R",
  },
  {
    name: "Benko Gambit: Nd2 Variation",
    fen: "rn1qkb1r/4pp1p/b2p1np1/2pP4/8/2N5/PP1NPPPP/R1BQKB1R",
  },
  {
    name: "Benko Gambit",
    fen: "rn1qkb1r/4pp1p/3p1np1/2pP4/4P3/2N3P1/PP3P1P/R1BQ1KNR",
  },
  {
    name: "Benko Gambit Accepted: King Walk Variation",
    fen: "rn1q1rk1/4ppbp/3p1np1/2pP4/4P3/2N2NP1/PP3PKP/R1BQ3R",
  },
  {
    name: "Benko Gambit Accepted: Yugoslav",
    fen: "rn1qkb1r/4pppp/b2p1n2/2pP4/4P3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Benko Gambit Accepted: Yugoslav",
    fen: "rn1qkb1r/4pp1p/3p1np1/2pP4/4P3/2N5/PP2NPPP/R1BQ1K1R",
  },
  {
    name: "Benoni Defense: Modern Variation",
    fen: "rnbqkb1r/pp1p1ppp/4pn2/2pP4/2P5/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Benoni Defense: Modern Variation, Snake Variation",
    fen: "rnbqk2r/pp1p1ppp/3b1n2/2pP4/8/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Benoni Defense",
    fen: "rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Benoni Defense: Fianchetto Variation",
    fen: "rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N2NP1/PP2PP1P/R1BQKB1R",
  },
  {
    name: "Benoni Defense: Knight's Tour Variation",
    fen: "rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N5/PP1NPPPP/R1BQKB1R",
  },
  {
    name: "Benoni Defense: Uhlmann Variation",
    fen: "rnbqkb1r/pp3p1p/3p1np1/2pP2B1/8/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Benoni Defense: Fianchetto Variation",
    fen: "rnbq1rk1/pp3pbp/3p1np1/2pP4/8/2N2NP1/PP2PPBP/R1BQK2R",
  },
  {
    name: "Benoni Defense: Fianchetto Variation, Hastings Defense",
    fen: "r1bq1rk1/pp1n1pbp/3p1np1/2pP4/8/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Benoni Defense: Fianchetto Variation, Hastings Defense, Main Line",
    fen: "r1bqr1k1/1p1n1pbp/p2p1np1/2pP4/P7/2N3P1/1P1NPPBP/R1BQ1RK1",
  },
  {
    name: "Benoni Defense: King's Pawn Line",
    fen: "rnbqkb1r/pp3ppp/3p1n2/2pP4/4P3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Benoni Defense: Mikenas Variation",
    fen: "rnbqk2r/pp3pbp/3p1np1/2pPP3/5P2/2N5/PP4PP/R1BQKBNR",
  },
  {
    name: "Benoni Defense: Pawn Storm Variation",
    fen: "rnbqkb1r/pp3p1p/3p1np1/2pP4/4PP2/2N5/PP4PP/R1BQKBNR",
  },
  {
    name: "Benoni Defense: Taimanov Variation",
    fen: "rnbqk2r/pp3pbp/3p1np1/1BpP4/4PP2/2N5/PP4PP/R1BQK1NR",
  },
  {
    name: "Benoni Defense: Four Pawns Attack",
    fen: "rnbq1rk1/pp3pbp/3p1np1/2pP4/4PP2/2N2N2/PP4PP/R1BQKB1R",
  },
  {
    name: "Benoni Defense: Four Pawns Attack, Main Line",
    fen: "rnbqr1k1/pp3pbp/3p1np1/2pP4/4PP2/2N2N2/PP2B1PP/R1BQK2R",
  },
  {
    name: "Benoni Defense: Classical Variation",
    fen: "rnbqkb1r/pp3p1p/3p1np1/2pP4/4P3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Benoni Defense: Classical Variation, New York Variation",
    fen: "rnbqk2r/pp3pbp/3p1np1/2pP4/4P3/2N2N1P/PP3PP1/R1BQKB1R",
  },
  {
    name: "Benoni Defense: Classical Variation, Traditional Variation",
    fen: "rnbqk2r/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP2BPPP/R1BQK2R",
  },
  {
    name: "Benoni Defense: Classical Variation, Averbakh-Grivas Attack",
    fen: "rnbqk2r/pp3pbp/3p1np1/2pP2B1/4P3/2N2N2/PP3PPP/R2QKB1R",
  },
  {
    name: "Benoni Defense: Classical",
    fen: "rnbq1rk1/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP2BPPP/R1BQK2R",
  },
  {
    name: "Benoni Defense: Classical Variation, Main Line",
    fen: "rnbq1rk1/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "Benoni Defense: Classical Variation, Full Line",
    fen: "rnbq1rk1/1p3pbp/p2p1np1/2pP4/P3P3/2N2N2/1P2BPPP/R1BQ1RK1",
  },
  {
    name: "Benoni Defense: Classical Variation, Argentine Counterattack",
    fen: "rn1q1rk1/1p3pbp/p2p1np1/2pP4/P3P1b1/2N2N2/1P2BPPP/R1BQ1RK1",
  },
  {
    name: "Benoni Defense: Classical Variation, Czerniak Defense",
    fen: "rnbqr1k1/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "Benoni Defense: Classical Variation, Czerniak Defense, Tal Line",
    fen: "rnbqr1k1/pp3pbp/3p1np1/2pP4/4P3/2N5/PP1NBPPP/R1BQ1RK1",
  },
  {
    name: "Benoni Defense: Classical Variation, Czerniak Defense",
    fen: "r1bqr1k1/pp3pbp/n2p1np1/2pP4/4P3/2N5/PP1NBPPP/R1BQ1RK1",
  },
  {
    name: "Benoni Defense: Classical Variation, Czerniak Defense",
    fen: "r1bqr1k1/pp3pbp/n2p1np1/2pP4/4P3/2N2P2/PP1NB1PP/R1BQ1RK1",
  },
  {
    name: "Dutch Defense",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Alapin Variation",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/3P4/3Q4/PPP1PPPP/RNB1KBNR",
  },
  {
    name: "Dutch Defense: Hevendehl Gambit",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/3P2P1/8/PPP1PP1P/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Hopton Attack",
    fen: "rnbqkbnr/ppppp1pp/8/5pB1/3P4/8/PPP1PPPP/RN1QKBNR",
  },
  {
    name: "Dutch Defense: Janzen-Korchnoi Gambit",
    fen: "rnbqkb1r/ppppp1pp/5n2/5p2/3P2P1/7P/PPP1PP2/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Kingfisher Gambit",
    fen: "rnbqkbnr/ppp1p1pp/8/3p1p2/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Dutch Defense: Korchnoi Attack",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/3P4/7P/PPP1PPP1/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Krejcik Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/3P2P1/8/PPP1PP1P/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Krejcik Gambit, Tate Gambit",
    fen: "rnbqkbnr/ppp1p1pp/8/3p4/3PP1p1/2N5/PPP2P1P/R1BQKBNR",
  },
  {
    name: "Dutch Defense: Manhattan Gambit, Anti-Classical Line",
    fen: "rnbqkbnr/pppp2pp/4p3/5p2/3P2P1/3Q4/PPP1PP1P/RNB1KBNR",
  },
  {
    name: "Dutch Defense: Manhattan Gambit, Anti-Leningrad",
    fen: "rnbqkbnr/ppppp2p/6p1/5p2/3P2P1/3Q4/PPP1PP1P/RNB1KBNR",
  },
  {
    name: "Dutch Defense: Manhattan Gambit, Anti-Modern",
    fen: "rnbqkbnr/ppp1p1pp/3p4/5p2/3P2P1/3Q4/PPP1PP1P/RNB1KBNR",
  },
  {
    name: "Dutch Defense: Manhattan Gambit, Anti-Stonewall",
    fen: "rnbqkbnr/ppp1p1pp/8/3p1p2/3P2P1/3Q4/PPP1PP1P/RNB1KBNR",
  },
  {
    name: "Dutch Defense: Omega-Isis Gambit",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Dutch Defense: Raphael Variation",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/3P4/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Dutch Defense: Spielmann Gambit",
    fen: "rnbqkb1r/ppppp1pp/5n2/5p2/3P2P1/2N5/PPP1PP1P/R1BQKBNR",
  },
  {
    name: "Queen's Pawn Game: Veresov Attack, Dutch System",
    fen: "rnbqkbnr/ppp1p1pp/8/3p1p2/3P4/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Dutch Defense: Blackburne Variation",
    fen: "rnbqkb1r/pppp2pp/4pn2/5p2/3P4/6PN/PPP1PPBP/RNBQK2R",
  },
  {
    name: "Dutch Defense: Fianchetto Attack",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/3P4/6P1/PPP1PP1P/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Leningrad Variation, Karlsbad Variation",
    fen: "rnbqk1nr/ppppp1bp/6p1/5p2/3P4/6PN/PPP1PPBP/RNBQK2R",
  },
  {
    name: "Dutch Defense: Leningrad, Basman System",
    fen: "rnbqk2r/pp1pp1bp/2p3pn/5p2/3P4/5NP1/PPP1PPBP/RNBQ1RK1",
  },
  {
    name: "Dutch Defense: Semi-Leningrad Variation",
    fen: "rnbqkb1r/ppppp2p/5np1/5p2/3P4/6P1/PPP1PPBP/RNBQK1NR",
  },
  {
    name: "Dutch Defense: Blackmar's Second Gambit",
    fen: "rnbqkb1r/ppppp1pp/5n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Dutch Defense: Staunton Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Staunton Gambit Accepted",
    fen: "rnbqkbnr/ppppp1pp/8/8/3Pp3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Staunton Gambit, American Attack",
    fen: "rnbqkbnr/ppppp1pp/8/8/3Pp3/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "Dutch Defense: Staunton Gambit, Tartakower Variation",
    fen: "rnbqkb1r/ppppp1pp/5n2/8/3Pp1P1/2N5/PPP2P1P/R1BQKBNR",
  },
  {
    name: "Rat Defense: Balogh Defense",
    fen: "rnbqkbnr/ppp1p1pp/3p4/5p2/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Staunton Gambit",
    fen: "rnbqkb1r/ppppp1pp/5n2/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "Dutch Defense: Staunton Gambit, Alekhine Variation",
    fen: "rnbqkb1r/ppppp2p/5np1/6B1/3Pp2P/2N5/PPP2PP1/R2QKBNR",
  },
  {
    name: "Dutch Defense: Staunton Gambit, Chigorin Variation",
    fen: "rnbqkb1r/pp1pp1pp/2p2n2/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "Dutch Defense: Staunton Gambit, Lasker Variation",
    fen: "rnbqkb1r/ppppp2p/5np1/6B1/3Pp3/2N2P2/PPP3PP/R2QKBNR",
  },
  {
    name: "Dutch Defense: Staunton Gambit, Nimzowitsch Variation",
    fen: "rnbqkb1r/p1ppp1pp/1p3n2/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "Dutch Defense",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Bellon Gambit",
    fen: "rnbqkbnr/pppp2pp/4p3/5p2/2PPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Bladel Variation",
    fen: "rnbqkb1r/ppppp2p/6pn/5p2/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Dutch Defense: Classical Variation",
    fen: "rnbqkbnr/pppp2pp/4p3/5p2/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Krause Variation",
    fen: "r1bqkb1r/ppp1p1pp/2np1n2/5p2/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Dutch Defense: Normal Variation",
    fen: "rnbqkb1r/ppppp1pp/5n2/5p2/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Rubinstein Variation",
    fen: "rnbqkbnr/pppp2pp/4p3/5p2/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Dutch Defense: Queen's Knight Variation",
    fen: "rnbqkb1r/ppppp1pp/5n2/5p2/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Dutch Defense: Fianchetto Variation",
    fen: "rnbqkb1r/ppppp1pp/5n2/5p2/2PP4/6P1/PP2PP1P/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Hort-Antoshin System",
    fen: "rnb1kb1r/ppq1p1pp/2pp1n2/5p2/2PP4/2N3P1/PP2PPBP/R1BQK1NR",
  },
  {
    name: "Dutch Defense: Leningrad Variation",
    fen: "rnbqkb1r/ppppp2p/5np1/5p2/2PP4/6P1/PP2PP1P/RNBQKBNR",
  },
  {
    name: "Dutch Defense: Leningrad Variation",
    fen: "rnbqk2r/ppppp1bp/5np1/5p2/2PP4/5NP1/PP2PPBP/RNBQK2R",
  },
  {
    name: "Dutch Defense: Leningrad Variation, Warsaw Variation",
    fen: "rnbq1rk1/pp2p1bp/2pp1np1/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Dutch Defense: Leningrad Variation, Matulovic Variation",
    fen: "r1bq1rk1/ppp1p1bp/2np1np1/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Dutch Defense: Classical Variation",
    fen: "rnbqkb1r/pppp2pp/4pn2/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR",
  },
  {
    name: "Dutch Defense: Nimzo-Dutch Variation",
    fen: "rnbqk2r/pppp2pp/4pn2/5p2/1bPP4/6P1/PP2PPBP/RNBQK1NR",
  },
  {
    name: "Dutch Defense: Nimzo-Dutch Variation, Alekhine Variation",
    fen: "rnbqk2r/ppppb1pp/4pn2/5p2/2PP4/6P1/PP1BPPBP/RN1QK1NR",
  },
  {
    name: "Dutch Defense: Classical Variation",
    fen: "rnbqk2r/ppppb1pp/4pn2/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR",
  },
  {
    name: "Dutch Defense: Classical Variation, Blackburne Attack",
    fen: "rnbqk2r/ppppb1pp/4pn2/5p2/2PP4/6PN/PP2PPBP/RNBQK2R",
  },
  {
    name: "Dutch Defense: Alekhine Variation",
    fen: "rnbq1rk1/ppppb1pp/4p3/5p2/2PPn3/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Dutch Defense: Classical Variation",
    fen: "rnbq1rk1/ppppb1pp/4pn2/5p2/2PP4/5NP1/PP2PPBP/RNBQK2R",
  },
  {
    name: "Dutch Defense: Stonewall",
    fen: "rnbq1rk1/ppp1b1pp/4pn2/3p1p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Dutch Defense: Stonewall Variation",
    fen: "rnbq1rk1/ppp1b1pp/4pn2/3p1p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Dutch Defense: Classical Variation, Stonewall Variation, Botvinnik Variation",
    fen: "rnbq1rk1/ppp1b1pp/4pn2/3p1p2/2PP4/1P3NP1/P3PPBP/RNBQ1RK1",
  },
  {
    name: "Dutch Defense: Classical Variation, Stonewall Variation",
    fen: "rnbq1rk1/pp2b1pp/2p1pn2/3p1p2/2PP4/BP3NP1/P3PPBP/RN1Q1RK1",
  },
  {
    name: "Dutch Defense: Classical Variation, Stonewall Variation",
    fen: "rnbq1rk1/pp2b1pp/2p1pn2/3p1p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Dutch Defense: Stonewall, Chekhover Variation",
    fen: "rnb1qrk1/pp2b1pp/2p1pn2/3p1pB1/2PP4/2N2NP1/PPQ1PPBP/R4RK1",
  },
  {
    name: "Dutch Defense: Classical Variation",
    fen: "rnbq1rk1/ppp1b1pp/3ppn2/5p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Dutch Defense: Classical Variation, Buenos Aires Variation",
    fen: "rnbq1rk1/1pp1b1pp/3ppn2/p4p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Dutch Defense: Classical Variation, Huisl Variation",
    fen: "rnbq1rk1/ppp1b1pp/3pp3/5p2/2PPn3/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Dutch Defense: Classical Variation, Ilyin-Zhenevsky Variation",
    fen: "rnb1qrk1/ppp1b1pp/3ppn2/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Dutch Defense: Classical Variation, Ilyin-Zhenevsky Variation, Winter Variation",
    fen: "rnb1qrk1/ppp1b1pp/3ppn2/5p2/2PP4/2N2NP1/PP2PPBP/R1BQR1K1",
  },
  {
    name: "Dutch Defense: Classical Variation, Ilyin-Zhenevsky Variation, Alatortsev-Lisitsyn Line",
    fen: "rnb1qrk1/ppp1b1pp/3ppn2/5p2/2PP4/2N2NP1/PPQ1PPBP/R1B2RK1",
  },
  {
    name: "Dutch Defense: Classical Variation, Ilyin-Zhenevsky Variation, Modern Main Line",
    fen: "rnb1qrk1/ppp1b1pp/3ppn2/5p2/2PP4/1PN2NP1/P3PPBP/R1BQ1RK1",
  },
  {
    name: "Barnes Defense",
    fen: "rnbqkbnr/ppppp1pp/5p2/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Borg Defense",
    fen: "rnbqkbnr/pppppp1p/8/6p1/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Borg Defense: Borg Gambit",
    fen: "rnbqk1nr/ppppppbp/8/6p1/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Borg Defense: Troon Gambit",
    fen: "rnbqkbnr/pppppp2/7p/8/3PP1pP/8/PPP2PP1/RNBQKBNR",
  },
  {
    name: "Borg Defense: Zilbermints Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/4p1p1/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Carr Defense",
    fen: "rnbqkbnr/ppppppp1/7p/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Carr Defense: Zilbermints Gambit",
    fen: "rnbqkbnr/pppp1pp1/7p/4p3/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Duras Gambit",
    fen: "rnbqkbnr/ppppp1pp/8/5p2/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Fried Fox Defense",
    fen: "rnbq1bnr/pppppkpp/5p2/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Goldsmith Defense",
    fen: "rnbqkbnr/ppppppp1/8/7p/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Goldsmith Defense: Picklepuss Defense",
    fen: "rnbqkb1r/ppppppp1/5n2/7p/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Guatemala Defense",
    fen: "rn1qkbnr/p1pppppp/bp6/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Hippopotamus Defense",
    fen: "rnbqkb1r/pppppppp/7n/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Hippopotamus Defense",
    fen: "rnbqkb1r/ppppp2p/5ppn/8/2PPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game",
    fen: "rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Lemming Defense",
    fen: "r1bqkbnr/pppppppp/n7/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Lion Defense: Lion's Jaw",
    fen: "rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/5P2/PPP3PP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense",
    fen: "r1bqkbnr/pppppppp/2n5/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense",
    fen: "r1bqkbnr/pppppppp/2n5/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Breyer Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Colorado Countergambit",
    fen: "r1bqkbnr/ppppp1pp/2n5/5p2/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Nimzowitsch Defense: Colorado Countergambit Accepted",
    fen: "r1bqkbnr/ppppp1pp/2n5/5P2/8/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Nimzowitsch Defense: Declined Variation",
    fen: "r1bqkbnr/pppppppp/2n5/8/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Nimzowitsch Defense: El Columpio Defense",
    fen: "r1bqkb1r/pppppppp/2n5/4P3/6n1/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Nimzowitsch Defense: El Columpio Defense, El Columpio Gambit",
    fen: "r1bqkb1r/ppp1pppp/2npP2n/8/3P4/5N1P/PPP2PP1/RNBQKB1R",
  },
  {
    name: "Nimzowitsch Defense: El Columpio Defense, Exchange Variation",
    fen: "r1bqkb1r/ppp1pppp/2nP3n/8/3P4/5N1P/PPP2PP1/RNBQKB1R",
  },
  {
    name: "Nimzowitsch Defense: El Columpio Defense, Pin Variation",
    fen: "r1bqkb1r/ppp1pppp/2np3n/1B2P3/3P4/5N1P/PPP2PP1/RNBQK2R",
  },
  {
    name: "Nimzowitsch Defense: Franco-Nimzowitsch Variation",
    fen: "r1bqkbnr/pppp1ppp/2n1p3/8/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Nimzowitsch Defense: French Connection",
    fen: "r1bqkbnr/pppp1ppp/2n1p3/8/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Hornung Gambit",
    fen: "r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/4B3/PPP2PPP/RN1QKBNR",
  },
  {
    name: "Nimzowitsch Defense: Kennedy Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Kennedy Variation, Bielefelder Gambit",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b1P3/4P3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Kennedy Variation, Hammer Gambit",
    fen: "r1bqkbnr/pppp2pp/2n2p2/4P3/4P3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Kennedy Variation, Herford Gambit",
    fen: "r1b1kbnr/pppp1ppp/2n5/4P3/4P2q/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Kennedy Variation, Keres Attack",
    fen: "r1bqkbnr/pppp1ppp/8/4n3/4P3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Kennedy Variation, Linksspringer Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/3Pp3/4P3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Kennedy Variation, Main Line",
    fen: "r1bqkbnr/pppp1ppp/6n1/8/4PP2/8/PPP3PP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Kennedy Variation, Paulsen Attack",
    fen: "r1bqkbnr/pppp1ppp/8/4n3/4P3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Nimzowitsch Defense: Kennedy Variation, Riemann Defense",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/4PP2/8/PPP3PP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Kennedy Variation, de Smet Gambit",
    fen: "r1bqkbnr/ppp2ppp/2np4/4P3/4P3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Mikenas Variation",
    fen: "r1bqkbnr/ppp1pppp/2np4/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Neo-Mongoloid Defense",
    fen: "r1bqkbnr/ppppp1pp/2n2p2/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Pirc Connection",
    fen: "r1bqkbnr/pppppp1p/2n3p1/8/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Pseudo-Spanish Variation",
    fen: "r1bqkbnr/pppppppp/2n5/1B6/4P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation",
    fen: "r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Aachen Gambit",
    fen: "r1bqkbnr/ppp1pppp/8/3P4/1n1P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Advance Variation",
    fen: "r1bqkbnr/ppp1pppp/2n5/3pP3/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Bogoljubov Variation",
    fen: "r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Bogoljubov Variation",
    fen: "r1bqkbnr/ppp1pppp/2n5/8/3Pp3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Bogoljubov Variation, Brandics Gambit",
    fen: "r1bqkbnr/1pp1pppp/p1n5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Bogoljubov Variation, Erben Gambit",
    fen: "r1bqkbnr/ppp1pp1p/2n3p1/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Bogoljubov Variation, Heinola-Deppe Gambit",
    fen: "r1bqkbnr/ppp2ppp/2n5/3pp3/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Bogoljubov Variation, Nimzowitsch Gambit",
    fen: "r1bqkbnr/ppp1pppp/8/3Pn3/4p3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Bogoljubov Variation, Richter Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/3P4/4p3/2N2P2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Bogoljubov Variation, Vehre Variation",
    fen: "r1bqkb1r/ppp1pppp/2n2n2/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Exchange Variation",
    fen: "r1b1kbnr/ppp1pppp/2n5/3q4/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Scandinavian Variation, Exchange Variation, Marshall Gambit",
    fen: "r1b1kbnr/ppp1pppp/2n5/3q4/3P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Wheeler Gambit",
    fen: "r1bqkbnr/pppppppp/2n5/8/1P2P3/8/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "Nimzowitsch Defense: Williams Variation",
    fen: "r1bqkbnr/ppp1pppp/2np4/8/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Nimzowitsch Defense: Woodchuck Variation",
    fen: "r1bqkbnr/1ppppppp/p1n5/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Owen Defense",
    fen: "rnbqkbnr/p1pppppp/1p6/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Owen Defense: Hekili-Loa Gambit",
    fen: "r1bqkbnr/p2ppppp/1pn5/2P5/4P3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Owen Defense: Matovinsky Gambit",
    fen: "rn1qkbnr/p1ppp2p/1p4p1/5P1Q/3P4/3B4/PPP2PbP/RNB1K1NR",
  },
  {
    name: "Owen Defense: Naselwaus Gambit",
    fen: "rn1qkbnr/pbpppppp/1p6/6B1/3PP3/8/PPP2PPP/RN1QKBNR",
  },
  {
    name: "Owen Defense: Smith Gambit",
    fen: "rn1qkbnr/pbpppppp/1p6/8/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Owen Defense: Unicorn Variation",
    fen: "rn1qkbnr/pbppp1pp/1p3p2/8/2PPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Owen Defense: Wind Gambit",
    fen: "rn1qkbnr/pbpp1ppp/1p6/4p3/3PP3/5P2/PPP3PP/RNBQKBNR",
  },
  {
    name: "Pirc Defense",
    fen: "rnbqkbnr/ppp1pppp/3p4/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Pirc Defense",
    fen: "rnbqkbnr/ppp1pppp/3p4/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Pirc Defense",
    fen: "rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Pirc Defense: Roscher Gambit",
    fen: "rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Rat Defense: Antal Defense",
    fen: "r1bqkbnr/pppnpppp/3p4/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Rat Defense: Fuller Gambit",
    fen: "rnbqkb1r/ppp1pppp/5n2/3P4/5P2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "Rat Defense: Harmonist",
    fen: "rnbqkbnr/ppp1pppp/3p4/8/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "Rat Defense: Petruccioli Attack",
    fen: "rnbqkbnr/ppp1pppp/3p4/8/4P2P/8/PPPP1PP1/RNBQKBNR",
  },
  {
    name: "Rat Defense: Spike Attack",
    fen: "rnbqkbnr/ppp1pppp/3p4/8/4P1P1/8/PPPP1P1P/RNBQKBNR",
  },
  {
    name: "St. George Defense",
    fen: "rnbqkbnr/1ppppppp/p7/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "St. George Defense: Polish Variation",
    fen: "rn1qkbnr/1bpp1ppp/p3p3/1p6/3PP3/3B1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "St. George Defense: San Jorge Variation",
    fen: "rn1qk1nr/1bp1ppbp/p2p2p1/1p6/3PP3/2PB1N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "St. George Defense: Zilbermints Gambit",
    fen: "rnbqkbnr/1ppp1ppp/p7/4p3/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Van Geet Opening: Berlin Gambit",
    fen: "r1bqkbnr/ppp1pppp/2n5/3P4/4p3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Ware Defense",
    fen: "rnbqkbnr/1ppppppp/8/p7/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Ware Defense: Snagglepuss Defense",
    fen: "r1bqkbnr/1ppppppp/2n5/p7/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/4P3/1P6/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Anderssen Counterattack",
    fen: "rnb1kbnr/ppp2ppp/8/q3p3/3P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Scandinavian Defense: Anderssen Counterattack, Collijn Variation",
    fen: "rn2kbnr/ppp2ppp/8/q3p3/3P2b1/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Scandinavian Defense: Anderssen Counterattack, Goteborg System",
    fen: "rnb1kbnr/ppp2ppp/8/q3p3/3P4/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Scandinavian Defense: Anderssen Counterattack, Orthodox Attack",
    fen: "r1b1k1nr/ppp2ppp/2n5/q3P3/1b6/2N2N2/PPPB1PPP/R2QKB1R",
  },
  {
    name: "Scandinavian Defense: Blackburne Gambit",
    fen: "r1bqkbnr/pp2pppp/2n5/8/8/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Blackburne-Kloosterboer Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/3P4/8/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Boehnke Gambit",
    fen: "rn1qkbnr/ppp2ppp/4b3/8/8/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Bronstein Variation",
    fen: "rnb1kb1r/1pp1pppp/p2q1n2/8/3P4/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Scandinavian Defense: Classical Variation",
    fen: "rn2kb1r/ppp1pppp/5n2/q4b2/3P4/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Scandinavian Defense: Grünfeld Variation",
    fen: "rn2kb1r/pp2pppp/2p2n2/q3Nb2/3P2P1/2N5/PPP2P1P/R1BQKB1R",
  },
  {
    name: "Scandinavian Defense: Gubinsky-Melts Defense",
    fen: "rnb1kbnr/ppp1pppp/3q4/8/8/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Scandinavian Defense: Icelandic-Palme Gambit",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3P4/2P5/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Kiel Variation",
    fen: "rnbqkb1r/ppp1pppp/8/8/1nPP4/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Kloosterboer Gambit",
    fen: "rnbqkbnr/pp3ppp/2P5/4p3/8/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Kádas Gambit",
    fen: "rnbqkb1r/pp3ppp/2P2n2/4p3/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Lasker Variation",
    fen: "rn2kb1r/ppp1pppp/5n2/q7/3P2b1/2N2N1P/PPP2PP1/R1BQKB1R",
  },
  {
    name: "Scandinavian Defense: Main Line",
    fen: "rnb1kbnr/ppp1pppp/8/q7/8/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Scandinavian Defense: Main Line, Leonhardt Gambit",
    fen: "rnb1kbnr/ppp1pppp/8/q7/1P6/2N5/P1PP1PPP/R1BQKBNR",
  },
  {
    name: "Scandinavian Defense: Main Line, Mieses Variation",
    fen: "rnb1kb1r/ppp1pppp/5n2/q7/3P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Scandinavian Defense: Marshall Variation",
    fen: "rnbqkb1r/ppp1pppp/8/3n4/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Mieses-Kotroc Variation",
    fen: "rnb1kbnr/ppp1pppp/8/3q4/8/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Modern Variation",
    fen: "rnbqkb1r/ppp1pppp/5n2/3P4/8/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Modern Variation",
    fen: "rnbqkb1r/ppp1pppp/5n2/3P4/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Modern Variation, Gipslis Variation",
    fen: "rn1qkb1r/ppp1pppp/8/3n4/3P2b1/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scandinavian Defense: Modern Variation, Wing Gambit",
    fen: "rnbqkb1r/p1p1pp1p/5np1/1p1P4/2PP4/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Panov Transfer",
    fen: "rnbqkb1r/pp2pppp/2p2n2/3P4/2P5/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Portuguese Gambit",
    fen: "rn1qkb1r/ppp1pppp/5n2/3P4/3P2b1/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Portuguese Gambit, Banker Variation",
    fen: "rn1qkb1r/ppp1pppp/5n2/3P1b2/2PP4/5P2/PP4PP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Portuguese Gambit, Classical Variation",
    fen: "rn1qkb1r/ppp1pppp/5n2/3P4/3P2b1/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scandinavian Defense: Portuguese Gambit, Correspondence Refutation",
    fen: "rn1qkb1r/ppp1pppp/5n2/3P1b2/3P2P1/5P2/PPP4P/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Portuguese Gambit, Elbow Variation",
    fen: "rn1qkb1r/pp2pppp/2p2n2/1B1P4/3P2b1/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Scandinavian Defense: Portuguese Gambit, Jadoul Variation",
    fen: "r2qkb1r/pppnpppp/5n2/1B1P1b2/2PP4/5P2/PP4PP/RNBQK1NR",
  },
  {
    name: "Scandinavian Defense: Portuguese Gambit, Lusophobe Variation",
    fen: "r2qkb1r/pppnpppp/5n2/3P4/3P2b1/8/PPP1BPPP/RNBQK1NR",
  },
  {
    name: "Scandinavian Defense: Portuguese Gambit, Melbourne Shuffle Variation",
    fen: "r2qkb1r/pppnpppp/5n2/1B1P1b2/3P4/2N2P2/PPP3PP/R1BQK1NR",
  },
  {
    name: "Scandinavian Defense: Portuguese Gambit, Wuss Variation",
    fen: "rn1qkb1r/ppp1pppp/5n2/3P4/3P2b1/8/PPP1BPPP/RNBQK1NR",
  },
  {
    name: "Scandinavian Defense: Richter Variation",
    fen: "rnbqkb1r/ppp1pp1p/6p1/3n4/3P4/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scandinavian Defense: Richter Variation",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3P4/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Scandinavian Defense: Schiller-Pytel Variation",
    fen: "rnb1kbnr/pp2pppp/2pq4/8/3P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Scandinavian Defense: Schiller-Pytel Variation, Modern Variation",
    fen: "rn2kb1r/pp2pppp/2p2n2/5b2/1qBP1B2/2N5/PPP1NPPP/R2QK2R",
  },
  {
    name: "Scandinavian Defense: Valencian Variation",
    fen: "rnbqkbnr/ppp1pppp/8/8/8/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Scandinavian Defense: Valencian Variation, Ilundain Variation",
    fen: "rnbqkb1r/pp2pppp/2p2n2/8/3P4/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Scandinavian Defense: Valencian Variation, Main Line",
    fen: "rn1qkb1r/ppp1pppp/5n2/8/3P2b1/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Scandinavian Defense: Zilbermints Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/1P2P3/8/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "Van Geet Opening: Grünfeld Defense",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/4N3/8/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Alekhine Defense",
    fen: "rnbqkb1r/pppppppp/5n2/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Brooklyn Variation",
    fen: "rnbqkbnr/pppppppp/8/4P3/8/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Brooklyn Variation, Everglades Variation",
    fen: "rnbqkbnr/ppppp1pp/8/4Pp2/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Buckley Attack",
    fen: "rnbqkb1r/pppppppp/8/3nP3/8/N7/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Alekhine Defense: Hunt Variation, Lasker Simul Gambit",
    fen: "rnbqkb1r/pppp1ppp/4p3/2PnP3/2B5/2N5/PP1P1PPP/R1BQK1NR",
  },
  {
    name: "Alekhine Defense: Hunt Variation, Matsukevich Gambit",
    fen: "rnbqkb1r/ppp1pppp/3p4/2P1P1B1/8/2P5/PP3PPP/R2QKBNR",
  },
  {
    name: "Alekhine Defense: Hunt Variation, Mikenas Gambit",
    fen: "rnbqkb1r/ppp2ppp/3p4/2PBP3/8/8/PP1P1PPP/R1BQK1NR",
  },
  {
    name: "Alekhine Defense: Kmoch Variation",
    fen: "rnbqkb1r/pp1ppppp/1n6/2p1P3/8/1B1P4/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Alekhine Defense: Krejcik Variation",
    fen: "rnbqkb1r/pppppppp/5n2/8/2B1P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Alekhine Defense: Krejcik Variation, Krejcik Gambit",
    fen: "rnbqkb1r/pppppBpp/8/8/4n3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Alekhine Defense: Maróczy Variation",
    fen: "rnbqkb1r/pppppppp/5n2/8/4P3/3P4/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Mokele Mbembe",
    fen: "rnbqkb1r/pppppppp/8/4P3/4n3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Mokele Mbembe, Modern Line",
    fen: "rnbqkb1r/ppppp1pp/5p2/4P3/3Pn3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Mokele Mbembe, Vavra Defense",
    fen: "rnbqkb1r/pppp1ppp/4p3/4P3/3Pn3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Normal Variation",
    fen: "rnbqkb1r/pppppppp/8/3nP3/8/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Scandinavian Variation",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Alekhine Defense: Scandinavian Variation, Geschev Gambit",
    fen: "rnbqkb1r/pp2pppp/2p2n2/3P4/8/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Alekhine Defense: Scandinavian Variation, Myers Gambit",
    fen: "rnbqkb1r/ppp1pppp/5n2/6B1/4p3/2NP4/PPP2PPP/R2QKBNR",
  },
  {
    name: "Alekhine Defense: Spielmann Gambit",
    fen: "rnbqkb1r/pppnpppp/4P3/3p4/8/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Alekhine Defense: Steiner Variation",
    fen: "rnbqkb1r/pppppppp/1n6/4P3/2P5/1P6/P2P1PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Sämisch Attack",
    fen: "rnbqkb1r/pppppppp/8/3nP3/8/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Alekhine Defense: The Squirrel",
    fen: "rnbqkb1r/pppppppp/8/4P3/2P2n2/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Two Pawns Attack",
    fen: "rnbqkb1r/pppppppp/8/3nP3/2P5/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Two Pawns Attack, Lasker Variation",
    fen: "rnbqkb1r/pppppppp/1n6/2P1P3/8/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Two Pawns Attack, Mikenas Variation",
    fen: "rnbqkb1r/ppp2ppp/3pp3/2PnP3/2B5/2N5/PP1P1PPP/R1BQK1NR",
  },
  {
    name: "Alekhine Defense: Welling Variation",
    fen: "rnbqkb1r/pppppppp/8/3nP3/8/1P6/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense",
    fen: "rnbqkb1r/pppppppp/8/3nP3/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense",
    fen: "rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense",
    fen: "rnbqkb1r/ppp1pppp/3p4/3nP3/2PP4/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Balogh Variation",
    fen: "rnbqkb1r/ppp1pppp/3p4/3nP3/2BP4/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Alekhine Defense: Exchange Variation",
    fen: "rnbqkb1r/ppp1pppp/1n1P4/8/2PP4/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Exchange Variation, Karpov Variation",
    fen: "r2q1rk1/pp2ppbp/1nnp2p1/5b2/2PP1B2/2N2N1P/PP2BPP1/R2Q1RK1",
  },
  {
    name: "Alekhine Defense: Exchange Variation, Voronezh Variation",
    fen: "rnbq1rk1/pp2ppbp/1n1p2p1/8/2PP4/1PN1B3/P4PPP/2RQKBNR",
  },
  {
    name: "Alekhine Defense: Four Pawns Attack",
    fen: "rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP1P2/8/PP4PP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Four Pawns Attack, Cambridge Gambit",
    fen: "rnbqkb1r/ppp1pp1p/1n1p4/4P1p1/2PP1P2/8/PP4PP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Four Pawns Attack, Fianchetto Variation",
    fen: "rnbqkb1r/ppp1pp1p/1n1p2p1/4P3/2PP1P2/8/PP4PP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Four Pawns Attack, Ilyin-Zhenevsky Variation",
    fen: "r2qkb1r/ppp1p1pp/1nn1p3/2P5/3P2b1/5N2/PP4PP/RNBQKB1R",
  },
  {
    name: "Alekhine Defense: Four Pawns Attack, Korchnoi Variation",
    fen: "rn1q1rk1/ppp1b1pp/1n2pp2/4Pb2/2PP4/2N2N2/PP2B1PP/R1BQ1RK1",
  },
  {
    name: "Alekhine Defense: Four Pawns Attack, Main Line",
    fen: "r1bqkb1r/ppp1pppp/1nn5/4P3/2PP4/4B3/PP4PP/RN1QKBNR",
  },
  {
    name: "Alekhine Defense: Four Pawns Attack, Tartakower Variation",
    fen: "2kr3r/pppqbppp/1nn1p3/4Pb2/2PP4/2N1BN2/PP2B1PP/R2Q1RK1",
  },
  {
    name: "Alekhine Defense: Four Pawns Attack, Trifunovic Variation",
    fen: "rn1qkb1r/ppp1pppp/1n1p4/4Pb2/2PP1P2/8/PP4PP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Hunt Variation",
    fen: "rnbqkb1r/ppp1pppp/1n1p4/2P1P3/3P4/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Modern Variation, Alekhine Gambit",
    fen: "rn1qkb1r/ppp1pppp/1n1p4/4P3/2PP2b1/5N2/PP2BPPP/RNBQK2R",
  },
  {
    name: "Alekhine Defense: O'Sullivan Gambit",
    fen: "rnbqkb1r/p1pppppp/8/1p1nP3/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Alekhine Defense: Modern Variation",
    fen: "rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Alekhine Defense: Modern Variation, Alburt Variation",
    fen: "rnbqkb1r/ppp1pp1p/3p2p1/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Alekhine Defense: Modern Variation, Keres Variation",
    fen: "rnbqk2r/ppp1ppbp/1n1p2p1/4P3/P2P4/1B3N2/1PP2PPP/RNBQK2R",
  },
  {
    name: "Alekhine Defense: Modern Variation, Larsen Variation",
    fen: "rnbqkb1r/ppp1pppp/8/3np3/3P4/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Alekhine Defense: Modern Variation, Larsen-Haakert Variation",
    fen: "r1bqkb1r/ppp1pppp/2np4/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Alekhine Defense: Modern Variation, Schmid Variation",
    fen: "rnbqkb1r/ppp1pppp/1n1p4/4P3/3P4/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Alekhine Defense: Modern Variation, Alekhine Variation",
    fen: "rn1qkb1r/ppp1pppp/3p4/3nP3/2PP2b1/5N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Alekhine Defense: Modern Variation, Flohr Variation",
    fen: "rn1qkb1r/pp2pppp/2pp4/3nP3/3P2b1/5N2/PPP1BPPP/RNBQK2R",
  },
  {
    name: "Alekhine Defense: Modern Variation, Main Line",
    fen: "rn1qkb1r/ppp1pppp/3p4/3nP3/3P2b1/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Alekhine Defense: Modern Variation, Panov Variation",
    fen: "rn1qkb1r/ppp1pppp/3p4/3nP3/3P2b1/5N1P/PPP2PP1/RNBQKB1R",
  },
  {
    name: "Alekhine Defense: Modern Variation, Vitolins Attack",
    fen: "rn1qkb1r/ppp1pppp/1n1p4/3PP3/2P3b1/5N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Modern Defense",
    fen: "rnbqkbnr/pppppp1p/6p1/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Modern Defense",
    fen: "rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Modern Defense: Anti-Modern",
    fen: "rnbqk1nr/pp2ppbp/2pp2p1/8/2BPP3/2N5/PPP1QPPP/R1B1K1NR",
  },
  {
    name: "Modern Defense: Bishop Attack",
    fen: "rnbqk1nr/ppppppbp/6p1/8/2BPP3/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Modern Defense: Bishop Attack, Bücker Gambit",
    fen: "rnbqk1nr/p1ppppbp/6p1/1p6/2BPP3/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Modern Defense: Bishop Attack, Monkey's Bum",
    fen: "rnbqk1nr/pppp1p1p/4p1p1/8/2BbP3/5Q2/PPP2PPP/RNB1K1NR",
  },
  {
    name: "Modern Defense: Dunworthy Variation",
    fen: "rnbqk1nr/pp2pp1p/2P3p1/8/2Pb4/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Modern Defense: Fianchetto Gambit",
    fen: "rnbqkbnr/ppppp2p/6p1/5p2/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Modern Defense: Gurgenidze Defense",
    fen: "rnbqk1nr/pp2ppb1/2p3p1/3pP2p/3P1P2/2N5/PPP3PP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Lizard Defense, Mittenberger Gambit",
    fen: "rnbqk1nr/ppp1ppbp/6p1/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Masur Gambit",
    fen: "rnbq1rk1/ppppp2p/6pb/5P2/3P4/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "Modern Defense: Modern Pterodactyl",
    fen: "rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Mongredien Defense, with Nc3",
    fen: "rnbqk1nr/p1ppppbp/1p4p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Mongredien Defense, with Nf3",
    fen: "rnbqk1nr/p1ppppbp/1p4p1/8/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Modern Defense: Norwegian Defense",
    fen: "rnbqkb1r/pppppp1p/5np1/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Modern Defense: Norwegian Defense, Norwegian Gambit",
    fen: "rnbqkb1r/ppp1pp1p/3p2p1/4P2n/3P4/8/PPP1BPPP/RNBQK1NR",
  },
  {
    name: "Modern Defense: Pseudo-Austrian Attack",
    fen: "rnbqk1nr/ppp1ppbp/3p2p1/8/3PPP2/2N5/PPP3PP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Semi-Averbakh Variation, Pterodactyl Variation Declined",
    fen: "rnb1k1nr/pp2ppbp/3p2p1/q1p5/2PPP3/5N2/PP2BPPP/RNBQK2R",
  },
  {
    name: "Modern Defense: Standard Defense",
    fen: "rnbqk1nr/ppp1ppbp/3p2p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Standard Line",
    fen: "rnbqk1nr/ppppppbp/6p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Modern Defense: Three Pawns Attack",
    fen: "rnbqk1nr/ppppppbp/6p1/8/3PPP2/8/PPP3PP/RNBQKBNR",
  },
  {
    name: "Modern Defense: Two Knights Variation",
    fen: "rnbqk1nr/ppp1ppbp/3p2p1/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Modern Defense: Two Knights Variation, Suttles Variation",
    fen: "rnbqk1nr/pp2ppbp/2pp2p1/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Modern Defense: Two Knights Variation, Suttles Variation, Tal Gambit",
    fen: "rnb1k1nr/pp2ppbp/2pp2p1/6B1/3PP3/2N2N2/PqPQ1PPP/R3KB1R",
  },
  {
    name: "Modern Defense: Westermann Gambit",
    fen: "rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPPB1PPP/RN1QKBNR",
  },
  {
    name: "Modern Defense: Wind Gambit",
    fen: "rnbqk1nr/ppppppbp/6p1/8/3PP3/3B4/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Norwegian Defense",
    fen: "rnbqkb1r/ppppppnp/6p1/4P3/3P2P1/8/PPP2P1P/RNBQKBNR",
  },
  {
    name: "Pterodactyl Defense: Austrian, Austriadactylus Western",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/3PPP2/5N2/PPP3PP/RNBQKB1R",
  },
  {
    name: "Pterodactyl Defense: Austrian, Grand Prix Pterodactyl",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/4PP2/2N2N2/PPPP2PP/R1BQKB1R",
  },
  {
    name: "Pterodactyl Defense: Austrian, Pteranodon",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/3PPP2/2P5/PP4PP/RNBQKBNR",
  },
  {
    name: "Pterodactyl Defense: Central, Anhanguera",
    fen: "rnb1k1nr/pp2ppbp/3p2p1/q1p5/2PPP3/2N1B3/PP3PPP/R2QKBNR",
  },
  {
    name: "Pterodactyl Defense: Central, Benoni Quetzalcoatlus",
    fen: "rnb1k1nr/pp2ppbp/3p2p1/q1pP4/2P1P3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Central, Quetzalcoatlus Gambit",
    fen: "rnb1k1nr/pp2ppbp/3p2p1/q1P5/2P1P3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Eastern, Anhanguera",
    fen: "rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/2N1B3/PPP2PPP/R2QKBNR",
  },
  {
    name: "Pterodactyl Defense: Eastern, Benoni",
    fen: "rnbqk1nr/pp1pppbp/6p1/2pP4/4P3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Eastern, Benoni Pteranodon",
    fen: "rnb1k1nr/pp1ppp1p/6p1/q1pP4/4P3/2P5/P1P2PPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Eastern, Benoni Pterodactyl",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1pP4/4P3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Eastern, Pteranodon",
    fen: "rnb1k1nr/pp1ppp1p/6p1/q1P5/4P3/2P5/P1P2PPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Eastern, Pterodactyl",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1P5/4P3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Eastern, Rhamphorhynchus",
    fen: "rnbqk1nr/pp1pppbp/6p1/2P5/4P3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Pterodactyl Defense: Fianchetto, King Pterodactyl",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/5NP1/PPP2P1P/RNBQKB1R",
  },
  {
    name: "Pterodactyl Defense: Fianchetto, Rhamphorhynchus",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1P5/4P3/6P1/PPP2P1P/RNBQKBNR",
  },
  {
    name: "Pterodactyl Defense: Sicilian, Quetzalcoatlus",
    fen: "rnb1k1nr/pp2ppbp/3p2p1/q1p5/3PP3/2N2N2/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Pterodactyl Defense: Sicilian, Siroccopteryx",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/2BPP3/2N2N2/PPP2PPP/R1BQK2R",
  },
  {
    name: "Pterodactyl Defense: Western, Anhanguera",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/4BN2/PPP2PPP/RN1QKB1R",
  },
  {
    name: "Pterodactyl Defense: Western, Siroccopteryx",
    fen: "rnb1k1nr/pp1pppbp/6p1/q7/2BNP3/8/PPP2PPP/RNBQK2R",
  },
  {
    name: "Rat Defense: Accelerated Gurgenidze",
    fen: "rnbqkbnr/pp2pp1p/2pp2p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Czech Defense",
    fen: "rnbqkb1r/pp2pppp/2pp1n2/8/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "King's Pawn Game: Maróczy Defense",
    fen: "rnbqkbnr/ppp2ppp/3p4/4p3/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Lion Defense: Anti-Philidor",
    fen: "r1bqkb1r/pppnpppp/3p1n2/8/3PPP2/2N5/PPP3PP/R1BQKBNR",
  },
  {
    name: "Lion Defense: Anti-Philidor, Lion's Cave",
    fen: "r1bqkb1r/pppn1ppp/3p1n2/4p3/3PPP2/2N5/PPP3PP/R1BQKBNR",
  },
  {
    name: "Lion Defense: Anti-Philidor, Lion's Cave, Lion Claw Gambit",
    fen: "r1bqkb1r/pp1n1ppp/2p2n2/3p4/2BQPP2/2N2N2/PPP3PP/R1B1K2R",
  },
  {
    name: "Lion Defense: Bayonet Attack",
    fen: "r1bqkb1r/pppnpppp/3p1n2/8/3PP1P1/2N5/PPP2P1P/R1BQKBNR",
  },
  {
    name: "Modern Defense: Geller's System",
    fen: "rnbqk1nr/ppp1ppbp/3p2p1/8/3PP3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Pirc Defense",
    fen: "rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Pirc Defense: 150 Attack",
    fen: "rnbqkb1r/pp2pp1p/2pp1np1/8/3PP3/2N1B3/PPPQ1PPP/R3KBNR",
  },
  {
    name: "Pirc Defense: 150 Attack, Inner Doll Defense",
    fen: "rn1qkb1r/pp2pp1p/2pp1np1/8/3PP1b1/2N1B3/PPPQ1PPP/R3KBNR",
  },
  {
    name: "Pirc Defense: 150 Attack, Sveshnikov-Jansa Attack",
    fen: "rnbqkb1r/pp2pp1p/2pp1np1/8/3PP3/2N1B2P/PPP2PP1/R2QKBNR",
  },
  {
    name: "Pirc Defense: Bayonet Attack",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/3PP2P/2N5/PPP1BPP1/R1BQK1NR",
  },
  {
    name: "Pirc Defense: Byrne Variation",
    fen: "rnbqkb1r/ppp1pp1p/3p1np1/6B1/3PP3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "Pirc Defense: Chinese Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/3PP1P1/2N5/PPP1BP1P/R1BQK1NR",
  },
  {
    name: "Pirc Defense: Kholmov System",
    fen: "rnbqkb1r/ppp1pp1p/3p1np1/8/2BPP3/2N5/PPP2PPP/R1BQK1NR",
  },
  {
    name: "Pirc Defense: Sveshnikov System",
    fen: "rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N3P1/PPP2P1P/R1BQKBNR",
  },
  {
    name: "Pirc Defense: Classical Variation",
    fen: "rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Pirc Defense: Classical Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Pirc Defense: Classical Variation, Quiet System",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/3PP3/2N2N2/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Pirc Defense: Classical Variation, Quiet System, Chigorin Line",
    fen: "r1bq1rk1/ppp1ppbp/2np1np1/8/3PP3/2N2N2/PPP1BPPP/R1BQ1RK1",
  },
  {
    name: "Pirc Defense: Classical Variation, Quiet System, Czech Defense",
    fen: "rnbq1rk1/pp2ppbp/2pp1np1/8/3PP3/2N2N2/PPP1BPPP/R1BQ1RK1",
  },
  {
    name: "Pirc Defense: Classical Variation, Quiet System, Parma Defense",
    fen: "rn1q1rk1/ppp1ppbp/3p1np1/8/3PP1b1/2N2N2/PPP1BPPP/R1BQ1RK1",
  },
  {
    name: "Pirc Defense: Classical Variation, Schlechter Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/3PP3/2N2N1P/PPP2PP1/R1BQKB1R",
  },
  {
    name: "Pirc Defense: Austrian Attack",
    fen: "rnbqkb1r/ppp1pp1p/3p1np1/8/3PPP2/2N5/PPP3PP/R1BQKBNR",
  },
  {
    name: "Pirc Defense: Austrian Attack",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/3PPP2/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Pirc Defense: Austrian Attack, Dragon Formation",
    fen: "rnbqk2r/pp2ppbp/3p1np1/2p5/3PPP2/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Pirc Defense: Austrian Attack, Kurajica Variation",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/3PPP2/2N1BN2/PPP3PP/R2QKB1R",
  },
  {
    name: "Pirc Defense: Austrian Attack, Ljubojevic Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2BPPP2/2N5/PPP3PP/R1BQK1NR",
  },
  {
    name: "Pirc Defense: Austrian Attack, Unzicker Attack",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/4P3/3P1P2/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Pirc Defense: Austrian Attack, Unzicker Attack, Bronstein Variation",
    fen: "rnbq1rk1/pppnppbp/3p2p1/4P3/3P1P1P/2N2N2/PPP3P1/R1BQKB1R",
  },
  {
    name: "Pirc Defense: Austrian Attack, Weiss Variation",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/3PPP2/2NB1N2/PPP3PP/R1BQK2R",
  },
  {
    name: "Caro-Kann Defense",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Accelerated Panov Attack",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/2P1P3/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Accelerated Panov Attack",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/2P1P3/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Accelerated Panov Attack, Modern Variation",
    fen: "rnbqkb1r/pp2pppp/5n2/3P4/8/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Accelerated Panov Attack, Open Variation",
    fen: "rnbqkbnr/pp1p1ppp/2p5/4p3/2P1P3/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Accelerated Panov Attack, Pseudo-Scandinavian",
    fen: "rnb1kbnr/pp2pppp/2p5/3q4/2P5/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Accelerated Panov Attack, Van Weersel Attack",
    fen: "rnbqkbnr/pp2pppp/8/3p4/4P3/1Q6/PP1P1PPP/RNB1KBNR",
  },
  {
    name: "Caro-Kann Defense: Apocalypse Attack",
    fen: "rnbqkbnr/pp2pppp/8/3pN3/8/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Caro-Kann Defense: Breyer Variation",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/4P3/3P4/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Breyer Variation, Stein Attack",
    fen: "rnbq1rk1/pp2npbp/2p3p1/3pp3/1P2P3/3P1NP1/P1PN1PBP/R1BQ1RK1",
  },
  {
    name: "Caro-Kann Defense: Euwe Attack",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/4P3/1P6/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Goldman Variation",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/4P3/2N2Q2/PPPP1PPP/R1B1KBNR",
  },
  {
    name: "Caro-Kann Defense: Hector Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/6N1/4p3/2N5/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense: Hillbilly Attack",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/2B1P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Caro-Kann Defense: Hillbilly Attack, Schaeffer Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/7Q/4p3/1B6/PPPP1PPP/RNB1K1NR",
  },
  {
    name: "Caro-Kann Defense: Labahn Attack",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/1P2P3/8/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Labahn Attack, Double Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/1P1p4/4P3/8/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Labahn Attack, Polish Variation",
    fen: "rnbqkbnr/pp1p1ppp/2p5/4p3/1P2P3/8/PBPP1PPP/RN1QKBNR",
  },
  {
    name: "Caro-Kann Defense: Scorpion-Horus Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/6B1/4p3/2NP4/PPP2PPP/R2QKBNR",
  },
  {
    name: "Caro-Kann Defense: Spike Variation",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/4P1P1/8/PPPP1P1P/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Spike Variation, Scorpion-Grob Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/8/4p1P1/2NP4/PPP2P1P/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Toikkanen Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/3pP3/2P5/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Two Knights Attack",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/4P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense: Two Knights Attack, Mindeno Variation",
    fen: "rn1qkbnr/pp2pppp/2p5/3p4/4P1b1/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense: Two Knights Attack, Mindeno Variation, Exchange Line",
    fen: "rn1qkbnr/pp2pppp/2p5/3p4/4P3/2N2b1P/PPPP1PP1/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense: Two Knights Attack, Mindeno Variation, Retreat Line",
    fen: "rn1qkbnr/pp2pppp/2p5/3p3b/4P3/2N2N1P/PPPP1PP1/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense",
    fen: "rnbqkbnr/pp1ppppp/2p5/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Advance Variation",
    fen: "rnbqkbnr/pp2pppp/2p5/3pP3/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Advance Variation, Bayonet Attack",
    fen: "rn1qkbnr/pp2pppp/2p5/3pPb2/3P2P1/8/PPP2P1P/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Advance Variation, Botvinnik-Carls Defense",
    fen: "rnbqkbnr/pp2pppp/8/2ppP3/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Advance Variation, Bronstein Variation",
    fen: "rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/8/PPP1NPPP/RNBQKB1R",
  },
  {
    name: "Caro-Kann Defense: Advance Variation, Prins Attack",
    fen: "rn1qkbnr/pp2pppp/2p5/3pPb2/1P1P4/8/P1P2PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Advance Variation, Short Variation",
    fen: "rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Caro-Kann Defense: Advance Variation, Tal Variation",
    fen: "rn1qkbnr/pp2pppp/2p5/3pPb2/3P3P/8/PPP2PP1/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Advance Variation, Van der Wiel Attack",
    fen: "rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Advance Variation, Van der Wiel Attack",
    fen: "rn1qkbnr/pp3ppp/4p1b1/2ppP3/3P2PP/2N5/PPP1NP2/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense: Advance Variation, Van der Wiel Attack, Dreyev Defense",
    fen: "rn2kbnr/pp2pppp/1qp5/3pPb2/3P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Advance, Short Variation",
    fen: "rn1qkbnr/pp3ppp/2p1p3/3pPb2/3P4/2P5/PP2BPPP/RNBQK1NR",
  },
  {
    name: "Caro-Kann Defense: De Bruycker Defense",
    fen: "r1bqkbnr/pp1ppppp/n1p5/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: De Bruycker Defense",
    fen: "r1bqkbnr/ppnppppp/2p5/8/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Edinburgh Variation",
    fen: "rnb1kbnr/pp2pppp/1qp5/3p4/3PP3/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Maróczy Variation",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/3PP3/5P2/PPP3PP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Maróczy Variation, Maróczy Gambit",
    fen: "rnbqkbnr/pp3ppp/2p5/8/2BpP3/5N2/PPP3PP/RNBQK2R",
  },
  {
    name: "Caro-Kann Defense: Masi Variation",
    fen: "rnbqkb1r/pp1ppppp/2p2n2/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Massachusetts Defense",
    fen: "rnbqkbnr/pp1pp1pp/2p5/5p2/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Mieses Attack, Landau Gambit",
    fen: "rnbqkb1r/pp1npppp/2p1P3/3p4/3P4/3B4/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Caro-Kann Defense: Mieses Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/3PP3/4B3/PPP2PPP/RN1QKBNR",
  },
  {
    name: "Caro-Kann Defense: Modern Variation",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Ulysses Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/6N1/3Pp3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Caro-Kann Defense: Exchange Variation",
    fen: "rnbqkbnr/pp2pppp/2p5/3P4/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Exchange Variation, Bulla Attack",
    fen: "rnbqkbnr/pp2pppp/8/3p4/3P2P1/8/PPP2P1P/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Exchange Variation, Rubinstein Variation",
    fen: "r1bqkb1r/pp2pppp/2n2n2/3p4/3P1B2/2PB4/PP3PPP/RN1QK1NR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack",
    fen: "rnbqkbnr/pp2pppp/8/3p4/2PP4/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack",
    fen: "rnbqkb1r/pp2pppp/5n2/3p4/2PP4/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack, Gunderam Attack",
    fen: "rnbqkb1r/pp2pppp/5n2/2Pp4/3P4/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack, Modern Defense",
    fen: "r1bqkb1r/pp2pppp/2n2n2/3p4/2PP4/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack, Modern Defense, Carlsbad Line",
    fen: "r1bqkb1r/pp3ppp/2n1pn2/3p2B1/2PP4/2N5/PP3PPP/R2QKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack, Modern Defense, Czerniak Line",
    fen: "r1b1kb1r/pp2pppp/2n2n2/q2p2B1/2PP4/2N5/PP3PPP/R2QKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack, Modern Defense, Mieses Line",
    fen: "r2qkb1r/pp2pppp/2n2n2/3p4/2PP2b1/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense: Panov Attack, Modern Defense, Reifir-Spielmann Line",
    fen: "r1b1kb1r/pp2pppp/1qn2n2/3p2B1/2PP4/2N5/PP3PPP/R2QKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov-Botvinnik, Herzog Defense",
    fen: "r1bqkb1r/pp2pppp/5n2/n2P2B1/2p5/2N5/PP3PPP/R2QKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack",
    fen: "rnbqkb1r/pp3ppp/4pn2/3p4/2PP4/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack, Fianchetto Defense",
    fen: "rnbqkb1r/pp2pp1p/5np1/3p4/2PP4/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack, Fianchetto Defense, Fianchetto Gambit",
    fen: "rnbqk2r/pp2ppbp/5np1/3P4/3P4/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Panov Attack, Main Line",
    fen: "rnbqk2r/pp3ppp/4pn2/3p4/1bPP4/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense",
    fen: "rnbqkbnr/pp2pppp/2p5/8/3Pp3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Alekhine Gambit",
    fen: "rnbqkb1r/pp2pppp/2p2n2/8/3PN3/3B4/PPP2PPP/R1BQK1NR",
  },
  {
    name: "Caro-Kann Defense: Campomanes Attack",
    fen: "rnbqkb1r/pp2pppp/2p2n2/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Forgacs Variation",
    fen: "rnbqkb1r/pp3ppp/2p2p2/8/2BP4/8/PPP2PPP/R1BQK1NR",
  },
  {
    name: "Caro-Kann Defense: Gurgenidze Counterattack",
    fen: "rnbqkbnr/p3pppp/2p5/1p1p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Gurgenidze System",
    fen: "rnbqkbnr/pp2pp1p/2p3p1/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Main Line",
    fen: "rnbqkbnr/pp2pppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Rasa-Studier Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Tartakower Variation",
    fen: "rnbqkb1r/pp3ppp/2p2p2/8/3P4/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: von Hennig Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/8/2BPp3/2N5/PPP2PPP/R1BQK1NR",
  },
  {
    name: "Caro-Kann Defense: Bronstein-Larsen Variation",
    fen: "rnbqkb1r/pp2pp1p/2p2p2/8/3P4/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Finnish Variation",
    fen: "rnbqkbnr/pp2ppp1/2p4p/8/3PN3/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Karpov Variation",
    fen: "r1bqkbnr/pp1npppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Karpov Variation, Modern Main Line",
    fen: "r1bqk2r/pp1n1pp1/2pbp2p/8/3PQ3/3B1N2/PPP2PPP/R1B1K2R",
  },
  {
    name: "Caro-Kann Defense: Karpov Variation, Modern Variation",
    fen: "r1bqkbnr/pp1npppp/2p5/6N1/3P4/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Karpov Variation, Modern Variation, Ivanchuk Defense",
    fen: "r1bqkbnr/pp2pppp/2p2n2/6N1/3P4/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Karpov Variation, Modern Variation, Kasparov Attack",
    fen: "r1bqkb1r/pp1npppp/2p2n2/8/3P4/5NN1/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense: Karpov Variation, Smyslov Variation",
    fen: "r1bqkb1r/pp3ppp/1np1pn2/6N1/2BP4/8/PPP1QPPP/R1B1K1NR",
  },
  {
    name: "Caro-Kann Defense: Karpov Variation, Smyslov Variation, Main Line",
    fen: "r1bqkb1r/pp3ppp/1np1pn2/6N1/3P4/1B6/PPP1QPPP/R1B1K1NR",
  },
  {
    name: "Caro-Kann Defense: Karpov Variation, Tiviakov-Fischer Attack",
    fen: "r1bqkb1r/pp2pppp/2p2n2/8/2BP4/8/PPP2PPP/R1BQK1NR",
  },
  {
    name: "Caro-Kann Defense: Classical Variation",
    fen: "rn1qkbnr/pp2pppp/2p5/5b2/3PN3/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Classical Variation, Flohr Variation",
    fen: "rn1qkbnr/pp2pppp/2p3b1/8/3P4/6NN/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense: Classical Variation, Main Line",
    fen: "rn1qkbnr/pp2pppp/2p3b1/8/3P3P/6N1/PPP2PP1/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Classical Variation, Maróczy Attack",
    fen: "rn1qkbnr/pp2pppp/2p3b1/8/3P1P2/6N1/PPP3PP/R1BQKBNR",
  },
  {
    name: "Caro-Kann Defense: Classical Variation",
    fen: "r2qkbnr/pp1nppp1/2p3bp/8/3P3P/5NN1/PPP2PP1/R1BQKB1R",
  },
  {
    name: "Caro-Kann Defense: Classical Variation, Lobron System",
    fen: "r2qk2r/pp1nbpp1/2p1pn1p/7P/3P4/3Q1NN1/PPPB1PP1/2KR3R",
  },
  {
    name: "Caro-Kann Defense: Classical Variation, Seirawan Variation",
    fen: "r2qk2r/pp1n1pp1/2pbpn1p/7P/3P4/3Q1NN1/PPPB1PP1/2KR3R",
  },
  {
    name: "Caro-Kann Defense: Classical Variation, Spassky Variation",
    fen: "r2qkbnr/pp1nppp1/2p3bp/7P/3P4/5NN1/PPP2PP1/R1BQKB1R",
  },
  {
    name: "Sicilian Defense",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Amazon Attack",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P1Q1/8/PPPP1PPP/RNB1KBNR",
  },
  {
    name: "Sicilian Defense: Big Clamp Formation",
    fen: "r1bqkbnr/pp2pppp/2np4/2p5/4PP2/2PP4/PP4PP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Bowdler Attack",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/2B1P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Sicilian Defense: Brick Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/7N/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Euwe Attack, Prins Gambit",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/4P3/1P6/PBPP1PPP/RN1QKBNR",
  },
  {
    name: "Sicilian Defense: Gloria Variation",
    fen: "r1bqkbnr/pp2ppp1/2np4/2p4p/2P1P3/2N3P1/PP1P1P1P/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Grob Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P1P1/8/PPPP1P1P/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Keres Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPPNPPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: King David's Opening",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPPKPPP/RNBQ1BNR",
  },
  {
    name: "Sicilian Defense: Kronberger Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/N7/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Kronberger Variation, Nemeth Gambit",
    fen: "r1bqkbnr/pp1ppppp/2n5/8/2BpP3/N7/PPP2PPP/R1BQK1NR",
  },
  {
    name: "Sicilian Defense: Lasker-Dunne Attack",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/6P1/PPPP1P1P/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Mengarini Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/P7/1PPP1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Myers Attack, with a4",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/P3P3/8/1PPP1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Myers Attack, with h4",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P2P/8/PPPP1PP1/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Snyder Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/1P6/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Snyder Variation, Queen Fianchetto Variation",
    fen: "rnbqkbnr/p2ppppp/1p6/2p5/4P3/1P6/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Staunton-Cochrane Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/2P1P3/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Wing Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/1P2P3/8/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Wing Gambit, Abrahams Variation",
    fen: "rnbqkbnr/pp1ppppp/8/8/1p2P3/8/PBPP1PPP/RN1QKBNR",
  },
  {
    name: "Sicilian Defense: Wing Gambit, Carlsbad Variation",
    fen: "rnbqkbnr/pp1ppppp/8/8/4P3/p7/2PP1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Wing Gambit, Marienbad Variation",
    fen: "rnb1kbnr/pp2pppp/8/3q4/1p6/P7/1BPP1PPP/RN1QKBNR",
  },
  {
    name: "Sicilian Defense: Wing Gambit, Marshall Variation",
    fen: "rnbqkbnr/pp1ppppp/8/8/1p2P3/P7/2PP1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Wing Gambit, Nanu Gambit",
    fen: "rnb1kbnr/pp3ppp/4q3/4p3/1pP5/P2B1N2/3P1PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Wing Gambit, Romanian Defense",
    fen: "r1b1kbnr/pp3ppp/2n1q3/4p3/1pP5/P4N2/1B1P1PPP/RN1QKB1R",
  },
  {
    name: "Sicilian Defense: Wing Gambit, Santasiere Variation",
    fen: "rnbqkbnr/pp1ppppp/8/8/1pP1P3/8/P2P1PPP/RNBQKBNR",
  },
  {
    name: "Bird Opening: Dutch Variation, Batavo Gambit",
    fen: "rnbqkbnr/pp2pppp/8/2p5/4pP2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Coles Sicilian Gambit",
    fen: "r1bqkb1r/pp1ppppp/2n2n2/8/2B1P3/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Sicilian Defense: Halasz Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/8/3pPP2/8/PPP3PP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: McDonnell Attack",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: McDonnell Attack, Tal Gambit",
    fen: "rnbqkb1r/pp2pppp/5n2/2pP4/5P2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Morphy Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/8/3pP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Morphy Gambit, Andreaschek Gambit",
    fen: "rnbqkbnr/pp1p1ppp/8/4p3/3pP3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit",
    fen: "rnbqkbnr/pp1ppppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Chicago Defense",
    fen: "rnbqkb1r/1p3ppp/p2ppn2/8/2B1P3/2N2N2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Classical Formation",
    fen: "r1bqkb1r/1p2pppp/p1np1n2/8/2B1P3/2N2N2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Fianchetto Defense",
    fen: "r1bqkbnr/pp1ppp1p/2n3p1/8/4P3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Finegold Defense",
    fen: "rnbqk2r/1p2bppp/p2ppn2/8/2B1P3/2N2N2/PP2QPPP/R1B2RK1",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Kan Formation",
    fen: "rnbqkbnr/1p1p1ppp/p3p3/8/4P3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Larsen Defense",
    fen: "r1b1k1nr/1pqp1ppp/p1nbp3/8/2B1P3/2N2N2/PP2QPPP/R1B2RK1",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Morphy Defense",
    fen: "r1bqk1nr/pp1p1ppp/2n1p3/2b5/2B1P3/2N2N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Morphy Defense Deferred",
    fen: "r1bqk1nr/3p1ppp/p1n1p3/1pb5/4P3/1BN2N2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Paulsen Formation",
    fen: "r1bqkbnr/1p1p1ppp/p1n1p3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Pin Defense",
    fen: "r1bqk1nr/pp1p1ppp/2n1p3/8/1bB1P3/2N2N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Scheveningen Formation",
    fen: "r1bqkbnr/pp3ppp/2npp3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Sozin Formation",
    fen: "r1bqkbnr/5ppp/p1npp3/1p6/2B1P3/2N2N2/PP2QPPP/R1B2RK1",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Accepted, Taimanov Formation",
    fen: "rnbqkb1r/1p1pnppp/p3p3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Declined, Alapin Formation",
    fen: "rnbqkb1r/pp1ppppp/5n2/8/3pP3/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Declined, Center Formation",
    fen: "rnbqkbnr/pp1p1ppp/8/4p3/3pP3/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Declined, Dubois Variation",
    fen: "rnbqkbnr/pp1ppppp/8/8/2P1P3/3p4/PP3PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Declined, Push Variation",
    fen: "rnbqkbnr/pp1ppppp/8/8/4P3/2Pp4/PP3PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Declined, Scandinavian Formation",
    fen: "rnbqkbnr/pp2pppp/8/3p4/3pP3/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Declined, Wing Formation",
    fen: "rnb1kbnr/pp1ppppp/8/q7/3pP3/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit, Chicago Defense",
    fen: "2bqkbnr/r4ppp/p1npp3/1p6/4P3/1BN2N2/PP2QPPP/R1B2RK1",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit, Danish Variation",
    fen: "rnbqkbnr/pp1ppppp/8/8/4P3/2p2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Alapin Variation",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/2P5/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Alapin Variation, Barmen Defense",
    fen: "rnb1kbnr/pp2pppp/8/2pq4/8/2P5/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Alapin Variation, Barmen Defense, Central Exchange",
    fen: "r3kbnr/pp2pppp/2n5/3q4/3P2b1/5N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Alapin Variation, Barmen Defense, Endgame Variation",
    fen: "r3kbnr/pp2pppp/8/8/3n4/2N2P2/PP3P1P/R1B1KB1R",
  },
  {
    name: "Sicilian Defense: Alapin Variation, Barmen Defense, Milner-Barry Attack",
    fen: "r1b1k1nr/pp3ppp/2n5/3qp3/1b1P4/2N2N2/PP2BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Alapin Variation, Barmen Defense, Modern Line",
    fen: "rn2kb1r/pp2pppp/5n2/2pq4/3P2b1/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Alapin Variation, Smith-Morra Declined",
    fen: "rnbqkb1r/pp1ppppp/8/3nP3/3p4/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "Sicilian Defense: Alapin Variation, Stoltz Attack",
    fen: "r1bqkb1r/pp1ppppp/1nn5/2p1P3/8/1BP2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Alapin Variation, Stoltz Attack, Ivanchuk Line",
    fen: "r1b1kb1r/ppqppp1p/1nn5/4P1p1/2p5/2P2N2/PPBPQPPP/RNB1K2R",
  },
  {
    name: "Sicilian Defense: Heidenfeld Variation",
    fen: "r1bqkb1r/pp1ppppp/2n5/2pnP3/8/N1P2N2/PP1P1PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Closed",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Closed",
    fen: "rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Closed",
    fen: "rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2N3P1/PPPP1P1P/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Closed, Chameleon Variation",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2N5/PPPPNPPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Closed, Grob Attack",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/4P1P1/2N5/PPPP1P1P/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Closed, Korchnoi Defense",
    fen: "rnbqkbnr/pp3ppp/4p3/2pp4/4P3/2N3P1/PPPP1P1P/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Closed, Traditional",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Grand Prix Attack",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/4PP2/2N5/PPPP2PP/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Grand Prix Attack, Schofman Variation",
    fen: "r1bqk1nr/pp1p1pbp/2n1p1p1/2p2P2/2B1P3/2N2N2/PPPP2PP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Closed",
    fen: "r1bqkbnr/pp1ppp1p/2n3p1/2p5/4P3/2N3P1/PPPP1P1P/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Closed",
    fen: "r1bqk1nr/pp1pppbp/2n3p1/2p5/4P3/2N3P1/PPPP1PBP/R1BQK1NR",
  },
  {
    name: "Sicilian Defense: Closed, Fianchetto Variation",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2N3P1/PPPP1P1P/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Closed, Smyslov Variation",
    fen: "r1bqk1nr/pp1p1pbp/4p1p1/2p5/3nP3/3PB1P1/PPP1NPBP/R2QK1NR",
  },
  {
    name: "Sicilian Defense: Closed",
    fen: "r1bqk1nr/pp2ppbp/2np2p1/2p5/4P3/2NP2P1/PPP2PBP/R1BQK1NR",
  },
  {
    name: "Sicilian Defense: Closed",
    fen: "r1bqk1nr/pp2ppbp/2np2p1/2p5/4PP2/2NP2P1/PPP3BP/R1BQK1NR",
  },
  {
    name: "Sicilian Defense: Closed, Botvinnik Defense, Edge Variation",
    fen: "r1bqk2r/pp2npbp/2np2p1/2p1p3/4PP2/2NP2PN/PPP3BP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Closed, Botvinnik Defense, with Nge2",
    fen: "r1bqk1nr/pp3pbp/2np2p1/2p1p3/4P3/2NP2P1/PPP1NPBP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Closed, Botvinnik Defense, with f4",
    fen: "r1bqk1nr/pp3pbp/2np2p1/2p1p3/4PP2/2NP2P1/PPP3BP/R1BQK1NR",
  },
  {
    name: "Sicilian Defense: Closed",
    fen: "r1bqk1nr/pp2ppbp/2np2p1/2p5/4P3/2NPB1P1/PPP2PBP/R2QK1NR",
  },
  {
    name: "Modern Defense: Pterodactyl Variation",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Pterodactyl Defense: Sicilian, Anhanguera",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/2N1BN2/PPP2PPP/R2QKB1R",
  },
  {
    name: "Pterodactyl Defense: Sicilian, Benoni Gambit",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1pP4/4P3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Pterodactyl Defense: Sicilian, Pteranodon",
    fen: "rnb1k1nr/pp1ppp1p/6p1/q1P5/4P3/2P2N2/P1P2PPP/R1BQKB1R",
  },
  {
    name: "Pterodactyl Defense: Sicilian, Rhamphorhynchus",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1P5/4P3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Pterodactyl Defense: Sicilian, Unpin",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/2N2N2/PPPB1PPP/R2QKB1R",
  },
  {
    name: "Pterodactyl Defense: Western, Pterodactyl",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Pterodactyl Defense: Western, Rhamphorhynchus",
    fen: "rnb1k1nr/pp1pppbp/6p1/q1P5/4P3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense",
    fen: "rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Acton Extension",
    fen: "rnbqk1nr/pp1ppp1p/6pb/2p5/2P1P3/5N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Brussels Gambit",
    fen: "rnbqkbnr/pp1pp1pp/8/2p2p2/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Bücker Variation",
    fen: "rnbqkbnr/pp1pppp1/7p/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Double-Dutch Gambit",
    fen: "rnbqkb1r/pp1pp1pp/7n/2p2P2/8/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Frederico Variation",
    fen: "rnbqkbnr/pp1pp2p/6p1/2p2p2/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Hyperaccelerated Dragon",
    fen: "rnbqkbnr/pp1ppp1p/6p1/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Hyperaccelerated Fianchetto",
    fen: "rnbqkbnr/pp1ppp1p/6p1/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Hyperaccelerated Pterodactyl",
    fen: "rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Hyperaccelerated Pterodactyl, Exchange Variation",
    fen: "rnb1k1nr/pp1ppp1p/6p1/2P5/4P3/2q2N2/P1P2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Jalalabad Variation",
    fen: "rnbqkbnr/pp1p1ppp/8/2p1p3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Katalimov Variation",
    fen: "rnbqkbnr/p2ppppp/1p6/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Mongoose Variation",
    fen: "rnb1kbnr/pp1ppppp/8/q1p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Polish Gambit",
    fen: "rnbqkbnr/p2ppppp/8/1pp5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Quinteros Variation",
    fen: "rnb1kbnr/ppqppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation",
    fen: "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Aronin System",
    fen: "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPPBPPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Kieseritzky System",
    fen: "rnbqkbnr/1p1ppppp/p7/2p5/4P3/1P3N2/P1PP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Maróczy Bind",
    fen: "rnbqkbnr/1p1ppppp/p7/2p5/2P1P3/5N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Maróczy Bind, Paulsen Line",
    fen: "rnbqkbnr/1p1p1ppp/p3p3/2p5/2P1P3/5N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Maróczy Bind, Robatsch Line",
    fen: "rnbqkbnr/1p2pppp/p2p4/2p5/2P1P3/5N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Normal System",
    fen: "rnbqkbnr/1p1ppppp/p7/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Normal System, Cortlever Gambit",
    fen: "rnbqkbnr/1p1ppppp/p7/8/2BpP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Normal System, Smith-Morra Line",
    fen: "rnbqkbnr/1p1ppppp/p7/8/3pP3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Normal System, Taimanov Line",
    fen: "rnbqkbnr/1p1p1ppp/p7/4p3/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Normal System, Zagorovsky Line",
    fen: "rnbqkbnr/1p1ppppp/p7/8/3QP3/5N2/PPP2PPP/RNB1KB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Quiet System",
    fen: "rnbqkbnr/1p1ppppp/p7/2p5/4P3/3P1N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Réti System",
    fen: "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5NP1/PPPP1P1P/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Venice System",
    fen: "rnbqkbnr/1p1ppppp/p7/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Venice System, Barcza Line",
    fen: "rnbqkb1r/1p1ppppp/p4n2/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Venice System, Gambit Line",
    fen: "rnbqkb1r/1p2pppp/p4n2/2pP4/8/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Venice System, Ljubojevic Line",
    fen: "rnbqkbnr/3ppppp/p7/1pp5/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Venice System, Steiner Line",
    fen: "rnbqkbnr/1p2pppp/p2p4/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Wing Gambit",
    fen: "rnbqkbnr/1p1ppppp/p7/2p5/1P2P3/5N2/P1PP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Yerevan System",
    fen: "rnbqkbnr/1p1ppppp/p7/2p5/4P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Nimzowitsch Variation",
    fen: "rnbqkb1r/pp1ppppp/5n2/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Nimzowitsch Variation, Advance Variation",
    fen: "rnbqkb1r/pp1ppppp/5n2/2p1P3/8/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Nimzowitsch Variation, Closed Variation",
    fen: "rnbqkb1r/pp1ppppp/5n2/2p5/4P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Nimzowitsch Variation, Exchange Variation",
    fen: "rnbqkb1r/pp1ppppp/8/2p1P3/8/2n2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Nimzowitsch Variation, Main Line",
    fen: "r1bqkb1r/pp1p1ppp/2n5/2ppP3/3P4/5N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Closed, Anti-Sveshnikov Variation, Kharlov-Kramnik Line",
    fen: "r1bqk1nr/pp3ppp/2np4/2p1p1b1/2B1P3/2NP4/PPPN1PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack",
    fen: "r1bqkbnr/pp1ppppp/2n5/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, San Francisco Gambit",
    fen: "r1bqkbnr/pp1ppppp/8/nBp5/1P2P3/5N2/P1PP1PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Old Sicilian",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Portsmouth Gambit",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/1P2P3/5N2/P1PP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Rossolimo Variation, Brooklyn Retreat Defense",
    fen: "rnbqkbnr/pp1ppppp/8/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Fianchetto Variation",
    fen: "r1bqkbnr/pp1ppp1p/2n3p1/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Fianchetto Variation, Gufeld Gambit",
    fen: "r1bqk1nr/pp1p1pbp/2n3p1/1Bp1p3/3PP3/2P2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Fianchetto Variation, Lutikov Gambit",
    fen: "r1bqk2r/pp1pppbp/2n2np1/1Bp5/3PP3/2P2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Fianchetto Variation, Totsky Attack",
    fen: "r1bqk2r/pp1pppbp/2n2np1/1Bp5/Q3P3/2P2N2/PP1P1PPP/RNB2RK1",
  },
  {
    name: "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Gurgenidze Variation",
    fen: "r1bqk1nr/pp1p1pbp/2n3p1/1Bp1p3/1P2P3/5N2/P1PP1PPP/RNBQR1K1",
  },
  {
    name: "Sicilian Defense: Accelerated Dragon",
    fen: "r1bqkbnr/pp1ppp1p/2n3p1/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Flohr Variation",
    fen: "r1b1kbnr/ppqppppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Franco-Sicilian Variation",
    fen: "r1bqkbnr/pp1p1ppp/2n1p3/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Godiva Variation",
    fen: "r1b1kbnr/pp1ppppp/1qn5/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Kalashnikov Variation",
    fen: "r1bqkbnr/pp3ppp/2np4/1N2p3/4P3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Löwenthal Variation",
    fen: "r1bqkbnr/pp1p1ppp/2n5/4p3/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Nimzo-American Variation",
    fen: "r1bqkbnr/pp2pppp/2n5/3p4/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: O'Kelly Variation, Maróczy Bind, Geller Line",
    fen: "r1bqkbnr/1p1p1ppp/p1n5/4p3/2PNP3/8/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Open",
    fen: "r1bqkbnr/pp1ppppp/2n5/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Open",
    fen: "r1bqkbnr/pp1ppppp/2n5/8/3pP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Open",
    fen: "r1bqkbnr/pp1ppppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Four Knights Variation, Cobra Variation",
    fen: "r1bqk2r/pp1p1ppp/2n1pn2/1Nb5/4P3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Lasker-Pelikan Variation",
    fen: "r1bqkb1r/pp1p1ppp/2n2n2/4p3/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Lasker-Pelikan Variation, Bird Variation",
    fen: "r2qkb1r/1p3ppp/p1npbn2/4p1B1/4P3/N1N5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Lasker-Pelikan Variation, Exchange Variation",
    fen: "r1bqkb1r/pp1p1ppp/2N2n2/4p3/4P3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Lasker-Pelikan Variation, Retreat Variation",
    fen: "r1bqkb1r/pp1p1ppp/2n2n2/4p3/4P3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Lasker-Pelikan Variation, Schlechter Variation",
    fen: "r1bqkb1r/pp1p1ppp/2n2n2/4p3/4P3/1NN5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Lasker-Pelikan Variation, Sveshnikov Variation",
    fen: "r1bqkb1r/5ppp/p1np1n2/1p2p1B1/4P3/N1N5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Lasker-Pelikan Variation, Sveshnikov Variation",
    fen: "r1bqkb1r/5p1p/p1np4/1p1Npp2/4P3/N7/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Lasker-Pelikan Variation, Sveshnikov Variation, Chelyabinsk Variation",
    fen: "r1bqkb1r/5ppp/p1np1n2/1p1Np1B1/4P3/N7/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Lasker-Pelikan Variation, Sveshnikov Variation, Novosibirsk Variation",
    fen: "r1bqk2r/5pbp/p1np1p2/1p1Np3/4P3/N7/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Lasker-Pelikan Variation, Sveshnikov Variation, Peresypkin's Sacrifice",
    fen: "r1bqkb1r/5p1p/p1np4/1B1Npp2/4P3/N7/PPP2PPP/R2QK2R",
  },
  {
    name: "Sicilian Defense: Open",
    fen: "r1bqkb1r/pp1ppppp/2n2n2/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Accelerated Dragon, Exchange Variation",
    fen: "r1bqkbnr/pp1ppp1p/2N3p1/8/4P3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Accelerated Dragon, Modern Variation",
    fen: "r1bqkbnr/pp1ppp1p/2n3p1/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Accelerated Dragon, Modern Bc4 Variation",
    fen: "r1bqk2r/pp1pppbp/2n2np1/8/2BNP3/2N1B3/PPP2PPP/R2QK2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Modern Bc4 Variation",
    fen: "r1bqk2r/pp2ppbp/2np1np1/8/2BNP3/2N1B3/PPP2PPP/R2QK2R",
  },
  {
    name: "Sicilian Defense: Accelerated Dragon, Maróczy Bind",
    fen: "r1bqkbnr/pp1ppp1p/2n3p1/8/2PNP3/8/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Accelerated Dragon, Maróczy Bind, Gurgenidze Variation",
    fen: "r1bqkb1r/pp2pp1p/3p1np1/8/2PQP3/2N5/PP3PPP/R1B1KB1R",
  },
  {
    name: "Sicilian Defense: Accelerated Dragon, Maróczy Bind",
    fen: "r1bqk1nr/pp1pppbp/2n3p1/8/2PNP3/8/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Accelerated Dragon, Simagin Variation",
    fen: "r1bqk2r/pp2ppbp/2np2pn/8/2P1P3/8/PPN1BPPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Accelerated Dragon, Maróczy Bind",
    fen: "r1bqk1nr/pp1pppbp/2n3p1/8/2PNP3/4B3/PP3PPP/RN1QKB1R",
  },
  {
    name: "Sicilian Defense: Accelerated Dragon, Maróczy Bind, Breyer Variation",
    fen: "r1bqk2r/pp1pppbp/2n3p1/8/2PNP1n1/2N1B3/PP3PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Alapin Variation, Sherzer Variation",
    fen: "r1bqkb1r/pp1p1ppp/2n1p3/2pnP3/3P4/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Delayed Alapin Variation",
    fen: "rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Drazic Variation",
    fen: "rnbqkbnr/1p1p1ppp/p3p3/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Four Knights Variation",
    fen: "r1bqkb1r/pp1p1ppp/2n1pn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Four Knights Variation, Exchange Variation",
    fen: "r1bqkb1r/pp1p1ppp/2N1pn2/8/4P3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: French Variation",
    fen: "rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: French Variation, Normal",
    fen: "rnbqkb1r/pp1p1ppp/4pn2/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: French Variation, Open",
    fen: "rnbqkbnr/pp1p1ppp/4p3/8/3pP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: French Variation, Westerinen Attack",
    fen: "rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/1P3N2/P1PP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Gaw-Paw Variation",
    fen: "rnb1kb1r/pp1p1ppp/1q2pn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Wing Attack, Fianchetto Variation",
    fen: "rnbqkbnr/3p1ppp/p3p3/1p6/3NP3/2N3P1/PPP2P1P/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Kramnik Variation",
    fen: "rnbqkbnr/pp1p1ppp/4p3/2p5/2P1P3/5N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Kveinis Variation",
    fen: "rnb1kbnr/pp1p1ppp/1q2p3/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Marshall Counterattack",
    fen: "rnbqkbnr/pp3ppp/4p3/2pp4/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Paulsen-Basman Defense",
    fen: "rnbqk1nr/pp1p1ppp/4p3/2b5/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Pin Variation",
    fen: "rnbqk2r/pp1p1ppp/4pn2/8/1b1NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Pin Variation, Jaffe Variation",
    fen: "rnbqk2r/pp1p1ppp/5n2/4p3/1b1NP3/2NB4/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Pin Variation, Koch Variation",
    fen: "rnbqk2r/pp1p1ppp/4pn2/4P3/1b1N4/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Smith-Morra Gambit Deferred",
    fen: "rnbqkbnr/pp1p1ppp/4p3/8/3pP3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Wing Gambit Deferred",
    fen: "rnbqkbnr/pp1p1ppp/4p3/2p5/1P2P3/5N2/P1PP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Kan Variation",
    fen: "rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Maróczy Bind, Bronstein Variation",
    fen: "r1bqk2r/1p1p1ppp/p1n1pn2/8/1bPNP3/2NB4/PP3PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Maróczy Bind, Bronstein Variation",
    fen: "r1bqk2r/1p1p1ppp/p1n1pn2/8/1bPNP3/2N5/PPB2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Maróczy Bind, Hedgehog Variation",
    fen: "rnbqkbnr/1p1p1p1p/p3p1p1/8/2PNP3/8/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Maróczy Bind, Réti Variation",
    fen: "rnbqkbnr/1p1p1ppp/p3p3/8/2PNP3/8/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Gipslis Variation",
    fen: "rnbqkb1r/1p3p1p/p2ppnp1/8/2PNP3/3B4/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Sicilian Defense: Kan Variation, Modern Variation",
    fen: "rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/3B4/PPP2PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Polugaevsky Variation",
    fen: "rnbqk1nr/1p1p1ppp/p3p3/2b5/3NP3/3B4/PPP2PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Swiss Cheese Variation",
    fen: "rnbqkbnr/1p1p1p1p/p3p1p1/8/3NP3/3B4/PPP2PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Knight Variation",
    fen: "rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Wing Attack",
    fen: "rnbqkbnr/3p1ppp/p3p3/1p6/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Wing Attack, Christiansen's Dream",
    fen: "rnb1k1nr/3p1ppp/pq2p3/1pb5/3NP1Q1/2NBB3/PPP2PPP/R3K2R",
  },
  {
    name: "Sicilian Defense: Kan Variation, Wing Attack, Spraggett Attack",
    fen: "rnb1kbnr/3p1ppp/pq2p3/1p6/4P3/2NB1N2/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Taimanov Variation",
    fen: "r1bqkbnr/pp1p1ppp/2n1p3/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Taimanov Variation, Gary Gambit",
    fen: "r1bqkb1r/1p3ppp/p1n1pn2/3p4/2P1P3/N1N5/PP3PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Taimanov Variation, Modern Line",
    fen: "r1bq1rk1/4bppp/ppnppn2/8/2P1P3/N1N5/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "Sicilian Defense: Taimanov Variation, Szén Variation",
    fen: "r1bqkbnr/pp1p1ppp/2n1p3/1N6/4P3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Taimanov Variation, American Attack",
    fen: "r1bqk2r/pp1p1ppp/2nNpn2/8/1b2P3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Taimanov Variation, Normal Variation",
    fen: "r1bqkbnr/pp1p1ppp/2n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Taimanov Variation",
    fen: "r1bqkbnr/1p1p1ppp/p1n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Taimanov Variation, Bastrikov Variation",
    fen: "r1b1kbnr/ppqp1ppp/2n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Taimanov Variation, Bastrikov Variation, Ponomariov Gambit",
    fen: "rqb1kbnr/1p1p1ppp/pBn1p3/1N6/4P3/2N5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Taimanov Variation, Bastrikov Variation, English Attack",
    fen: "r1b1kbnr/ppqp1ppp/2n1p3/8/3NP3/2N1B3/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Taimanov Variation, Bastrikov Variation",
    fen: "r1b1kbnr/1pqp1ppp/p1n1p3/8/3NP3/2N1B3/PPP1BPPP/R2QK2R",
  },
  {
    name: "Sicilian Defense",
    fen: "rnbqkbnr/pp2pppp/3p4/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense",
    fen: "rnbqkbnr/pp2pppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Delayed Alapin",
    fen: "rnbqkbnr/pp2pppp/3p4/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Delayed Alapin, Basman-Palatnik Double Gambit",
    fen: "r1b1kb1r/pp2pppp/2np4/q2P4/8/2P2N2/P3BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Delayed Alapin, Basman-Palatnik Gambit",
    fen: "r1bqkb1r/pp2pppp/2np4/8/3Pn3/5N2/PP2BPPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Kopec System",
    fen: "rnbqkbnr/pp2pppp/3p4/2p5/4P3/3B1N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Kotov Gambit",
    fen: "rnbqkbnr/p3pppp/3p4/1pp5/4P3/5NP1/PPPP1P1P/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Modern Variations",
    fen: "rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Modern Variations, Anti-Qxd4 Move Order",
    fen: "rnbqkb1r/pp2pppp/3p1n2/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Modern Variations, Anti-Qxd4 Move Order Accepted",
    fen: "rnbqkb1r/pp2pppp/3p4/2P5/4n3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Modern Variations, Tartakower",
    fen: "rnbqkbnr/pp2pppp/3p4/8/3pP3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Wing Gambit, Deferred Variation",
    fen: "rnbqkbnr/pp2pppp/3p4/2p5/1P2P3/5N2/P1PP1PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Moscow Variation",
    fen: "rnbqkbnr/pp2pppp/3p4/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Moscow Variation, Dorfman Gambit",
    fen: "r2qkbnr/pp1bpp1p/2np2p1/1Bp1P3/8/5N2/PPPPQPPP/RNB2RK1",
  },
  {
    name: "Sicilian Defense: Moscow Variation, Moscow Gambit",
    fen: "r2qkb1r/1p2pppp/p2p1n2/2p3B1/3Pb3/2P2N2/PP3PPP/RN1QR1K1",
  },
  {
    name: "Sicilian Defense: Moscow Variation, Haag Gambit",
    fen: "r3kb1r/pp1qpppp/2np1n2/2p5/3PP3/2P2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Sicilian Defense: Moscow Variation, Main Line",
    fen: "rn1qkbnr/pp1bpppp/3p4/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Moscow Variation, Sokolsky Variation",
    fen: "rn2kbnr/pp1qpppp/3p4/2p5/2P1P3/5N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Chekhover Variation",
    fen: "rnbqkbnr/pp2pppp/3p4/8/3QP3/5N2/PPP2PPP/RNB1KB1R",
  },
  {
    name: "Sicilian Defense: Chekhover Variation, Zaitsev Defense",
    fen: "r1b1kbnr/pp1qpppp/2np4/1B6/3QP3/5N2/PPP2PPP/RNB1K2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Accelerated Dragon",
    fen: "rnbqkbnr/pp2pp1p/3p2p1/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Modern Variations, Ginsberg Gambit",
    fen: "rnbqkb1r/pp2pppp/3p1n2/8/2BNP3/8/PPP2PPP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Modern Variations, Main Line",
    fen: "rnbqkb1r/pp2pppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Prins Variation",
    fen: "rnbqkb1r/pp2pppp/3p1n2/8/3NP3/5P2/PPP3PP/RNBQKB1R",
  },
  {
    name: "Sicilian Defense: Prins Variation, Venice Attack",
    fen: "rnbqkb1r/pp3ppp/3p1n2/1B2p3/3NP3/5P2/PPP3PP/RNBQK2R",
  },
  {
    name: "Sicilian Defense: Classical Variation",
    fen: "r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Classical Variation, Fianchetto Variation",
    fen: "r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N3P1/PPP2P1P/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Kupreichik Variation",
    fen: "rn1qkb1r/pp1bpppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Spielmann Variation",
    fen: "r1bqkb1r/pp2pppp/2np1n2/8/4P3/2N5/PPP1NPPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Venice Attack",
    fen: "rnbqkb1r/pp3ppp/3p1n2/1B2p3/3NP3/2N5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Yates Variation",
    fen: "r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2NB4/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Classical Variation, Anti-Sozin Variation",
    fen: "r1b1kb1r/pp2pppp/1qnp1n2/8/2BNP3/2N5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Classical Variation, Sozin Attack",
    fen: "r1bqkb1r/pp2pppp/2np1n2/8/2BNP3/2N5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Magnus Smith Trap",
    fen: "r1bqkb1r/p3pp1p/2pp1np1/4P3/2B5/2N5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Boleslavsky Variation",
    fen: "r1bqkb1r/pp3ppp/2np1n2/4p3/3NP3/2N5/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Boleslavsky Variation, Louma Variation",
    fen: "r1bqkb1r/pp3ppp/2Np1n2/4p3/4P3/2N5/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Classical Variation",
    fen: "r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Classical Variation, Dragon Transfer",
    fen: "r1bqkb1r/pp2pp1p/3p1np1/8/3QP3/2N5/PPP1BPPP/R1B1K2R",
  },
  {
    name: "Sicilian Defense: Boleslavsky Variation",
    fen: "r1bqkb1r/pp3ppp/2np1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation",
    fen: "r1bqkb1r/pp2pppp/2np1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Dragon Variation",
    fen: "r1bqkb1r/pp2pp1p/2np1np1/6B1/3NP3/2N5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Modern Variation",
    fen: "r2qkb1r/pp1bpppp/2np1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Modern Variation",
    fen: "r2qkb1r/pp1bpppp/2np1n2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation",
    fen: "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation",
    fen: "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2NQ4/PPP2PPP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Exchange Variation",
    fen: "r1bqkb1r/pp3ppp/2Nppn2/6B1/4P3/2N5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Podebrady Variation",
    fen: "r1bqkb1r/pp3ppp/2nppn2/6B1/4P3/1NN5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Vitolins Variation",
    fen: "r1bqkb1r/pp3ppp/2nppn2/1B4B1/3NP3/2N5/PPP2PPP/R2QK2R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Classical Variation",
    fen: "r1bqk2r/pp2bppp/2nppn2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Classical Variation, Kantscher Line",
    fen: "r1bqk2r/4bppp/p2ppn2/1p4B1/3QPP2/2N5/PPP3PP/2KR1B1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Ivanov Variation",
    fen: "r1b1kb1r/pp3ppp/1qnppn2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Traditional Variation",
    fen: "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Classical Variation",
    fen: "r1bq1rk1/pp2bppp/2np1n2/4p1B1/3NPP2/2N5/PPPQ2PP/2KR1B1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Classical Variation",
    fen: "r1bq1rk1/pp2bppp/2nppn2/6B1/3NPP2/2N5/PPPQ2PP/2KR1B1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Classical Variation",
    fen: "r1bq1rk1/pp2bppp/3ppn2/6B1/3QPP2/2N5/PPP3PP/2KR1B1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Rauzer Attack",
    fen: "r1bq1rk1/pp2bppp/3ppn2/6B1/3nPP2/2N5/PPPQ2PP/2KR1B1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Neo-Modern Variation, Early Deviations",
    fen: "r1bqkb1r/1p3ppp/p1nppn2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Neo-Modern Variation",
    fen: "r2qkb1r/1p1b1ppp/p1nppn2/6B1/3NP3/2N5/PPPQ1PPP/2KR1B1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Neo-Modern Variation",
    fen: "r2qk2r/1p1bbppp/p1nppn2/6B1/3NPP2/2N5/PPPQ2PP/2KR1B1R",
  },
  {
    name: "Sicilian Defense: Richter-Rauzer Variation, Neo-Modern Variation, Nyezhmetdinov Attack",
    fen: "r2qk2r/3bbppp/p1nppB2/1p6/4PP2/2N2N2/PPPQ2PP/2KR1B1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation",
    fen: "rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation",
    fen: "rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N5/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Fianchetto Variation",
    fen: "rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N3P1/PPP2P1P/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Levenfish Variation",
    fen: "rnbqkb1r/pp2pp1p/3p1np1/8/3NPP2/2N5/PPP3PP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Levenfish Variation, Main Line",
    fen: "r1bqkb1r/pp1npp1p/3p1np1/8/3NPP2/2N5/PPP3PP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation",
    fen: "rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N1B3/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation",
    fen: "rnbqk2r/pp2ppbp/3p1np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation",
    fen: "r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation",
    fen: "r1bqk2r/pp2ppbp/2np1np1/8/4P3/1NN1B3/PPP1BPPP/R2QK2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Amsterdam Variation",
    fen: "r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPPQBPPP/R3K2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Grigoriev Variation",
    fen: "r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPPQBPPP/2KR3R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation",
    fen: "r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Battery Variation",
    fen: "r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPPQBPPP/R4RK1",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Zollner Gambit",
    fen: "r1b2rk1/pp2ppbp/1qnp1np1/4P3/3N1P2/2N1B3/PPP1B1PP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Alekhine Line",
    fen: "r1bq1rk1/1p2ppbp/2np1np1/p7/4P3/1NN1B3/PPP1BPPP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Bernard Defense",
    fen: "r2q1rk1/pp2ppbp/5np1/n2p1P2/4P3/1NNPB3/PP4PP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Maróczy Line",
    fen: "r2q1rk1/pp2ppbp/3pbnp1/n7/4PP2/1NN1B3/PPP1B1PP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Normal Line",
    fen: "r1bq1rk1/pp2ppbp/2np1np1/8/4P3/1NN1B3/PPP1BPPP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Spielmann Variation",
    fen: "r2q1rk1/pp2ppbp/3p1np1/n4P2/2b1P3/1NNBB3/PPP3PP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Stockholm Attack",
    fen: "r4rk1/pp2ppbp/3p1np1/q4P2/4P1P1/2N1B3/PPP1Q2P/R4RK1",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Classical Variation, Tartakower Line",
    fen: "r1q2rk1/pp2ppbp/2npbnp1/8/4PP2/1NN1B3/PPP1B1PP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack, Belezky Line",
    fen: "r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1BP2/PPP3PP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack, Early Deviations",
    fen: "rnbqk2r/pp2ppbp/3p1np1/8/3NP3/2N1BP2/PPP3PP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack",
    fen: "rnbq1rk1/pp2ppbp/3p1np1/8/3NP3/2N1BP2/PPP3PP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack",
    fen: "r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1BP2/PPPQ2PP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack, Modern Line",
    fen: "r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1BP2/PPPQ2PP/2KR1B1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack, Panov Variation",
    fen: "r1bq1rk1/pp2ppbp/2np1np1/8/3NP1P1/2N1BP2/PPPQ3P/R3KB1R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack",
    fen: "r2q1rk1/pp1bppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/R3K2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack, Byrne Variation",
    fen: "r1bq1rk1/1p2ppbp/2np1np1/p7/2BNP3/2N1BP2/PPPQ2PP/R3K2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack, Czerniak Variation",
    fen: "r2q1rk1/pp2ppbp/3pbnp1/8/2BBP3/2N2P2/PPPQ2PP/R3K2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack, Main Line",
    fen: "r1bq1rk1/pp2ppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/R3K2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack, Sosonko Variation",
    fen: "r1bq1rk1/pp1nppbp/2np2p1/8/2BNP3/2N1BP2/PPPQ2PP/R3K2R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack",
    fen: "r2q1rk1/pp1bppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/2KR3R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack, Old Line",
    fen: "2rq1rk1/pp1bppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/2KR3R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack",
    fen: "r1r3k1/pp1bppbp/2np1np1/q7/3NP2P/1BN1BP2/PPPQ2P1/2KR3R",
  },
  {
    name: "Sicilian Defense: Dragon Variation, Yugoslav Attack, Soltis Variation",
    fen: "r1r3k1/pp1bppb1/2np1np1/q6p/3NP2P/1BN1BP2/PPPQ2P1/2KR3R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation",
    fen: "rnbqkb1r/pp3ppp/3ppn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, English Attack, with Qd2",
    fen: "rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/2N1B3/PPPQ1PPP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Fianchetto Variation",
    fen: "rnbqkb1r/pp3ppp/3ppn2/8/3NP3/2N3P1/PPP2P1P/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Vitolins Variation",
    fen: "rnbqkb1r/pp3ppp/3ppn2/1B6/3NP3/2N5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Keres Attack",
    fen: "rnbqkb1r/pp3ppp/3ppn2/8/3NP1P1/2N5/PPP2P1P/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Matanovic Attack",
    fen: "rnbqkb1r/pp3ppp/3ppn2/8/3NPP2/2N5/PPP3PP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Tal Variation",
    fen: "r1bqk2r/pp2bppp/2nppn2/8/3NPP2/2N1BQ2/PPP3PP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Classical Variation",
    fen: "rnbqkb1r/pp3ppp/3ppn2/8/3NP3/2N5/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Modern Variation",
    fen: "r1bqkb1r/pp3ppp/2nppn2/8/3NP3/2N5/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Modern Variation",
    fen: "r1bq1rk1/pp2bppp/2nppn2/8/3NPP2/2N1B3/PPP1B1PP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Modern Variation",
    fen: "r2q1rk1/pp1bbppp/2nppn2/8/4PP2/1NN1B3/PPP1B1PP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Scheveningen Variation",
    fen: "r1bqkb1r/1p1n1ppp/p2ppn2/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Classical Variation",
    fen: "rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/2N5/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Classical Variation",
    fen: "rnb1kb1r/1pq2ppp/p2ppn2/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Classical Main Line",
    fen: "r1b2rk1/1pq1bppp/p1nppn2/8/3NPP2/2N1B3/PPP1B1PP/R3QRK1",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Classical Variation, Paulsen Variation",
    fen: "r1b1kb1r/1pq2ppp/p1nppn2/8/3NPP2/2N5/PPP1B1PP/R1BQ1RK1",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Classical Variation, Paulsen Variation",
    fen: "r1b1kb1r/1pq2ppp/p1nppn2/8/3NPP2/2N1B3/PPP1B1PP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Classical Variation, Paulsen Variation",
    fen: "r1b1k2r/1pq1bppp/p1nppn2/8/P2NPP2/2N5/1PP1B1PP/R1BQ1R1K",
  },
  {
    name: "Sicilian Defense: Sozin Attack",
    fen: "rnbqkb1r/pp3ppp/3ppn2/8/2BNP3/2N5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Sozin Attack, Flank Variation",
    fen: "rnbqkb1r/5ppp/p2ppn2/1p6/3NP3/1BN5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Sozin Attack, Fischer Variation",
    fen: "r1bq1rk1/pp2bppp/2nppn2/8/3NPP2/1BN1B3/PPP3PP/R2QK2R",
  },
  {
    name: "Sicilian Defense: Sozin Attack, Leonhardt Variation",
    fen: "r1bqkb1r/pp3ppp/2nppn2/8/2BNP3/2N5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Sozin Attack, Main Line",
    fen: "r1bqkb1r/pp3ppp/2nppn2/8/2BNP3/2N1B3/PPP2PPP/R2QK2R",
  },
  {
    name: "Sicilian Defense: Sozin Attack, Main Line, Sherbakov Variation",
    fen: "r1bq1rk1/p3bppp/1p1ppn2/n7/3NPP2/1BN1B3/PPP3PP/R2Q1RK1",
  },
  {
    name: "Sicilian Defense: Velimirovic Attack",
    fen: "r1bqk2r/pp2bppp/2nppn2/8/2BNP3/2N1B3/PPP1QPPP/R3K2R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation",
    fen: "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Adams Attack",
    fen: "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N4P/PPP2PP1/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Dekker Gambit",
    fen: "rnbqkb1r/1p2pppp/p2p1n2/8/3NP1P1/2N5/PPP2P1P/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, English Attack",
    fen: "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N1B3/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, English Attack, Anti-English",
    fen: "rnbqkb1r/1p2pppp/p2p4/8/3NP1n1/2N1B3/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Freak Attack",
    fen: "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKBR1",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Lipnitsky Attack",
    fen: "rnbqkb1r/1p2pppp/p2p1n2/8/2BNP3/2N5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Delayed Keres Attack",
    fen: "rnbqkb1r/1p3ppp/p2ppn2/8/3NP1P1/2N1B3/PPP2P1P/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, Delayed Keres Attack, Perenyi Gambit",
    fen: "rnbqkb1r/1p3p1p/p2p1np1/4pNP1/4P3/2N1B3/PPP2P1P/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Scheveningen Variation, English Attack, with f3",
    fen: "rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/2N1BP2/PPP3PP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Zagreb Variation",
    fen: "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N3P1/PPP2P1P/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Opocensky Variation",
    fen: "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP1BPPP/R1BQK2R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Opocensky Variation, Modern Line",
    fen: "rn1qk2r/1p2bppp/p2pbn2/4p3/4P3/1NN5/PPP1BPPP/R1BQ1RK1",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Opocensky Variation, Traditional Line",
    fen: "rnbq1rk1/1p2bppp/p2p1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQ1RK1",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Amsterdam Variation",
    fen: "rnbqkb1r/1p2pppp/p2p1n2/8/3NPP2/2N5/PPP3PP/R1BQKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation",
    fen: "rnbqkb1r/1p2pppp/p2p1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Ivkov Variation",
    fen: "r3kb1r/1b3ppp/p2ppn2/qpn1P1B1/3N4/1BN5/PPPQ1PPP/2KRR3",
  },
  {
    name: "Sicilian Defense: Najdorf Variation",
    fen: "rnbqkb1r/1p3ppp/p2ppn2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation",
    fen: "rnbqkb1r/1p3ppp/p2ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Neo-Classical Defense",
    fen: "r1bqkb1r/1p3ppp/p1nppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Polugaevsky Variation",
    fen: "rnbqkb1r/5ppp/p2ppn2/1p4B1/3NPP2/2N5/PPP3PP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Polugaevsky Variation, Simagin Line",
    fen: "rnb1kb1r/2q2ppp/p3pn2/1p2P1B1/3N4/2N5/PPP1Q1PP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Poisoned Pawn Accepted",
    fen: "rnb1kb1r/1p3ppp/p2ppn2/6B1/3NPP2/q1N5/P1PQ2PP/1R2KB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Poisoned Pawn Variation",
    fen: "rnb1kb1r/1p3ppp/pq1ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation",
    fen: "rnbqk2r/1p2bppp/p2ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Browne Variation",
    fen: "rnb1k2r/1pq1bpp1/p2ppn1p/8/3NPP1B/2N2Q2/PPP3PP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Goteborg Variation",
    fen: "rnbqk2r/1p2bp2/p2ppn1p/6p1/3NPP1B/2N2Q2/PPP3PP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Traditional Line",
    fen: "rnb1k2r/1pq1bppp/p2ppn2/6B1/3NPP2/2N2Q2/PPP3PP/R3KB1R",
  },
  {
    name: "Sicilian Defense: Najdorf Variation, Main Line",
    fen: "r1b1k2r/1pqnbppp/p2ppn2/6B1/3NPP2/2N2Q2/PPP3PP/2KR1B1R",
  },
  {
    name: "French Defense",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "French Defense",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Alapin Gambit",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/4B3/PPP2PPP/RN1QKBNR",
  },
  {
    name: "French Defense: Baeuerle Gambit",
    fen: "rnbqkbnr/p1pp1ppp/4p3/1p6/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Banzai-Leong Gambit",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/1P2P3/8/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Banzai-Leong Gambit, Pinova Gambit",
    fen: "rnbqk1nr/pppp1ppp/4p3/4P3/1b6/8/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Bird Invitation",
    fen: "rnbqkbnr/pppp1ppp/4p3/1B6/4P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "French Defense: Carlson Gambit",
    fen: "rnbqkbnr/ppp2ppp/4p3/4N3/3Pp3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "French Defense: Chigorin Variation",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPPQPPP/RNB1KBNR",
  },
  {
    name: "French Defense: Diemer-Duhm Gambit",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/2PPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Diemer-Duhm Gambit Accepted",
    fen: "rnbqkbnr/ppp2ppp/4p3/8/2PPp3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Franco-Hiva Gambit",
    fen: "rnbqkbnr/pppp2pp/4p3/5p2/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Franco-Hiva Gambit Accepted",
    fen: "rnbqkbnr/pppp2pp/4p3/5P2/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Franco-Sicilian Defense",
    fen: "rnbqkbnr/pp1p1ppp/4p3/2p5/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Hoffmann Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3p4/3PPp2/8/PPP1Q1PP/RNB1KBNR",
  },
  {
    name: "French Defense: Horwitz Attack",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/4P3/1P6/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Horwitz Attack, Papa-Ticulat Gambit",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/4P3/1P6/PBPP1PPP/RN1QKBNR",
  },
  {
    name: "French Defense: King's Indian Attack",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/4P3/3P4/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: King's Indian Attack, Franco-Hiva Gambit",
    fen: "rnbqkbnr/pppp2pp/4p3/5p2/4P3/3P4/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Knight Variation",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "French Defense: Knight Variation, Franco-Hiva Gambit",
    fen: "rnbqkbnr/pppp2pp/4p3/5p2/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "French Defense: La Bourdonnais Variation",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "French Defense: La Bourdonnais Variation, Reuter Gambit",
    fen: "rnbqkbnr/ppp2ppp/4p3/8/4pP2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "French Defense: Mediterranean Defense",
    fen: "rnbqkb1r/pppp1ppp/4pn2/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Morphy Gambit",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/7N/PPP2PPP/RNBQKB1R",
  },
  {
    name: "French Defense: Normal Variation",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Orthoschnapp Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3p4/4P3/1Q6/PP1P1PPP/RNB1KBNR",
  },
  {
    name: "French Defense: Pelikan Variation",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/4PP2/2N5/PPPP2PP/R1BQKBNR",
  },
  {
    name: "French Defense: Perseus Gambit",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "French Defense: Queen's Knight",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Reversed Philidor Formation",
    fen: "r1bqkb1r/ppp2ppp/2n1pn2/3p4/4P3/3P1N2/PPPNBPPP/R1BQK2R",
  },
  {
    name: "French Defense: Réti-Spielmann Attack",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/4P3/6P1/PPPP1P1P/RNBQKBNR",
  },
  {
    name: "French Defense: Schlechter Variation",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/3B4/PPP2PPP/RNBQK1NR",
  },
  {
    name: "French Defense: St. George Defense",
    fen: "rnbqkbnr/1ppp1ppp/p3p3/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: St. George Defense, Sanky-George Gambit",
    fen: "rnbqkbnr/2pp1ppp/p3p3/1p6/2PPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "French Defense: St. George Defense, St. George Gambit",
    fen: "rnbqkbnr/2pp1ppp/4p3/1p6/3PP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "French Defense: St. George Defense, Three Pawn Attack",
    fen: "rnbqkbnr/1ppp1ppp/p3p3/8/2PPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "French Defense: St. George Defense, Traditional Line",
    fen: "rn1qkb1r/1b1p1ppp/p3pn2/1pp5/3PP3/2PB1N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "French Defense: Steiner Variation",
    fen: "rnbqkbnr/pppp1ppp/4p3/8/2P1P3/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Steinitz Attack",
    fen: "rnbqkbnr/pppp1ppp/4p3/4P3/8/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Two Knights Variation",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/4P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "French Defense: Wing Gambit",
    fen: "rnbqkbnr/pp3ppp/4p3/2ppP3/1P6/5N2/P1PP1PPP/RNBQKB1R",
  },
  {
    name: "Rat Defense: Small Center Defense",
    fen: "rnbqkbnr/ppp2ppp/3pp3/8/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Exchange Variation",
    fen: "rnbqkbnr/ppp2ppp/4p3/3P4/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Exchange Variation, Bogoljubov Variation",
    fen: "r1bqkb1r/ppp2ppp/2n2n2/3p2B1/3P4/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Exchange Variation, Monte Carlo Variation",
    fen: "rnbqkbnr/ppp2ppp/8/3p4/2PP4/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Exchange Variation, Svenonius Variation",
    fen: "rnbqkb1r/ppp2ppp/5n2/3p2B1/3P4/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Advance Variation",
    fen: "rnbqkbnr/ppp2ppp/4p3/3pP3/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Advance Variation",
    fen: "rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Advance Variation",
    fen: "rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Advance Variation",
    fen: "r1bqkbnr/pp3ppp/2n1p3/2ppP3/3P4/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Advance Variation, Euwe Variation",
    fen: "r2qkbnr/pp1b1ppp/2n1p3/2ppP3/3P4/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "French Defense: Advance Variation, Extended Bishop Swap",
    fen: "rn1qkbnr/pppb1ppp/4p3/3pP3/3P4/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Advance Variation, Frenkel Gambit",
    fen: "rnbqkbnr/pp3ppp/4p3/2ppP3/1P1P4/8/P1P2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Advance Variation, Lputian Variation",
    fen: "r1b1kb1r/pp3ppp/1qn1p2n/2ppP3/3P4/P1P2N2/1P3PPP/RNBQKB1R",
  },
  {
    name: "French Defense: Advance Variation, Main Line",
    fen: "r1b1kbnr/pp3ppp/1qn1p3/2ppP3/3P4/P1P2N2/1P3PPP/RNBQKB1R",
  },
  {
    name: "French Defense: Advance Variation, Milner-Barry Gambit",
    fen: "r1b1kbnr/pp3ppp/1qn1p3/2ppP3/3P4/2PB1N2/PP3PPP/RNBQK2R",
  },
  {
    name: "French Defense: Advance Variation, Nimzowitsch Attack",
    fen: "rnbqkbnr/pp3ppp/4p3/2ppP3/3P2Q1/8/PPP2PPP/RNB1KBNR",
  },
  {
    name: "French Defense: Advance Variation, Nimzowitsch Gambit",
    fen: "rnbqkbnr/pp3ppp/4p3/3pP3/3p2Q1/5N2/PPP2PPP/RNB1KB1R",
  },
  {
    name: "French Defense: Advance Variation, Nimzowitsch System",
    fen: "rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "French Defense: Advance Variation, Paulsen Attack",
    fen: "r1bqkbnr/pp3ppp/2n1p3/2ppP3/3P4/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "French Defense: Advance Variation, Ruisdonk Gambit",
    fen: "rnbqkbnr/pp3ppp/4p3/3pP3/3p4/3B1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "French Defense: Advance Variation, Steinitz Variation",
    fen: "rnbqkbnr/pp3ppp/4p3/2PpP3/8/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "French Defense: Advance Variation, Wade Variation",
    fen: "rn2kbnr/pp1b1ppp/1q2p3/2ppP3/3P4/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "French Defense: Guimard Variation, Thunderbunny Variation",
    fen: "r1bqkbnr/ppp2ppp/2n5/4p3/3PN3/2P5/PP3PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Guimard Defense",
    fen: "r1bqkbnr/ppp2ppp/2n1p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Haberditz Variation",
    fen: "rnbqkbnr/ppp3pp/4p3/3p1p2/3PP3/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Modern System",
    fen: "rnbqkbnr/1pp2ppp/p3p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Morozevich Variation",
    fen: "rnbqk1nr/ppp1bppp/4p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Guimard Defense, Main Line",
    fen: "r1bqkb1r/ppp2ppp/2n1pn2/3p4/3PP3/5N2/PPPN1PPP/R1BQKB1R",
  },
  {
    name: "French Defense: Tarrasch Variation, Botvinnik Variation",
    fen: "rnbqkb1r/p2n1ppp/1p2p3/2ppP3/3P4/2PB4/PP1N1PPP/R1BQK1NR",
  },
  {
    name: "French Defense: Tarrasch Variation, Closed Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/3PP3/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Closed Variation",
    fen: "r1bqkb1r/pp1n1ppp/2n1p3/2ppP3/3P4/2PB4/PP1N1PPP/R1BQK1NR",
  },
  {
    name: "French Defense: Tarrasch Variation, Pawn Center Variation",
    fen: "rnbqkb1r/pppn1ppp/4p3/3pP3/3P1P2/8/PPPN2PP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Closed Variation, Main Line",
    fen: "r1bqkb1r/pp1n1ppp/2n1p3/3pP3/3P4/3B4/PP1NNPPP/R1BQK2R",
  },
  {
    name: "French Defense: Tarrasch Variation, Leningrad Variation",
    fen: "r1bqkb1r/pp3ppp/1nn1p3/3pP3/3P4/3B4/PP1NNPPP/R1BQK2R",
  },
  {
    name: "French Defense: Tarrasch Variation, Chistyakov Defense",
    fen: "rnb1kbnr/pp3ppp/4p3/2pq4/3P4/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Chistyakov Defense, Modern Line",
    fen: "r1b1kb1r/1p3ppp/p2qpn2/8/2BN4/8/PPP2PPP/R1BQ1RK1",
  },
  {
    name: "French Defense: Tarrasch Variation, Eliskases Variation",
    fen: "rnbqkbnr/pp3ppp/4p3/8/2Bp4/5N2/PPPN1PPP/R1BQK2R",
  },
  {
    name: "French Defense: Tarrasch Variation, Open System",
    fen: "rnbqkbnr/pp3ppp/4p3/2pp4/3PP3/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Open System, Euwe-Keres Line",
    fen: "rnbqkbnr/pp3ppp/4p3/2pp4/3PP3/5N2/PPPN1PPP/R1BQKB1R",
  },
  {
    name: "French Defense: Tarrasch Variation, Open System, Shaposhnikov Gambit",
    fen: "rnbqkb1r/pp3ppp/4pn2/2pP4/3P4/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Open System, Süchting Line",
    fen: "rnbqkbnr/pp3ppp/4p3/2pp4/3PP3/2P5/PP1N1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Open System",
    fen: "rnbqkbnr/pp3ppp/8/2pp4/3P4/8/PPPN1PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Tarrasch Variation, Open System, Advance Line",
    fen: "rnbqkbnr/pp3ppp/8/3p4/2pP4/5N2/PPPN1PPP/R1BQKB1R",
  },
  {
    name: "French Defense: Tarrasch Variation, Open System, Main Line",
    fen: "r1bqkbnr/pp3ppp/2n5/2pp4/3P4/5N2/PPPN1PPP/R1BQKB1R",
  },
  {
    name: "French Defense: Classical Variation, Svenonius Variation",
    fen: "r1bqkbnr/ppp2ppp/2n1p3/3P4/3P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Paulsen Variation",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Rubinstein Variation",
    fen: "rnbqkbnr/ppp2ppp/4p3/8/3Pp3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Rubinstein Variation, Blackburne Defense",
    fen: "r1bqkbnr/pppn1ppp/4p3/8/3PN3/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Rubinstein Variation, Capablanca Line",
    fen: "r1bqkb1r/ppp2ppp/4pn2/4N3/3P4/8/PPP2PPP/R1BQKB1R",
  },
  {
    name: "French Defense: Rubinstein Variation, Ellis Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/3PN3/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Rubinstein Variation, Fort Knox Variation",
    fen: "rn1qkbnr/ppp2ppp/2b1p3/8/3PN3/5N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "French Defense: Rubinstein Variation, Kasparov Attack",
    fen: "r1bqkb1r/ppp2ppp/4pn2/8/3P4/2P2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "French Defense: Rubinstein Variation, Maric Variation",
    fen: "rnb1kbnr/ppp2ppp/4p3/3q4/3PN3/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Sicilian Defense: Marshall Gambit",
    fen: "rnbqkbnr/pp3ppp/4p3/2pp4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Burn Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p2B1/3PP3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Classical Variation, Burn Variation, Main Line",
    fen: "rnbq1rk1/ppp2ppp/4pb2/8/3PN3/5N2/PPP2PPP/R2QKB1R",
  },
  {
    name: "French Defense: Classical Variation, Burn Variation, Morozevich Line",
    fen: "rnbqk2r/ppp1bp1p/4pp2/8/3PN3/8/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation, Delayed Exchange Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3P4/3P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Classical Variation, Steinitz Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3pP3/3P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Classical Variation, Swiss Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/3PP3/2NB4/PPP2PPP/R1BQK1NR",
  },
  {
    name: "French Defense: Henneberger Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/3PP3/2N1B3/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Steinitz Variation",
    fen: "r1bqkb1r/pp1n1ppp/2n1p3/2PpP3/5P2/2N5/PPP3PP/R1BQKBNR",
  },
  {
    name: "French Defense: Steinitz Variation",
    fen: "rnbqkb1r/pp1n1ppp/4p3/2ppP3/3P1P2/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "French Defense: Steinitz Variation, Boleslavsky Variation",
    fen: "r1bqkb1r/pp1n1ppp/2n1p3/2ppP3/3P1P2/2N1BN2/PPP3PP/R2QKB1R",
  },
  {
    name: "French Defense: Steinitz Variation, Bradford Attack Variation",
    fen: "rnbqk2r/pp1n1ppp/4p3/2bpP3/5PQ1/2N5/PPP3PP/R1B1KBNR",
  },
  {
    name: "French Defense: Steinitz Variation, Brodsky-Jones Variation",
    fen: "r1bq1rk1/pp1n2pp/2n1pp2/2bpP3/5PQ1/P1N2N2/1PP3PP/R1B1KB1R",
  },
  {
    name: "French Defense: Steinitz Variation, Gledhill Attack",
    fen: "rnbqkb1r/pppn1ppp/4p3/3pP3/3P2Q1/2N5/PPP2PPP/R1B1KBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation",
    fen: "rnbqk2r/ppp2ppp/4pn2/3p2B1/1b1PP3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Advance Variation",
    fen: "rnbqk2r/ppp2ppp/4pn2/3pP1B1/1b1P4/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Bernstein Variation",
    fen: "rnbqk2r/ppp2pp1/4pn1p/3pP3/1b1P3B/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Bogoljubov Variation",
    fen: "rnb1k2r/ppp2p1p/4pp2/q7/1b1P4/2N5/PPPQ1PPP/R3KBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Chigorin Variation",
    fen: "rnbqk2r/ppp2pp1/4pP1p/3p2B1/1b1P4/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Dr. Olland Variation",
    fen: "rnbqk2r/ppp2pp1/4pn1p/3pP3/1b1P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Duras Variation",
    fen: "rnbq1k1r/ppp2pp1/4p2p/3pP3/3Pn1Q1/2P5/P1P2PPP/R1B1KBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Exchange Variation",
    fen: "rnbqk2r/ppp2ppp/4pn2/3P2B1/1b1P4/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Grigoriev Variation",
    fen: "rnbqk1r1/ppp2pP1/4p3/3p4/1b1P2Qp/2N5/PPP2PP1/R3KBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Janowski Variation",
    fen: "rnbqk2r/ppp2pp1/4pn1p/3pP3/1b1P4/2N1B3/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Lasker Variation",
    fen: "rnbqk2r/ppp2pp1/4pn1p/3pP3/3P4/2b5/PPPB1PPP/R2QKBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Lasker Variation",
    fen: "rnbqk2r/ppp2p2/4p1pp/3pP3/3Pn1Q1/2P5/P1PB1PPP/R3KBNR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Tartakower Variation",
    fen: "rnbqk2r/pppn1pp1/4p2p/3pP3/1b1P4/2N5/PPPB1PPP/R2QKBNR",
  },
  {
    name: "French Defense: Alekhine-Chatard Attack",
    fen: "rnbqk2r/pppnbppp/4p3/3pP1B1/3P3P/2N5/PPP2PP1/R2QKBNR",
  },
  {
    name: "French Defense: Alekhine-Chatard Attack, Albin-Chatard Gambit",
    fen: "rnb1k2r/pppn1ppp/4p3/3pP1q1/3P4/2N5/PPP2PP1/R2QKBNR",
  },
  {
    name: "French Defense: Alekhine-Chatard Attack, Breyer Variation",
    fen: "rnbqk2r/pp1nbppp/4p3/2ppP1B1/3P3P/2N5/PPP2PP1/R2QKBNR",
  },
  {
    name: "French Defense: Alekhine-Chatard Attack, Maróczy Variation",
    fen: "rnbqk2r/1ppnbppp/p3p3/3pP1B1/3P3P/2N5/PPP2PP1/R2QKBNR",
  },
  {
    name: "French Defense: Alekhine-Chatard Attack, Spielmann Variation",
    fen: "rnbq1rk1/pppnbppp/4p3/3pP1B1/3P3P/2N5/PPP2PP1/R2QKBNR",
  },
  {
    name: "French Defense: Alekhine-Chatard Attack, Teichmann Variation",
    fen: "rnbqk2r/pppnb1pp/4pp2/3pP1B1/3P3P/2N5/PPP2PP1/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation, Frankfurt Variation",
    fen: "rnbqk1nr/p1p1bppp/1p2p3/3pP3/3P4/2N1B3/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation, Normal Variation",
    fen: "rnbqk2r/ppp1bppp/4pn2/3p2B1/3PP3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation, Richter Attack",
    fen: "rnbqk2r/ppp1bppp/4pB2/3p4/3PP3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation, Richter Attack",
    fen: "rnbqk2r/ppp1bppp/4p3/3pP3/3P2Q1/2N5/PPP2PPP/R3KBNR",
  },
  {
    name: "French Defense: Classical Variation, Tartakower Variation",
    fen: "rnbqk2r/ppp1bppp/4p3/3pP1B1/3Pn3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation, Vistaneckis Variation",
    fen: "rnbqk1nr/ppp1bppp/4p3/3pP1B1/3P4/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation",
    fen: "rnb1k2r/pppnqppp/4p3/3pP3/3P4/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation, Alapin Variation",
    fen: "rnb1k2r/pppnqppp/4p3/1N1pP3/3P4/8/PPP2PPP/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation, Pollock Variation",
    fen: "rnb1k2r/pppnqppp/4p3/3pP3/3P2Q1/2N5/PPP2PPP/R3KBNR",
  },
  {
    name: "French Defense: Classical Variation, Rubinstein Variation",
    fen: "rnb1k2r/pppnqppp/4p3/3pP3/3P4/2N5/PPPQ1PPP/R3KBNR",
  },
  {
    name: "French Defense: Classical Variation, Stahlberg Variation",
    fen: "r1b2rk1/pp1nqppp/2n1p3/3pP3/2pP1P2/2N2N2/PPPQ2PP/2KR1B1R",
  },
  {
    name: "French Defense: Classical Variation, Steinitz Variation",
    fen: "rnb1k2r/pppnqppp/4p3/3pP3/3P1P2/2N5/PPP3PP/R2QKBNR",
  },
  {
    name: "French Defense: Classical Variation, Tarrasch Variation",
    fen: "rnb1k2r/pppnqppp/4p3/3pP3/3P4/2NB4/PPP2PPP/R2QK1NR",
  },
  {
    name: "French Defense: MacCutcheon Variation, Wolf Gambit",
    fen: "rnbqk2r/ppp2ppp/4pn2/3p2B1/1b1PP3/2N5/PPP1NPPP/R2QKB1R",
  },
  {
    name: "French Defense: Winawer Variation",
    fen: "rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Alekhine Gambit Accepted",
    fen: "rnbqk1nr/ppp2ppp/4p3/8/3Pp3/P1b5/1PP1NPPP/R1BQKB1R",
  },
  {
    name: "French Defense: Winawer Variation, Alekhine Gambit, Alatortsev Variation",
    fen: "r1bq1rk1/ppp1bppp/2n1pn2/8/3PN3/P5N1/1PP1BPPP/R1BQK2R",
  },
  {
    name: "French Defense: Winawer Variation, Alekhine Gambit, Kan Variation",
    fen: "r1bqk1nr/ppp2ppp/2n1p3/8/3Pp3/P1N5/1PP2PPP/R1BQKB1R",
  },
  {
    name: "French Defense: Winawer Variation, Alekhine-Maróczy Gambit",
    fen: "rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP1NPPP/R1BQKB1R",
  },
  {
    name: "French Defense: Winawer Variation, Delayed Exchange Variation",
    fen: "rnbqk1nr/ppp2ppp/4p3/3P4/1b1P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Exchange Variation, Canal Attack",
    fen: "rnbqk2r/ppp1nppp/8/3p3Q/1b1P4/2NB4/PPP2PPP/R1B1K1NR",
  },
  {
    name: "French Defense: Winawer Variation, Fingerslip Variation",
    fen: "rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPPB1PPP/R2QKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Fingerslip Variation, Kunin Double Gambit",
    fen: "rnb1k1nr/ppp2ppp/4p3/8/1b1qp1Q1/2N5/PPPB1PPP/R3KBNR",
  },
  {
    name: "French Defense: Winawer Variation, Fingerslip Variation, Main Line",
    fen: "rnbqk1r1/ppp2p1p/4pn1Q/8/1b1Pp3/2N5/PPPB1PPP/R3KBNR",
  },
  {
    name: "French Defense: Winawer Variation, Fingerslip Variation, Schwarz's Line",
    fen: "rnbqk2r/ppp1nppp/4p3/3p4/1b1PP3/8/PPPB1PPP/RN1QKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Kondratiyev Variation",
    fen: "rnb1k1nr/pp3ppp/4p3/2pq4/1b1P4/2NB4/PPPB1PPP/R2QK1NR",
  },
  {
    name: "French Defense: Winawer Variation, Winckelmann-Riemer Gambit",
    fen: "rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/P1N5/1PP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Advance Variation",
    fen: "rnbqk1nr/ppp2ppp/4p3/3pP3/1b1P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Petrosian Variation",
    fen: "rnb1k1nr/pppq1ppp/4p3/3pP3/1b1P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Advance Variation",
    fen: "rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P4/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Advance Variation",
    fen: "rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P4/P1N5/1PP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Advance Variation",
    fen: "rnbqk1nr/pp3ppp/4p3/3pP3/1P6/2p2N2/1PP2PPP/R1BQKB1R",
  },
  {
    name: "French Defense: Winawer Variation, Advance Variation, Moscow Variation",
    fen: "rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P2Q1/2N5/PPP2PPP/R1B1KBNR",
  },
  {
    name: "French Defense: Winawer Variation, Bogoljubov Variation",
    fen: "rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P4/2N5/PPPB1PPP/R2QKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Bogoljubov Variation, Icelandic Defense",
    fen: "rnbqk2r/pp2nppp/4p3/2ppP3/1b1P1P2/2N5/PPPB2PP/R2QKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Maróczy-Wallis Variation",
    fen: "rnbqk1nr/pp3ppp/4p3/3pP3/1P6/2p5/1PP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Retreat Variation",
    fen: "rnbqk1nr/pp3ppp/4p3/b1ppP3/3P4/P1N5/1PP2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Retreat Variation, Armenian Line",
    fen: "rnbqk1nr/pp3ppp/4p3/b2pP3/1P1p4/P1N5/2P2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Advance Variation",
    fen: "rnbqk1nr/pp3ppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Classical Variation",
    fen: "rnb1k1nr/ppq2ppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Portisch-Hook Variation",
    fen: "rnb1k1nr/pp3ppp/4p3/q1ppP3/3P4/P1P5/2P2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Advance Variation",
    fen: "rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Advance Variation",
    fen: "rnbqk2r/pp2nppp/4p3/2ppP3/P2P4/2P5/2P2PPP/R1BQKBNR",
  },
  {
    name: "French Defense: Winawer Variation, Poisoned Pawn Variation",
    fen: "rnbqk2r/pp2nppp/4p3/2ppP3/3P2Q1/P1P5/2P2PPP/R1B1KBNR",
  },
  {
    name: "French Defense: Winawer Variation, Poisoned Pawn Variation, Main Line",
    fen: "rnb1k1r1/ppq1np1Q/4p3/3pP3/3p4/P1P5/2P1NPPP/R1B1KB1R",
  },
  {
    name: "French Defense: Winawer Variation, Poisoned Pawn Variation, Paoli Variation",
    fen: "rnb1k1r1/ppq1np1Q/4p3/3pP3/3p4/P1P5/2P2PPP/R1BK1BNR",
  },
  {
    name: "French Defense: Winawer Variation, Positional Variation",
    fen: "rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1P2N2/2P2PPP/R1BQKB1R",
  },
  {
    name: "Barnes Opening: Walkerling",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/5P2/PPPP2PP/RNBQK1NR",
  },
  {
    name: "Bongcloud Attack",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPPKPPP/RNBQ1BNR",
  },
  {
    name: "Center Game",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "English Opening: The Whale",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/2P1P3/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: Alapin Opening",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPPNPPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: Bavarian Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/2P1P3/8/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: Beyer Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: Clam Variation, King's Gambit Reversed",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/4P3/3P4/PPP2PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: Clam Variation, Radisch Gambit",
    fen: "rnbqk2r/pppp1ppp/5n2/2b1p3/4PP2/3P4/PPP3PP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: King's Head Opening",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/5P2/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: King's Head Opening",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N2P2/PPPP2PP/R1BQKBNR",
  },
  {
    name: "King's Pawn Game: Leonardis Variation",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/3P4/PPP2PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: MacLeod Attack",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/2P5/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: MacLeod Attack, Lasa Gambit",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/4P3/2P5/PP1P1PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: MacLeod Attack, Norwalde Gambit",
    fen: "rnbqk1nr/ppp2ppp/3b4/3pp2Q/4P3/2P5/PP1P1PPP/RNB1KBNR",
  },
  {
    name: "King's Pawn Game: Mengarini's Opening",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/P7/1PPP1PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: Napoleon Attack",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/5Q2/PPPP1PPP/RNB1KBNR",
  },
  {
    name: "King's Pawn Game: Philidor Gambit",
    fen: "rn1qkbnr/pppb1ppp/3p4/4P3/4P3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Game: Tortoise Opening",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/3B4/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "King's Pawn Game: Wayward Queen Attack",
    fen: "rnbqkbnr/pppp1ppp/8/4p2Q/4P3/8/PPPP1PPP/RNB1KBNR",
  },
  {
    name: "King's Pawn Game: Wayward Queen Attack, Kiddie Countergambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p2Q/4P3/8/PPPP1PPP/RNB1KBNR",
  },
  {
    name: "King's Pawn Game: Wayward Queen Attack, Mellon Gambit",
    fen: "r1bqkb1r/ppp4p/2n2ppn/3pp3/2B1P3/3P1Q2/PPP1NPPP/RNB1K2R",
  },
  {
    name: "King's Pawn Game: Weber Gambit",
    fen: "r1bqkbnr/pp3ppp/2n5/4p3/8/3P4/PPP2PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Opening",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/1P6/P1PP1PPP/RNBQKBNR",
  },
  {
    name: "King's Pawn Opening: Speers",
    fen: "rnbqkb1r/pppp1ppp/5n2/4pQ2/4P3/8/PPPP1PPP/RNB1KBNR",
  },
  {
    name: "King's Pawn Opening: Van Hooydoon Gambit",
    fen: "r1bqk2r/pppp1ppp/5n2/2b5/3nP3/5N2/PP2QPPP/RNB1KB1R",
  },
  {
    name: "Portuguese Opening",
    fen: "rnbqkbnr/pppp1ppp/8/1B2p3/4P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Portuguese Opening: Miguel Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/1Bb1p3/1P2P3/8/P1PP1PPP/RNBQK1NR",
  },
  {
    name: "Portuguese Opening: Portuguese Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/1B2p3/3PP3/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Center Game",
    fen: "rnbqkbnr/pppp1ppp/8/8/3QP3/8/PPP2PPP/RNB1KBNR",
  },
  {
    name: "Center Game Accepted",
    fen: "rnbqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Center Game: Halasz-McDonnell Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/3pPP2/8/PPP3PP/RNBQKBNR",
  },
  {
    name: "Center Game: Halasz-McDonnell Gambit, Crocodile Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b5/3pPP2/2P2N2/PP4PP/RNBQKB1R",
  },
  {
    name: "Center Game: Kieseritzky Variation",
    fen: "rnbqkbnr/pppp1ppp/8/8/3pP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Center Game: Kieseritzky Variation",
    fen: "rnbqkbnr/pp1p1ppp/8/2p5/3pP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Center Game: Kieseritzky Variation",
    fen: "rnbqkbnr/pp1p1ppp/8/2p5/2BpP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Center Game: Kieseritzky Variation",
    fen: "rnbqkbnr/p2p1ppp/8/1pp5/2BpP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Center Game: Lanc-Arnold Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/2b5/3pP3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Center Game: Lanc-Arnold Gambit, Schippler Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/2b5/2B1P3/2p2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Center Game: Ross Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/3pP3/3B4/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Center Game: von der Lasa Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/2BpP3/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Danish Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "Danish Gambit Accepted",
    fen: "rnbqkbnr/pppp1ppp/8/8/2B1P3/8/PB3PPP/RN1QK1NR",
  },
  {
    name: "Danish Gambit Accepted: Chigorin Defense",
    fen: "rnb1kbnr/ppppqppp/8/8/2B1P3/8/PB3PPP/RN1QK1NR",
  },
  {
    name: "Danish Gambit Accepted: Classical Defense",
    fen: "rnbqkb1r/pppp1ppp/5n2/8/2B1P3/8/PB3PPP/RN1QK1NR",
  },
  {
    name: "Danish Gambit Accepted: Copenhagen Defense",
    fen: "rnbqk1nr/pppp1ppp/8/8/1bB1P3/8/PB3PPP/RN1QK1NR",
  },
  {
    name: "Danish Gambit Accepted: Schlechter Defense",
    fen: "rnbqkbnr/ppp2ppp/8/3p4/2B1P3/8/PB3PPP/RN1QK1NR",
  },
  {
    name: "Danish Gambit Accepted: Svenonius Defense",
    fen: "rnbqkb1r/ppppnppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "Danish Gambit Declined: Sorensen Defense",
    fen: "rnbqkbnr/ppp2ppp/8/3p4/3pP3/2P5/PP3PPP/RNBQKBNR",
  },
  {
    name: "Center Game: Berger Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/8/4P3/4Q3/PPP2PPP/RNB1KBNR",
  },
  {
    name: "Center Game: Charousek Variation",
    fen: "r1bqk1nr/ppppbppp/2n5/8/4P3/2P1Q3/PP3PPP/RNB1KBNR",
  },
  {
    name: "Center Game: Hall Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/2Q1P3/8/PPP2PPP/RNB1KBNR",
  },
  {
    name: "Center Game: Kupreichik Variation",
    fen: "r1bqr1k1/ppp2ppp/2np1n2/8/1bB1P3/2N1Q2N/PPPB1PPP/2KR3R",
  },
  {
    name: "Center Game: Normal Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/3QP3/8/PPP2PPP/RNB1KBNR",
  },
  {
    name: "Center Game: Paulsen Attack Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/4P3/4Q3/PPP2PPP/RNB1KBNR",
  },
  {
    name: "Center Game: l'Hermet Variation",
    fen: "r1bqkbnr/pppp2pp/2n5/5p2/4P3/4Q3/PPP2PPP/RNB1KBNR",
  },
  {
    name: "Bishop's Opening",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Anderssen Gambit",
    fen: "rnbqkbnr/p2p1ppp/2p5/1B2p3/4P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Boi Variation",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Calabrese Countergambit",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/2B1P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Calabrese Countergambit, Jaenisch Variation",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/2B1P3/3P4/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Four Pawns Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/8/2BPP2b/5N2/P1P4p/RNBQ1R1K",
  },
  {
    name: "Bishop's Opening: Khan Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/2B1P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Lewis Countergambit",
    fen: "rnbqk1nr/ppp2ppp/8/2bpp3/2B1P3/2P5/PP1P1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Lewis Countergambit",
    fen: "rnbqk2r/ppp2ppp/5n2/2bBp3/4P3/2P5/PP1P1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Lewis Countergambit, Walker Variation",
    fen: "rnbqk2r/ppp2ppp/5n2/2bBp3/3PP3/2P5/PP3PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Lewis Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/2BPP3/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Lisitsyn Variation",
    fen: "r2qkbnr/pp3ppp/8/3pn3/8/8/PPP1NPPP/RNBQK2R",
  },
  {
    name: "Bishop's Opening: Lopez Gambit",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1PP2/2P5/PP1PQ1PP/RNB1K1NR",
  },
  {
    name: "Bishop's Opening: Lopez Variation",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPPQPPP/RNB1K1NR",
  },
  {
    name: "Bishop's Opening: Lopez Variation, Lopez Gambit",
    fen: "rnbqk2r/pppp1ppp/5n2/2b1p3/2B1PP2/8/PPPPQ1PP/RNB1K1NR",
  },
  {
    name: "Bishop's Opening: McDonnell Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/1PB1P3/8/P1PP1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: McDonnell Gambit, La Bourdonnais-Denker Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/4p3/1bB1P3/2P5/P2P1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: McDonnell Gambit, McDonnell Double Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/4p3/1bB1PP2/8/P1PP2PP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Philidor Counterattack",
    fen: "rnbqkbnr/pp1p1ppp/2p5/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Philidor Variation",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/2P5/PP1P1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Pratt Variation",
    fen: "rnbq1rk1/ppp2ppp/5P2/2b4Q/2pp4/2P5/PP3PPP/RNB1K1NR",
  },
  {
    name: "Bishop's Opening: Stein Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/2B1PP2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Thorold Gambit",
    fen: "rnbqkbnr/p1pp2pp/8/1B2pp2/4P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: del Rio Variation",
    fen: "rnb1k1nr/pppp1ppp/8/2b1p1q1/2B1P3/2P5/PP1P1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Berlin Defense",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Berlin Defense, Greco Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2B1PP2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Kitchener Folly",
    fen: "rnbq1rk1/ppppbppp/5n2/4p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Bishop's Opening: Krejcik Gambit",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/1PB1P3/5P2/P1PPN1PP/RNBQK2R",
  },
  {
    name: "Bishop's Opening: Pachman Gambit",
    fen: "rnbqkb1r/pppp1ppp/8/4p3/2B1n3/2N5/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Bishop's Opening: Ponziani Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2BPP3/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Bishop's Opening: Urusov Gambit, Panov Variation",
    fen: "rnb1k2r/ppp1qppp/5n2/3P4/1bBp4/2P2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Bishop's Opening: Vienna Hybrid",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/2NP4/PPP2PPP/R1BQK1NR",
  },
  {
    name: "Bishop's Opening: Warsaw Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/8/2BpP3/2P5/PP3PPP/RNBQK1NR",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4PP2/2N5/PPPP2PP/R1BQKBNR",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Cunningham Defense",
    fen: "r1bqk1nr/ppppbppp/2n5/8/4Pp2/2N2N2/PPPP2PP/R1BQKB1R",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Hamppe-Allgaier Gambit",
    fen: "r1bqkbnr/pppp1p1p/2n5/6N1/4PppP/2N5/PPPP2P1/R1BQKB1R",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Hamppe-Allgaier Gambit, Alapin Variation",
    fen: "r1bqkbnr/ppp2p1p/2np4/6N1/4PppP/2N5/PPPP2P1/R1BQKB1R",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Hamppe-Allgaier Gambit, Thorold Variation",
    fen: "r1bq1bnr/pppp1k2/2n4p/8/3PPppP/2N5/PPP3P1/R1BQKB1R",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Hamppe-Muzio Gambit",
    fen: "r1bqkbnr/pppp1p1p/2n5/8/2B1Pp2/2N2p2/PPPP2PP/R1BQ1RK1",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Knight Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/4Pp2/2N2N2/PPPP2PP/R1BQKB1R",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Pierce Gambit",
    fen: "r1bqkbnr/pppp1p1p/2n5/6p1/3PPp2/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Quelle Gambit",
    fen: "r1bqk1nr/ppp2ppp/2np4/2b1P3/4P3/2N5/PPPP2PP/R1BQKBNR",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Steinitz Gambit",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/3PPp2/2N5/PPP3PP/R1BQKBNR",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Steinitz Gambit, Fraser-Minckwitz Defense",
    fen: "r1b1kbnr/p1pp1ppp/1pn5/8/3PPp1q/2N5/PPP1K1PP/R1BQ1BNR",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Steinitz Gambit, Main Line",
    fen: "r1b1kbnr/pppp1ppp/2n5/8/3PPp1q/2N5/PPP1K1PP/R1BQ1BNR",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Steinitz Gambit, Paulsen Defense",
    fen: "r1b1kbnr/ppp2ppp/2np4/8/3PPp1q/2N5/PPP1K1PP/R1BQ1BNR",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Steinitz Gambit, Sörensen Defense",
    fen: "r1b1kbnr/pppp1p1p/2n5/6p1/3PPp1q/2N5/PPP1K1PP/R1BQ1BNR",
  },
  {
    name: "Vienna Gambit, with Max Lange Defense: Steinitz Gambit, Zukertort Defense",
    fen: "r1b1kbnr/ppp2ppp/2n5/3p4/3PPp1q/2N5/PPP1K1PP/R1BQ1BNR",
  },
  {
    name: "Vienna Game",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Anderssen Defense",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Fyfe Gambit",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Giraffe Attack",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/4P1Q1/2N5/PPPP1PPP/R1B1KBNR",
  },
  {
    name: "Vienna Game: Hamppe-Meitner Variation",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/N3P3/8/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Hamppe-Muzio Gambit",
    fen: "r1bqkbnr/pppp1p1p/2n5/8/2B1Ppp1/2N2N2/PPPP2PP/R1BQ1RK1",
  },
  {
    name: "Vienna Game: Hamppe-Muzio, Dubois Variation",
    fen: "r1b1kbnr/pppp1p1p/5q2/4n3/2B1PQ2/2N5/PPPP2PP/R1B2RK1",
  },
  {
    name: "Vienna Game: Max Lange Defense",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Omaha Gambit",
    fen: "rnbqkbnr/ppp2ppp/3p4/4p3/4PP2/2N5/PPPP2PP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Paulsen Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N3P1/PPPP1P1P/R1BQKBNR",
  },
  {
    name: "Vienna Game: Paulsen Variation",
    fen: "r1bqk2r/ppp2ppp/2n2n2/2bpp3/4P3/2N3P1/PPPPNPBP/R1BQK2R",
  },
  {
    name: "Vienna Game: Paulsen Variation, Mariotti Gambit",
    fen: "r1bqk1nr/pppp1pp1/2n5/2b1p3/4P2p/2N2NP1/PPPP1PBP/R1BQK2R",
  },
  {
    name: "Vienna Game: Philidor Countergambit",
    fen: "r1bqkbnr/pppp2pp/2n5/4pp2/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Pierce Gambit, Rushmere Attack",
    fen: "r2qkbnr/ppp2p1p/2P5/8/2BP1pb1/2N2p2/PPP3PP/R1BQ1RK1",
  },
  {
    name: "Vienna Game: Stanley Variation, Meitner-Mieses Gambit",
    fen: "r1b1k1nr/pppp1ppp/2n2q2/2bNp3/2B1P1Q1/8/PPPP1PPP/R1B1K1NR",
  },
  {
    name: "Vienna Game: Zhuravlev Countergambit",
    fen: "rnbqk2r/pppp1ppp/5n2/4p3/1b2P1Q1/2N5/PPPP1PPP/R1B1KBNR",
  },
  {
    name: "Bishop's Opening: Horwitz Gambit",
    fen: "rnbqkb1r/p1pp1ppp/5n2/1p2p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR",
  },
  {
    name: "Bishop's Opening: Vienna Hybrid, Spielmann Attack",
    fen: "rnbqk2r/pppp1ppp/5n2/2b1p3/2B1P3/2NP4/PPP2PPP/R1BQK1NR",
  },
  {
    name: "Vienna Game: Falkbeer Variation",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Mengarini Variation",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/4P3/P1N5/1PPP1PPP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Mieses Variation",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N3P1/PPPP1P1P/R1BQKBNR",
  },
  {
    name: "Vienna Game: Mieses Variation, Erben Gambit",
    fen: "rnbqkb1r/pp3ppp/2p2n2/3Pp3/8/2N3P1/PPPP1P1P/R1BQKBNR",
  },
  {
    name: "Vienna Game: Paulsen Variation, Pollock Gambit",
    fen: "r1bqk2r/ppp2ppp/2n2n2/2bPp3/8/2N3P1/PPPPNPBP/R1BQK2R",
  },
  {
    name: "Vienna Game: Stanley Variation",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR",
  },
  {
    name: "Vienna Game: Stanley Variation, Eifel Gambit",
    fen: "rnbqk2r/p1pp1ppp/5n2/1pb1p3/2B1P3/2N5/PPPPNPPP/R1BQK2R",
  },
  {
    name: "Vienna Game: Stanley Variation, Reversed Spanish",
    fen: "rnbqk2r/pppp1ppp/5n2/4p3/1bB1P3/2N5/PPPP1PPP/R1BQK1NR",
  },
  {
    name: "Bishop's Opening: Boden-Kieseritzky Gambit",
    fen: "rnbqkb1r/pppp1ppp/8/4p3/2B1n3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Bishop's Opening: Boden-Kieseritzky Gambit, Lichtenhein Defense",
    fen: "rnbqkb1r/ppp2ppp/8/3pp3/2B1n3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Vienna Game: Adams' Gambit",
    fen: "r1bqkb1r/pppp1ppp/2nn4/4p2Q/3P4/1BN5/PPP2PPP/R1B1K1NR",
  },
  {
    name: "Vienna Game: Frankenstein-Dracula Variation",
    fen: "rnbqkb1r/pppp1ppp/8/4p3/2B1n3/2N5/PPPP1PPP/R1BQK1NR",
  },
  {
    name: "Vienna Game: Stanley Variation, Alekhine Variation",
    fen: "r1bqk2r/ppppbppp/2nn4/4N2Q/8/1BN5/PPPP1PPP/R1B1K2R",
  },
  {
    name: "Vienna Game: Stanley Variation, Frankenstein-Dracula Variation",
    fen: "N1bk1b1r/p2pq2p/1pnn2p1/3Qpp2/8/1B6/PPPP1PPP/R1B1K1NR",
  },
  {
    name: "Vienna Game: Stanley Variation, Monster Declined",
    fen: "rnbqk2r/ppppbppp/3n4/4p2Q/8/1BN5/PPPP1PPP/R1B1K1NR",
  },
  {
    name: "Bishop's Opening: Vienna Hybrid, Hromádka Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/4p3/1bB1P3/2NP4/PPP1NPPP/R1BQK2R",
  },
  {
    name: "Vienna Game: Stanley Variation, Bronstein Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n5/4p3/2B1nP2/2N2N2/PPPP2PP/R1BQK2R",
  },
  {
    name: "Vienna Game: Stanley Variation, Three Knights Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR",
  },
  {
    name: "Vienna Game: Heyde Variation",
    fen: "rnbqkb1r/ppp3pp/8/3pPp2/3Pn3/2N2Q2/PPP3PP/R1B1KBNR",
  },
  {
    name: "Vienna Game: Vienna Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/4PP2/2N5/PPPP2PP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Vienna Gambit, Bardeleben Variation",
    fen: "rnbqkb1r/ppp3pp/8/3pPp2/4n3/2N2Q2/PPPP2PP/R1B1KBNR",
  },
  {
    name: "Vienna Game: Vienna Gambit, Breyer Variation",
    fen: "rnbqk2r/ppp1bppp/8/3pP3/4n3/2N2N2/PPPP2PP/R1BQKB1R",
  },
  {
    name: "Vienna Game: Vienna Gambit, Kaufmann Variation",
    fen: "rn1qkb1r/ppp2ppp/8/3pP3/4n1b1/2N2N2/PPPPQ1PP/R1B1KB1R",
  },
  {
    name: "Vienna Game: Vienna Gambit, Main Line",
    fen: "rnbqkb1r/ppp2ppp/5n2/3pp3/4PP2/2N5/PPPP2PP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Vienna Gambit, Modern Variation",
    fen: "rnbqkb1r/ppp2ppp/8/3pP3/4n3/2NP4/PPP3PP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Vienna Gambit, Paulsen Attack",
    fen: "rnbqkb1r/ppp2ppp/8/3pP3/4n3/2N2Q2/PPPP2PP/R1B1KBNR",
  },
  {
    name: "Vienna Game: Vienna Gambit, Steinitz Variation",
    fen: "rnbqkb1r/ppp2ppp/5n2/3pp3/4PP2/2NP4/PPP3PP/R1BQKBNR",
  },
  {
    name: "Vienna Game: Vienna Gambit, Wurzburger Trap",
    fen: "rnb1kb1r/ppp2ppp/8/3NP2q/8/3P1Nn1/PPP4P/R1BQKB1R",
  },
  {
    name: "King's Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Classical Variation",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Classical Variation",
    fen: "rnbqk1nr/ppp2ppp/3p4/2b1p3/4PP2/2P2N2/PP1P2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Declined: Classical Variation, Euwe Attack",
    fen: "rn1qk1nr/ppp2ppp/8/2b1p3/Q3P1b1/2P2N2/PP1P2PP/RNB1KB1R",
  },
  {
    name: "King's Gambit Declined: Classical Variation, Rotlewi Countergambit",
    fen: "rnbqk1nr/ppp2ppp/3p4/2b1p3/1P2PP2/5N2/P1PP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Declined: Classical Variation, Rubinstein Countergambit",
    fen: "rnbqk1nr/ppp3pp/3p4/2b1pp2/4PP2/2P2N2/PP1P2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Declined: Classical, Hanham Variation",
    fen: "r1bqk1nr/pppn1ppp/3p4/2b1p3/4PP2/2N2N2/PPPP2PP/R1BQKB1R",
  },
  {
    name: "King's Gambit Declined: Classical, Réti Variation",
    fen: "rnbqk1nr/ppp3pp/8/2b2p2/2BpP3/2P2N2/PP4PP/RNBQK2R",
  },
  {
    name: "King's Gambit Declined: Classical, Soldatenkov Variation",
    fen: "rnbqk1nr/ppp2ppp/3p4/2b1P3/4P3/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Declined: Classical, Svenonius Variation",
    fen: "r2qk2r/ppp2ppp/2np1n2/2b5/2B1Pp2/2NP1Q1P/PPP3P1/R1B1K2R",
  },
  {
    name: "King's Gambit Declined: Hobbs-Zilbermints Gambit",
    fen: "r1bqkbnr/pppp1p2/2n4p/4p1P1/4P3/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Declined: Keene Defense",
    fen: "rnb1kbnr/ppppqppp/8/4p3/4PP2/6P1/PPPP3P/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Keene's Defense",
    fen: "rnb1kbnr/pppp1ppp/8/4p3/4PP1q/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Keene's Defense",
    fen: "rnb1kbnr/pppp1ppp/8/4p3/4PP1q/6P1/PPPP3P/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Mafia Defense",
    fen: "rnbqkbnr/pp1p1ppp/8/2p1p3/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Miles Defense",
    fen: "r1bqkbnr/pppp2pp/2n5/4pp2/4PP2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Declined: Norwalde Variation",
    fen: "rnb1kbnr/pppp1ppp/5q2/4p3/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Norwalde Variation, Bücker Gambit",
    fen: "rnb1k1nr/pppp1ppp/8/4p3/1bB1Pq2/2N2N2/PPPP2PP/R1BQK2R",
  },
  {
    name: "King's Gambit Declined: Norwalde Variation, Schubert Variation",
    fen: "rnb1kbnr/pppp1ppp/8/4p3/3PPq2/2N5/PPP3PP/R1BQKBNR",
  },
  {
    name: "King's Gambit Declined: Panteldakis Countergambit",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Panteldakis Countergambit, Greco Variation",
    fen: "rnb1kbnr/pppp2pp/8/4pP2/5P1q/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Panteldakis Countergambit, Pawn Sacrifice Line",
    fen: "rnb1kbnr/ppppq2p/6P1/7Q/5p2/8/PPPP2PP/RNBK1BNR",
  },
  {
    name: "King's Gambit Declined: Panteldakis Countergambit, Schiller's Defense",
    fen: "rnbqk1nr/pppp2pp/8/2b1pP2/5P2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Panteldakis Countergambit, Shirazi Line",
    fen: "rnbq1bnr/ppppk1pp/8/5P1Q/5p2/8/PPPP2PP/RNB1KBNR",
  },
  {
    name: "King's Gambit Declined: Panteldakis Countergambit, Symmetrical Variation",
    fen: "rnbqk1nr/ppp3pp/3b4/3p1P2/3P1p2/3B1N2/PPP3PP/RNBQK2R",
  },
  {
    name: "King's Gambit Declined: Petrov's Defense",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Queen's Knight Defense",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Senechaud Countergambit",
    fen: "rnbqk1nr/pppp1p1p/8/2b1p1p1/4PP2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Declined: Soller-Zilbermints Gambit",
    fen: "r1bqkbnr/pppp2pp/2n2p2/4P3/4P3/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Zilbermints Double Countergambit",
    fen: "rnbqkbnr/pppp1p1p/8/4p1p1/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Zilbermints Double Gambit",
    fen: "r1bqkbnr/pppp1p1p/2n5/4p1p1/4PP2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/4PP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit Accepted",
    fen: "rnbqkbnr/ppp2ppp/8/3Pp3/5P2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Anderssen Attack",
    fen: "rnbqkbnr/ppp2ppp/8/1B1P4/4pP2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Blackburne Attack",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/4PP2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3P4/4pP2/3P4/PPP3PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit, Morphy Defense",
    fen: "rnbqk2r/ppp2ppp/5n2/3P4/1b3P2/2NPp3/PPPB2PP/R2QKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Hinrichsen Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/3PPP2/8/PPP3PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Miles Gambit",
    fen: "rnbqk1nr/ppp2ppp/8/2bPp3/5P2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Milner-Barry Variation",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/4PP2/2N5/PPPP2PP/R1BQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Modern Transfer",
    fen: "rnbqkbnr/ppp2ppp/8/3P4/5p2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Nimzowitsch-Marshall Countergambit",
    fen: "rnbqkbnr/pp3ppp/2p5/3Pp3/5P2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Pickler Gambit",
    fen: "rnbqk1nr/pp3ppp/2P5/2b1p3/5P2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Rubinstein Variation",
    fen: "rnbqkb1r/ppp2ppp/5n2/3P4/4pP2/2N5/PPPPQ1PP/R1B1KBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Staunton Line",
    fen: "rnbqkbnr/ppp2ppp/8/3P4/4pP2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "Van Geet Opening: Grünfeld Defense, Steiner Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/4NP2/8/PPPP2PP/R1BQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Alapin Variation",
    fen: "rnb1k2r/ppp2ppp/8/3q4/4nP2/8/PPPNQbPP/RNBK1B1R",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit",
    fen: "rnbqkb1r/ppp2ppp/8/3P4/4nP2/8/PPP1Q1PP/RNB1KBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit Accepted",
    fen: "rnbqkb1r/ppp2ppp/5n2/3P4/4PP2/8/PPP3PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit, Keres Variation",
    fen: "rnbqkb1r/ppp2ppp/5n2/3P4/4pP2/3P4/PPPN2PP/R1BQKBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit, Main Line",
    fen: "rn1qk2r/ppp2ppp/8/2bP1b2/4nP2/5N2/PPP1Q1PP/RNB1KB1R",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit, Old Line",
    fen: "rnbqkb1r/ppp2ppp/5n2/3P4/4pP2/3P4/PPP1Q1PP/RNB1KBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Charousek Variation",
    fen: "rnb1kb1r/ppp3pp/8/3q1p2/4nPP1/8/PPPNQ2P/R1B1KBNR",
  },
  {
    name: "King's Gambit Declined: Falkbeer Countergambit, Tarrasch Variation",
    fen: "rn1q1rk1/ppp2ppp/8/2bP1b2/4nPP1/5N2/PPP1Q2P/RNB1KB1R",
  },
  {
    name: "King's Gambit Accepted",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Accepted: Basman Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPPQ1PP/RNB1KBNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Anderssen Defense",
    fen: "rnbqkbnr/pppp1p1p/8/6p1/2B1Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Anderssen Variation",
    fen: "rnbqkbnr/pp3ppp/2p5/3B4/4Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Bledow Countergambit",
    fen: "rnbqkb1r/ppp2ppp/5n2/3B4/4Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Bledow Variation",
    fen: "rnbqkbnr/ppp2ppp/8/3p4/2B1Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Boden Variation",
    fen: "r1b1kbnr/pppp1ppp/2n5/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Bogoljubov Defense",
    fen: "rnbqkb1r/pp1p1ppp/2p2n2/8/2B1Pp2/2N5/PPPP2PP/R1BQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Bogoljubov Variation",
    fen: "rnbqkb1r/pppp1ppp/5n2/8/2B1Pp2/2N5/PPPP2PP/R1BQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Boren-Svenonius Variation",
    fen: "rnb1k1nr/ppp2ppp/3b4/3B4/4Pp1q/8/PPPP2PP/RNBQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Bryan Countergambit",
    fen: "rnb1kbnr/p1pp1ppp/8/1p6/2B1Pp1q/8/PPPP2PP/RNBQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Chigorin's Attack",
    fen: "rnb1kbnr/ppp2p1p/8/3B2p1/4Pp1q/6P1/PPPP3P/RNBQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Classical Defense",
    fen: "rnb1k2r/ppppnpbp/8/6p1/2BPPp1q/2N5/PPP3PP/R1BQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Classical Defense, Cozio Attack",
    fen: "rnb1kbnr/pppp1p1p/8/6p1/2B1Pp1q/5Q2/PPPP2PP/RNB2KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Cozio Defense",
    fen: "rnbqkb1r/pppp1ppp/5n2/8/2B1Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Cozio Variation",
    fen: "rnb1kbnr/ppp2ppp/3p4/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, First Jaenisch Variation",
    fen: "rnb1kb1r/pppp1ppp/5n2/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Fraser Variation",
    fen: "rnb1k1nr/pppp1pbp/8/6p1/2B1P2q/2N2Qp1/PPPP3P/R1B2KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Gianutio Gambit",
    fen: "rnbqkbnr/pppp2pp/8/5p2/2B1Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Greco Variation",
    fen: "rnb1k1nr/pppp1ppp/8/2b5/2B1Pp1q/8/PPPP2PP/RNBQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Grimm Attack",
    fen: "rnb1k1nr/ppp2pbp/3p4/4P1p1/2BP1p1q/2N5/PPP3PP/R1BQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Kieseritzky Gambit",
    fen: "rnbqkbnr/p1pp1ppp/8/1p6/2B1Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Lopez Defense",
    fen: "rnbqkbnr/pp1p1ppp/2p5/8/2B1Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Lopez Variation",
    fen: "rnb1kbnr/pppp1p1p/8/6p1/2B1Pp1q/8/PPPP2PP/RNBQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Maurian Defense",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/2B1Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, McDonnell Attack",
    fen: "rnb1k2r/ppppnpbp/8/6p1/2BPPp1q/2N3P1/PPP4P/R1BQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, McDonnell Attack",
    fen: "rnb1k1nr/pppp1pbp/8/6p1/2B1Pp1q/2N3P1/PPPP3P/R1BQ1KNR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Paulsen Attack",
    fen: "rnbqk2r/pppp1ppp/5n2/4P3/1bB2p2/2N5/PPPP2PP/R1BQK1NR",
  },
  {
    name: "King's Gambit Accepted: Bishop's Gambit, Steinitz Defense",
    fen: "rnbqkb1r/ppppnppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Breyer Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/5Q2/PPPP2PP/RNB1KBNR",
  },
  {
    name: "King's Gambit Accepted: Carrera Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/7Q/4Pp2/8/PPPP2PP/RNB1KBNR",
  },
  {
    name: "King's Gambit Accepted: Dodo Variation",
    fen: "rnbqkbnr/pppp1ppp/8/8/4PpQ1/8/PPPP2PP/RNB1KBNR",
  },
  {
    name: "King's Gambit Accepted: Eisenberg Variation",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/7N/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Gaga Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/6P1/PPPP3P/RNBQKBNR",
  },
  {
    name: "King's Gambit Accepted: Lopez-Gianutio Countergambit, Hein Variation",
    fen: "rnbk1bnr/pppp2pp/8/8/2B1pp1q/2N5/PPPPQ1PP/R1BK2NR",
  },
  {
    name: "King's Gambit Accepted: Mason-Keres Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/2N5/PPPP2PP/R1BQKBNR",
  },
  {
    name: "King's Gambit Accepted: Orsini Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/1P6/P1PP2PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Accepted: Paris Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPPN1PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Polerio Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/3PPp2/8/PPP3PP/RNBQKBNR",
  },
  {
    name: "King's Gambit Accepted: Schurig Gambit, with Bb5",
    fen: "rnbqkbnr/pppp1ppp/8/1B6/4Pp2/8/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Schurig Gambit, with Bd3",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/3B4/PPPP2PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Stamma Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp1P/8/PPPP2P1/RNBQKBNR",
  },
  {
    name: "King's Gambit Accepted: Tartakower Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPPB1PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Tartakower Gambit, Weiss Defense",
    fen: "rnbqkbnr/ppp3pp/3p4/5P2/5p2/8/PPPPB1PP/RNBQK1NR",
  },
  {
    name: "King's Gambit Accepted: Tumbleweed",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP1KPP/RNBQ1BNR",
  },
  {
    name: "King's Gambit Accepted: Becker Defense",
    fen: "rnbqkbnr/pppp1pp1/7p/8/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Bonsch-Osmolovsky Variation",
    fen: "rnbqkb1r/ppppnppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Fischer Defense",
    fen: "rnbqkbnr/ppp2ppp/3p4/8/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Fischer Defense, Schulder Gambit",
    fen: "rnbqkbnr/ppp2ppp/3p4/8/1P2Pp2/5N2/P1PP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Fischer Defense, Spanish Variation",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/8/3PPp2/3B1N2/PPP3PP/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Gianutio Countergambit",
    fen: "rnbqkbnr/pppp2pp/8/5p2/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Greco Gambit",
    fen: "rnbqk1nr/ppp2pb1/3p3p/6p1/2BPPp1P/5N2/PPP3P1/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: King's Knight's Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/6p1/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: King's Knight's Gambit",
    fen: "rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: MacLeod Defense",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Schallopp Defense",
    fen: "rnbqkb1r/pppp1ppp/5n2/8/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Schallopp Defense, Tashkent Attack",
    fen: "rnbqkb1r/pppp1ppp/8/4P2n/5pP1/5N2/PPPP3P/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Wagenbach Defense",
    fen: "rnbqkbnr/pppp1pp1/8/7p/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Cunningham Defense",
    fen: "rnbqk1nr/ppppbppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Cunningham Defense, Bertin Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/8/2B1Pp1b/5NP1/PPPP3P/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Cunningham Defense, Bertin Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/8/2B1P2b/5N2/PPPP3p/RNBQ1R1K",
  },
  {
    name: "King's Gambit Accepted: Cunningham Defense, McCormick Defense",
    fen: "rnbqk2r/ppppbppp/5n2/8/2B1Pp2/5N2/PPPP2PP/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Abbazia Defense",
    fen: "rnbqkb1r/ppp2ppp/5n2/3P4/5p2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Abbazia Defense, Main Line",
    fen: "rnbqkb1r/p4ppp/2p5/3n4/2B2p2/5N2/PPPP2PP/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Modern Defense",
    fen: "rnbqkbnr/ppp2ppp/8/3p4/4Pp2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Modern Defense",
    fen: "rnbqkbnr/ppp2ppp/8/3P4/5p2/5N2/PPPP2PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Australian Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/8/2B1PppP/5N2/PPPP2P1/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Blachly Gambit",
    fen: "r1bqkbnr/pppp1p1p/2n5/6p1/2B1Pp2/5N2/PPPP2PP/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Double Muzio Gambit",
    fen: "rnb1kbnr/pppp1B1p/8/4q3/5p2/5Q2/PPPP2PP/RNB2RK1",
  },
  {
    name: "King's Gambit Accepted: Double Muzio Gambit, Baldwin Gambit",
    fen: "rnb1kbnr/pppp1p1p/8/3N4/2q1Pp2/5Q2/PPPP2PP/R1B2R1K",
  },
  {
    name: "King's Gambit Accepted: Double Muzio Gambit, Bello Gambit",
    fen: "rnb1kbnr/pppp1p1p/5q2/8/2B1Pp2/2N2Q2/PPPP2PP/R1B2RK1",
  },
  {
    name: "King's Gambit Accepted: Double Muzio Gambit, Paulsen Defense",
    fen: "r1b1k2r/ppppnp1p/2n4b/4q3/2B2p2/2NP1Q2/PPPB2PP/4RRK1",
  },
  {
    name: "King's Gambit Accepted: Double Muzio Gambit, Young Gambit",
    fen: "rnb2bnr/pppp1k1p/5q2/8/4P3/2N1pQ2/PPP3PP/R4RK1",
  },
  {
    name: "King's Gambit Accepted: Ghulam-Kassim Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/8/2BPPpp1/5N2/PPP3PP/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Ghulam-Kassim Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/8/2BPPp2/5Q2/PPP3PP/RNB1K2R",
  },
  {
    name: "King's Gambit Accepted: King's Knight's Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/6p1/2B1Pp2/5N2/PPPP2PP/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Kotov Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/8/2BPPB2/5p2/PPP3PP/RN1QK2R",
  },
  {
    name: "King's Gambit Accepted: Lolli Gambit",
    fen: "rnbqkbnr/pppp1B1p/8/8/4Ppp1/5N2/PPPP2PP/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Lolli Gambit, Young Variation",
    fen: "rnb2bnr/pppp1k1p/5q2/8/4Pp2/2N1BQ2/PPP3PP/R4RK1",
  },
  {
    name: "King's Gambit Accepted: McDonnell Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/2N2N2/PPPP2PP/R1BQK2R",
  },
  {
    name: "King's Gambit Accepted: Middleton Countergambit",
    fen: "rn1qkbnr/ppp2p2/3p4/6p1/2B1Ppp1/5N2/PPPP2P1/RNBQ1RK1",
  },
  {
    name: "King's Gambit Accepted: Muzio Gambit Accepted, From's Defense",
    fen: "rnb1kbnr/ppppqp1p/8/8/2B1Pp2/5Q2/PPPP2PP/RNB2RK1",
  },
  {
    name: "King's Gambit Accepted: Muzio Gambit, Brentano Defense",
    fen: "rnbqkbnr/ppp2p1p/8/3p4/2B1Ppp1/5N2/PPPP2PP/RNBQ1RK1",
  },
  {
    name: "King's Gambit Accepted: Muzio Gambit, Holloway Defense",
    fen: "r1bqkbnr/pppp1p1p/2n5/8/2B1Pp2/5Q2/PPPP2PP/RNB2RK1",
  },
  {
    name: "King's Gambit Accepted: Muzio Gambit, Kling and Horwitz Counterattack",
    fen: "rnb1kbnr/ppppqp1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQ1RK1",
  },
  {
    name: "King's Gambit Accepted: Muzio Gambit, Sarratt Defense",
    fen: "rnb1kbnr/pppp1p1p/5q2/8/2B1Pp2/5Q2/PPPP2PP/RNB2RK1",
  },
  {
    name: "King's Gambit Accepted: Muzio Gambit, Wild Muzio Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQ1RK1",
  },
  {
    name: "King's Gambit Accepted: Quade Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/6p1/4Pp2/2N2N2/PPPP2PP/R1BQKB1R",
  },
  {
    name: "King's Gambit Accepted: Rosentreter Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/6p1/3PPp2/5N2/PPP3PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Rosentreter Gambit, Bird Gambit",
    fen: "rnb1kbnr/pppp1p1p/8/4N3/3PPppq/6P1/PPP4P/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Rosentreter Gambit, Sörensen Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/8/3PPpp1/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "King's Gambit Accepted: Rosentreter Gambit, Testa Variation",
    fen: "rnbqkbnr/pppp1p1p/8/8/3PPBp1/5N2/PPP3PP/RN1QKB1R",
  },
  {
    name: "King's Gambit Accepted: Salvio Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/4N3/2B1Ppp1/8/PPPP2PP/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Salvio Gambit, Anderssen Counterattack",
    fen: "rnb1kb1r/ppp2p1p/3p3n/4N3/2BPPppq/8/PPP3PP/RNBQ1K1R",
  },
  {
    name: "King's Gambit Accepted: Salvio Gambit, Cochrane Gambit",
    fen: "rnb1kbnr/pppp1p1p/8/4N3/2B1P1pq/5p2/PPPP2PP/RNBQ1K1R",
  },
  {
    name: "King's Gambit Accepted: Salvio Gambit, Santa Maria Defense",
    fen: "rnb1kb1r/pppp1p1p/5n2/4N3/2B1Pppq/8/PPPP2PP/RNBQ1K1R",
  },
  {
    name: "King's Gambit Accepted: Salvio Gambit, Silberschmidt Defense",
    fen: "rnb1kb1r/pppp1p1p/7n/4N3/2B1Pppq/8/PPPP2PP/RNBQ1K1R",
  },
  {
    name: "King's Gambit Accepted: Salvio Gambit, Viennese Variation",
    fen: "r1b1kbnr/pppp1p1p/2n5/4N3/2B1Pppq/8/PPPP2PP/RNBQ1K1R",
  },
  {
    name: "King's Gambit Accepted: Silberschmidt Gambit",
    fen: "rnb1kb1r/pppp1p1p/7n/4N3/2BPP1pq/5p2/PPP3PP/RNBQ1K1R",
  },
  {
    name: "King's Gambit Accepted: Sörensen Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/4N3/3PPpp1/8/PPP3PP/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Greco Gambit",
    fen: "rnbqk1nb/pp3p2/2pp4/4N1p1/2BPPp2/2N5/PPP3P1/R1BQK3",
  },
  {
    name: "King's Gambit Accepted: Hanstein Gambit",
    fen: "rnbqk1nr/pppp1pbp/8/6p1/2B1Pp2/5N2/PPPP2PP/RNBQ1RK1",
  },
  {
    name: "King's Gambit Accepted: Mayet Gambit",
    fen: "rnbqk1nr/ppp2pbp/3p4/6p1/2BPPp2/2P2N2/PP4PP/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Philidor Gambit",
    fen: "rnbqk1nr/pppp1pbp/8/6p1/2B1Pp1P/5N2/PPPP2P1/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Philidor Gambit, Schultz Variation",
    fen: "rnbqk1nr/ppp2pb1/3p3p/6p1/2BPPp1P/3Q1N2/PPP3P1/RNB1K2R",
  },
  {
    name: "King's Gambit Accepted: Traditional Variation",
    fen: "rnbqk1nr/pppp1pbp/8/6p1/2B1Pp2/5N2/PPPP2PP/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Allgaier Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/6N1/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Allgaier Gambit, Thorold Attack",
    fen: "rnbq1bnr/pppp1k2/7p/8/3PPppP/8/PPP3P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Allgaier Gambit, Urusov Attack",
    fen: "rnbq1bnr/pppp1k2/7p/8/2B1PppP/8/PPPP2P1/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Allgaier, Blackburne Gambit",
    fen: "rnbq1bnr/pppp1k2/7p/8/4PppP/2N5/PPPP2P1/R1BQKB1R",
  },
  {
    name: "King's Gambit Accepted: Allgaier, Cook Variation",
    fen: "rnbq1bnr/ppp3k1/7p/4B3/2BPp1pP/8/PPP3P1/RN1QK2R",
  },
  {
    name: "King's Gambit Accepted: Allgaier, Horny Defense",
    fen: "rnbq3r/pppp1k2/3b1n1p/8/4PQ1P/8/PPPP2P1/RNB1KB1R",
  },
  {
    name: "King's Gambit Accepted: Allgaier, Schlechter Defense",
    fen: "rnbqkb1r/pppp1p1p/5n2/6N1/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Allgaier, Urusov Attack",
    fen: "rnbq1bnr/ppp3k1/7p/3B4/3PPppP/8/PPP3P1/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Anderssen Defense",
    fen: "rnbqk2r/ppp2p1p/3b1n2/3PN3/2B2ppP/8/PPPP2P1/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Anderssen-Cordel Gambit",
    fen: "rnbqk2r/ppp2p1p/3b4/3PN3/2BP1npP/8/PPP3P1/RN1QK2R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Berlin Defense",
    fen: "rnbqkb1r/pppp1p1p/5n2/4N3/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Berlin Defense, Rubinstein Variation",
    fen: "rnbqkb1r/pppp1p1p/5n2/4N3/3PPppP/8/PPP3P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Berlin Defense, de Riviere Variation",
    fen: "rnbqkb1r/ppp2p1p/5n2/3p4/4PpNP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Brentano Defense",
    fen: "rnbqkbnr/ppp2p1p/8/3pN3/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Brentano Defense",
    fen: "rnbqkb1r/ppp2p1p/5n2/3pN3/3PPBpP/8/PPP3P1/RN1QKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Brentano Defense, Caro Variation",
    fen: "rnbqkb1r/ppp2p1p/8/3pN3/3PnBpP/8/PPPN2P1/R2QKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Cotter Gambit",
    fen: "rnbqkbnr/pppp1N2/7p/8/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Kolisch Defense",
    fen: "rnbqkbnr/ppp2p1p/3p4/4N3/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Long Whip",
    fen: "rnbqkbnr/pppp1p2/8/4N2p/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Neumann Defense",
    fen: "r1bqkbnr/pppp1p1p/2n5/4N3/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Paulsen Defense",
    fen: "rnbqk1nr/pppp1pbp/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Paulsen Defense Deferred",
    fen: "rnbqk2r/ppp2pbp/5n2/3PN3/2B2ppP/8/PPPP2P1/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Rice Gambit",
    fen: "rnbqk2r/ppp2p1p/5n2/3Pb3/2B2ppP/8/PPPP2P1/RNBQ1RK1",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky Gambit, Rosenthal Defense",
    fen: "rnb1kbnr/ppppqp1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky, Long Whip Defense, Jaenisch Variation",
    fen: "rnbqk1n1/pppp1p1r/7b/4N2p/2BPPppP/2N5/PPP3P1/R1BQK2R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky, Polerio Defense",
    fen: "rnbqk1nr/ppppbp1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky, Rice Gambit",
    fen: "rnbqk2r/ppp2p1p/3b1n2/3PN3/2B2ppP/8/PPPP2P1/RNBQ1RK1",
  },
  {
    name: "King's Gambit Accepted: Kieseritzky, Salvio Defense, Cozio Variation",
    fen: "rnb1kbnr/ppppq2p/8/4Np2/2BPPppP/8/PPP3P1/RNBQK2R",
  },
  {
    name: "King's Gambit Accepted: King's Knight's Gambit",
    fen: "rnbqkbnr/pppp1p1p/8/6p1/4Pp1P/5N2/PPPP2P1/RNBQKB1R",
  },
  {
    name: "Elephant Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Elephant Gambit: Maróczy Gambit",
    fen: "rnbqk1nr/ppp2ppp/3b4/3Pp3/8/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Elephant Gambit: Paulsen Countergambit",
    fen: "rnbqkbnr/ppp2ppp/8/3P4/4p3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Elephant Gambit: Wasp Variation",
    fen: "rnb1kbnr/ppp2ppp/8/4N1q1/2B1p3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Gunderam Defense",
    fen: "rnb1kbnr/ppppqppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "King's Knight Opening",
    fen: "rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: Busch-Gass Gambit",
    fen: "rnbqk1nr/pppp1ppp/8/2b1p3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: Busch-Gass Gambit, Chiodini Gambit",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b1N3/4P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: Damiano Defense",
    fen: "rnbqkbnr/pppp2pp/5p2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: Damiano Defense, Damiano Gambit",
    fen: "rnb1kbnQ/ppppq2p/6p1/8/4P3/8/PPPP1PPP/RNB1KB1R",
  },
  {
    name: "King's Pawn Game: Damiano Defense, Damiano Gambit, Chigorin Gambit",
    fen: "rnb1kbnr/ppp1q1pp/5p2/3p4/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: Gunderam Defense, Gunderam Gambit",
    fen: "rnb1kbnr/ppppq1pp/8/4pp2/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "King's Pawn Game: Gunderam Gambit",
    fen: "rnbqkbnr/pp1p1ppp/2p5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: La Bourdonnais Gambit",
    fen: "rnb1kbnr/pppp1ppp/6q1/4p3/2B1P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "King's Pawn Game: McConnell Defense",
    fen: "rnb1kbnr/pppp1ppp/5q2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit Accepted",
    fen: "rnbqkbnr/pppp2pp/8/4pP2/8/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit Accepted: Bilguer Variation",
    fen: "rnb1kbnr/ppp3pp/3p1q2/5p2/2NPP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit Accepted: Bronstein Attack",
    fen: "rnb1kbnr/ppp3pp/3p1q2/8/2NPp3/8/PPP1BPPP/RNBQK2R",
  },
  {
    name: "Latvian Gambit Accepted: Bronstein Gambit",
    fen: "rnb1kbnr/ppp4p/3p1qp1/8/2NPp3/8/PPP1QPPP/RNB1KB1R",
  },
  {
    name: "Latvian Gambit Accepted: Foltys Variation",
    fen: "rnb1kbnr/pppp2pp/5q2/8/2N1p3/3P4/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit Accepted: Foltys-Leonhardt Variation",
    fen: "rnb1kbnr/pppp2pp/5q2/5p2/2N1P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit Accepted: Leonhardt Variation",
    fen: "rnb1kbnr/pppp2pp/5q2/8/2N1p3/2N5/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Latvian Gambit Accepted: Main Line",
    fen: "rnb1kbnr/pppp2pp/5q2/4Np2/3PP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit Accepted: Nimzowitsch Attack",
    fen: "rnb1kbnr/ppp3pp/3p1q2/8/3Pp3/4N3/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit: Behting Variation",
    fen: "rnb1kb1N/ppp3pp/5n2/3p4/2B1p3/8/PPPP1PqP/RNBQKR2",
  },
  {
    name: "Latvian Gambit: Corkscrew Countergambit",
    fen: "rnbqkb1r/pppp2pp/5n2/4N3/2B1p3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Latvian Gambit: Corkscrew Gambit",
    fen: "rnb1kb1N/ppp1q1pp/5n2/3p4/2B1p3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Latvian Gambit: Diepstraten Countergambit",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/2P1P3/5N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit: Fraser Defense",
    fen: "r1bqkbnr/pppp2pp/2n5/4Np2/4P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit: Greco Variation",
    fen: "rnb1kbnr/ppppq1pp/8/4Np2/4P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit: Lobster Gambit",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/4P1P1/5N2/PPPP1P1P/RNBQKB1R",
  },
  {
    name: "Latvian Gambit: Mason Countergambit",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Latvian Gambit: Mayet Attack",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Latvian Gambit: Mayet Attack, Morgado Defense",
    fen: "rnbqkb1r/pppp2pp/5n2/4pp2/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Latvian Gambit: Mayet Attack, Poisoned Pawn Variation",
    fen: "rnb1kbnr/pppp2pp/8/4N3/2BPp3/8/PPP2PqP/RNBQK2R",
  },
  {
    name: "Latvian Gambit: Mayet Attack, Polerio-Svedenborg Variation",
    fen: "rnbqkbnr/ppp3pp/8/3pN3/2B1p3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Latvian Gambit: Mayet Attack, Strautins Gambit",
    fen: "rnbqkbnr/p1pp2pp/8/1p2pp2/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Latvian Gambit: Mlotkowski Variation",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/4P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Latvian Gambit: Senechaud Gambit",
    fen: "rnbqkbnr/pppp2pp/8/4pp2/1P2P3/5N2/P1PP1PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense",
    fen: "rnbqkbnr/ppp2ppp/3p4/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense",
    fen: "rnbqkbnr/ppp2ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense",
    fen: "rnbqkbnr/ppp2ppp/3p4/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Philidor Defense",
    fen: "rnbqk1nr/ppp1bppp/3p4/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Philidor Defense: Albin-Blackburne Gambit",
    fen: "r2qkbnr/pppn1ppp/3p4/4P3/4P1b1/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Berger Variation",
    fen: "r2q1rk1/pp2bppp/2npbn2/2p3B1/4P3/2N2N2/PPP1BPPP/R2QR1K1",
  },
  {
    name: "Philidor Defense: Bird Gambit",
    fen: "rnbqkbnr/ppp2ppp/3p4/8/3pP3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Boden Variation",
    fen: "rn1qkbnr/pppb1ppp/3p4/8/3QP3/5N2/PPP2PPP/RNB1KB1R",
  },
  {
    name: "Philidor Defense: Exchange Variation",
    fen: "rnbqkbnr/ppp2ppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Exchange Variation",
    fen: "rnbqkbnr/ppp2ppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Exchange Variation",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Hanham Variation",
    fen: "r1bqkbnr/pppn1ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Hanham Variation, Delmar Variation",
    fen: "r1bqkbnr/pp1n1ppp/2pp4/4p3/2BPP3/2P2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Philidor Defense: Hanham Variation, Krause Variation",
    fen: "r1bqkbnr/pp1n1ppp/2pp4/4p3/2BPP3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Philidor Defense: Hanham Variation, Schlechter Variation",
    fen: "r1bqkbnr/pp1n1ppp/2pp4/4p3/2BPP3/2N2N2/PPP2PPP/R1BQK2R",
  },
  {
    name: "Philidor Defense: Hanham Variation, Sharp Variation",
    fen: "r1bqkbnr/ppp2ppp/1n1p4/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Philidor Defense: Hanham Variation, Steiner Variation",
    fen: "r1bqk1nr/pp1nbppp/2pp4/4P3/2B1P3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Philidor Defense: Hanham, Kmoch Variation",
    fen: "r1bqkbnr/pp1n1ppp/2pp4/4p1N1/2BPP3/8/PPP2PPP/RNBQK2R",
  },
  {
    name: "Philidor Defense: Larsen Variation",
    fen: "rnbqkbnr/ppp2p1p/3p2p1/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Lion Variation",
    fen: "r1bqkb1r/pppn1ppp/3p1n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Philidor Defense: Lion Variation, Bishop Sacrifice",
    fen: "r1bqk2r/pppnbBpp/3p1n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQK2R",
  },
  {
    name: "Philidor Defense: Lion Variation, Delayed Bishop Sacrifice",
    fen: "r1bqk2r/pppnbBpp/5n2/4p3/4P3/2N2N2/PPP2PPP/R1BQK2R",
  },
  {
    name: "Philidor Defense: Lion Variation, Forcing Line",
    fen: "r1bq2k1/pppnbrpp/3pNn2/4p3/3PP3/2N5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Philidor Defense: Lion Variation, Lion's Claw, with Bc4 and h6",
    fen: "r1bqk2r/pppnbpp1/3p1n1p/4p3/2BPP3/2N2N2/PPP2PPP/R1BQ1RK1",
  },
  {
    name: "Philidor Defense: Lion Variation, Lion's Claw, with Be2 and c6",
    fen: "r1bqk2r/pp1nbppp/2pp1n2/4p3/3PP3/2N2N2/PPP1BPPP/R1BQ1RK1",
  },
  {
    name: "Philidor Defense: Lion Variation, Shirov Gambit",
    fen: "r1bqkb1r/pppn1ppp/3p1n2/4p3/3PP1P1/2N2N2/PPP2P1P/R1BQKB1R",
  },
  {
    name: "Philidor Defense: Lion Variation, Sozin Variation",
    fen: "r1bq1rk1/pp1nbppp/2pp1n2/8/P1BpP3/2N2N2/1PP1QPPP/R1B2RK1",
  },
  {
    name: "Philidor Defense: Lopez Countergambit",
    fen: "rnbqkbnr/ppp3pp/3p4/4pp2/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Philidor Defense: Lopez Countergambit, Jaenisch Variation",
    fen: "rnbqkb1r/ppp3pN/3p3n/5p2/2BpP3/8/PPP2PPP/RNBQK2R",
  },
  {
    name: "Philidor Defense: Morphy Gambit",
    fen: "rnbqkbnr/ppp2ppp/3p4/8/2BpP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Philidor Defense: Nimzowitsch Variation",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Nimzowitsch Variation",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/4P3/4P3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Nimzowitsch Variation, Klein Variation",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Philidor Defense: Nimzowitsch Variation, Rellstab Variation",
    fen: "rnbqkb1r/ppp2ppp/3p4/3QP3/4n3/5N2/PPP2PPP/RNB1KB1R",
  },
  {
    name: "Philidor Defense: Nimzowitsch Variation, Sokolsky Variation",
    fen: "rnbqkb1r/ppp2ppp/3p4/4P3/4n3/5N2/PPPN1PPP/R1BQKB1R",
  },
  {
    name: "Philidor Defense: Nimzowitsch, Larobok Variation",
    fen: "r1bq1rk1/pppnbBpp/3p1n2/4p1N1/3PP3/2N5/PPP2PPP/R1BQK2R",
  },
  {
    name: "Philidor Defense: Nimzowitsch, Locock Variation",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/4p1N1/3PP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Paulsen Attack",
    fen: "rnbqkbnr/ppp2ppp/8/3P4/3N4/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Philidor Countergambit",
    fen: "rnbqkbnr/ppp3pp/3p4/4pp2/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Philidor Countergambit, Berger Variation",
    fen: "rnbqk1nr/ppp3pp/4P3/2bp2N1/4p3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Philidor Defense: Philidor Countergambit, Zukertort Variation",
    fen: "rnbqkbnr/ppp3pp/3p4/4pp2/3PP3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Philidor Defense: Philidor Countergambit, del Rio Attack",
    fen: "rnbqkbnr/ppp3pp/4P3/3p2N1/4p3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Philidor Gambit",
    fen: "rn1qkbnr/pppb1ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Philidor Defense: Steinitz Variation",
    fen: "rnbqk1nr/ppp1bppp/3p4/4p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Russian Game",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game",
    fen: "rnbqkb1r/pppp1ppp/5n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/8/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game",
    fen: "rnbqkb1r/ppp2ppp/3p4/8/4n3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Classical Attack",
    fen: "rnbqkb1r/ppp2ppp/3p4/8/3Pn3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Classical Attack, Berger Variation",
    fen: "r2qk2r/ppp1b1pp/2n5/3p1p2/3Pn1b1/2PB1N2/PP1N1PPP/R1BQR1K1",
  },
  {
    name: "Russian Game: Classical Attack, Chigorin Variation",
    fen: "r1bqk2r/ppp1bppp/2n5/3p4/3Pn3/3B1N2/PPP2PPP/RNBQR1K1",
  },
  {
    name: "Russian Game: Classical Attack, Chigorin Variation, Browne Attack",
    fen: "r1bqk2r/ppp1bppp/8/3P4/1n1Pn3/3B1N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Russian Game: Classical Attack, Chigorin Variation, Main Line",
    fen: "r1bqk2r/ppp1bppp/8/3p4/1nPPn3/5N2/PP2BPPP/RNBQ1RK1",
  },
  {
    name: "Russian Game: Classical Attack, Closed Variation",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/8/3P4/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Classical Attack, Jaenisch Variation",
    fen: "r1bqk2r/ppp1bppp/2n5/3p4/2PPn3/3B1N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Russian Game: Classical Attack, Krause Variation",
    fen: "r2qk2r/ppp1b1pp/2n5/3p1p2/2PPn1b1/3B1N2/PP3PPP/RNBQR1K1",
  },
  {
    name: "Russian Game: Classical Attack, Marshall Trap",
    fen: "rn1q1rk1/ppp3pp/8/3P1p2/3Pn1b1/3B1N2/PP3PPb/RNBQR1K1",
  },
  {
    name: "Russian Game: Classical Attack, Marshall Variation",
    fen: "rnbqk2r/ppp2ppp/3b4/3p4/3Pn3/3B1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Russian Game: Classical Attack, Marshall Variation, Chinese Gambit",
    fen: "rn1q1rk1/pp3ppp/2pb4/3p4/2PPn1b1/3B1N2/PP3PPP/RNBQR1K1",
  },
  {
    name: "Russian Game: Classical Attack, Maróczy Variation",
    fen: "r2qk2r/ppp3pp/2n5/3p1p2/2PPn1bb/3B1N2/PP3PPP/RNBQR1K1",
  },
  {
    name: "Russian Game: Classical Attack, Mason Variation",
    fen: "rnbq1rk1/ppp1bppp/8/3p4/3Pn3/3B1N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Russian Game: Classical Attack, Mason-Showalter Variation",
    fen: "r1bqkb1r/ppp2ppp/2n5/3p4/3Pn3/3B1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Russian Game: Classical Attack, Staunton Variation",
    fen: "rnbq1rk1/pp3ppp/2pb4/3p4/2PPn3/3B1N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Russian Game: Classical Attack, Tarrasch Variation",
    fen: "rn1q1rk1/ppp2ppp/3b4/3p4/2PPn1b1/3B1N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Russian Game: Cochrane Gambit",
    fen: "rnbqkb1r/ppp2Npp/3p1n2/8/4P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Cochrane Gambit, Bishop Check Line",
    fen: "rnbq1b1r/ppp2kpp/3p1n2/8/2B1P3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Russian Game: Cochrane Gambit, Center Variation",
    fen: "rnbq1b1r/ppp2kpp/3p1n2/8/3PP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Cozio Attack",
    fen: "rnbqkb1r/ppp2ppp/3p4/8/4n3/5N2/PPPPQPPP/RNB1KB1R",
  },
  {
    name: "Russian Game: Damiano Variation",
    fen: "rnbqkb1r/pppp1ppp/8/4N3/4n3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Damiano Variation, Kholmov Gambit",
    fen: "rnb1kb1r/ppppqppp/8/4N3/4n3/8/PPPPQPPP/RNB1KB1R",
  },
  {
    name: "Russian Game: French Attack",
    fen: "rnbqkb1r/ppp2ppp/3p4/8/4n3/3P1N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Italian Variation",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Russian Game: Karklins-Martinovsky Variation",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/8/4P3/3N4/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Kaufmann Attack",
    fen: "rnbqkb1r/ppp2ppp/3p4/8/2P1n3/5N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Millennium Attack",
    fen: "rnbqkb1r/ppp2ppp/3p4/8/4n3/3B1N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Russian Game: Moody Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/3PP3/5N2/PPP1QPPP/RNB1KB1R",
  },
  {
    name: "Russian Game: Nimzowitsch Attack",
    fen: "rnbqkb1r/ppp2ppp/3p4/8/4n3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Russian Game: Paulsen Attack",
    fen: "rnbqkb1r/ppp2ppp/3p1n2/8/2N1P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Stafford Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Stafford Gambit",
    fen: "r1bqkb1r/ppp2ppp/2p2n2/8/4P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Three Knights Game",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Bishop's Opening: Urusov Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/8/2BpP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Bishop's Opening: Urusov Gambit, Keidansky Gambit",
    fen: "rnbqkb1r/pppp1ppp/8/8/2BQn3/5N2/PPP2PPP/RNB1K2R",
  },
  {
    name: "Russian Game: Modern Attack",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Modern Attack",
    fen: "rnbqkb1r/pppp1ppp/5n2/8/3pP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Modern Attack, Bardeleben Variation",
    fen: "r1bqkb1r/pppp1ppp/2n5/2n1P3/3N4/8/PPP1QPPP/RNB1KB1R",
  },
  {
    name: "Russian Game: Modern Attack, Center Attack",
    fen: "rnbqkb1r/pppp1ppp/8/4P3/3Qn3/5N2/PPP2PPP/RNB1KB1R",
  },
  {
    name: "Russian Game: Modern Attack, Center Variation",
    fen: "rnbqkb1r/pppp1ppp/8/4p3/3Pn3/3B1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Russian Game: Modern Attack, Murrey Variation",
    fen: "r1bqkb1r/pppp1ppp/2n5/4p3/3Pn3/3B1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Russian Game: Modern Attack, Steinitz Variation",
    fen: "rnbqkb1r/pppp1ppp/8/4P3/3pn3/5N2/PPP1QPPP/RNB1KB1R",
  },
  {
    name: "Russian Game: Modern Attack, Symmetrical Variation",
    fen: "rnbqkb1r/ppp2ppp/5n2/3pp3/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Russian Game: Modern Attack, Tal Gambit",
    fen: "rnbqkb1r/pppp1ppp/8/1B2P3/3pn3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Russian Game: Modern Attack, Trifunovic Variation",
    fen: "rnbq1rk1/ppp2ppp/8/3pb3/2PPn3/3B4/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Dresden Opening: The Goblin",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4N3/2P1P3/8/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Irish Gambit",
    fen: "r1bqkbnr/pppp1ppp/2n5/4N3/4P3/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "King's Knight Opening: Konstantinopolsky",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5NP1/PPPP1P1P/RNBQKB1R",
  },
  {
    name: "King's Knight Opening: Normal Variation",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: Dresden Opening",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/2P1P3/5N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: Pachman Wing Gambit",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/1P2P3/5N2/P1PP1PPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: Schulze-Müller Gambit",
    fen: "r1bqkbnr/pppp1ppp/8/4n3/3PP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "King's Pawn Game: Tayler Opening",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPPBPPP/RNBQK2R",
  },
  {
    name: "King's Pawn Game: Tayler Opening",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/3PP3/5N2/PPP1BPPP/RNBQK2R",
  },
  {
    name: "King's Pawn Game: Tayler Opening, Basman Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4P3/3p4/5N2/PPP1BPPP/RNBQK2R",
  },
  {
    name: "King's Pawn Game: Tayler Opening, Inverted Hanham",
    fen: "r1bqkb1r/ppp2ppp/2n2n2/3pp3/4P3/3P1N2/PPPNBPPP/R1BQK2R",
  },
  {
    name: "Latvian Gambit: Clam Gambit",
    fen: "r1bqkbnr/pppp2pp/2n5/4pP2/8/3P1N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Ponziani Opening",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Ponziani Opening: Caro Gambit",
    fen: "r2qkbnr/pppb1ppp/2n5/3pp3/Q3P3/2P2N2/PP1P1PPP/RNB1KB1R",
  },
  {
    name: "Ponziani Opening: Jaenisch Counterattack",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Ponziani Opening: Leonhardt Variation",
    fen: "r1bqkb1r/ppp2ppp/2n2n2/3pp3/Q3P3/2P2N2/PP1P1PPP/RNB1KB1R",
  },
  {
    name: "Ponziani Opening: Neumann Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ponziani Opening: Ponziani Countergambit",
    fen: "r1bqkbnr/pppp2pp/2n5/4pp2/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Ponziani Opening: Ponziani Countergambit, Schmidt Attack",
    fen: "r1bqkbnr/ppp3pp/2np4/3Ppp2/4P3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Ponziani Opening: Romanishin Variation",
    fen: "r1bqk1nr/ppppbppp/2n5/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Ponziani Opening: Réti Variation",
    fen: "r1bqkb1r/ppppnppp/2n5/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Ponziani Opening: Spanish Variation",
    fen: "r1bqkbnr/ppp2ppp/2n5/1B1pp3/4P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ponziani Opening: Spanish Variation, Harrwitz Attack, Nikitin Gambit",
    fen: "r1b1kbnr/ppp2ppp/2n5/1B1qN3/Q3p3/2P5/PP1P1PPP/RNB1K2R",
  },
  {
    name: "Ponziani Opening: Steinitz Variation",
    fen: "r1bqkbnr/ppp3pp/2n2p2/3pp3/Q3P3/2P2N2/PP1P1PPP/RNB1KB1R",
  },
  {
    name: "Ponziani Opening: Vukovic Gambit",
    fen: "r1bqk2r/pppp1ppp/2n5/2bPp3/4n3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/3pP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Benima Defense",
    fen: "r1bqk1nr/ppppbppp/2n5/8/2BpP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Cochrane Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/b3P3/2B5/2P2N2/P4PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Cochrane-Shumov Defense",
    fen: "r1bq3r/ppp2k1p/2n3p1/2Qp4/3pP3/8/PPP2PPP/RNB1K2R",
  },
  {
    name: "Scotch Game: Göring Gambit",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/3pP3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Göring Gambit, Bardeleben Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/8/1bB1P3/2N2N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Scotch Game: Göring Gambit, Double Pawn Sacrifice",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/2B1P3/2p2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Göring Gambit, Main Line",
    fen: "r1bqk1nr/pppp1ppp/2n5/8/1b2P3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Scotch Game: Hanneken Variation",
    fen: "r1bq1rk1/pppp1ppp/5n2/4n1N1/1bB5/8/PB3PPP/RN1Q1RK1",
  },
  {
    name: "Scotch Game: Haxo Gambit",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b5/2BpP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Lolli Variation",
    fen: "r1bqkbnr/pppp1ppp/8/4p3/3nP3/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Napoleon Gambit",
    fen: "r1bqkbnr/pppp1ppp/8/8/2BpP3/8/PPP2PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Relfsson Gambit",
    fen: "r1bqkbnr/pppp1ppp/2n5/1B6/3pP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Scotch Gambit",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/2BpP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Scotch Gambit, Advance Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4P3/2Bp4/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Scotch Gambit, Cochrane-Anderssen Variation",
    fen: "r2qk1nr/ppp2ppp/2np4/2b5/2BpP1b1/2P2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Scotch Game: Scotch Gambit, Dubois Réti Defense",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/8/2BpP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Scotch Gambit, Göring Gambit Declined",
    fen: "r1bqkbnr/ppp2ppp/2n5/3p4/3pP3/2P2N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Scotch Gambit, Kingside Variation",
    fen: "r1bqkb1r/pppp1ppp/2n5/4P3/2Bp2n1/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Scotch Gambit, London Defense",
    fen: "r1bqk1nr/pppp1ppp/2n5/8/1bBpP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Scotch Gambit, Sarratt Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b3N1/2BpP3/8/PPP2PPP/RNBQK2R",
  },
  {
    name: "Scotch Game: Sea-Cadet Mate",
    fen: "r2q1bnr/ppp1kBpp/3p4/3NN3/4P3/8/PP3PPP/R1Bb1RK1",
  },
  {
    name: "Scotch Game: Vitzthum Attack",
    fen: "r1bqk2r/pppp1ppp/2n4n/2b3NQ/2BpP3/8/PPP2PPP/RNB1K2R",
  },
  {
    name: "Scotch Game",
    fen: "r1bqkbnr/pppp1ppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game",
    fen: "r1b1k1nr/pppp1ppp/2n5/1N6/1b2P2q/8/PPPB1PPP/RN1QKB1R",
  },
  {
    name: "Scotch Game: Alekhine Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4P3/3N4/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Blumenfeld Attack",
    fen: "r1b1k1nr/pppp1ppp/2n2q2/1Nb5/4P3/4B3/PPP2PPP/RN1QKB1R",
  },
  {
    name: "Scotch Game: Braune Variation",
    fen: "r1b1kbnr/pppp1ppp/2n5/8/3NP2q/4B3/PPP2PPP/RN1QKB1R",
  },
  {
    name: "Scotch Game: Classical Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b5/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Classical Variation, Blackburne Attack",
    fen: "r1b1k2r/ppppnppp/2n2q2/2b5/3NP3/2P1B3/PP1Q1PPP/RN2KB1R",
  },
  {
    name: "Scotch Game: Classical Variation, Intermezzo Variation",
    fen: "r1b1k1nr/pppp1ppp/2N2q2/2b5/4P3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Classical Variation, Millennium Variation",
    fen: "r1b1k1nr/pppp1ppp/2n3q1/2b5/3NP3/2P1B3/PP3PPP/RN1QKB1R",
  },
  {
    name: "Scotch Game: Fraser Variation",
    fen: "r1b1kbnr/pppp1ppp/2n5/8/4P2q/5N2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Ghulam-Kassim Variation",
    fen: "r1bqkbnr/ppp2ppp/3p4/8/3QP3/3B4/PPP2PPP/RNB1K2R",
  },
  {
    name: "Scotch Game: Gottschall Variation",
    fen: "1rb2rk1/pp3ppp/5q2/3P4/1n6/2P1Q3/PP3PPP/RN2KB1R",
  },
  {
    name: "Scotch Game: Horwitz Attack",
    fen: "r1b1kbnr/pppp1ppp/2n5/1N6/4P2q/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Horwitz Attack, Blackburne Variation",
    fen: "r1bk2nr/pppp1ppp/2n5/1N6/4q3/8/PPPQBPPP/RN3RK1",
  },
  {
    name: "Scotch Game: Malaniuk Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/8/1b1NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Meitner Variation",
    fen: "r1b1k2r/ppppnppp/2n2q2/2b5/4P3/2P1B3/PPN2PPP/RN1QKB1R",
  },
  {
    name: "Scotch Game: Mieses Variation",
    fen: "r1bqkb1r/p1pp1ppp/2p2n2/4P3/8/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Modern Defense",
    fen: "r1b1k1nr/pppp1ppp/2n5/8/1b1NP2q/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Scotch Game: Paulsen Attack",
    fen: "r1b1k2r/ppppnppp/2n2q2/1Bb5/3NP3/2P1B3/PP3PPP/RN1QK2R",
  },
  {
    name: "Scotch Game: Paulsen Variation",
    fen: "r1b1kbnr/pppp1ppp/2n5/5N2/4P2q/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Paulsen, Gunsberg Defense",
    fen: "r1bnk2r/ppppnppp/5q2/1Bb5/3NP3/2P1B3/PP3PPP/RN1QK2R",
  },
  {
    name: "Scotch Game: Potter Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b5/4P3/1N6/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Romanishin Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/8/1b2P3/1N6/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Rosenthal Variation",
    fen: "r1bk2nr/pppp1ppp/2n3q1/1N6/8/8/PPPNBPPP/R2Q1RK1",
  },
  {
    name: "Scotch Game: Schmidt Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/8/3NP3/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Steinitz Variation",
    fen: "r1b1kbnr/pppp1ppp/2n5/8/3NP2q/8/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Scotch Game: Steinitz Variation",
    fen: "r1b1kbnr/pppp1ppp/2n5/8/3NP2q/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Scotch Game: Tartakower Variation",
    fen: "r1bqkb1r/p1pp1ppp/2p2n2/8/4P3/8/PPPN1PPP/R1BQKB1R",
  },
  {
    name: "Three Knights Opening",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Three Knights Opening",
    fen: "r1bqk1nr/pppp1ppp/2n5/4p3/1b2P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Three Knights Opening: Schlechter Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/3Np3/1b2P3/5N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Three Knights Opening: Steinitz Defense",
    fen: "r1bqkbnr/pppp1p1p/2n3p1/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Three Knights Opening: Steinitz-Rosenthal Variation",
    fen: "r1bqkbnr/pppp1p1p/2n3p1/3N4/3pP3/5N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Three Knights Opening: Winawer Defense",
    fen: "r1bqkbnr/pppp2pp/2n5/4pp2/4P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Gunsberg Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/P1N2N2/1PPP1PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Halloween Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4N3/4P3/2N5/PPPP1PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Halloween Gambit, Oldtimer Variation",
    fen: "r1bqk1nr/pppp2pp/6n1/4Pp2/1bBP4/2N2Q2/PPP2PPP/R1B1K2R",
  },
  {
    name: "Four Knights Game: Halloween Gambit, Plasma Variation",
    fen: "1rb1kbnr/pp1p1ppp/3P1qn1/1N6/5P2/8/PPP3PP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Italian Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Italian Variation, Noa Gambit",
    fen: "r1bqkb1r/pppp1Bpp/2n5/4p3/4n3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Scotch Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Scotch Variation Accepted",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/8/3pP3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Scotch Variation, Belgrade Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/3N4/3pP3/5N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Scotch Variation, Belgrade Gambit, Modern Defense",
    fen: "r1bqkb1r/pppp2pp/2n5/3N1p2/3pn3/5N2/PPP1QPPP/R1B1KB1R",
  },
  {
    name: "Four Knights Game: Scotch Variation, Krause Gambit",
    fen: "r1bqk2r/pppp1ppp/2n2n2/4N3/1b1PP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Scotch Variation, Krause Gambit, Leonhardt Defense",
    fen: "r1b1k2r/ppppqppp/2n2n2/4N3/1b1PP3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Scotch Variation, Oxford Gambit",
    fen: "r1bqk2r/pppp1ppp/5n2/3Pp3/1b1nP3/2N2N2/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Scotch Variation, Schmid Defense",
    fen: "r1bqkb1r/pppp1ppp/2n5/8/3Nn3/2N5/PPP2PPP/R1BQKB1R",
  },
  {
    name: "Four Knights Game: Bardeleben Variation",
    fen: "r1bq1rk1/pppp1ppp/2n2n2/1B2P3/1b1P1P2/2N5/PPP3PP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Marshall Variation",
    fen: "r1bq1rk1/pppp1ppp/5n2/1Bb1N3/3nP3/2N5/PPPP1PPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Ranken Variation",
    fen: "r1bqkb1r/1ppp1ppp/p1B2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Rubinstein Countergambit",
    fen: "r1bqkb1r/pppp1ppp/5n2/4p3/3nP3/2N2N2/PPPPBPPP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Rubinstein Countergambit, Henneberger Variation",
    fen: "r1bqkb1r/pppp1ppp/5n2/1B2p3/3nP3/2N2N2/PPPP1PPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Rubinstein Countergambit, Maróczy Variation",
    fen: "r1bq1rk1/ppp2ppp/1b1p1n2/4p3/N3P3/3P1B2/PPP2PPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Spanish Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Spanish Variation, Classical Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/1Bb1p3/4P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Spanish Variation, Classical Variation, Marshall Gambit",
    fen: "r1bq1rk1/pppp1ppp/5n2/2b1N3/B2nP3/2N5/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Spanish Variation, Rubinstein Variation",
    fen: "r1bqkb1r/pppp1ppp/5n2/1B2p3/3nP3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Spanish Variation, Rubinstein Variation",
    fen: "r1b1kb1r/ppppqppp/5n2/1B2N3/3nPP2/2N5/PPPP2PP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Spanish Variation, Rubinstein Variation Accepted",
    fen: "r1bqkb1r/pppp1ppp/5n2/1B2p3/3NP3/2N5/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Spielmann Variation",
    fen: "r3kb1r/1pp2ppp/p1p1b3/3q4/3PN3/8/PPP2PPP/R1BQR1K1",
  },
  {
    name: "Four Knights Game: Alatortsev Variation",
    fen: "r1b2rk1/ppp1qppp/2n2n2/1B1pp3/1b2P3/3P1N2/PPP1NPPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Double Spanish",
    fen: "r1bqk2r/pppp1ppp/2n2n2/1B2p3/1b2P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Four Knights Game: Double Spanish",
    fen: "r1bq1rk1/pppp1ppp/2n2n2/1B2p3/1b2P3/2NP1N2/PPP2PPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Gunsberg Counterattack",
    fen: "r1bq1rk1/pppp1ppp/2n5/1B1P4/1b2p3/5N2/PPPP1PPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Janowski Variation",
    fen: "r1bq1rk1/ppp2ppp/2np1n2/1B2p3/4P3/2PP1N2/P1P2PPP/R1BQR1K1",
  },
  {
    name: "Four Knights Game: Nimzowitsch Variation",
    fen: "r1bq1rk1/pppp1ppp/2B2n2/4p3/1b2P3/2N2N2/PPPP1PPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Spanish Variation",
    fen: "r1bq1rk1/pppp1ppp/2n2n2/1B2p3/4P3/2bP1N2/PPP2PPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Spanish Variation, Symmetrical Variation",
    fen: "r1bq1rk1/ppp2ppp/2np1n2/1B2p3/1b2P3/2NP1N2/PPP2PPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Spanish Variation, Symmetrical Variation",
    fen: "r2n1rk1/ppp1qppp/3p1n2/1B2p1B1/3PP1b1/2P2N2/P1P2PPP/R2QR1K1",
  },
  {
    name: "Four Knights Game: Spanish Variation, Symmetrical Variation",
    fen: "r1bq1rk1/ppp1nppp/3p1n2/1B2p1B1/1b2P3/2NP1N2/PPP2PPP/R2Q1RK1",
  },
  {
    name: "Four Knights Game: Spanish Variation, Symmetrical Variation",
    fen: "r1bq1rk1/ppp2ppp/2np1n2/1B2p3/1b2P3/3P1N2/PPP1NPPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Svenonius Variation",
    fen: "r1bq1rk1/ppp2ppp/2n2n2/1B1pp3/4P3/2PP1N2/P1P2PPP/R1BQ1RK1",
  },
  {
    name: "Four Knights Game: Symmetrical, Blake Variation",
    fen: "r1b2rk1/pp2nppp/2pq1n2/3pp1B1/1b2P2N/1BNP4/PPP2PPP/R2Q1RK1",
  },
  {
    name: "Four Knights Game: Symmetrical, Metger Unpin",
    fen: "r1b2rk1/ppp1qppp/2np1n2/1B2p1B1/4P3/2PP1N2/P1P2PPP/R2Q1RK1",
  },
  {
    name: "Four Knights Game: Symmetrical, Tarrasch Variation",
    fen: "r2q1rk1/ppp2ppp/2npbn2/1B2p1B1/1b2P3/2NP1N2/PPP2PPP/R2Q1RK1",
  },
  {
    name: "Four Knights Game: Italian Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Italian Game",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Anti-Fried Liver Defense",
    fen: "r1bqkbnr/pppp1pp1/2n4p/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Blackburne-Kostić Gambit",
    fen: "r1bqkbnr/pppp1ppp/8/4p3/2BnP3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation, Albin Gambit",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Deutz Gambit",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2BPP3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Giuoco Pianissimo",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Giuoco Pianissimo, Canal Variation",
    fen: "r1bqk2r/ppp2ppp/2np1n2/2b1p1B1/2B1P3/2NP1N2/PPP2PPP/R2QK2R",
  },
  {
    name: "Italian Game: Giuoco Pianissimo, Dubois Variation",
    fen: "r1bqk1nr/pppp2pp/2n5/2b1p1N1/2B1Pp2/3P4/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Giuoco Pianissimo, Italian Four Knights Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2NP1N2/PPP2PPP/R1BQK2R",
  },
  {
    name: "Italian Game: Giuoco Pianissimo, Lucchini Gambit",
    fen: "r1bqk1nr/pppp2pp/2n5/2b1pp2/2B1P3/3P1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Giuoco Pianissimo, Normal",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Giuoco Piano",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Hungarian Defense",
    fen: "r1bqk1nr/ppppbppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Hungarian Defense, Tartakower Variation",
    fen: "r1bqk2r/ppppbppp/2n5/4P3/2Bpn3/2P2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Jerome Gambit",
    fen: "r1bqk1nr/pppp1Bpp/2n5/2b1p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Paris Defense",
    fen: "r1bqkbnr/ppp2ppp/2np4/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Rosentreter Gambit",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b1p3/2BPP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Rousseau Gambit",
    fen: "r1bqkbnr/pppp2pp/2n5/4pp2/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b1p3/1PB1P3/5N2/P1PP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit",
    fen: "r2qk1nr/ppp2ppp/1bnp4/8/2BPP1b1/2N2N2/P4PPP/R1BQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit Accepted",
    fen: "r1bqk1nr/pppp1ppp/2n5/4p3/1bB1P3/5N2/P1PP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit Declined",
    fen: "r1bqk1nr/pppp1ppp/1bn5/4p3/1PB1P3/5N2/P1PP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit Declined",
    fen: "r1bqk1nr/pppp1ppp/1bn5/4p3/PPB1P3/5N2/2PP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit Declined, Cordel Variation",
    fen: "r1bqk1nr/pppp1ppp/1bn5/4p3/1PB1P3/5N2/PBPP1PPP/RN1QK2R",
  },
  {
    name: "Italian Game: Evans Gambit Declined, Hicken Variation",
    fen: "r1bk2nr/pppp1Qpp/1b6/nP2q3/2B1P3/8/PBPP1PPP/RN2K2R",
  },
  {
    name: "Italian Game: Evans Gambit Declined, Hirschbach Variation",
    fen: "r1b1k1nr/pppp1ppp/1b6/nP2N1q1/2B1P3/8/P1PP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit Declined, Lange Variation",
    fen: "r1bqk2r/pppp1ppp/1b5n/nP2N3/2B1P3/8/P1PP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit Declined, Pavlov Variation",
    fen: "r1b3r1/ppp2k1p/1b6/nP2B1q1/3PP3/8/P1PN1PPP/R2QK2R",
  },
  {
    name: "Italian Game: Evans Gambit Declined, Showalter Variation",
    fen: "r1bqk1nr/1ppp1ppp/pbn5/4p3/PPB1P3/2N2N2/2PP1PPP/R1BQK2R",
  },
  {
    name: "Italian Game: Evans Gambit Declined, Vasquez Variation",
    fen: "r1b3nr/ppppkBpp/1b6/nP2N1qQ/4P3/8/P1PP1PPP/RNB1K2R",
  },
  {
    name: "Italian Game: Evans Gambit, Anderssen Variation",
    fen: "r1bqk1nr/ppppbppp/2n5/4p3/2B1P3/2P2N2/P2P1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Anderssen Variation, Cordel Line",
    fen: "r1bqk1nr/ppppbppp/8/n3p3/2BPP3/2P2N2/P4PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Fontaine Countergambit",
    fen: "r1bqk1nr/p1pp1ppp/2n5/1pb1p3/1PB1P3/5N2/P1PP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Fraser Attack",
    fen: "r2qk1nr/ppp2ppp/1bnp4/8/Q1BPP1b1/2N2N2/P4PPP/R1B2RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Fraser-Mortimer Attack",
    fen: "r2q1knr/pppb1Bpp/1b1p4/n7/3PP3/2N2N2/P1Q2PPP/R1B2RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Göring Attack",
    fen: "r1bqk1nr/ppp2ppp/1b1p4/n5B1/2BPP3/2N2N2/P4PPP/R2Q1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Harding Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/8/1bBPP3/5N2/P2B1PPP/RN1QK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Hein Countergambit",
    fen: "r1bqk1nr/ppp2ppp/2n5/2bpp3/1PB1P3/5N2/P1PP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Mayet Defense",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/2P2N2/P2P1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, McDonnell Defense",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/2P2N2/P2P1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, McDonnell Defense, Main Line",
    fen: "r1bqk1nr/ppp2ppp/1bnp4/8/2BPP3/5N2/P4PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Morphy Attack",
    fen: "r1bqk1nr/ppp2ppp/1bnp4/8/2BPP3/2N2N2/P4PPP/R1BQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Mortimer-Evans Gambit",
    fen: "r2q2nr/pppb1kpp/1b1p4/n7/3PP3/2N2N2/P1Q2PPP/R1B2RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Paulsen Variation",
    fen: "r1bqk2r/ppp1nppp/1b1p4/n2P4/2B1P3/5N2/PB3PPP/RN1Q1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Steinitz Variation",
    fen: "r1bqk1nr/ppp3pp/1b1p1p2/n7/2BPP3/2N1BN2/P4PPP/R2Q1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Stone-Ware Variation",
    fen: "r1bqk1nr/pppp1ppp/2nb4/4p3/2B1P3/2P2N2/P2P1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Ulvestad Variation",
    fen: "r1bqk1nr/ppp2ppp/1b1p4/n2P4/2B1P3/5N2/PB3PPP/RN1Q1RK1",
  },
  {
    name: "Italian Game: Evans Gambit",
    fen: "r1bqk1nr/ppp2ppp/2np4/b3p3/2B1P3/2P2N2/P2P1PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Alapin-Steinitz Variation",
    fen: "r2qk1nr/ppp2ppp/2np4/b3p3/2BPP1b1/2P2N2/P4PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Anderssen Defense",
    fen: "r1bqk2r/pppp1ppp/2n2n2/b7/2BpP3/2P2N2/P4PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Bronstein Defense",
    fen: "r1bqk1nr/ppp2ppp/2np4/b3p3/2BPP3/2P2N2/P4PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Compromised Defense",
    fen: "r1bqk1nr/pppp1ppp/2n5/b7/2B1P3/2p2N2/P4PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Compromised Defense, Main Line",
    fen: "r1b1k2r/ppppnppp/2n3q1/b3P3/2B5/BQN2N2/P4PPP/R4RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Compromised Defense, Potter Variation",
    fen: "r1b1k2r/ppppnppp/2n3q1/b3P3/2B5/1QN2N2/P4PPP/R1BR2K1",
  },
  {
    name: "Italian Game: Evans Gambit, Dufresne Defense",
    fen: "r1bqk1nr/pppp1ppp/2n5/b7/2B1P3/2Pp1N2/P4PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Johner Defense",
    fen: "r1bqk1nr/p1pp1ppp/2n5/bp6/2BpP3/2P2N2/P4PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Laroche Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/b3p3/2BPP3/2P2N2/P4PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Lasker Defense",
    fen: "r1bqk1nr/ppp2ppp/1bnp4/4p3/2BPP3/2P2N2/P4PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Leonhardt Countergambit",
    fen: "r1bqk1nr/p1pp1ppp/2n5/bp2p3/2BPP3/2P2N2/P4PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Levenfish Variation",
    fen: "r1b1k1nr/pppq1ppp/1b6/n3N3/2B1P3/BQP5/P4PPP/RN3RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Main Line",
    fen: "r1bqk1nr/pppp1ppp/2n5/b3p3/2B1P3/2P2N2/P2P1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Mieses Defense",
    fen: "r1bqk2r/ppppnppp/2n5/b7/2BpP3/2P2N2/P4PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Pierce Defense",
    fen: "r1bqk1nr/pppp1ppp/2n5/b7/2BpP3/2P2N2/P4PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Richardson Attack",
    fen: "r1bq1rk1/pppp1ppp/2n2n2/b3N3/2BPP3/2P5/P4PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Sanders-Alapin Variation",
    fen: "r2qk1nr/pppb1ppp/2np4/b3p3/2BPP3/2P2N2/P4PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Slow Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/b3p3/2B1P3/2P2N2/P2P1PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Evans Gambit, Sokolsky Variation",
    fen: "r1bqk1nr/ppp2ppp/2np4/b3p1B1/2BPP3/2P2N2/P4PPP/RN1QK2R",
  },
  {
    name: "Italian Game: Evans Gambit, Tartakower Attack",
    fen: "r1bqk1nr/ppp2ppp/2np4/b3p3/2BPP3/1QP2N2/P4PPP/RNB1K2R",
  },
  {
    name: "Italian Game: Evans Gambit, Waller Attack",
    fen: "r1bqk1nr/ppp2ppp/2np4/b7/2BpP3/1QP2N2/P4PPP/RNB2RK1",
  },
  {
    name: "Italian Game: Bird's Attack",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/1PB1P3/2P2N2/P2P1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation, Alexandre Gambit",
    fen: "r1bqk1nr/pppp2pp/2n5/2b1pp2/2B1P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation, Center Attack",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2BPP3/2P2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation, Center Holding Variation",
    fen: "r1b1k1nr/ppppqppp/1bn5/4p3/2BPP3/2P2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation, Closed Variation",
    fen: "r1b1k1nr/ppppqppp/2n5/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation, Giuoco Pianissimo",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation, Giuoco Pianissimo, Main Line",
    fen: "r1bq1rk1/bpp2ppp/p1np1n2/4p3/4P3/1BPP1N1P/PP3PP1/RNBQR1K1",
  },
  {
    name: "Italian Game: Classical Variation, Greco Gambit",
    fen: "r1bqk2r/ppp2ppp/2n2n2/2bpP3/2Bp4/2P2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation, Greco Gambit, Anderssen Variation",
    fen: "r1bqk2r/ppp2ppp/2n5/1B1pP3/1b1Pn3/5N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation, La Bourdonnais Variation",
    fen: "r1bqk1nr/ppp2ppp/1bnp4/8/2BPP3/5N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Classical Variation, Tarrasch Variation",
    fen: "r1b1k2r/1pp1qppp/pbnp1n2/4p3/P1BPP3/2P2N1P/1P3PP1/RNBQR1K1",
  },
  {
    name: "Italian Game: Giuoco Piano, Eisinger Variation",
    fen: "rnb1k1nr/ppppqppp/1b1P4/4p3/2B1P3/2P2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Giuoco Piano, Ghulam-Kassim Variation",
    fen: "r1bqk2r/pppp1ppp/2n5/2bBP3/8/2p2NK1/PP4PP/RNBQ3R",
  },
  {
    name: "Italian Game: Giuoco Piano, Mestel Variation",
    fen: "r1b1k1nr/ppppqppp/1bn5/4p1B1/2BPP3/2P2N2/PP3PPP/RN1QK2R",
  },
  {
    name: "Italian Game: Scotch Gambit, Walbrodt-Baird Gambit",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b5/2BpP3/2P2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Classical Variation, Greco Gambit, Greco Variation",
    fen: "r1bqk2r/pppp1ppp/2n5/8/1bBP4/2n2N2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Italian Game: Classical Variation, Greco Gambit, Main Line",
    fen: "r1bqk2r/pppp1ppp/2n5/8/2BPn3/2b2N2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Italian Game: Classical Variation, Greco Gambit, Moeller-Bayonet Attack",
    fen: "r1bqk2r/ppp1nppp/3p1b2/3P4/2B1R1P1/5N2/PP3P1P/R1BQ2K1",
  },
  {
    name: "Italian Game: Classical Variation, Greco Gambit, Moeller-Therkatz Attack",
    fen: "r1bqk2r/pppp1ppp/2n5/3P4/2B1n3/2b2N2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Italian Game: Classical Variation, Greco Gambit, Traditional Line",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b5/2BPP3/5N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Giuoco Piano, Aitken Variation",
    fen: "r1bqk2r/pppp1ppp/2n5/8/2BP4/B1b2N2/P4PPP/R2Q1RK1",
  },
  {
    name: "Italian Game: Giuoco Piano, Bernstein Variation",
    fen: "r1bqk2r/ppp2ppp/2n5/3p4/2BP4/1Qb2N2/P4PPP/R1B2RK1",
  },
  {
    name: "Italian Game: Giuoco Piano, Cracow Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/8/1bBPP3/5N2/PP3PPP/RNBQ1K1R",
  },
  {
    name: "Italian Game: Giuoco Piano, Greco's Attack",
    fen: "r1bqk2r/pppp1ppp/2n2n2/8/1bBPP3/2N2N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Italian Game: Giuoco Piano, Krause Variation",
    fen: "r1bq3r/ppp3pp/5k2/3pN3/1n1Pn3/1Q3P2/PP4PP/RN2K2R",
  },
  {
    name: "Italian Game: Giuoco Piano, Steinitz Variation",
    fen: "r1bqk2r/ppp2ppp/2n5/3p4/2BPn3/B1P2N2/P4PPP/R2Q1RK1",
  },
  {
    name: "Italian Game: Giuoco Piano, Therkatz-Herzog Variation",
    fen: "r1bq1rk1/ppp1nppN/3p4/3P4/2B1R3/8/PP3PPP/R2Q2K1",
  },
  {
    name: "Italian Game: Giuoco Piano",
    fen: "r1bqk2r/ppp2ppp/3p1n2/4p1B1/2BnP3/8/PPP2PPP/RN1Q1RK1",
  },
  {
    name: "Italian Game: Giuoco Piano, Holzhausen Attack",
    fen: "r1b1k2r/ppp1qppp/5n2/4p1B1/2BnP3/2N5/PPP3PP/R2Q1RK1",
  },
  {
    name: "Italian Game: Giuoco Piano, Rosentreter Variation",
    fen: "r1bqk2r/pppp1p2/5n1p/4p1p1/2BnPP1B/8/PPP3PP/RN1Q1RK1",
  },
  {
    name: "Italian Game: Scotch Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/8/2BpP3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Scotch Gambit, Janowski Defense",
    fen: "r1bqkb1r/ppp2ppp/2np1n2/8/2BpP3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Scotch Gambit, Max Lange Attack",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b5/2BpP3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Scotch Gambit, Max Lange Attack Accepted",
    fen: "r2qk2r/ppp2pPp/2n1b3/2b5/2pp4/5N2/PPP2PPP/RNBQR1K1",
  },
  {
    name: "Italian Game: Scotch Gambit, Max Lange Attack, Long Variation",
    fen: "r3k2r/ppp2ppp/2n1bP2/2b2qN1/2ppN3/8/PPP2PPP/R1BQR1K1",
  },
  {
    name: "Italian Game: Scotch Gambit, Max Lange Attack, Spielmann Defense",
    fen: "r1bqk2r/pppp1ppp/2n5/2b1P3/2Bp2n1/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Scotch Gambit, de Riviere Defense",
    fen: "r1bqk2r/ppppbppp/2n2n2/8/2BpP3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Scotch Invitation Declined",
    fen: "r1bqkb1r/ppp2ppp/2np1n2/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense",
    fen: "r1bqkb1r/pppp1ppp/2n5/4p3/2BPn3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Keidansky Variation",
    fen: "r1b1k2r/ppp2ppp/2N5/1B1pP3/4n2q/8/PPP2bPP/RNBQ1K1R",
  },
  {
    name: "Italian Game: Two Knights Defense, Max Lange Attack",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1P3/2Bp4/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Two Knights Defense, Max Lange Attack, Berger Variation",
    fen: "2kr3r/ppp2ppp/1bn1bPq1/6N1/2ppNPP1/8/PPP4P/R1BQR1K1",
  },
  {
    name: "Italian Game: Two Knights Defense, Max Lange Attack, Krause Variation",
    fen: "r1bqk2r/pppp1ppp/2n5/2b1P3/2Bp2n1/2P2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Two Knights Defense, Max Lange Attack, Loman Defense",
    fen: "r2qk2r/ppp2p1p/2n1bPp1/2b3N1/2pp4/8/PPP2PPP/RNBQR1K1",
  },
  {
    name: "Italian Game: Two Knights Defense, Max Lange Attack, Rubinstein Variation",
    fen: "r3kb1r/ppp2ppp/2n1bP2/5qN1/2ppN3/8/PPP2PPP/R1BQR1K1",
  },
  {
    name: "Italian Game: Two Knights Defense, Modern Bishop's Opening",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Open Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Perreux Variation",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/6N1/2BpP3/8/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Scotch Gambit, Anderssen Attack",
    fen: "r1b1kb1r/ppp2ppp/2n5/3q4/3pn3/2N2N2/PPP2PPP/R1BQR1K1",
  },
  {
    name: "Italian Game: Scotch Gambit, Anderssen Attack, Main Line",
    fen: "r3kb1r/ppp2ppp/2n1b3/3q2B1/3pN3/5N2/PPP2PPP/R2QR1K1",
  },
  {
    name: "Italian Game: Scotch Gambit, Canal Variation",
    fen: "r1bqkb1r/ppp2ppp/2n5/3p4/2Bpn3/2N2N2/PPP2PPP/R1BQR1K1",
  },
  {
    name: "Italian Game: Scotch Gambit, Double Gambit Accepted",
    fen: "r1bqkb1r/pppp1ppp/2n5/8/2Bpn3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Italian Game: Scotch Gambit, Nakhmanson Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n5/8/2Bpn3/2N2N2/PPP2PPP/R1BQ1RK1",
  },
  {
    name: "Italian Game: Two Knights Defense, Yurdansky Attack",
    fen: "r4b1r/ppp1kp2/2n1bN1p/q5p1/1P1p3B/5N2/P1P2PPP/R2QR1K1",
  },
  {
    name: "Italian Game: Two Knights Defense, Fegatello Attack, Leonhardt Variation",
    fen: "r1bq1b1r/ppn3pp/2p1k3/3np3/2BPQ3/P1N5/1PP2PPP/R1B1K2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Fried Liver Attack",
    fen: "r1bqkb1r/ppp2Npp/2n5/3np3/2B5/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Fritz Variation",
    fen: "r1bqkb1r/ppp2ppp/5n2/3Pp1N1/2Bn4/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Fritz, Gruber Variation",
    fen: "r1bqkb1r/p1p2ppp/8/1p1np3/3nN3/2P5/PP1P1PPP/RNBQKB1R",
  },
  {
    name: "Italian Game: Two Knights Defense, Kloss Gambit",
    fen: "r1bqkb1r/ppp2ppp/5n2/3Pp1N1/1nB5/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Knight Attack",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/4p1N1/2B1P3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Knight Attack, Normal Variation",
    fen: "r1bqkb1r/ppp2ppp/2n2n2/3pp1N1/2B1P3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Lolli Attack",
    fen: "r1bqkb1r/ppp2ppp/2n5/3np1N1/2BP4/8/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Pincus Variation",
    fen: "r1bqk2r/ppp2ppp/2n5/3np1N1/1bBP4/8/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Ponziani-Steinitz Gambit",
    fen: "r1bqkb1r/pppp1ppp/2n5/4p1N1/2B1n3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Traxler Counterattack",
    fen: "r1bqk2r/pppp1ppp/2n2n2/2b1p1N1/2B1P3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Traxler Counterattack, Bishop Sacrifice Line",
    fen: "r1bqk2r/pppp1Bpp/2n2n2/2b1p1N1/4P3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Traxler Counterattack, King March Line",
    fen: "r1bqk2r/pppp1Npp/2n5/4p3/2B1n3/4K3/PPPP2PP/RNBQ3R",
  },
  {
    name: "Italian Game: Two Knights Defense, Traxler Counterattack, Knight Sacrifice Line",
    fen: "r1bqk2r/pppp1Npp/2n2n2/2b1p3/2B1P3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Traxler Variation, Trencianske-Teplice Gambit",
    fen: "r1bq3r/ppppkBpp/2n2n2/2b1p1N1/3PP3/8/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Ulvestad Variation",
    fen: "r1bqkb1r/p1p2ppp/2n2n2/1p1Pp1N1/2B5/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Ulvestad Variation, Kurkin Gambit",
    fen: "r1bqkb1r/p1p2Np1/2n2n1p/1p1Pp3/8/8/PPPP1PPP/RNBQKB1R",
  },
  {
    name: "Italian Game: Two Knights Defense",
    fen: "r1bqkb1r/p4ppp/2p2n2/n3p1N1/8/8/PPPPBPPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Blackburne Variation",
    fen: "r1bqkb1r/p4ppp/5n2/np2p1N1/8/5Q2/PPPP1PPP/RNB1K2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Colman Variation",
    fen: "1rbqkb1r/p4ppp/2p2n2/nB2p1N1/8/5Q2/PPPP1PPP/RNB1K2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Maróczy Variation",
    fen: "r1bqk2r/ppp1bpp1/5n1p/3P4/2P1p3/5N2/PPP1QPPP/RNB1K2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Paoli Variation",
    fen: "r1b1kb1r/p1q2ppp/2p2n2/n3p1N1/8/3B1Q2/PPPP1PPP/RNB1K2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Polerio Defense",
    fen: "r1bqkb1r/ppp2ppp/5n2/n2Pp1N1/2B5/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Polerio Defense, Bishop Check Line",
    fen: "r1bqkb1r/ppp2ppp/5n2/nB1Pp1N1/8/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Polerio Defense, Bogoljubov Variation",
    fen: "r1bqkb1r/p4ppp/2p2n2/nB2p1N1/8/5Q2/PPPP1PPP/RNB1K2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Polerio Defense, Kieseritzky Variation",
    fen: "r1bqkb1r/ppp2ppp/5n2/n2Pp1N1/2B5/3P4/PPP2PPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Polerio Defense, Yankovich Variation",
    fen: "r1bqk2r/ppp2pp1/5n1p/2bP4/2P1p3/8/PPPNQPPP/RNB1K2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Knorre Variation",
    fen: "r1b1k2r/p1q2pp1/2pb1n1p/n3N3/3Pp3/8/PPPBBPPP/RN1QK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Polerio Defense, Göring Variation",
    fen: "r1b1kb1r/p1q2pp1/2p2n1p/n3N3/4p3/8/PPPPBPPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Polerio Defense, Suhle Defense",
    fen: "r1bqkb1r/p4pp1/2p2n1p/n3p1N1/8/8/PPPPBPPP/RNBQK2R",
  },
  {
    name: "Italian Game: Two Knights Defense, Steinitz Variation",
    fen: "r1bqkb1r/p4pp1/2p2n1p/n3p3/8/7N/PPPPBPPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez",
    fen: "r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Alapin Defense",
    fen: "r1bqk1nr/pppp1ppp/2n5/1B2p3/1b2P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Alapin Defense, Alapin Gambit",
    fen: "r1bqk1nr/ppp2ppp/2p5/b3p3/4P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Brentano Gambit",
    fen: "r1bqkbnr/pppp1p1p/2n5/1B2p1p1/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Bulgarian Variation",
    fen: "r1bqkbnr/1ppp1ppp/2n5/pB2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Cozio Defense",
    fen: "r1bqkb1r/ppppnppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Cozio Defense, Paulsen Variation",
    fen: "r1bqkb1r/ppppnp1p/2n3p1/1B2p3/4P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Cozio Defense, Tartakower Gambit",
    fen: "r1bq1rk1/ppp1npbp/2n3p1/1B1p4/3NP3/2N1B3/PPPQ1PPP/R3K2R",
  },
  {
    name: "Ruy Lopez: Fianchetto Defense",
    fen: "r1bqkbnr/pppp1p1p/2n3p1/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Fianchetto Defense, Kevitz Gambit",
    fen: "r1bqkbnr/pppp3p/2n3p1/1B2pp2/4P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Lucena Variation",
    fen: "r1bqk1nr/ppppbppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Nürnberg Variation",
    fen: "r1bqkbnr/pppp2pp/2n2p2/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Pollock Defense",
    fen: "r1bqkbnr/pppp1ppp/8/nB2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Retreat Variation",
    fen: "rnbqkbnr/pppp1ppp/8/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Rotary-Albany Gambit",
    fen: "r1bqkbnr/p1pp1ppp/1pn5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Spanish Countergambit",
    fen: "r1bqkbnr/ppp2ppp/2n5/1B1pp3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Spanish Countergambit, Harding Countergambit, Fricke Gambit",
    fen: "r1b1kbnr/ppp2ppp/2n5/1B1pN1q1/4P3/8/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Spanish Countergambit, Harding Gambit",
    fen: "r1b1kbnr/ppp2ppp/2N5/1B1p2q1/4P3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Vinogradov Variation",
    fen: "r1b1kbnr/ppppqppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Bird Variation",
    fen: "r1bqkbnr/pppp1ppp/8/1B2p3/3nP3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Bird Variation, Paulsen Variation",
    fen: "r1bqkb1r/ppppnppp/8/1B6/3pP3/8/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Old Steinitz Defense, Semi-Duras Variation",
    fen: "r2qkbnr/pppb1ppp/2np4/1B2p3/2PPP3/5N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Steinitz Defense",
    fen: "r1bqkbnr/ppp2ppp/2np4/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Steinitz Defense, Center Gambit",
    fen: "r1bqkbnr/ppp2ppp/2np4/1B6/3pP3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Steinitz Defense, Nimzowitsch Attack",
    fen: "r2qkb1r/pppb1ppp/2Bp1n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Schliemann Defense",
    fen: "r1bqkbnr/pppp2pp/2n5/1B2pp2/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Schliemann Defense, Classical Variation",
    fen: "r1b1kbnr/ppp3pp/2N5/1B4q1/4p3/8/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Schliemann Defense, Dyckhoff Variation",
    fen: "r1bqkbnr/pppp2pp/2n5/1B2pp2/4P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Schliemann Defense, Exchange Variation",
    fen: "r1bqkbnr/pppp2pp/2B5/4pp2/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Schliemann Defense, Jaenisch Gambit Accepted",
    fen: "r1bqkbnr/pppp2pp/2n5/1B2pP2/8/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Schliemann Defense, Kostić Defense",
    fen: "r1bqk1nr/ppppb1pp/2n5/1B2p3/4N3/5N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Schliemann Defense, Möhring Variation",
    fen: "r1b1kbnr/ppp3pp/2N5/1B1q4/4p3/8/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Schliemann Defense, Schönemann Attack",
    fen: "r1bqkbnr/pppp2pp/2n5/1B2pp2/3PP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Schliemann Defense, Tartakower Variation",
    fen: "r1bqkb1r/pppp2pp/2n2n2/1B2p3/4N3/5N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Classical Defense, Benelux Variation",
    fen: "r1bq1rk1/pppp1ppp/1bn2n2/1B2p3/3PP3/2P2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Classical Defense, Boden Variation",
    fen: "r1b1k1nr/ppppqppp/2n5/1Bb1p3/4P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Classical Defense, Zaitsev Variation",
    fen: "r1bqk1nr/pppp1ppp/8/1Bb1p3/1P1nP3/5N2/P1PP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Classical Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Classical Variation, Central Variation",
    fen: "r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Classical Variation, Charousek Variation",
    fen: "r1bqk1nr/pppp1ppp/1bn5/1B2p3/4P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Classical Variation, Cordel Gambit",
    fen: "r1bqk1nr/pppp2pp/2n5/1Bb1pp2/4P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Classical Variation, Konikowski Gambit",
    fen: "r1bqk1nr/ppp2ppp/2n5/1Bbpp3/4P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Classical Variation, Modern Main Line",
    fen: "r1bq1rk1/pppp1ppp/1bn2n2/1B2p1B1/3PP3/2P2N2/PP3PPP/RN1Q1RK1",
  },
  {
    name: "Ruy Lopez: Classical Variation, Spanish Wing Gambit",
    fen: "r1bqk1nr/pppp1ppp/2n5/1Bb1p3/1P2P3/5N2/P1PP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Berlin Defense",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Berlin Defense",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Anderssen Variation",
    fen: "r1bqkb1r/ppp2ppp/2Bp1n2/4p3/4P3/3P1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Beverwijk Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/1Bb1p3/4P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Duras Variation",
    fen: "r1bqkb1r/ppp2ppp/2np1n2/1B2p3/2P1P3/3P1N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Fishing Pole Variation",
    fen: "r1bqkb1r/pppp1ppp/2n5/1B2p3/4P1n1/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Kaufmann Variation",
    fen: "r1bqk2r/pppp1ppp/2n2n2/1Bb1p3/4P3/3PBN2/PPP2PPP/RN1QK2R",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Mortimer Trap",
    fen: "r1bqkb1r/pp1pnppp/2p2n2/1B2N3/4P3/3P4/PPP2PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Mortimer Variation",
    fen: "r1bqkb1r/ppppnppp/5n2/1B2p3/4P3/3P1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Nyholm Attack",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/1B6/3pP3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Classical Variation, Zukertort Gambit",
    fen: "r1bqk2r/pppp1ppp/2n2n2/1Bb1p3/4P3/2P2N2/PP1P1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Halloween Attack",
    fen: "r1bqkb1r/pppp1ppp/2n2n2/1B2N3/4P3/8/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Closed Bernstein Variation",
    fen: "r2qk2r/pppbbppp/2np1n2/1B2p1B1/3PP3/2N2N2/PPP2PPP/R2Q1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Closed Showalter Variation",
    fen: "r2qk2r/pppbbppp/2Bp1n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Closed Wolf Variation",
    fen: "r2qkb1r/pppb1ppp/2np1n2/1B6/3pP3/2N2N2/PPP2PPP/R1BQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Hedgehog Variation",
    fen: "r2qk2r/pppbbppp/2np1n2/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Improved Steinitz Defense",
    fen: "r1bqkb1r/ppp2ppp/2np1n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Tarrasch Trap",
    fen: "r2q1rk1/pppbbppp/2np1n2/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQR1K1",
  },
  {
    name: "Ruy Lopez: Closed Berlin Defense, Chigorin Variation",
    fen: "r1bqkb1r/pppn1ppp/2np4/1B2p3/3PP3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Berlin Wall",
    fen: "r2k1b1r/pppb1ppp/2p5/4Pn2/8/2N2N2/PPP2PPP/R1B2RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Cordel Variation",
    fen: "r1bqk2r/p1ppbppp/2p5/4Pn2/8/5N2/PPP1QPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Minckwitz Variation",
    fen: "r1bqk2r/ppppbppp/2n5/1B2P3/4n3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Pillsbury Variation",
    fen: "r1bqk2r/pnppbppp/2p5/4P3/8/1P3N2/P1P1QPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Rio Gambit Accepted",
    fen: "r1bqkb1r/pppp1ppp/2n5/1B2p3/4n3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Rio de Janeiro Variation",
    fen: "r1bqk2r/ppppbppp/2n5/1B2p3/3Pn3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Rio de Janeiro Variation",
    fen: "r1bq1rk1/p1ppbppp/8/2p1P3/3B4/2N5/PPP1QPPP/R3R1K1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Rosenthal Variation",
    fen: "r1bqkb1r/1ppp1ppp/p1n5/1B2p3/3Pn3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Trifunovic Variation",
    fen: "r1bqk2r/ppp1bppp/2n5/1B1pp3/3Pn3/5N2/PPP1QPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Winawer Attack",
    fen: "r1bqk2r/pnppbppp/2p5/4P3/3N4/8/PPP1QPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, Zukertort Variation",
    fen: "r1bqk2r/pnppbppp/2p5/4P3/2P5/5N2/PP2QPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, l'Hermet Variation",
    fen: "r1bqkb1r/pppp1ppp/2nn4/1B2p3/3P4/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, l'Hermet Variation, Berlin Wall Defense",
    fen: "r1bk1b1r/ppp2ppp/2p5/4Pn2/8/5N2/PPP2PPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Berlin Defense, l'Hermet Variation, Westerinen Line",
    fen: "r1bqkb1r/ppp2ppp/2p5/4P3/4n3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open Berlin Defense, Showalter Variation",
    fen: "r1bqkb1r/pppp1ppp/2nn4/4p3/B2P4/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open Berlin Defense, l'Hermet Variation",
    fen: "r1bqkb1r/pppp1ppp/2nn4/1B2P3/8/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Exchange Variation",
    fen: "r1bqkbnr/1ppp1ppp/p1B5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Exchange Variation, Alekhine Variation",
    fen: "r1b1k1nr/1pp2ppp/p1pb4/8/3NP3/8/PPP2PPP/RNB1K2R",
  },
  {
    name: "Ruy Lopez: Exchange Variation, Keres Variation",
    fen: "r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Exchange Variation, Lutikov Variation",
    fen: "r1bqkbnr/2pp1ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Exchange Variation, Romanovsky Variation",
    fen: "r1bqkbnr/1pp3pp/p1p2p2/4p3/4P3/2NP1N2/PPP2PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Exchange, Alekhine Variation",
    fen: "r3kbnr/1ppb1ppp/p1p5/8/3NP3/8/PPP2PPP/RNB1K2R",
  },
  {
    name: "Ruy Lopez: Exchange Variation, Alapin Gambit",
    fen: "r2qkbnr/1pp2pp1/p1p5/4p2p/4P1b1/5N1P/PPPP1PP1/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Exchange Variation, Bronstein Variation",
    fen: "r1b1kbnr/1pp2ppp/p1pq4/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Exchange Variation, Gligoric Variation",
    fen: "r1bqkbnr/1pp3pp/p1p2p2/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Exchange Variation, King's Bishop Variation",
    fen: "r1bqk1nr/1pp2ppp/p1pb4/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Exchange Variation, Normal Variation",
    fen: "r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Bird's Defense Deferred",
    fen: "r1bqkbnr/1ppp1ppp/p7/4p3/B2nP3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense",
    fen: "r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Alapin's Defense Deferred",
    fen: "r1bqk1nr/1ppp1ppp/p1n5/4p3/Bb2P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Caro Variation",
    fen: "r1bqkbnr/2pp1ppp/p1n5/1p2p3/B3P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Classical Defense Deferred",
    fen: "r1bqk1nr/1ppp1ppp/p1n5/2b1p3/B3P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Cozio Defense",
    fen: "r1bqkb1r/1pppnppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Fianchetto Defense Deferred",
    fen: "r1bqkbnr/1ppp1p1p/p1n3p1/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Graz Variation",
    fen: "r1bqk1nr/2pp1ppp/p1n5/1pb1p3/4P3/1B3N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Norwegian Variation",
    fen: "r1bqkbnr/2pp1ppp/p7/np2p3/4P3/1B3N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Norwegian Variation, Nightingale Gambit",
    fen: "r1bqkbnr/2pp1Bpp/p7/np2p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Schliemann Defense Deferred",
    fen: "r1bqkbnr/1ppp2pp/p1n5/4pp2/B3P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Schliemann Defense Deferred, Jaenisch Gambit Deferred",
    fen: "r1bqkbnr/1ppp2pp/p1n5/4pP2/B7/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
    fen: "r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
    fen: "r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
    fen: "r1bqkbnr/1pp2ppp/p1np4/4p3/B1P1P3/5N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Noah's Ark Trap",
    fen: "r1bqkbnr/5ppp/p2p4/1pp5/3QP3/1B6/PPP2PPP/RNB1K2R",
  },
  {
    name: "Ruy Lopez: Closed, Kecskemet Variation",
    fen: "r2qbrk1/1pp1bppp/p1np1n2/4p3/B2PP3/2P2N2/PP1N1PPP/R1BQR1K1",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
    fen: "r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
    fen: "r1bqkbnr/2p2ppp/p1pp4/4p3/3PP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
    fen: "r1bqkbnr/2p3pp/p1pp1p2/4p3/3PP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
    fen: "r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
    fen: "r2qkbnr/1pp3pp/p1np4/4pb2/B7/2P2N2/PP1P1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense, Siesta Variation",
    fen: "r1bqkbnr/1pp3pp/p1np4/4pp2/B3P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
    fen: "r2qkbnr/1ppb1ppp/p1np4/4p3/B3P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
    fen: "r2qkb1r/1ppbnppp/p1np4/4p3/B2PP3/2P2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Modern Steinitz Defense, Fianchetto Variation",
    fen: "r2qkbnr/1ppb1p1p/p1np2p1/4p3/B2PP3/2P2N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Anderssen Variation",
    fen: "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/3P1N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Bayreuth Variation",
    fen: "r1bqkb1r/1ppp1ppp/p1B2n2/4p3/4P3/5N2/PPPP1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Duras Variation",
    fen: "r1bqkb1r/1pp2ppp/p1np1n2/4p3/B1P1P3/3P1N2/PP3PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Jaffe Gambit",
    fen: "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/2P2N2/PP1P1PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Mackenzie Variation",
    fen: "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B2PP3/5N2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Tarrasch Variation",
    fen: "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/2N2N2/PPPP1PPP/R1BQK2R",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Wormald Attack",
    fen: "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPPQPPP/RNB1K2R",
  },
  {
    name: "Ruy Lopez: Wormald Attack, Grünfeld Variation",
    fen: "r2qk2r/2p1bppp/p1np1n2/1p2p3/3PP1b1/1BP2N2/PP2QPPP/RNB1K2R",
  },
  {
    name: "Ruy Lopez: Brix Variation",
    fen: "r1bqkb1r/1ppp1p1p/p1n2np1/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Central Countergambit",
    fen: "r1bqkb1r/1pp2ppp/p1n2n2/3pp3/B3P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Morphy Defense",
    fen: "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Morphy Defense",
    fen: "r1bqkb1r/2p2ppp/p1np1n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Arkhangelsk Variation",
    fen: "r2qkb1r/1bpp1ppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Neo-Arkhangelsk Variation",
    fen: "r1bqk2r/1ppp1ppp/p1n2n2/2b1p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Wing Attack",
    fen: "r1bqk2r/2ppbppp/p1n2n2/1p2p3/P3P3/1B3N2/1PPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Rabinovich Variation",
    fen: "r1bq1k1r/2p2ppp/p4n2/1pbPR1N1/3n4/1B6/PPPP1PPP/RNBQ2K1",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Steinitz Deferred",
    fen: "r1bqkb1r/1pp2ppp/p1np1n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Steinitz Deferred",
    fen: "r1bqkb1r/2p2ppp/p1pp4/4p3/3Pn3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Steinitz Defense Deferred, Boleslavsky Variation",
    fen: "r1bqkb1r/2p3pp/p1p5/3pPp2/4n3/2N2N2/PPP2PPP/R1BQR1K1",
  },
  {
    name: "Ruy Lopez: Steinitz Defense Deferred, Lipnitsky Variation",
    fen: "r2qkb1r/2p2ppp/p1pp1n2/4p3/3PP1b1/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Morphy Defense, Tartakower Variation",
    fen: "r1bqkb1r/1ppp1ppp/p1n5/4p3/B3n3/5N2/PPPPQPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Open",
    fen: "r1bqkb1r/1ppp1ppp/p1n5/4p3/B3n3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open",
    fen: "r1bqkb1r/1ppp1ppp/p1n5/4p3/B2Pn3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open",
    fen: "r1bqkb1r/2pp1ppp/p1n5/1p2p3/3Pn3/1B3N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open",
    fen: "r1bqkb1r/2p2ppp/p1n5/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Berger Variation",
    fen: "r1bqkb1r/2p2ppp/p7/1p1p4/P2pn3/1BN5/1PP2PPP/R1BQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Bernstein Variation",
    fen: "r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPPN1PPP/R1BQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Bernstein Variation, Luther Line",
    fen: "r2qk2r/2p2ppp/p1n1b3/1pbpP3/4n3/1B3N2/PPPN1PPP/R1B1QRK1",
  },
  {
    name: "Ruy Lopez: Open, Friess Attack",
    fen: "r1bqkb1r/2pp1ppp/p1n5/1p2N3/B2Pn3/8/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Harksen Gambit",
    fen: "r1bqkb1r/2p2ppp/p1n5/1p1pp3/2PPn3/1B3N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Karpov Gambit",
    fen: "r2qkb1r/2p2ppp/p1n1b3/1pn1P1N1/3p4/1BP5/PP1N1PPP/R1BQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Knorre Variation",
    fen: "r1bqkb1r/1ppp1ppp/p1n5/4p3/B3n3/2N2N2/PPPP1PPP/R1BQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Main Line",
    fen: "r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Richter Variation",
    fen: "r1bqkb1r/2pp1ppp/p1n5/1p1Pp3/B3n3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Riga Variation",
    fen: "r1bqkb1r/1ppp1ppp/p1n5/8/B2pn3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Schlechter Defense",
    fen: "r1bqkb1r/2p2ppp/p7/1p1pp3/P2nn3/1B3N2/1PP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Skipworth Gambit",
    fen: "r1bqkb1r/1pp2ppp/p1n5/3pp3/B3n3/5N2/PPPP1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Open, Zukertort Variation",
    fen: "r1bqkb1r/2p1nppp/p7/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Howell Attack",
    fen: "r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP1QPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Open, Howell Attack",
    fen: "r2qk2r/2p1bppp/p1n1b3/1p1pP3/2P1n3/1B3N2/PP2QPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Open, Howell Attack, Ekstrom Variation",
    fen: "r4rk1/2pqbppp/p1n1b3/3pP3/2B1n3/5N2/PP2QPPP/RNBR2K1",
  },
  {
    name: "Ruy Lopez: Open",
    fen: "r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Berlin Variation",
    fen: "r2qkb1r/2p2ppp/p1n1b3/1pnpP3/8/1BP2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Dilworth Variation",
    fen: "r2q1rk1/2p2ppp/p1n1b3/1pbpP3/8/2P2N2/PPBN1nPP/R1BQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Italian Variation",
    fen: "r2qk2r/2p2ppp/p1n1b3/1pbpP3/4n3/1BP2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Motzko Attack",
    fen: "r2qk2r/2p2ppp/p1n1b3/1pbpP3/4n3/1BPQ1N2/PP3PPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Open, Motzko Attack, Nenarokov Variation",
    fen: "r2qk2r/2p1nppp/p3b3/1pbpP3/4n3/1BPQ1N2/PP3PPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Open, St. Petersburg Variation",
    fen: "r2qk2r/2p2ppp/p1n1b3/1pbpP3/4n3/1BP2N2/PP1N1PPP/R1BQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Breslau Variation",
    fen: "r2q1rk1/2p1bppp/p3b3/1p1pn3/3Nn3/1BP5/PP3PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Open, Classical Defense",
    fen: "r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Open, Classical Defense, Main Line",
    fen: "r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP3PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Open, Malkin Variation",
    fen: "r2q1rk1/2p1bppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP1NQPPP/R1B2RK1",
  },
  {
    name: "Ruy Lopez: Open, Tarrasch Trap",
    fen: "r4rk1/2pqb1pp/p1n1p3/1p1pP3/4R3/1BP5/PP3PPP/RNBQ2K1",
  },
  {
    name: "Ruy Lopez: Closed",
    fen: "r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Closed, Basque Gambit",
    fen: "r1bqk2r/1pppbppp/p1n5/4P3/B2pn3/2P2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Closed, Center Attack",
    fen: "r1bqk2r/1pppbppp/p1n2n2/4p3/B2PP3/5N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Closed, Center Attack, Basque Gambit",
    fen: "r1bqk2r/1pppbppp/p1n5/4P3/B3n3/2p2N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Closed, Martinez Variation",
    fen: "r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/3P1N2/PPP2PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Closed, Morphy Attack",
    fen: "r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/2N2N2/PPPP1PPP/R1BQ1RK1",
  },
  {
    name: "Ruy Lopez: Closed, Delayed Exchange",
    fen: "r1bqk2r/1pppbppp/p1B2n2/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1",
  },
  {
    name: "Ruy Lopez: Closed, Worrall Attack",
    fen: "r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPPQPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Closed, Worrall Attack, Castling Line",
    fen: "r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPPQPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Closed, Worrall Attack, Delayed Castling Line",
    fen: "r1bqk2r/2p1bppp/p1np1n2/1p2p3/4P3/1B3N2/PPPPQPPP/RNB2RK1",
  },
  {
    name: "Ruy Lopez: Closed, Averbakh Variation",
    fen: "r1bqk2r/1pp1bppp/p1np1n2/4p3/B3P3/5N2/PPPP1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed",
    fen: "r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed",
    fen: "r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Alekhine Gambit",
    fen: "r4rk1/2q1bppp/p2p1n2/npp1p3/3PP3/2P1NQ2/PPB2PPP/R1B1R1K1",
  },
  {
    name: "Ruy Lopez: Closed, Anti-Marshall",
    fen: "r1bq1rk1/2ppbppp/p1n2n2/1p2p3/P3P3/1B3N2/1PPP1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Balla Variation",
    fen: "r1b1k2r/2q1bppp/p2p1n2/npp1p3/P2PP3/2P2N2/1PB2PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Leonhardt Variation",
    fen: "rnb1k2r/2q1bp1p/p2p1n2/1ppPp1p1/4P3/2P2N1P/PPBN1PP1/R1BQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Rosen Attack",
    fen: "r1bqk2r/2p1bppp/p1np1n2/1p2p3/3PP3/1B3N2/PPP2PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Trajkovic Counterattack",
    fen: "r2qk2r/1bppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Noah's Ark Trap",
    fen: "r1bqk2r/4bppp/p2p1n2/1pp5/3QP3/1B6/PPP2PPP/RNB1R1K1",
  },
  {
    name: "Ruy Lopez: Marshall Attack",
    fen: "r1bq1rk1/2p1bppp/p1n2n2/1p1pp3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Marshall Attack, Main Line",
    fen: "r1bq1rk1/4bppp/p1p5/1p1nR3/3P4/1BP5/PP3PPP/RNBQ2K1",
  },
  {
    name: "Ruy Lopez: Marshall Attack, Main Line, Spassky Variation",
    fen: "5rk1/5ppp/p1pbr3/1p1n3q/P2P2b1/1BPQB1P1/1P1N1P1P/R3R1K1",
  },
  {
    name: "Ruy Lopez: Marshall Attack, Modern Main Line",
    fen: "r1b2rk1/5ppp/p1pb4/1p1n4/3P4/1BP3Pq/PP3P1P/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Marshall Attack, Modern Variation",
    fen: "r1bq1rk1/4bppp/p1p5/1p1nR3/8/1BP5/PP1P1PPP/RNBQ2K1",
  },
  {
    name: "Ruy Lopez: Marshall Attack, Original Marshall Attack",
    fen: "r1bq1rk1/2p1bppp/p4n2/1p2R3/8/1BP5/PP1P1PPP/RNBQ2K1",
  },
  {
    name: "Ruy Lopez: Marshall Attack, Re3 Variation",
    fen: "r1bq1rk1/5ppp/p2b4/1p1p4/3P4/2P1R3/PP3PPP/RNBQ2K1",
  },
  {
    name: "Ruy Lopez: Marshall Attack, Steiner Variation",
    fen: "r1bq1rk1/2p1bppp/p1n2n2/1p1P4/4p3/1BP2N2/PP1P1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed",
    fen: "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Lutikov Variation",
    fen: "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/2P2N2/PPBP1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Pilnik Variation",
    fen: "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BPP1N2/PP3PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Suetin Variation",
    fen: "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/PBP2N2/1P1P1PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Bogoljubov Variation",
    fen: "r2q1rk1/2p1bppp/p1np1n2/1p2p3/3PP1b1/1BP2N2/PP3PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Yates Variation",
    fen: "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/3PP3/1BP2N2/PP3PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Yates Variation, Short Attack",
    fen: "r2q1rk1/2p1bppp/p1np1n2/1p2p3/P2PP1b1/1BP2N2/1P3PPP/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed",
    fen: "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Flohr System",
    fen: "r2q1rk1/1bp1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Karpov Variation",
    fen: "r1bq1rk1/2pnbppp/p1np4/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Kholmov Variation",
    fen: "r2q1rk1/2p1bppp/p1npbn2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Smyslov-Breyer-Zaitsev Hybrid",
    fen: "r2qrbk1/1bp2pp1/p1np1n1p/1p2p3/3PP3/PBP2N1P/1P1N1PP1/R1BQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Zaitsev System",
    fen: "r1bqr1k1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Smyslov Defense",
    fen: "r1bq1rk1/2p1bpp1/p1np1n1p/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Breyer Defense",
    fen: "rnbq1rk1/2p1bppp/p2p1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Breyer Defense, Quiet Variation",
    fen: "rnbq1rk1/2p1bppp/p2p1n2/1p2p3/4P3/1BPP1N1P/PP3PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Breyer",
    fen: "rnbq1rk1/2p1bppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Breyer Defense",
    fen: "r2q1rk1/1b1nbppp/p2p1n2/1pp1p3/3PP3/2P2N1P/PPBN1PP1/R1BQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Breyer Defense",
    fen: "r1bq1rk1/2pnbppp/p2p1n2/1p2p3/3PP2N/1BP4P/PP3PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Breyer Defense, Zaitsev Hybrid",
    fen: "r1bq1rk1/2pnbppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Borisenko Variation",
    fen: "r1bq1rk1/4bppp/p1np1n2/1pp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Chigorin Defense",
    fen: "r1bq1rk1/2p1bppp/p2p1n2/np2p3/4P3/2P2N1P/PPBP1PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Chigorin Defense",
    fen: "r1bq1rk1/4bppp/p2p1n2/npp1p3/4P3/2P2N1P/PPBP1PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Keres Defense",
    fen: "r1bq1rk1/3nbppp/p2p4/npp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Rossolimo Defense",
    fen: "r1b2rk1/2q1bppp/p1pp1n2/np2p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Chigorin Defense",
    fen: "r1bq1rk1/2p1bppp/p2p1n2/np2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Chigorin Defense",
    fen: "r1b2rk1/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Chigorin, Yugoslav System",
    fen: "r3r1k1/2qbbp1p/p2p1np1/npp1p3/3PP3/2P1NN1P/PPB2PP1/R1BQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Chigorin Defense",
    fen: "r1b2rk1/2q1bppp/p1np1n2/1pp1p3/3PP3/2P2N1P/PPBN1PP1/R1BQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Chigorin Defense",
    fen: "r1b2rk1/2q1bppp/p1np1n2/1pP1p3/4P3/2P2N1P/PPBN1PP1/R1BQR1K1",
  },
  {
    name: "Ruy Lopez: Closed, Chigorin Defense, Panov System",
    fen: "r1b2rk1/2q1bppp/p2p1n2/np2p3/3PP3/5N1P/PPBN1PP1/R1BQR1K1",
  },
  {
    name: "Amazon Attack",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/3P4/3Q4/PPP1PPPP/RNB1KBNR",
  },
  {
    name: "Blackmar-Diemer Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/3PP3/8/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2p2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Bogoljubow Defense",
    fen: "rnbqkb1r/ppp1pp1p/5np1/8/3P4/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Bogoljubow Defense, Kloss Attack",
    fen: "rnbq1rk1/ppp1ppbp/5np1/8/2BP4/2N2N2/PPP3PP/R1BQ1R1K",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Bogoljubow Defense, Mad Dog Attack",
    fen: "rnbqk2r/ppp1ppbp/5np1/8/2BP3P/2N2N2/PPP3P1/R1BQK2R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Bogoljubow Defense, Nimzowitsch Attack",
    fen: "rnbqk2r/ppp1ppbp/5np1/4N3/2BP4/2N5/PPP3PP/R1BQK2R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Bogoljubow Defense, Studier Attack",
    fen: "rnbq1rk1/ppp1ppbp/5np1/8/2BP4/2N2N2/PPP3PP/R1B1QRK1",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Euwe Defense",
    fen: "rnbqkb1r/ppp2ppp/4pn2/8/3P4/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Euwe Defense, Zilbermints Gambit",
    fen: "r1bqk2r/ppp1bppp/4pn2/6B1/3n4/2NB1N2/PPP3PP/R2Q1R1K",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Gunderam Defense",
    fen: "rn1qkb1r/ppp1pppp/5n2/5b2/3P4/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Gunderam Defense, Stader Variation",
    fen: "rn1qkb1r/ppp2ppp/4pn2/4N3/3Pb1P1/2N5/PPP4P/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Holwell Defense",
    fen: "rnb1kb1r/ppp1pppp/3q1n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Kaulich Defense",
    fen: "rnbqkb1r/pp2pppp/5n2/2p5/3P4/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Pietrowsky Defense",
    fen: "r1bqkb1r/ppp1pppp/2n2n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Ritter Defense",
    fen: "rnbqkb1r/p1p1pppp/1p3n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Ryder Gambit",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2Q2/PPP3PP/R1B1KBNR",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Schlutter Defense",
    fen: "r1bqkb1r/pppnpppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Teichmann Defense",
    fen: "rn1qkb1r/ppp1pppp/5n2/8/3P2b1/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Teichmann Defense, Ciesielski Variation",
    fen: "rn1qkb1r/pp2pppp/2p2n2/8/3P4/2N4P/PPP2QP1/R1B1KB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Teichmann Defense, Classical Variation",
    fen: "rn1qkb1r/pp2pppp/2p2n2/8/3P4/2N1BQ1P/PPP3P1/R3KB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Teichmann Defense, Seidel-Hall Attack",
    fen: "rn1qkb1r/pp2pppp/2p2n2/8/3P2P1/2N2Q1P/PPP5/R1B1KB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Accepted: Ziegler Defense",
    fen: "rnbqkb1r/pp2pppp/2p2n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit Declined: Brombacher Countergambit",
    fen: "rnbqkb1r/pp2pppp/5n2/2p5/3Pp3/2N2P2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit Declined: Elbert Countergambit",
    fen: "rnbqkb1r/ppp2ppp/5n2/4p3/3Pp3/2N2P2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit Declined: Gedult Defense",
    fen: "rnbqkb1r/1pp1pppp/p4n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit Declined: Lamb Defense",
    fen: "r1bqkb1r/ppp1pppp/2n2n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit Declined: Langeheinicke Defense",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N1pP2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit Declined: O'Kelly Defense",
    fen: "rnbqkb1r/pp2pppp/2p2n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit Declined: Vienna Defense",
    fen: "rn1qkb1r/ppp1pppp/5n2/5b2/3Pp3/2N2P2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit Declined: Weinsbach Defense",
    fen: "rnbqkb1r/ppp2ppp/4pn2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Blackmar Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/8/3Pp3/5P2/PPP3PP/RNBQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Diemer-Rosenberg Attack",
    fen: "rnbqkbnr/ppp1pppp/8/8/3Pp3/4B3/PPP2PPP/RN1QKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Fritz Attack",
    fen: "rnbqkbnr/ppp1pppp/8/8/2BPp3/8/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Blackmar-Diemer Gambit: Lemberger Countergambit",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/3Pp3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Lemberger Countergambit, Endgame Variation",
    fen: "rnbqkbnr/ppp2ppp/8/4P3/4p3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Lemberger Countergambit, Lange Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/3PN3/8/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Lemberger Countergambit, Rasmussen Attack",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/3Pp3/2N5/PPP1NPPP/R1BQKB1R",
  },
  {
    name: "Blackmar-Diemer Gambit: Lemberger Countergambit, Sneiders Attack",
    fen: "rnbqkbnr/ppp2ppp/8/4p2Q/3Pp3/2N5/PPP2PPP/R1B1KBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Lemberger Countergambit, Soller Attack",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/3Pp3/2N1B3/PPP2PPP/R2QKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Netherlands Variation",
    fen: "rnbqkbnr/ppp1p1pp/8/5p2/3Pp3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Rasa-Studier Gambit",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N1B3/PPP2PPP/R2QKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Reversed Albin Countergambit",
    fen: "rnbqkbnr/pp2pppp/8/2p5/3Pp3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Zeller Defense",
    fen: "rn1qkbnr/ppp1pppp/8/5b2/3Pp3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: Zeller Defense, Soller Attack",
    fen: "rn1qkb1r/ppp1pppp/5n2/5b2/2BPp3/2N2P2/PPP3PP/R1BQK1NR",
  },
  {
    name: "Blackmar-Diemer Gambit: von Popiel Gambit",
    fen: "rnbqkb1r/ppp1pppp/5n2/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "Blackmar-Diemer Gambit: von Popiel Gambit, Zilbermints Variation",
    fen: "rn1qk2r/ppp2ppp/5pb1/1Q6/1b1Pp1P1/2N5/PPP2P1P/R3KBNR",
  },
  {
    name: "Queen's Pawn Game",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Pawn Game",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/3P4/4P3/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Queen's Pawn Game",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/4P3/PPP2PPP/RNBQKBNR",
  },
  {
    name: "Queen's Pawn Game: Accelerated London System",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/3P1B2/8/PPP1PPPP/RN1QKBNR",
  },
  {
    name: "Queen's Pawn Game: Accelerated London System, Steinitz Countergambit",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/3P1B2/8/PPP1PPPP/RN1QKBNR",
  },
  {
    name: "Queen's Pawn Game: Accelerated London System, Steinitz Countergambit Accepted",
    fen: "rnbqkbnr/pp2pppp/8/2Pp4/5B2/8/PPP1PPPP/RN1QKBNR",
  },
  {
    name: "Queen's Pawn Game: Accelerated London System, Steinitz Countergambit, Morris Countergambit",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/3PPB2/8/PPP2PPP/RN1QKBNR",
  },
  {
    name: "Queen's Pawn Game: Accelerated London System, Steinitz Countergambit, Morris Countergambit Accepted",
    fen: "rnbqkbnr/pp2pppp/8/2p5/3PpB2/8/PPP2PPP/RN1QKBNR",
  },
  {
    name: "Queen's Pawn Game: Chigorin Variation",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Pawn Game: Chigorin Variation, Alburt Defense",
    fen: "rn1qkbnr/ppp1pppp/8/3p1b2/3P4/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Pawn Game: Chigorin Variation, Anti-Veresov",
    fen: "rn1qkbnr/ppp1pppp/8/3p4/3P2b1/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Pawn Game: Chigorin Variation, Fianchetto Defense",
    fen: "rnbqk1nr/ppp1ppbp/6p1/3p4/3P4/2N2N2/PPP1PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Pawn Game: Chigorin Variation, Irish Gambit",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/3P4/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Pawn Game: Chigorin Variation, Shaviliuk Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/3P4/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Pawn Game: Chigorin Variation, Shropshire Defense",
    fen: "rnbqkbnr/ppp1ppp1/8/3p3p/3P4/2N5/PPP1PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Pawn Game: Hübsch Gambit",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR",
  },
  {
    name: "Queen's Pawn Game: Levitsky Attack",
    fen: "rnbqkbnr/ppp1pppp/8/3p2B1/3P4/8/PPP1PPPP/RN1QKBNR",
  },
  {
    name: "Queen's Pawn Game: Levitsky Attack, Welling Variation",
    fen: "rn1qkbnr/ppp1pppp/8/3p2B1/3P2b1/8/PPP1PPPP/RN1QKBNR",
  },
  {
    name: "Queen's Pawn Game: Mason Attack",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/3P1P2/8/PPP1P1PP/RNBQKBNR",
  },
  {
    name: "Queen's Pawn Game: Stonewall Attack",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/3BP3/PPP2PPP/RNBQK1NR",
  },
  {
    name: "Queen's Pawn Game: Zurich Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/3P2P1/8/PPP1PP1P/RNBQKBNR",
  },
  {
    name: "Rapport-Jobava System",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P1B2/2N5/PPP1PPPP/R2QKBNR",
  },
  {
    name: "Richter-Veresov Attack",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p2B1/3P4/2N5/PPP1PPPP/R2QKBNR",
  },
  {
    name: "Richter-Veresov Attack",
    fen: "rn1qkb1r/ppp1pppp/5n2/3p1bB1/3P4/2N5/PPP1PPPP/R2QKBNR",
  },
  {
    name: "Richter-Veresov Attack: Boyce Defense",
    fen: "rnbqkb1r/ppp1pppp/8/3p2B1/3Pn3/2N5/PPP1PPPP/R2QKBNR",
  },
  {
    name: "Richter-Veresov Attack: Malich Gambit",
    fen: "rnbqkb1r/pp2pp1p/5p2/2pP4/4p3/2N5/PPP2PPP/R2QKBNR",
  },
  {
    name: "Richter-Veresov Attack: Richter Variation",
    fen: "rn1qkb1r/ppp1pppp/5n2/3p1bB1/3P4/2N2P2/PPP1P1PP/R2QKBNR",
  },
  {
    name: "Richter-Veresov Attack: Two Knights System",
    fen: "r1bqkb1r/pppnpppp/5n2/3p2B1/3P4/2N2N2/PPP1PPPP/R2QKB1R",
  },
  {
    name: "Richter-Veresov Attack: Two Knights System, Grünfeld Defense",
    fen: "r1bqkb1r/pppnpp1p/5np1/3p2B1/3P4/2N2N2/PPP1PPPP/R2QKB1R",
  },
  {
    name: "Richter-Veresov Attack: Veresov Variation",
    fen: "rn1qkb1r/ppp1pppp/5B2/3p1b2/3P4/2N5/PPP1PPPP/R2QKBNR",
  },
  {
    name: "London System: Poisoned Pawn Variation",
    fen: "rnb1kb1r/pp2pppp/1q3n2/2pp4/3P1B2/2N1PN2/PPP2PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Baltic Defense, Pseudo-Slav",
    fen: "rn1qkbnr/pp3ppp/2p1p3/3p1b2/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Pawn Game: Anti-Torre",
    fen: "rn1qkbnr/ppp1pppp/8/3p4/3P2b1/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Chandler Gambit",
    fen: "rnbqkbnr/pp2pppp/8/3p4/3p4/5NP1/PPP1PPBP/RNBQK2R",
  },
  {
    name: "Queen's Pawn Game: Chigorin Variation",
    fen: "r1bqkbnr/ppp1pppp/2n5/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Krause Variation",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Levitsky Attack, Euwe Variation, Modern Line",
    fen: "rnb1kbnr/pp2ppp1/1qp4p/3p4/3P3B/5N2/PPP1PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Pawn Game: London System",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P1B2/5N2/PPP1PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Pawn Game: London System, Pterodactyl Variation",
    fen: "rnb1k1nr/pp1pppbp/6p1/q7/3P1B2/5N2/PP2PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Pawn Game: Symmetrical Variation",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Symmetrical Variation, Pseudo-Catalan",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5NP1/PPP1PP1P/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Zilbermints Countergambit",
    fen: "rnbqkb1r/p1p1pppp/5n2/1p1p4/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Zukertort Variation",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Torre Attack",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p2B1/3P4/5N2/PPP1PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Pawn Game: Torre Attack, Gossip Variation",
    fen: "rnbqkb1r/ppp1pppp/8/3p2B1/3Pn3/5N2/PPP1PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Pawn Game: Torre Attack, Grünfeld Variation",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p2B1/3P4/5N2/PPP1PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Pawn Game: Colle System",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/4PN2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Colle System, Anti-Colle",
    fen: "rn1qkb1r/ppp1pppp/5n2/3p1b2/3P4/4PN2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Colle System, Grünfeld Formation",
    fen: "rnbqk2r/ppp1ppbp/5np1/3p4/3P4/3BPN2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Queen's Pawn Game: Colle System",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/3P4/4PN2/PPP2PPP/RNBQKB1R",
  },
  {
    name: "Queen's Pawn Game: Colle System",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/3P4/3BPN2/PPP2PPP/RNBQK2R",
  },
  {
    name: "Queen's Pawn Game: Colle System, Traditional Colle",
    fen: "rnbqkb1r/pp3ppp/4pn2/2pp4/3P4/2PBPN2/PP3PPP/RNBQK2R",
  },
  {
    name: "Queen's Pawn Game: Zukertort Variation",
    fen: "rnbqkb1r/pp3ppp/4pn2/2pp4/3P4/1P2PN2/P1PN1PPP/R1BQKB1R",
  },
  {
    name: "Rubinstein Opening",
    fen: "rnbqkb1r/pp3ppp/4pn2/2pp4/3P4/1P1BPN2/P1P2PPP/RNBQK2R",
  },
  {
    name: "Rubinstein Opening: Bogoljubov Defense",
    fen: "r1bq1rk1/pp3ppp/2nbpn2/2pp4/3P4/1P1BPN2/PBP2PPP/RN1Q1RK1",
  },
  {
    name: "Rubinstein Opening: Classical Defense",
    fen: "r1bq1rk1/pp2bppp/2n1pn2/2pp4/3P4/1P1BPN2/PBP2PPP/RN1Q1RK1",
  },
  {
    name: "Rubinstein Opening: Semi-Slav Defense",
    fen: "r1bq1rk1/pppn1ppp/3bpn2/3p4/3P4/1P1BPN2/PBP2PPP/RN1Q1RK1",
  },
  {
    name: "Queen's Gambit",
    fen: "rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Austrian Attack, Salvio Countergambit",
    fen: "rnbqkbnr/pp2pppp/8/2P5/2Pp4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Austrian Defense",
    fen: "rnbqkbnr/pp2pppp/8/2pp4/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Austrian Defense, Gusev Countergambit",
    fen: "rnbqkb1r/pp2pppp/5n2/2pP4/3P4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Austrian Defense, Haberditz Variation",
    fen: "rnb1kb1r/pp2pppp/8/q1PP4/4n3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Baltic Defense",
    fen: "rn1qkbnr/ppp1pppp/8/3p1b2/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Baltic Defense, Argentinian Gambit",
    fen: "r2qkbnr/pp2pppp/2n5/8/Q2P4/8/PP2PPPP/RbB1KBNR",
  },
  {
    name: "Queen's Gambit Declined: Baltic Defense, Pseudo-Chigorin",
    fen: "r2qkbnr/ppp2ppp/2n1p3/3p1b2/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Baltic Defense, Queen Attack",
    fen: "rn1qkbnr/ppp1pppp/8/3p1b2/2PP4/1Q6/PP2PPPP/RNB1KBNR",
  },
  {
    name: "Queen's Gambit Declined: Baltic Defense, Queen Attack Deferred",
    fen: "rn1qkbnr/ppp2ppp/4p3/3p1b2/2PP4/1QN5/PP2PPPP/R1B1KBNR",
  },
  {
    name: "Queen's Gambit Declined: Marshall Defense",
    fen: "rnbqkb1r/ppp1pppp/5n2/3p4/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Marshall Defense, Tan Gambit",
    fen: "rnbqkb1r/pp2pppp/2p2n2/3P4/3P4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Zilbermints Gambit",
    fen: "rnbqkbnr/p1p1pppp/8/1p1p4/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense",
    fen: "r1bqkbnr/ppp1pppp/2n5/3p4/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense",
    fen: "r1bqkbnr/ppp1pppp/2n5/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense",
    fen: "r1bqkbnr/ppp1pppp/2n5/8/2pP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense, Exchange Variation",
    fen: "r1b1kbnr/ppp1pppp/2n5/3q4/3P4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense, Exchange Variation, Costa's Line",
    fen: "r1b1k1nr/ppp2ppp/2n5/3q4/3p4/2B1P3/PP2NPPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense, Janowski Variation",
    fen: "r1bqkbnr/ppp1pppp/2n5/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense, Lazard Gambit",
    fen: "r1bqkbnr/ppp2ppp/2n5/3pp3/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense, Main Line",
    fen: "r2qkbnr/ppp1pppp/2n5/3p4/2PP2b1/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense, Main Line, Alekhine Variation",
    fen: "r2qkbnr/ppp1pppp/2n5/3p4/Q1PP2b1/5N2/PP2PPPP/RNB1KB1R",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense, Modern Gambit",
    fen: "r1bqkb1r/ppp1pppp/2n2n2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Chigorin Defense, Tartakower Gambit",
    fen: "r1bqkbnr/ppp2ppp/2n5/3pp3/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit",
    fen: "rnbqkbnr/ppp2ppp/8/3pp3/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Balogh Variation",
    fen: "r1b1kbnr/ppp1qppp/2n5/4P3/2Pp4/5N2/PP1NPPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Janowski Variation",
    fen: "r1bqkbnr/ppp3pp/2n2p2/4P3/2Pp4/5N2/PP1NPPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Krenosz Variation",
    fen: "r3k1nr/ppp1qppp/2n5/4P3/1bPp4/5N1P/PP1BPPP1/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Lasker Trap",
    fen: "rnbqk1nr/ppp2ppp/8/4P3/1bP5/4p3/PP1B1PPP/RN1QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Modern Line",
    fen: "r1bqkbnr/ppp2ppp/2n5/4P3/2Pp4/5N2/PP1NPPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Normal Line",
    fen: "rnbqkbnr/ppp2ppp/8/4P3/2Pp4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Tartakower Defense",
    fen: "rnbqkbnr/pp3ppp/8/2p1P3/2Pp4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Fianchetto Variation",
    fen: "r1bqkbnr/ppp2ppp/2n5/4P3/2Pp4/5NP1/PP2PP1P/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Fianchetto Variation, Be6 Line",
    fen: "r2qkbnr/ppp2ppp/2n1b3/4P3/2Pp4/5NP1/PP2PP1P/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Fianchetto Variation, Bf5 Line",
    fen: "r2qkbnr/ppp2ppp/2n5/4Pb2/2Pp4/5NP1/PP2PP1P/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Albin Countergambit, Fianchetto Variation, Bg4 Line",
    fen: "r2qkbnr/ppp2ppp/2n5/4P3/2Pp2b1/5NP1/PP2PP1P/RNBQKB1R",
  },
  {
    name: "Slav Defense",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Slav Defense",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Slav Defense",
    fen: "rnbqkbnr/pp2pppp/2p5/8/2pP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Slav Defense: Diemer Gambit",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/2PPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Slav Defense: Exchange Variation",
    fen: "rnbqkbnr/pp2pppp/2p5/3P4/3P4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Slav Defense: Exchange Variation, Boor Attack",
    fen: "rnbqkb1r/pp2pppp/5n2/3p4/3P4/2N2P2/PP2P1PP/R1BQKBNR",
  },
  {
    name: "Slav Defense: Slav Gambit, Alekhine Attack",
    fen: "rnbqkbnr/pp2pppp/2p5/8/2pPP3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Slav Defense: Winawer Countergambit",
    fen: "rnbqkbnr/pp3ppp/2p5/3pp3/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Slav Defense: Winawer Countergambit, Anti-Winawer Gambit",
    fen: "rnbqkbnr/pp3ppp/2p5/3pp3/2PPP3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Slav Defense: Bonet Gambit",
    fen: "rnbqkb1r/pp2pppp/2p2n2/3p2B1/2PP4/5N2/PP2PPPP/RN1QKB1R",
  },
  {
    name: "Slav Defense: Breyer Variation",
    fen: "rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/5N2/PP1NPPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Modern Line",
    fen: "rnbqkbnr/pp2pppp/2p5/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Slav Defense: Quiet Variation",
    fen: "rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Slav Defense: Quiet Variation, Pin Defense",
    fen: "rn1qkb1r/pp2pppp/2p2n2/3p4/2PP2b1/4PN2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Slav Defense: Quiet Variation, Amsterdam Variation",
    fen: "rn1qkb1r/pp1n1ppp/4p3/3pNb2/3P4/2N1P3/PP3PPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Quiet Variation, Landau Variation",
    fen: "rnq1kb1r/pp3ppp/4pn2/3p1b2/3P4/NQ2PN2/PP1B1PPP/R3KB1R",
  },
  {
    name: "Slav Defense: Quiet Variation, Schallopp Defense",
    fen: "rn1qkb1r/pp2pppp/2p2n2/3p1b2/2PP4/4PN2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Slav Defense: Exchange Variation",
    fen: "rnbqkb1r/pp2pppp/5n2/3p4/3P4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Slav Defense: Exchange Variation, Schallopp Variation",
    fen: "rn1qkb1r/pp2pppp/5n2/3p1b2/3P4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Exchange Variation, Symmetrical Line",
    fen: "r2qkb1r/pp2pppp/2n2n2/3p1b2/3P1B2/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Slav Defense: Exchange Variation, Trifunovic Variation",
    fen: "r2qk2r/pp3ppp/2n1pn2/3p1b2/1b1P1B2/1QN1PN2/PP3PPP/R3KB1R",
  },
  {
    name: "Slav Defense: Alekhine Variation",
    fen: "rnbqkb1r/pp2pppp/2p2n2/8/2pP4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Chameleon Variation",
    fen: "rnbqkb1r/1p2pppp/p1p2n2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Chameleon Variation, Advance System",
    fen: "rnbqkb1r/1p2pppp/p1p2n2/2Pp4/3P4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Geller Gambit",
    fen: "rnbqkb1r/pp2pppp/2p2n2/8/2pPP3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Geller Gambit",
    fen: "rnbqkb1r/p3pppp/2p2n2/1p2P3/2pP4/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Schlechter Variation",
    fen: "rnbqkb1r/pp2pp1p/2p2np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Süchting Variation",
    fen: "rnb1kb1r/pp2pppp/1qp2n2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Three Knights Variation",
    fen: "rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Two Knights Attack",
    fen: "rnbqkb1r/pp2pppp/2p2n2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Alapin Variation",
    fen: "rnbqkb1r/pp2pppp/2p2n2/8/P1pP4/2N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Smyslov Variation",
    fen: "r1bqkb1r/pp2pppp/n1p2n2/8/P1pP4/2N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Soultanbeieff Variation",
    fen: "rnbqkb1r/pp3ppp/2p1pn2/8/P1pP4/2N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Steiner Variation",
    fen: "rn1qkb1r/pp2pppp/2p2n2/8/P1pP2b1/2N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Czech Variation",
    fen: "rn1qkb1r/pp2pppp/2p2n2/5b2/P1pP4/2N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Czech Variation, Bled Attack",
    fen: "rn1qkb1r/pp2pppp/2p2n2/5b2/P1pP3N/2N5/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Czech Variation, Carlsbad Variation",
    fen: "r3kb1r/ppqn1ppp/2p2n2/4pb2/P1NP4/2N3P1/1P2PP1P/R1BQKB1R",
  },
  {
    name: "Slav Defense: Czech Variation, Carlsbad Variation, Morozevich Variation",
    fen: "r3kb1r/ppqn1p1p/2p5/4nbp1/P1N2B2/2N3P1/1P2PPBP/R2QK2R",
  },
  {
    name: "Slav Defense: Czech Variation, Krause Attack",
    fen: "rn1qkb1r/pp2pppp/2p2n2/4Nb2/P1pP4/2N5/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Czech Variation, Krause Attack, Fazekas Gambit",
    fen: "r2qkb1r/pp2pppp/n1p2n2/4Nb2/P1pPP3/2N5/1P3PPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Czech Variation, Wiesbaden Variation",
    fen: "rn1qkb1r/pp3ppp/2p1pn2/4Nb2/P1pP4/2N5/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Czech Variation, Wiesbaden Variation, Sharp Line",
    fen: "rn1qk2r/pp3ppp/2p1pn2/4Nb2/PbpPP3/2N2P2/1P4PP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Czech Variation, Classical System",
    fen: "rn1qkb1r/pp2pppp/2p2n2/5b2/P1pP4/2N1PN2/1P3PPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Czech Variation, Lasker Variation",
    fen: "r2qkb1r/pp2pppp/n1p2n2/5b2/P1pP4/2N1PN2/1P3PPP/R1BQKB1R",
  },
  {
    name: "Slav Defense: Czech Variation, Classical System, Main Line",
    fen: "rn1q1rk1/pp3ppp/2p1pn2/5b2/PbBP4/2N1PN2/1P2QPPP/R1B2RK1",
  },
  {
    name: "Slav Defense: Czech Variation, Dutch Variation",
    fen: "rn1qk2r/pp3ppp/2p1pn2/5b2/PbBP4/2N1PN2/1P3PPP/R1BQ1RK1",
  },
  {
    name: "Slav Defense: Czech Variation, Dutch Variation, Sämisch Variation",
    fen: "rn1q1rk1/pp3ppp/2p1p3/5b2/PbBPn1P1/2N1PN2/1P2QP1P/R1B2RK1",
  },
  {
    name: "Queen's Gambit Accepted",
    fen: "rnbqkbnr/ppp1pppp/8/8/2pP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Accelerated Mannheim Variation",
    fen: "rnbqkbnr/ppp1pppp/8/8/Q1pP4/8/PP2PPPP/RNB1KBNR",
  },
  {
    name: "Queen's Gambit Accepted: Central Variation, Alekhine System",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/2pPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Central Variation, Greco Variation",
    fen: "rnbqkbnr/p1p1pppp/8/1p6/2pPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Central Variation, McDonnell Defense",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/2pPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Central Variation, McDonnell Defense, Somov Gambit",
    fen: "rnbqkbnr/ppp2ppp/8/4p3/2BPP3/8/PP3PPP/RNBQK1NR",
  },
  {
    name: "Queen's Gambit Accepted: Central Variation, Modern Defense",
    fen: "r1bqkbnr/ppp1pppp/2n5/8/2pPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Central Variation, Rubinstein Defense",
    fen: "rnbqkbnr/pp2pppp/8/2p5/2pPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Central Variation, Rubinstein Defense, Yefimov Gambit",
    fen: "rnbqkbnr/p3pppp/8/1ppP4/2p1P3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Linares Variation",
    fen: "rnbqkb1r/p3pppp/5n2/1ppP4/2p1P3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Old Variation",
    fen: "rnbqkbnr/ppp1pppp/8/8/2pP4/4P3/PP3PPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Old Variation, Billinger Gambit",
    fen: "rnb1kbnr/ppp1qppp/8/8/2Bp4/PQ2P3/1P3PPP/RNB1K1NR",
  },
  {
    name: "Queen's Gambit Accepted: Old Variation, Christensen Gambit",
    fen: "rnb1kbnr/ppp1qppp/8/8/2Bp4/1Q2PN2/PP3PPP/RNB1K2R",
  },
  {
    name: "Queen's Gambit Accepted: Old Variation, Korchnoi Gambit",
    fen: "rnb1kbnr/ppp1qppp/8/8/2Bp4/1Q2P3/PP3PPP/RNB2KNR",
  },
  {
    name: "Queen's Gambit Accepted: Old Variation, Novikov Gambit",
    fen: "rnb1kbnr/ppp1qppp/8/8/2Bp4/1Q2P3/PP1N1PPP/R1B1K1NR",
  },
  {
    name: "Queen's Gambit Accepted: Saduleto Variation",
    fen: "rnbqkbnr/ppp1pppp/8/8/2pPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Schwartz Defense",
    fen: "rnbqkbnr/ppp1p1pp/8/5p2/2pPP3/8/PP3PPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Accepted: Alekhine Defense, Borisenko-Furman Variation",
    fen: "rnbqkbnr/1pp1pppp/p7/8/2pPP3/5N2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Godes Variation",
    fen: "r1bqkbnr/pppnpppp/8/8/2pP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Gunsberg Defense",
    fen: "rnbqkbnr/pp2pppp/8/2p5/2pP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Normal Variation",
    fen: "rnbqkbnr/ppp1pppp/8/8/2pP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Rosenthal Variation",
    fen: "rnbqkbnr/ppp2ppp/4p3/8/2pP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Slav Gambit",
    fen: "rnbqkbnr/p1p1pppp/8/1p6/2pP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Alekhine Defense",
    fen: "rnbqkbnr/1pp1pppp/p7/8/2pP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Alekhine Defense, Alatortsev Variation",
    fen: "rn1qkbnr/1pp2ppp/p3p3/3P4/2B3b1/4PN2/PP3PPP/RNBQK2R",
  },
  {
    name: "Queen's Gambit Accepted: Alekhine Defense, Haberditz Variation",
    fen: "rnbqkbnr/2p1pppp/p7/1p6/2pP4/4PN2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/2pP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Mannheim Variation",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/Q1pP4/5N2/PP2PPPP/RNB1KB1R",
  },
  {
    name: "Queen's Gambit Accepted: Bogoljubov Defense",
    fen: "rnbqkb1r/1pp1pppp/p4n2/8/2pPP3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Gunsberg Defense, Prianishenmo Gambit",
    fen: "rnbqkb1r/pp3ppp/5n2/2ppP3/2p5/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Showalter Variation",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Janowski-Larsen Variation",
    fen: "rn1qkb1r/ppp1pppp/5n2/8/2pP2b1/4PN2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Normal Variation",
    fen: "rnbqkb1r/ppp1pppp/5n2/8/2pP4/4PN2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Smyslov Variation",
    fen: "rnbqkb1r/ppp1pp1p/5np1/8/2pP4/4PN2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Winawer Defense",
    fen: "rn1qkb1r/ppp1pppp/4bn2/8/2pP4/4PN2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense",
    fen: "rnbqkb1r/pp3ppp/4pn2/2p5/2BP4/4PN2/PP3PPP/RNBQK2R",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense, Normal Line",
    fen: "rnbqkb1r/pp3ppp/4pn2/2p5/2BP4/4PN2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense, Steinitz Variation, Development Variation",
    fen: "r1bqkb1r/pp3ppp/2n1pn2/2p5/2BP4/4PN2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense, Steinitz Variation, Exchange Variation",
    fen: "rnbqkb1r/pp3ppp/4pn2/8/2Bp4/4PN2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Queen's Gambit Accepted: Classical, Furman Variation",
    fen: "r1bqk2r/5ppp/p1n1pn2/1pb1P3/2B5/5N2/PP2QPPP/RNB2RK1",
  },
  {
    name: "Queen's Gambit Accepted: Normal Variation, Traditional System",
    fen: "rnbqkb1r/ppp2ppp/4pn2/8/2pP4/4PN2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense, Main Line",
    fen: "rnbqkb1r/1p3ppp/p3pn2/2p5/2BP4/4PN2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense, Rubinstein Variation",
    fen: "rnbqkb1r/1p3ppp/p3pn2/2p5/P1BP4/4PN2/1P3PPP/RNBQ1RK1",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense, Russian Gambit",
    fen: "rnbqkb1r/1p3ppp/p3pn2/2p5/2BPP3/5N2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Queen's Gambit Accepted: Furman Variation",
    fen: "rnbqk2r/1p3ppp/p3pn2/2b5/2B5/4PN2/PP3PPP/RNBQ1RK1",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense, Alekhine System",
    fen: "rnbqkb1r/1p3ppp/p3pn2/2p5/2BP4/4PN2/PP2QPPP/RNB2RK1",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense, Alekhine System",
    fen: "rnbqkb1r/5ppp/p3pn2/1pp5/2BP4/4PN2/PP2QPPP/RNB2RK1",
  },
  {
    name: "Queen's Gambit Accepted: Classical, Flohr Variation",
    fen: "r3kb1r/1bq2ppp/p3pn2/1p1P4/2p5/2N1PN2/PPQ2PPP/R1BR2K1",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense, Alekhine System, Main Line",
    fen: "rn1qkb1r/1b3ppp/p3pn2/1pp5/3P4/1B2PN2/PP2QPPP/RNB2RK1",
  },
  {
    name: "Queen's Gambit Accepted: Classical Defense, Alekhine System, Smyslov Variation",
    fen: "r2qk2r/1b1n1ppp/p2bpn2/1pp5/3P4/1BN1PN2/PP2QPPP/R1BR2K1",
  },
  {
    name: "Queen's Gambit Declined",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Capablanca Variation",
    fen: "rnbqkb1r/ppp2pp1/4pn1p/3p2B1/2PP4/5N2/PP2PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Capablanca Variation",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/4PN2/PP1N1PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Semmering Variation",
    fen: "r1bqkb1r/pp1n1ppp/4pn2/2pp4/2PP4/3BPN2/PP1N1PPP/R1BQK2R",
  },
  {
    name: "Queen's Gambit Declined: Spielmann Variation",
    fen: "rnbqkb1r/pp3p1p/2p1pnp1/3p4/2PP4/4PN2/PP1N1PPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Stonewall Variation",
    fen: "rnbqkb1r/pp4pp/2p1p3/3p1p2/2PPn3/3BPN2/PP1N1PPP/R1BQK2R",
  },
  {
    name: "Queen's Gambit Declined: Tarrasch Defense, Pseudo-Tarrasch",
    fen: "rnbqkbnr/pp3ppp/4p3/2pp4/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Tarrasch Defense, Pseudo-Tarrasch Bishop Attack",
    fen: "rnbqkbnr/pp3ppp/8/2pp2B1/3P4/5N2/PP2PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Traditional Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p2B1/2PP4/5N2/PP2PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Vienna Variation",
    fen: "rnbqk2r/ppp2ppp/4pn2/3p2B1/1bPP4/5N2/PP2PPPP/RN1QKB1R",
  },
  {
    name: "Semi-Slav Defense: Quiet Variation",
    fen: "rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/4PN2/PP1N1PPP/R1BQKB1R",
  },
  {
    name: "Semi-Slav Defense: Quiet Variation",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/4PN2/PP1N1PPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Alapin Variation",
    fen: "rnbqkbnr/p1p2ppp/1p2p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Charousek Variation",
    fen: "rnbqk1nr/ppp1bppp/4p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Charousek Variation, Miladinovic Gambit",
    fen: "rnbqk1nr/ppp1bppp/4p3/8/2PPp3/2N2P2/PP4PP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Janowski Variation",
    fen: "rnbqkbnr/1pp2ppp/p3p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Queen's Knight Variation",
    fen: "rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Semi-Slav, Abrahams Variation",
    fen: "rnbqk1nr/5ppp/2p1p3/pp6/PbpP4/2N1PN2/1P1B1PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Slav, Junge Variation",
    fen: "rnb1k1nr/p4ppp/1qp1p3/1p6/PbpP4/2N1PN2/1P1B1PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Slav, Koomen Variation",
    fen: "rnb1k1nr/p3qppp/2p1p3/1p6/PbpP4/2N1PN2/1P1B1PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Uhlmann Variation",
    fen: "rnbq1rk1/ppp1bpp1/4pn1p/8/2pP3B/2N2N2/PP2PPPP/2RQKB1R",
  },
  {
    name: "Semi-Slav Defense: Accelerated Move Order",
    fen: "rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Semi-Slav Defense: Anti-Noteboom, Stonewall Variation, Portisch Gambit",
    fen: "rnbqkbnr/pp4pp/2p1p3/3p1p2/2PP2P1/2N1P3/PP3P1P/R1BQKBNR",
  },
  {
    name: "Semi-Slav Defense: Gunderam Gambit",
    fen: "rnbqkbnr/pp3ppp/2p1p3/8/2PPp3/2N2P2/PP4PP/R1BQKBNR",
  },
  {
    name: "Semi-Slav Defense: Marshall Gambit",
    fen: "rnbqkbnr/pp3ppp/2p1p3/3p4/2PPP3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Semi-Slav Defense: Marshall Gambit, Forgotten Variation",
    fen: "rnbqk1nr/pp3ppp/2p1p3/8/1bPP4/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Semi-Slav Defense: Marshall Gambit, Main Line",
    fen: "rnbqk1nr/pp3ppp/2p1p3/8/1bPPN3/8/PP1B1PPP/R2QKBNR",
  },
  {
    name: "Semi-Slav Defense: Marshall Gambit, Tolush Variation",
    fen: "rnb1k1nr/pp3ppp/4p3/2B5/2P5/8/PP2BPqP/R2QK1NR",
  },
  {
    name: "Semi-Slav Defense: Noteboom Variation",
    fen: "rnbqkbnr/pp3ppp/2p1p3/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Semi-Slav Defense: Noteboom Variation, Abrahams Variation",
    fen: "rnbqk1nr/p4ppp/4p3/1p6/2pP4/2P1PN2/5PPP/R1BQKB1R",
  },
  {
    name: "Semi-Slav Defense: Noteboom Variation, Anti-Noteboom Gambit",
    fen: "rnbqkbnr/pp3ppp/2p1p3/8/2pP4/2N2NP1/PP2PP1P/R1BQKB1R",
  },
  {
    name: "Semi-Slav Defense: Noteboom Variation, Anti-Noteboom Variation",
    fen: "rnbqkbnr/pp3ppp/2p1p3/6B1/2pP4/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Semi-Slav Defense: Noteboom Variation, Anti-Noteboom Variation, Belyavsky Line",
    fen: "rnbqkbnr/pp4pp/2p1pp2/6B1/2pP4/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Tarrasch Defense",
    fen: "rnbqkbnr/pp3ppp/8/2pp4/3P4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Tarrasch Defense",
    fen: "rnbqkbnr/pp3ppp/4p3/2pp4/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Tarrasch Defense: Grünfeld Gambit",
    fen: "r1bqkbnr/p4ppp/2n5/1pP5/N2p4/5N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Tarrasch Defense: Marshall Gambit",
    fen: "rnbqkbnr/pp3ppp/8/2pp4/3PP3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "Tarrasch Defense: Schara Gambit",
    fen: "rnbqkbnr/pp3ppp/4p3/3P4/3p4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Tarrasch Defense: Symmetrical Variation",
    fen: "r1bqkb1r/pp3ppp/2n1pn2/2pp4/2PP4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Tarrasch Defense: Tarrasch Gambit",
    fen: "rnbqkbnr/p4ppp/8/1pP5/N2p4/8/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Tarrasch Defense: Two Knights Variation",
    fen: "rnbqkbnr/pp3ppp/8/2pp4/3P4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Tarrasch Defense: von Hennig Gambit",
    fen: "r2qkbnr/pp3ppp/2n1b3/3Q4/8/2N5/PP2PPPP/R1B1KBNR",
  },
  {
    name: "Tarrasch Defense: Dubov Tarrasch",
    fen: "r1bqk2r/pp3ppp/2n2n2/2bp4/3N4/2N3P1/PP2PPBP/R1BQK2R",
  },
  {
    name: "Tarrasch Defense: Prague Variation",
    fen: "r1bqkb1r/pp3ppp/2n2n2/2pp4/3P4/2N2NP1/PP2PP1P/R1BQKB1R",
  },
  {
    name: "Tarrasch Defense: Rubinstein System",
    fen: "r1bqkbnr/pp3ppp/2n5/2pp4/3P4/2N2NP1/PP2PP1P/R1BQKB1R",
  },
  {
    name: "Tarrasch Defense: Swedish Variation",
    fen: "r1bqkbnr/pp3ppp/2n5/3p4/2pP4/2N2NP1/PP2PP1P/R1BQKB1R",
  },
  {
    name: "Tarrasch Defense: Swedish Variation, Central Break",
    fen: "r1bqkbnr/pp3ppp/2n5/3p4/2pPP3/2N2NP1/PP3P1P/R1BQKB1R",
  },
  {
    name: "Tarrasch Defense: Wagner Variation",
    fen: "r2qkb1r/pp3ppp/2n2n2/2pp4/3P2b1/2N2NP1/PP2PPBP/R1BQK2R",
  },
  {
    name: "Queen's Gambit Declined: Tarrasch Defense, Stoltz Variation",
    fen: "r2q1rk1/p3bppp/1pn1bn2/2pp2B1/3P4/2N2NP1/PP2PPBP/2RQ1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation",
    fen: "r1bq1rk1/pp2bppp/2n2n2/2pp4/3P4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation, Advance Variation",
    fen: "r1bq1rk1/pp2bppp/2n2n2/3p2B1/2pP4/2N2NP1/PP2PPBP/R2Q1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation, Bogoljubov Variation",
    fen: "r2q1rk1/pp2bppp/2n1bn2/3p2B1/2pP4/2N2NP1/PP2PPBP/2RQ1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation, Carlsbad Variation",
    fen: "r1bq1rk1/pp2bppp/2n2n2/2pp2B1/3P4/2N2NP1/PP2PPBP/R2Q1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation, Chandler Variation",
    fen: "r2qr1k1/pp2bpp1/2n1bn1p/3p4/3N4/2N1B1P1/PP2PPBP/2RQ1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation, Classical Tarrasch Gambit",
    fen: "r1bq1rk1/pp2bppp/2n2n2/2P5/3p4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation, Endgame Variation",
    fen: "r2q1rk1/pp2bppp/2n1bn2/2pp2B1/3P4/2N2NP1/PP2PPBP/R2Q1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation, Main Line",
    fen: "r1bqr1k1/pp2bpp1/2n2n1p/3p4/3N4/2N1B1P1/PP2PPBP/R2Q1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation, Petursson Variation",
    fen: "r1bqr1k1/pp2bppp/2n2n2/3p2B1/3N4/2N3P1/PP2PPBP/R2Q1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation, Réti Variation",
    fen: "r1bq1rk1/pp3ppp/2n2n2/2bp4/N7/5NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Tarrasch Defense: Classical Variation, Spassky Variation",
    fen: "r2q1rk1/pp2bpp1/2n2n1p/3p4/3N2b1/2N1B1P1/PP2PPBP/R2Q1RK1",
  },
  {
    name: "Tarrasch Defense: Prague Variation, Main Line",
    fen: "r1bqk2r/pp2bppp/2n2n2/2pp4/3P4/2N2NP1/PP2PPBP/R1BQK2R",
  },
  {
    name: "Queen's Gambit Declined: Exchange Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3P4/3P4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Exchange Variation, Chameleon Variation",
    fen: "r1bqrnk1/ppp1bppp/5n2/3p2B1/3P4/2NBP3/PPQ1NPPP/2KR3R",
  },
  {
    name: "Queen's Gambit Declined: Exchange Variation, Positional Variation",
    fen: "rnbqkb1r/ppp2ppp/5n2/3p2B1/3P4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Exchange Variation, Positional Variation",
    fen: "rnbqkb1r/pp3ppp/2p2n2/3p2B1/3P4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Exchange Variation, Sämisch Variation",
    fen: "r1bqkb1r/pppn1ppp/5n2/3p4/3P1B2/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Harrwitz Attack",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP1B2/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Normal Defense",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Exchange Variation, Reshevsky Variation",
    fen: "rnbqkb1r/pp3ppp/2p2n2/3p2B1/3P4/2N5/PPQ1PPPP/R3KBNR",
  },
  {
    name: "Queen's Gambit Declined: Barmen Variation",
    fen: "r1bqkb1r/pppn1ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Harrwitz Attack",
    fen: "rnbqk2r/ppp1bppp/4pn2/3p4/2PP1B2/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Harrwitz Attack",
    fen: "r1b2rk1/pp3ppp/2n1pn2/q1bp4/2P2B2/P1N1PN2/1PQ2PPP/3RKB1R",
  },
  {
    name: "Queen's Gambit Declined: Harrwitz Attack",
    fen: "r1b2rk1/pp3ppp/2n1pn2/q1bp4/2P2B2/P1N1PN2/1PQ2PPP/2KR1B1R",
  },
  {
    name: "Queen's Gambit Declined: Harrwitz Attack, Fianchetto Defense",
    fen: "rnbq1rk1/p1p1bppp/1p2pn2/3p4/2PP1B2/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Harrwitz Attack, Main Line",
    fen: "rnbq1rk1/pp3ppp/4pn2/2bp4/2P2B2/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Harrwitz Attack, Orthodox Defense",
    fen: "rnbq1rk1/pp2bppp/2p1pn2/3p4/2PP1B2/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Harrwitz Attack, Two Knights Defense",
    fen: "r1bq1rk1/pppnbppp/4pn2/3p4/2PP1B2/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Harrwitz Attack, Two Knights Defense, Blockade Line",
    fen: "r1bq1rk1/pppnbppp/4pn2/2Pp4/3P1B2/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Knight Defense, Alekhine Gambit",
    fen: "r1bqkb1r/pppn1pp1/4pn1p/8/2pP3B/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Miles Variation",
    fen: "rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N2N2/PPQ1PPPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Three Knights Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Three Knights, Vienna Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Vienna Variation, Quiet Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/8/2pP4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Ragozin Defense",
    fen: "rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Ragozin Defense, Alekhine Variation",
    fen: "rnbqk2r/ppp2ppp/4pn2/3p4/QbPP4/2N2N2/PP2PPPP/R1B1KB1R",
  },
  {
    name: "Queen's Gambit Declined: Westphalian Variation",
    fen: "r1bqk2r/pp1n1ppp/4pn2/2pp2B1/1bPP4/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Ragozin Defense, Vienna Variation",
    fen: "rnbqk2r/ppp2ppp/4pn2/6B1/1bpP4/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense",
    fen: "rnbqkb1r/pp3ppp/4pn2/2pp4/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense, Levenfish Variation",
    fen: "r1b2rk1/pp2qppp/2n1pn2/2bp4/2P1P3/2NB1N2/PP2QPPP/R1B2RK1",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense, Pillsbury Variation",
    fen: "rnbqkb1r/pp3ppp/4pn2/2pp2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense, Symmetrical Variation",
    fen: "r1bq1rk1/pp3ppp/2nbpn2/2pp4/2PP4/2NBPN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense",
    fen: "rnbqkb1r/pp3ppp/4pn2/2pP4/3P4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense, Exchange Variation",
    fen: "rnbqkb1r/pp3ppp/4p3/2pn4/3PP3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense, Kmoch Variation",
    fen: "rnbq1rk1/pp3ppp/4p3/1B6/3PP3/5N2/P2Q1PPP/R3K2R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense, Pillsbury Variation",
    fen: "rnbqkb1r/pp3ppp/4p3/2pn4/3P4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense, San Sebastian Variation",
    fen: "rnb1k2r/pp3ppp/4p3/q7/1b1PP3/5N2/P2B1PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense, Main Line",
    fen: "r1bqkb1r/pp3ppp/2n1p3/2pn4/3P4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Queen's Gambit Declined: Hastings Variation",
    fen: "rnb1kb1r/pp3pp1/2p1pq1p/3p4/2PP4/1QN2N2/PP2PPPP/R3KB1R",
  },
  {
    name: "Semi-Slav Defense",
    fen: "rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Semi-Slav Defense: Anti-Moscow Gambit",
    fen: "rnbqkb1r/pp3pp1/2p1pn1p/3p4/2PP3B/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Semi-Slav Defense Accepted",
    fen: "rnbqkb1r/pp3ppp/2p1pn2/6B1/2pP4/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Semi-Slav Defense: Botvinnik Variation",
    fen: "rnbqkb1r/pp3ppp/2p1pn2/6B1/2pPP3/2N2N2/PP3PPP/R2QKB1R",
  },
  {
    name: "Semi-Slav Defense: Botvinnik Variation",
    fen: "rnbqkb1r/p4p2/2p1pn1p/1p2P1N1/2pP3B/2N5/PP3PPP/R2QKB1R",
  },
  {
    name: "Semi-Slav Defense: Botvinnik Variation, Alatortsev System",
    fen: "rnbqkb1r/p4p2/2p1p2p/1p1nP1N1/2pP3B/2N5/PP3PPP/R2QKB1R",
  },
  {
    name: "Semi-Slav Defense: Botvinnik Variation, Ekstrom Variation",
    fen: "rnbqkb1r/p4p2/2p1pP1p/1p2N3/2pP3p/2N5/PP3PPP/R2QKB1R",
  },
  {
    name: "Semi-Slav Defense: Botvinnik Variation, Lilienthal Variation",
    fen: "r1bqkb1r/p2n1p2/2p1pn2/1p2P1B1/2pP4/2N3P1/PP3P1P/R2QKB1R",
  },
  {
    name: "Semi-Slav Defense: Botvinnik Variation, Szabo Variation",
    fen: "r1bqkb1r/p2n1p2/2p1pn2/1p2P1B1/2pP4/2N2Q2/PP3PPP/R3KB1R",
  },
  {
    name: "Semi-Slav Defense: Accelerated Meran Variation",
    fen: "rnbqkb1r/1p3ppp/p1p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Semi-Slav Defense: Main Line",
    fen: "rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Semi-Slav Defense: Normal Variation",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Semi-Slav Defense: Rubinstein System",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/3pN3/2PP4/2N1P3/PP3PPP/R1BQKB1R",
  },
  {
    name: "Semi-Slav Defense: Stoltz Variation",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2N1PN2/PPQ2PPP/R1B1KB1R",
  },
  {
    name: "Semi-Slav Defense: Stoltz Variation, Center Variation",
    fen: "r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PPP3/2N2N2/PPQ2PPP/R1B1KB1R",
  },
  {
    name: "Semi-Slav Defense: Stoltz Variation, Center Variation, Mikhalchishin Line",
    fen: "r1bqk2r/pp1n1ppp/2pb4/4P3/2P1Q3/5N2/PP3PPP/R1B1KB1R",
  },
  {
    name: "Semi-Slav Defense: Stoltz Variation, Shabalov Attack",
    fen: "r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PP2P1/2N1PN2/PPQ2P1P/R1B1KB1R",
  },
  {
    name: "Semi-Slav Defense: Stonewall Defense",
    fen: "rnbqkb1r/pp4pp/2p1p3/3p1p2/2PPn3/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Bogoljubov Variation",
    fen: "r1bqk2r/pp1nbppp/2p1pn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Chigorin Defense",
    fen: "r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Main Line",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Romih Variation",
    fen: "r1bqk2r/pp1n1ppp/2p1pn2/3p4/1bPP4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation",
    fen: "r1bqkb1r/p2n1ppp/2p1pn2/1p6/2BP4/2N1PN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Lundin Variation",
    fen: "r1bqkb1r/p2n1ppp/2p1pn2/8/1p1P4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Wade Variation",
    fen: "r2qkb1r/pb1n1ppp/2p1pn2/1p6/3P4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Wade Variation, Kaidanov Gambit",
    fen: "r2qkb1r/pb1n1ppp/4p3/3nP3/Np1N4/3B4/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Wade Variation, Larsen Variation",
    fen: "r2qkb1r/pb1n1ppp/4p3/2pnP3/Np1P4/3B1N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Semi-Meran Variation",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/8/2BP4/2N1PN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation",
    fen: "r1bqkb1r/3n1ppp/p1p1pn2/1p6/3P4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation",
    fen: "r1bqkb1r/3n1ppp/p3pn2/1pp5/3PP3/2NB1N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Old Variation",
    fen: "r1bqkb1r/3n1ppp/p3pn2/1pp1P3/3P4/2NB1N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Pirc Variation",
    fen: "r1bqkb1r/3n1ppp/p1p1pn2/8/1p1PP3/2NB1N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Reynolds' Variation",
    fen: "r1bqkb1r/3n1ppp/p3pn2/1ppP4/4P3/2NB1N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Blumenfeld Variation",
    fen: "r1bqkb1r/3n1ppp/p3pn2/1N2P3/3p4/3B1N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Rabinovich Variation",
    fen: "r1bqkb1r/3n1ppp/p3p3/1N2P3/3p2n1/3B1N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Rellstab Attack",
    fen: "r3kb1r/5ppp/b3pn2/1p1qN1B1/3p4/3B4/PP2QPPP/R4RK1",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Sozin Variation",
    fen: "r1bqkb1r/5ppp/p3pn2/1N2n3/3p4/3B1N2/PP3PPP/R1BQK2R",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Sozin Variation",
    fen: "r1bqkb1r/5ppp/4pn2/1p2N3/3p4/3B4/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Semi-Slav Defense: Meran Variation, Stahlberg Variation",
    fen: "r1bqkb1r/5ppp/4pn2/1p2N3/3p4/3B1Q2/PP3PPP/R1B1K2R",
  },
  {
    name: "Queen's Gambit Declined: Been-Koomen Variation",
    fen: "rnbqkb1r/pp3ppp/4pn2/2pp2B1/2PP4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Modern Variation",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Pseudo-Tarrasch Variation",
    fen: "rnbqkb1r/pp3ppp/4pn2/2pP2B1/3P4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Pseudo-Tarrasch Variation, Canal Variation",
    fen: "rnb1kb1r/pp3ppp/1q2pn2/2pP2B1/3P4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Pseudo-Tarrasch Variation, Primitive Pillsbury Variation",
    fen: "rnbqkb1r/pp3ppp/4pn2/3p2B1/2PQ4/2N2N2/PP2PPPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Semi-Tarrasch Defense, Krause Variation",
    fen: "rnbqkb1r/1p3ppp/p4n2/1N1pp1B1/Q1P5/2N5/PP2PPPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Alekhine Variation",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PPP3/2N2N2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Capablanca Variation, Anti-Cambridge Springs Variation",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/P1N1P3/1P3PPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Manhattan Variation",
    fen: "r1bqk2r/pppn1ppp/4pn2/3p2B1/1bPP4/2N1P3/PP3PPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Modern Variation, Knight Defense",
    fen: "r1bqkb1r/pppn1ppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Modern Variation, Knight Defense",
    fen: "r1bqkb1r/pppn1ppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Modern Variation, Knight Defense",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Rochlin Variation",
    fen: "r1b1kb1r/pp1n1ppp/2p1pn2/q2p4/2PP4/2N2N2/PP1BPPPP/2RQKB1R",
  },
  {
    name: "Queen's Gambit Declined",
    fen: "r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Cambridge Springs Defense",
    fen: "r1b1kb1r/pp1n1ppp/2p1pn2/q2p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Cambridge Springs Defense",
    fen: "r1b1kb1r/pp1n1ppp/2p1pn2/q2P2B1/3P4/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Cambridge Springs Defense, Argentine Variation",
    fen: "r1b2rk1/pp1n1ppp/2p1pn2/q2p4/1bPP3B/2N1P3/PPQN1PPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Cambridge Springs Defense, Bogoljubov Variation",
    fen: "r1b1k2r/pp1n1ppp/2p1pn2/q2p2B1/1bPP4/2N1P3/PPQN1PPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Cambridge Springs Defense, Capablanca Variation",
    fen: "r1b1kb1r/pp1n1ppp/2p1pB2/q2p4/2PP4/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Cambridge Springs Defense, Rubinstein Variation",
    fen: "r1b1kb1r/pp1n1ppp/2p1pn2/q5B1/2pP4/2N1P3/PP1N1PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Cambridge Springs Defense, Yugoslav Variation",
    fen: "r1b1kb1r/pp1n1ppp/2p1p3/q2n2B1/3P4/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined",
    fen: "rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Lasker Defense",
    fen: "rnbqk2r/ppp1bppp/4p3/3p2B1/2PPn3/2N1P3/PP3PPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Modern Variation, Heral Variation",
    fen: "rnbqk2r/ppp1bppp/4pB2/3p4/2PP4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Queen's Gambit Declined: Neo-Orthodox Variation",
    fen: "rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/2RQKBNR",
  },
  {
    name: "Queen's Gambit Declined: Anti-Tartakower Variation",
    fen: "rnbq1rk1/ppp1bpp1/4pB1p/3p4/2PP4/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Anti-Tartakower Variation, Petrosian Variation",
    fen: "r1bq1rk1/pp1n1pp1/2p1pb1p/8/2BP4/2N1PN2/PP3PPP/2RQ1RK1",
  },
  {
    name: "Queen's Gambit Declined: Modern Variation, Normal Line",
    fen: "rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Neo-Orthodox Variation",
    fen: "rnbq1rk1/ppp1bpp1/4pn1p/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Neo-Orthodox Variation, Main Line",
    fen: "rnbq1rk1/ppp1bpp1/4pn1p/3p4/2PP3B/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Pillsbury Attack",
    fen: "rn1q1rk1/pbp1bppp/1p3n2/3pN1B1/3P4/2NBP3/PP3PPP/R2QK2R",
  },
  {
    name: "Queen's Gambit Declined: Lasker Defense",
    fen: "rnbq1rk1/ppp1bpp1/4p2p/3p4/2PPn2B/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Lasker Defense, Russian Variation",
    fen: "r4rk1/pp1bqpp1/2n1pn1p/2p5/2BP4/2N1PN2/PPQ2PPP/R2R2K1",
  },
  {
    name: "Queen's Gambit Declined: Lasker Defense, Teichmann Variation",
    fen: "rnb2rk1/ppp1qpp1/4p2p/3p4/2PPn3/2N1PN2/PPQ2PPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Lasker Defense, Bernstein Variation",
    fen: "rnb2rk1/ppp2pp1/3q3p/3p4/3P4/1QP1PN2/P4PPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Lasker Defense, Bernstein Variation, Mar del Plata Gambit",
    fen: "rn1r2k1/ppp1qpp1/4b2p/3p4/2PP4/1Q2PN2/P4PPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Lasker Defense, Main Line",
    fen: "rnb2rk1/ppp1qpp1/4p2p/3P4/3P4/2P1PN2/P4PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Tartakower Defense",
    fen: "rnbq1rk1/p1p1bpp1/1p2pn1p/3p4/2PP3B/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Tartakower Defense, Exchange Variation",
    fen: "rnbq1rk1/p1p1bpp1/1p3n1p/3p4/3P3B/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Tartakower Defense",
    fen: "rn3rk1/p1p1qpp1/1p2b2p/3p4/3P4/4PN2/PP3PPP/2RQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Tartakower Defense, Makogonov Exchange Variation",
    fen: "rnbq1rk1/p1p1bpp1/1p2p2p/3n4/3P3B/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense",
    fen: "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Botvinnik Variation",
    fen: "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2NBPN2/PP3PPP/R2QK2R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Rauzer Variation",
    fen: "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/1QN1PN2/PP3PPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Rubinstein Variation",
    fen: "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PPQ2PPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Rubinstein Variation, Flohr Line",
    fen: "r1bq1rk1/pp1nbppp/4pn2/2pP2B1/3P4/2N1PN2/PPQ2PPP/R3KB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Capablanca Variation",
    fen: "r1bq1rk1/p1pnbppp/1p3n2/1B1p2B1/3P4/2N1PN2/PP3PPP/2RQK2R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Henneberger Variation",
    fen: "r1bq1rk1/1ppnbppp/p3pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Main Line",
    fen: "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Main Line",
    fen: "r1bq1rk1/pp1nbppp/2p1pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Pillsbury Variation",
    fen: "r1bq1rk1/p1pnbppp/1p3n2/3p2B1/3P4/2NBPN2/PP3PPP/2RQK2R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Swiss, Karlsbad Variation",
    fen: "r1bq1rk1/1ppnbppp/p3pn2/3P2B1/3P4/2N1PN2/PP3PPP/2RQKB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Rubinstein Attack",
    fen: "r1bq1rk1/1p1nbppp/p1p1pn2/3p2B1/2PP4/P1N1PN2/1PQ2PPP/2R1KB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Rubinstein Attack",
    fen: "r1bq1rk1/pp1nbppp/2p1pn2/3p2B1/2PP4/2N1PN2/PPQ2PPP/2R1KB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Rubinstein Attack",
    fen: "r1bq1rk1/1p1nbppp/p1p1pn2/3p2B1/2PP4/2N1PN2/PPQ2PPP/2R1KB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Rubinstein Attack",
    fen: "r1bq1rk1/pp1nbppp/2p1p3/3p2B1/2PPn3/2N1PN2/PPQ2PPP/2R1KB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Rubinstein Attack",
    fen: "r1bq1rk1/1p1nbppp/p1p1pn2/3P2B1/3P4/2N1PN2/PPQ2PPP/2R1KB1R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Bd3 Line",
    fen: "r1bq1rk1/pp1nbppp/2p1pn2/3p2B1/2PP4/2NBPN2/PP3PPP/2RQK2R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Fianchetto Variation",
    fen: "r1bq1rk1/p2nbppp/2p1pn2/1p4B1/2BP4/2N1PN2/PP3PPP/2RQK2R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Alekhine Variation",
    fen: "r1b2rk1/pp1nqppp/2p1p3/3n4/2BPN3/4PN2/PP3PPP/2RQK2R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Bd3 Line",
    fen: "r1b2rk1/pp1nqppp/2p1p3/3n4/2BP4/2N1PN2/PP3PPP/2RQK2R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Capablanca System",
    fen: "r1bq1rk1/pp1nbppp/2p1p3/3n2B1/2BP4/2N1PN2/PP3PPP/2RQK2R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Janowski Variation",
    fen: "r1bq1rk1/pp1nbppp/2p1p3/3n2B1/2BP3P/2N1PN2/PP3PP1/2RQK2R",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Main Line",
    fen: "r1b2rk1/pp1nqppp/2p1p3/3n4/2BP4/2N1PN2/PP3PPP/2RQ1RK1",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Classical Variation",
    fen: "r1b2rk1/pp1nqppp/2p5/4p3/2BP4/2R1PN2/PP3PPP/3Q1RK1",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Classical Variation",
    fen: "r1b2rk1/pp1nqppp/2p5/4p3/2BP4/2R1PN2/PP3PPP/1Q3RK1",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Classical Variation",
    fen: "r1b2rk1/pp1nqppp/2p5/4p3/2BP4/2R1PN2/PPQ2PPP/5RK1",
  },
  {
    name: "Queen's Gambit Declined: Orthodox Defense, Classical Variation",
    fen: "r1b2rk1/pp3ppp/2p5/4q3/2B5/2R1P3/PP3PPP/3Q1RK1",
  },
  {
    name: "Neo-Grünfeld Defense: Goglidze Attack",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/5P2/PP2P1PP/RNBQKBNR",
  },
  {
    name: "Neo-Grünfeld Defense: with Nf3",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Neo-Grünfeld Defense: with g3",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/6P1/PP2PP1P/RNBQKBNR",
  },
  {
    name: "Neo-Grünfeld Defense: Exchange Variation",
    fen: "rnbqk2r/ppp1ppbp/6p1/3n4/3P4/6P1/PP2PPBP/RNBQK1NR",
  },
  {
    name: "Neo-Grünfeld Defense: Delayed Exchange Variation",
    fen: "rnbq1rk1/ppp1ppbp/6p1/3n4/3P4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Neo-Grünfeld Defense: Delayed Exchange Variation",
    fen: "rnbq1rk1/pp2ppbp/6p1/2pn4/3P4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Neo-Grünfeld Defense: Delayed Exchange Variation",
    fen: "rnbq1rk1/pp2ppbp/6p1/2Pn4/8/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Neo-Grünfeld Defense: Delayed Exchange Variation",
    fen: "rnbq1rk1/ppp1ppbp/1n4p1/8/3P4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Neo-Grünfeld Defense: Classical Variation",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Neo-Grünfeld Defense: Classical Variation, Modern Defense",
    fen: "rnbq1rk1/ppp1ppbp/5np1/8/2pP4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Neo-Grünfeld Defense: Classical Variation, Polgar Variation",
    fen: "r1bq1rk1/ppp1ppbp/2n2np1/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Neo-Grünfeld Defense: Classical Variation, Original Defense",
    fen: "rnbq1rk1/pp2ppbp/2p2np1/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Neo-Grünfeld Defense: Ultra-Delayed Exchange Variation",
    fen: "rnbq1rk1/pp2ppbp/5np1/3p4/3P4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Grünfeld Defense",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Grünfeld Defense: Gibbon Gambit",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP2P1/2N5/PP2PP1P/R1BQKBNR",
  },
  {
    name: "Grünfeld Defense: Lundin Variation",
    fen: "rnbqkb1r/pp2pp1p/6p1/2p3B1/2PPp3/8/PP1QPPPP/R3KBNR",
  },
  {
    name: "Grünfeld Defense: Lutikov Variation",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N2P2/PP2P1PP/R1BQKBNR",
  },
  {
    name: "Grünfeld Defense: Lutikov Variation, Murrey Attack",
    fen: "rnbqkb1r/pp2pp1p/6p1/2pn4/N2P4/5P2/PP2P1PP/R1BQKBNR",
  },
  {
    name: "Grünfeld Defense: Stockholm Variation",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Grünfeld Defense: Zaitsev Gambit",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP3P/2N5/PP2PPP1/R1BQKBNR",
  },
  {
    name: "Grünfeld Defense: Russian Variation, Accelerated Variation",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/1QN5/PP2PPPP/R1B1KBNR",
  },
  {
    name: "Grünfeld Defense: Brinckmann Attack",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP1B2/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Grünfeld Defense: Brinckmann Attack, Grünfeld Gambit",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP1B2/2N1P3/PP3PPP/R2QKBNR",
  },
  {
    name: "Grünfeld Defense: Brinckmann Attack, Grünfeld Gambit, Botvinnik Variation",
    fen: "rn1q1rk1/pp2ppbp/4bnp1/2Pp4/2P2B2/2N1P3/PP3PPP/2RQKBNR",
  },
  {
    name: "Grünfeld Defense: Brinckmann Attack, Grünfeld Gambit, Capablanca Variation",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP1B2/2N1P3/PP3PPP/2RQKBNR",
  },
  {
    name: "Grünfeld Defense: Brinckmann Attack, Reshevsky Gambit",
    fen: "rnb2rk1/pp2ppbp/5np1/q1Pp4/2P2B2/2N1P3/PP3PPP/2RQKBNR",
  },
  {
    name: "Grünfeld Defense: Brinckmann Attack, Grünfeld Gambit Accepted",
    fen: "rnb2rk1/ppB1ppbp/6p1/3q4/3P4/4P3/PP3PPP/R2QKBNR",
  },
  {
    name: "Grünfeld Defense: Exchange Variation",
    fen: "rnbqkb1r/ppp1pp1p/6p1/3n4/3P4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Modern Exchange Variation",
    fen: "rnbqk2r/ppp1ppbp/6p1/8/3PP3/2P2N2/P4PPP/R1BQKB1R",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Modern Exchange Variation, Kramnik's Line",
    fen: "rnbqk2r/pp2ppbp/6p1/2p5/3PP3/2P2N1P/P4PP1/R1BQKB1R",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Modern Exchange Variation, Pawn Grab Line",
    fen: "r1bq1rk1/pp2pp1p/2n3p1/2pP4/4P3/2b2N2/P3BPPP/1RBQK2R",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Nadanian Attack",
    fen: "rnbqkb1r/ppp1pp1p/6p1/3n4/N2P4/8/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Classical Variation",
    fen: "rnbqk2r/ppp1ppbp/6p1/8/2BPP3/2P5/P4PPP/R1BQK1NR",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Larsen Variation",
    fen: "rnb2rk1/pppqppbp/6p1/8/2BPP3/2P5/P3NPPP/R1BQK2R",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Larsen Variation",
    fen: "rnb2rk1/p1pqppbp/1p4p1/8/2BPP3/2P5/P3NPPP/R1BQ1RK1",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Simagin's Improved Variation",
    fen: "r1bq1rk1/ppp1ppbp/2n3p1/8/2BPP3/2P5/P3NPPP/R1BQK2R",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Simagin's Lesser Variation",
    fen: "rnbq1rk1/p1p1ppbp/1p4p1/8/2BPP3/2P5/P3NPPP/R1BQK2R",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Seville Variation",
    fen: "r2q1rk1/pp2pBbp/6p1/n1p5/3PP1b1/2P1BP2/P3N1PP/R2Q1RK1",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Spassky Variation",
    fen: "rnbq1rk1/pp2ppbp/6p1/2p5/2BPP3/2P5/P3NPPP/R1BQK2R",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Spassky Variation",
    fen: "r1bq1rk1/pp2ppbp/2n3p1/8/2BPP3/4B3/P3NPPP/R2Q1RK1",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Sokolsky Variation",
    fen: "r2q1rk1/pp2ppbp/4b1p1/n2P4/4P3/3BBP2/P3N1PP/R2Q1RK1",
  },
  {
    name: "Grünfeld Defense: Exchange Variation, Spassky Variation",
    fen: "r2q1rk1/pp2ppbp/4b1p1/n7/3PP3/3BBP2/P3N1PP/R2Q1RK1",
  },
  {
    name: "Grünfeld Defense: Flohr Variation",
    fen: "rnbqk2r/ppp1ppbp/5np1/3p4/Q1PP4/2N2N2/PP2PPPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Three Knights Variation",
    fen: "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Grünfeld Defense: Three Knights Variation",
    fen: "rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Grünfeld Defense: Three Knights Variation, Petrosian System",
    fen: "rnbqk2r/ppp1ppbp/5np1/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Grünfeld Defense: Three Knights Variation, Hungarian Attack",
    fen: "rnbqk2r/ppp1ppbp/5np1/3p4/2PP1B2/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Grünfeld Defense: Three Knights Variation, Hungarian Variation",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP1B2/2N1PN2/PP3PPP/R2QKB1R",
  },
  {
    name: "Grünfeld Defense: Flohr Defense",
    fen: "rn1q1rk1/pp2ppbp/2p2np1/3p1b2/2PP4/2NBPN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Grünfeld Defense: Makogonov Variation",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p4/1PPP4/2N1PN2/P4PPP/R1BQKB1R",
  },
  {
    name: "Grünfeld Defense: Opocensky Variation",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/2N1PN2/PP1B1PPP/R2QKB1R",
  },
  {
    name: "Grünfeld Defense: Smyslov Defense",
    fen: "rn1q1rk1/pp2ppbp/2p2np1/3p4/2PP2b1/2NBPN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Grünfeld Defense: Three Knights Variation, Burille Variation",
    fen: "rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Grünfeld Defense: Three Knights Variation, Paris Variation",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Grünfeld Defense: Botvinnik Variation",
    fen: "rnbq1rk1/ppp2pbp/4pnp1/3p4/2PP4/1QN1PN2/PP3PPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Pachman Variation",
    fen: "r1bq1rk1/pppnppbp/5np1/6N1/2BP4/1QN1P3/PP3PPP/R1B1K2R",
  },
  {
    name: "Grünfeld Defense: Three Knights Variation, Vienna Variation",
    fen: "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/1QN1PN2/PP3PPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Russian Variation",
    fen: "rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/1QN2N2/PP2PPPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Russian Variation",
    fen: "rnbq1rk1/ppp1ppbp/5np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Russian Variation, Byrne Variation",
    fen: "r1bq1rk1/ppp1ppbp/2n2np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Russian Variation, Hungarian Variation",
    fen: "rnbq1rk1/1pp1ppbp/p4np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Russian Variation, Levenfish Variation",
    fen: "rnbq1rk1/p1p1ppbp/1p3np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Russian Variation, Prins Variation",
    fen: "r1bq1rk1/ppp1ppbp/n4np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Russian Variation, Szabo Variation",
    fen: "rnbq1rk1/pp2ppbp/2p2np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Russian Variation, Keres Variation",
    fen: "r2q1rk1/ppp1ppbp/1nn3p1/8/3PP1b1/2NQBN2/PP2BPPP/2KR3R",
  },
  {
    name: "Grünfeld Defense: Russian Variation, Smyslov Variation",
    fen: "rn1q1rk1/ppp1ppbp/5np1/8/2QPP1b1/2N2N2/PP3PPP/R1B1KB1R",
  },
  {
    name: "Grünfeld Defense: Russian Variation, Smyslov Variation",
    fen: "rn1q1rk1/pppnppbp/6p1/8/3PP1b1/1QN1BN2/PP3PPP/R3KB1R",
  },
  {
    name: "Grünfeld Defense: Russian Variation, Yugoslav Variation",
    fen: "rn1q1rk1/pp1nppbp/6p1/2p5/3PP1b1/1QN1BN2/PP3PPP/R3KB1R",
  },
  {
    name: "Catalan Opening",
    fen: "rnbqkb1r/pppp1ppp/4pn2/8/2PP4/6P1/PP2PP1P/RNBQKBNR",
  },
  {
    name: "Catalan Opening",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/6P1/PP2PP1P/RNBQKBNR",
  },
  {
    name: "Catalan Opening: Hungarian Gambit",
    fen: "rnbqkb1r/pppp1ppp/5n2/4p3/2PP4/6P1/PP2PP1P/RNBQKBNR",
  },
  {
    name: "Indian Defense",
    fen: "rnbqkb1r/pppp1ppp/4pn2/8/2PP4/1Q6/PP2PPPP/RNB1KBNR",
  },
  {
    name: "Indian Defense: Devin Gambit",
    fen: "rnbqkb1r/pppp1ppp/4pn2/8/2PP2P1/8/PP2PP1P/RNBQKBNR",
  },
  {
    name: "Indian Defense: Seirawan Attack",
    fen: "rnbqkb1r/pppp1ppp/4pn2/6B1/2PP4/8/PP2PPPP/RN1QKBNR",
  },
  {
    name: "Catalan Opening: Closed",
    fen: "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/6P1/PP2PPBP/RNBQK1NR",
  },
  {
    name: "Catalan Opening: Open Defense",
    fen: "rnbqkb1r/ppp2ppp/4pn2/8/2pP4/6P1/PP2PPBP/RNBQK1NR",
  },
  {
    name: "Catalan Opening: Open Defense",
    fen: "r1bqkb1r/pppn1ppp/4pn2/8/2QP4/6P1/PP2PPBP/RNB1K1NR",
  },
  {
    name: "Catalan Opening: Open Defense, Alekhine Variation",
    fen: "r1bqkb1r/1ppn1ppp/p3pn2/8/3P4/6P1/PPQ1PPBP/RNB1K1NR",
  },
  {
    name: "Catalan Opening: Open Defense",
    fen: "rnbqkb1r/ppp2ppp/4pn2/8/2pP4/5NP1/PP2PPBP/RNBQK2R",
  },
  {
    name: "Catalan Opening: Open Defense, Modern Sharp Variation",
    fen: "r1bqk2r/ppp2ppp/2n1pn2/8/QbpP4/5NP1/PP2PPBP/RNB1K2R",
  },
  {
    name: "Catalan Opening: Open Defense, Classical Line",
    fen: "rnbqk2r/ppp1bppp/4pn2/8/2pP4/5NP1/PP2PPBP/RNBQK2R",
  },
  {
    name: "Catalan Opening: Closed",
    fen: "rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQK2R",
  },
  {
    name: "Catalan Opening: Closed",
    fen: "r1bq1rk1/pppnbppp/4pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Catalan Opening: Closed, Botvinnik Variation",
    fen: "r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/2NQ1NP1/PP2PPBP/R1B2RK1",
  },
  {
    name: "Catalan Opening: Closed",
    fen: "r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/1P3NP1/P1Q1PPBP/RNB2RK1",
  },
  {
    name: "Catalan Opening: Closed",
    fen: "r1bq1rk1/pppnbppp/4pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNB2RK1",
  },
  {
    name: "Catalan Opening: Closed, Spassky Gambit",
    fen: "r2q1rk1/pb1nbppp/2p1pn2/1p1p4/2PP4/1PN2NP1/P1Q1PPBP/R1BR2K1",
  },
  {
    name: "Catalan Opening: Closed, Zagoryansky Variation",
    fen: "r1bq1rk1/p2nbppp/1pp1pn2/3p4/P1PP4/5NP1/1PQ1PPBP/RNBR2K1",
  },
  {
    name: "Catalan Opening: Closed Variation, Rabinovich Variation",
    fen: "r1bq1rk1/p2nbppp/2p1pn2/1p1p4/2PP4/5NP1/PPQNPPBP/R1B2RK1",
  },
  {
    name: "Catalan Opening: Closed Variation, Traditional Variation",
    fen: "r1bq1rk1/p2nbppp/1pp1pn2/3p4/2PP4/5NP1/PPQNPPBP/R1B2RK1",
  },
  {
    name: "Catalan Opening: Closed, Main Line",
    fen: "r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQNPPBP/R1B2RK1",
  },
  {
    name: "Catalan Opening: Closed, Sokolsky Variation",
    fen: "r2q1rk1/3nbppp/bpp1pn2/p2p4/2PP4/1P3NP1/PBQNPPBP/R4RK1",
  },
  {
    name: "Blumenfeld Countergambit",
    fen: "rnbqkb1r/p2p1ppp/4pn2/1ppP4/2P5/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Blumenfeld Countergambit Accepted",
    fen: "rnbqkb1r/p5pp/4pn2/1Ppp4/8/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Blumenfeld Countergambit: Dus-Khotimirsky Variation",
    fen: "rnbqkb1r/p2p1ppp/4pn2/1ppP2B1/2P5/5N2/PP2PPPP/RN1QKB1R",
  },
  {
    name: "Blumenfeld Countergambit: Spielmann Variation",
    fen: "rnbqkb1r/p2p1pp1/5n1p/1ppP2B1/8/5N2/PP2PPPP/RN1QKB1R",
  },
  {
    name: "Indian Defense: Anti-Nimzo-Indian",
    fen: "rnbqkb1r/pppp1ppp/4pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Dzindzi-Indian Defense",
    fen: "rnbqkb1r/1ppp1ppp/p3pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Indian Defense: Döry Indian",
    fen: "rnbqkb1r/pppp1ppp/4p3/8/2PPn3/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Bogo-Indian Defense",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Bogo-Indian Defense: Exchange Variation",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/2PP4/5N2/PP1bPPPP/RN1QKB1R",
  },
  {
    name: "Bogo-Indian Defense: Grünfeld Variation",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP1NPPPP/R1BQKB1R",
  },
  {
    name: "Bogo-Indian Defense: Haiti Variation",
    fen: "r1bqk2r/pppp1ppp/2n1pn2/8/1bPP4/5N2/PP1BPPPP/RN1QKB1R",
  },
  {
    name: "Bogo-Indian Defense: Monticelli Trap",
    fen: "rn1q1rk1/pbpp1ppp/1p2p3/6N1/2PP4/2n3P1/PPQ1PPBP/R3K2R",
  },
  {
    name: "Bogo-Indian Defense: New England Variation",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/8/PP1NPPPP/RNBQKB1R",
  },
  {
    name: "Bogo-Indian Defense: Nimzowitsch Variation",
    fen: "rnb1k2r/ppppqppp/4pn2/8/1bPP4/5N2/PP1BPPPP/RN1QKB1R",
  },
  {
    name: "Bogo-Indian Defense: Retreat Variation",
    fen: "rnbqk2r/ppppbppp/4pn2/8/2PP4/5N2/PP1BPPPP/RN1QKB1R",
  },
  {
    name: "Bogo-Indian Defense: Vitolins Variation",
    fen: "rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/5N2/PP1BPPPP/RN1QKB1R",
  },
  {
    name: "Bogo-Indian Defense: Wade-Smyslov Variation",
    fen: "rnbqk2r/1ppp1ppp/4pn2/p7/1bPP4/5N2/PP1BPPPP/RN1QKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Three Knights Variation, Duchamp Variation",
    fen: "rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Three Knights Variation, Duchamp Variation, Modern Line",
    fen: "rn1qk2r/pbpp1ppp/1p2pn2/6B1/1bPP4/2N5/PP1NPPPP/R2QKB1R",
  },
  {
    name: "Queen's Indian Defense",
    fen: "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov Variation",
    fen: "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov Variation, Botvinnik Attack",
    fen: "rn1qkb1r/pbpp1p2/1p2p2p/6pn/2PP4/2N2NB1/PP2PPPP/R2QKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation",
    fen: "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/P1N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Andersson Variation",
    fen: "rn1qkb1r/pbpp1ppp/1p2p3/8/2PPn3/P1N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Classical Variation",
    fen: "rn1qkb1r/pbp2ppp/1p3n2/3p4/3P4/P1N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Hedgehog Variation",
    fen: "rn1qkb1r/pbpp1p1p/1p2pnp1/8/2PP4/P1N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Kasparov Attack",
    fen: "rn1qkb1r/pbp2ppp/1p2p3/3n4/3P4/P1N2N2/1PQ1PPPP/R1B1KB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Main Line",
    fen: "rn1qkb1r/pbp2ppp/1p2pn2/3p4/2PP4/P1N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Marco Defense",
    fen: "rn1qk2r/pbppbppp/1p2pn2/8/2PP4/P1N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Modern Variation",
    fen: "rn1qkb1r/pbp2ppp/1p2p3/3n4/3P4/P1N2N2/1P2PPPP/R1BQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Petrosian Attack",
    fen: "rn1qkb1r/pbp2ppp/1p2p3/3n4/3P4/P1N1PN2/1P3PPP/R1BQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Polovodin Gambit",
    fen: "rn1qkb1r/pbp2ppp/1p2p3/3n4/3PP3/P1N2N2/1P3PPP/R1BQKB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Rashkovsky Attack",
    fen: "rn1qkb1r/pbp2ppp/1p2p3/3n4/Q2P4/P1N2N2/1P2PPPP/R1B1KB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov-Petrosian Variation, Romanishin Attack",
    fen: "rn1qkb1r/pbp2ppp/1p2p3/3n4/3P4/P1N2N2/1P1BPPPP/R2QKB1R",
  },
  {
    name: "Queen's Indian Defense: Miles Variation",
    fen: "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP1B2/5N2/PP2PPPP/RN1QKB1R",
  },
  {
    name: "Queen's Indian Defense: Petrosian Variation",
    fen: "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/P4N2/1P2PPPP/RNBQKB1R",
  },
  {
    name: "Queen's Indian Defense: Petrosian Variation, Farago Defense",
    fen: "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/P4N2/1PQ1PPPP/RNB1KB1R",
  },
  {
    name: "Queen's Indian Defense: Kasparov Variation",
    fen: "rn1qk2r/pbpp1pp1/1p2pn1p/8/1bPP3B/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "Queen's Indian Defense: Averbakh Variation",
    fen: "rn1q1rk1/pb1pbppp/1p2pn2/8/2PN4/1P1BP3/PB3PPP/RN1Q1RK1",
  },
  {
    name: "Queen's Indian Defense: Spassky System",
    fen: "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/4PN2/PP3PPP/RNBQKB1R",
  },
  {
    name: "Queen's Indian Defense: Buerger Variation",
    fen: "rn1qkb1r/pb1p1ppp/1p3n2/2pp2N1/2P5/6P1/PP2PPBP/RNBQK2R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Traditional",
    fen: "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/5NP1/PP2PP1P/RNBQKB1R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation",
    fen: "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/5NP1/PP2PP1P/RNBQKB1R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation, Check Variation",
    fen: "rn1qk2r/p1pp1ppp/bp2pn2/8/1bPP4/1P3NP1/P3PP1P/RNBQKB1R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation, Check Variation, Intermezzo Line",
    fen: "rn1qk2r/p1ppbppp/bp2pn2/8/2PP4/1P3NP1/P2BPP1P/RN1QKB1R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation, Check Variation, Modern Line",
    fen: "rn2k2r/p1ppqppp/bp2pn2/8/1bPP4/1P3NP1/P2BPP1P/RN1QKB1R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation, Nimzowitsch Variation",
    fen: "rn1qkb1r/p1pp1ppp/bp2pn2/8/2PP4/5NP1/PP2PP1P/RNBQKB1R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation, Nimzowitsch Variation, Nimzowitsch Attack",
    fen: "rn1qkb1r/p1pp1ppp/bp2pn2/8/Q1PP4/5NP1/PP2PP1P/RNB1KB1R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation, Nimzowitsch Variation, Quiet Line",
    fen: "rn1qkb1r/p1pp1ppp/bp2pn2/8/2PP4/1P3NP1/P3PP1P/RNBQKB1R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation, Nimzowitsch Variation, Timman's Line",
    fen: "rn1qkb1r/p1pp1ppp/bp2pn2/8/2PP4/1Q3NP1/PP2PP1P/RNB1KB1R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation, Rubinstein Variation",
    fen: "rn1qkb1r/pb1p1ppp/1p3n2/2pp4/2P4N/6P1/PP2PPBP/RNBQK2R",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation, Sämisch Variation",
    fen: "rn1qkb1r/pb1p1ppp/1p2pn2/2p5/2PP4/5NP1/PP2PPBP/RNBQK2R",
  },
  {
    name: "Queen's Indian Defense: Capablanca Variation",
    fen: "rn1qk2r/pbpp1ppp/1p2pn2/8/1bPP4/5NP1/PP2PPBP/RNBQK2R",
  },
  {
    name: "Queen's Indian Defense: Riumin Variation",
    fen: "rn1qk2r/pbppbppp/1p2pn2/8/2PP4/5NP1/PP1BPPBP/RN1QK2R",
  },
  {
    name: "Queen's Indian Defense: Yates Variation",
    fen: "rn1qk2r/1bpp1ppp/1p2pn2/p7/1bPP4/5NP1/PP1BPPBP/RN1QK2R",
  },
  {
    name: "Queen's Indian Defense: Anti-Queen's Indian System",
    fen: "rn1qk2r/pbppbppp/1p2pn2/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R",
  },
  {
    name: "Queen's Indian Defense: Classical Variation",
    fen: "rn1qk2r/pbppbppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Queen's Indian Defense: Classical Variation, Polugaevsky Gambit",
    fen: "rn1q1rk1/pbppbppp/1p3n2/3p4/2P4N/6P1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Queen's Indian Defense: Classical Variation, Taimanov Gambit",
    fen: "rn1q1rk1/pbppbppp/1p3n2/3p4/2PN4/6P1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "Queen's Indian Defense: Euwe Variation",
    fen: "rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/1P3NP1/P3PPBP/RNBQ1RK1",
  },
  {
    name: "Queen's Indian Defense: Fianchetto Variation, Kramnik Variation",
    fen: "rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQR1K1",
  },
  {
    name: "Queen's Indian Defense: Opocensky Variation",
    fen: "rn1qk2r/pbppbppp/1p2p3/8/2PPn3/2N2NP1/PP1BPPBP/R2QK2R",
  },
  {
    name: "Queen's Indian Defense: Traditional Variation",
    fen: "rn1qk2r/pbppbppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQK2R",
  },
  {
    name: "Queen's Indian Defense: Classical Variation, Tiviakov Defense",
    fen: "r2q1rk1/pbppbppp/np2pn2/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Queen's Indian Defense: Classical Variation, Traditional Variation",
    fen: "rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Queen's Indian Defense: Classical Variation, Traditional Variation, Nimzowitsch Line",
    fen: "rn1q1rk1/pbp1bppp/1p2pn2/3p4/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "Queen's Indian Defense: Classical Variation, Traditional Variation, Main Line",
    fen: "rn1q1rk1/pbppbppp/1p2p3/8/2PP4/2Q2NP1/PP2PPBP/R1B2RK1",
  },
  {
    name: "Nimzo-Indian Defense",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Kmoch Variation",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N2P2/PP2P1PP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Mikenas Attack",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2NQ4/PP2PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Romanishin Variation",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N3P1/PP2PP1P/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Romanishin Variation",
    fen: "rnbq1rk1/pp1p1ppp/4pn2/2p5/1bPP4/2N2NP1/PP2PPBP/R1BQK2R",
  },
  {
    name: "Nimzo-Indian Defense: Romanishin Variation, English Hybrid",
    fen: "rnbq1rk1/pp3ppp/4p3/3n4/1b1N4/2N3P1/PP2PPBP/R1BQK2R",
  },
  {
    name: "Nimzo-Indian Defense: Three Knights Variation",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Three Knights Variation, Euwe Variation",
    fen: "rnbqk2r/pp1p1ppp/4p3/2pP4/1bP1n3/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Three Knights Variation, Korchnoi Variation",
    fen: "rnbqk2r/pp1p1ppp/4pn2/2pP4/1bP5/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Three Knights Variation, Shocron Gambit",
    fen: "rnbqk2r/p2p1ppp/4pn2/1ppP4/1bP5/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Spielmann Variation",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/1QN5/PP2PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Spielmann Variation, Karlsbad Variation",
    fen: "r1bqk2r/pp1p1ppp/2n1p3/2P5/1bP5/1QN2N2/PP1nPPPP/R3KB1R",
  },
  {
    name: "Nimzo-Indian Defense: Spielmann Variation, Romanovsky Gambit",
    fen: "r1bqk2r/pp1p1ppp/2n1pn2/2P5/1bP5/1QN5/PP2PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Spielmann Variation, Stahlberg Variation",
    fen: "r1bqk2r/pp1p1ppp/2n1p3/2n5/1bP5/1QN2N2/PP1BPPPP/R3KB1R",
  },
  {
    name: "Nimzo-Indian Defense: Spielmann Variation, Stahlberg Variation",
    fen: "r1bqk2r/pp1p2pp/2n1p3/2n2p2/1bP5/2N2NP1/PPQBPP1P/R3KB1R",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation, Accelerated",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/2PP4/P1P5/4PPPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation, Botvinnik Variation",
    fen: "rnbq1rk1/pp3ppp/4p3/2pn4/3P4/P1P1PP2/6PP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation",
    fen: "rnbqk2r/pp3ppp/4pn2/2pP4/3P4/P1P2P2/4P1PP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation, Keres Variation",
    fen: "rnbqk2r/pp3ppp/4p3/2Pn4/8/P1P2P2/4P1PP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation, Romanovsky Variation",
    fen: "rnbqk2r/pp4pp/4p3/2Pn1p2/8/P1P2P2/4P1PP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation",
    fen: "rnbqk2r/pp1p1ppp/4pn2/2p5/2PP4/P1P1P3/5PPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation, O'Kelly Variation",
    fen: "rnbqk2r/p2p1ppp/1p2pn2/2p5/2PP4/P1P1P3/5PPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation",
    fen: "rnbq1rk1/pppp1ppp/4pn2/8/2PP4/P1P5/4PPPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation",
    fen: "rnbq1rk1/pppp1ppp/4pn2/8/2PP4/P1P1P3/5PPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation",
    fen: "r1bq1rk1/pp1p1ppp/2n1pn2/2p5/2PP4/P1PBP3/5PPP/R1BQK1NR",
  },
  {
    name: "Nimzo-Indian Defense: Sämisch Variation, Capablanca Variation",
    fen: "r1bqnrk1/p2p1ppp/1pn1p3/2p5/2PPP3/P1PB4/4NPPP/R1BQK2R",
  },
  {
    name: "Nimzo-Indian Defense: Leningrad Variation",
    fen: "rnbqk2r/pppp1ppp/4pn2/6B1/1bPP4/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Leningrad Variation, Averbakh Gambit",
    fen: "rnbqk2r/p2p1pp1/4pn1p/1ppP4/1bP4B/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Leningrad Variation, Benoni Defense",
    fen: "rnbqk2r/pp3pp1/3ppn1p/2pP4/1bP4B/2N5/PP2PPPP/R2QKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PPQ1PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Keres Defense",
    fen: "rnbq1rk1/p1pp1ppp/1p2pn2/8/2PP4/P1Q5/1P2PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Vitolins-Adorjan Gambit",
    fen: "rnbq1rk1/p1pp1ppp/4pn2/1p6/2PP4/P1Q5/1P2PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Milner-Barry Variation",
    fen: "r1bqk2r/ppp2ppp/2nppn2/8/1bPP4/2N2N2/PPQ1PPPP/R1B1KB1R",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Zurich Variation",
    fen: "r1bqk2r/pppp1ppp/2n1pn2/8/1bPP4/2N5/PPQ1PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Belyavsky Gambit",
    fen: "rnb1k2r/ppp2ppp/5n2/4pq2/1b1P4/2N2N2/PP2PPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Noa Variation",
    fen: "rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/2N5/PPQ1PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Noa Variation",
    fen: "rnbqk2r/ppp2ppp/5n2/3p4/1b1P4/2N5/PPQ1PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Noa Variation",
    fen: "rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/P1N5/1PQ1PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Noa Variation, Botvinnik Variation",
    fen: "r1bqk2r/ppp2ppp/2n1pn2/3p4/2PP4/P1Q5/1P2PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Noa Variation, Main Line",
    fen: "rnbqk2r/ppp2ppp/4p3/3p4/2PPn3/P1Q5/1P2PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Noa Variation",
    fen: "rnbqk2r/ppp2ppp/4p3/3p4/2PPn3/P7/1PQ1PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Noa Variation, San Remo Variation",
    fen: "r1bqk2r/ppp2ppp/2n5/3pp3/2PPn3/P3P3/1PQ2PPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Berlin Variation",
    fen: "rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N5/PPQ1PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Berlin Variation, Steiner Variation",
    fen: "rnbqk2r/pp1p1ppp/4pn2/2P5/2P5/2b5/PPQ1PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Berlin Variation, Macieja System",
    fen: "rnbq1rk1/p2p1ppp/1p2pn2/2b5/2P2B2/P1N2N2/1PQ1PPPP/R3KB1R",
  },
  {
    name: "Nimzo-Indian Defense: Classical Variation, Berlin Variation, Pirc Variation",
    fen: "rnbq1rk1/pp1p1ppp/4pn2/2P5/1bP5/2N5/PPQ1PPPP/R1B1KBNR",
  },
  {
    name: "Nimzo-Indian Defense: Normal Line",
    fen: "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Taimanov Variation",
    fen: "r1bqk2r/pppp1ppp/2n1pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Hübner Variation",
    fen: "rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N1P3/PP3PPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Hübner Variation, Main Line",
    fen: "r1bqk2r/pp3ppp/2nppn2/2p5/2PP4/2PBPN2/P4PPP/R1BQK2R",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Hübner Deferred",
    fen: "rnbq1rk1/pp1p1ppp/4pn2/2p5/1bPP4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Hübner Variation, Rubinstein Variation",
    fen: "rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N1P3/PP2NPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Hübner Variation, Rubinstein Variation, Main Line",
    fen: "rnbq1rk1/pp1p1ppp/4pn2/8/1bPP4/P1N5/1P2NPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Hübner Variation, Rubinstein Variation, Sherbakov Attack",
    fen: "rnbq1rk1/pp1p1ppp/4pn2/2P5/1b1P4/2N5/PP2NPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: St. Petersburg Variation",
    fen: "rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Fischer Variation",
    fen: "rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N1P3/PP2NPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Bronstein (Byrne) Variation",
    fen: "rn1qk2r/p1pp1ppp/bp2pn2/8/1bPP4/2N1P3/PP2NPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation",
    fen: "rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR",
  },
  {
    name: "Nimzo-Indian Defense: Reshevsky Variation",
    fen: "rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP2NPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Simagin Variation",
    fen: "rnbq1rk1/ppp2ppp/3bpn2/3p4/2PP4/P1N1P3/1P2NPPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Bishop Attack",
    fen: "rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2NBP3/PP3PPP/R1BQK1NR",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Bishop Attack, Classical Defense",
    fen: "rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2NBP3/PP3PPP/R1BQK1NR",
  },
  {
    name: "Nimzo-Indian Defense: Ragozin Defense",
    fen: "r1bq1rk1/ppp2ppp/2n1pn2/3p4/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Botvinnik System",
    fen: "rnbq1rk1/ppp2ppp/4pn2/3p4/2PP4/P1PBP3/5PPP/R1BQK1NR",
  },
  {
    name: "Nimzo-Indian Defense",
    fen: "rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Ragozin Variation",
    fen: "rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2N1PN2/PP3PPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Sämisch Deferred",
    fen: "rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/P1N1PN2/1P3PPP/R1BQKB1R",
  },
  {
    name: "Nimzo-Indian Defense: Ragozin Variation",
    fen: "r1bq1rk1/ppp2ppp/2n1pn2/8/1bpP4/2NBPN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Schlechter Defense",
    fen: "rnbq1rk1/p1p2ppp/1p2pn2/3p4/1bPP4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Gligoric System",
    fen: "rnbq1rk1/pp3ppp/4pn2/2pp4/1bPP4/2NBPN2/PP3PPP/R1BQK2R",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Gligoric System",
    fen: "r1bq1rk1/pp1n1ppp/4pn2/2pp4/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Gligoric System, Keres Variation",
    fen: "rnbq1rk1/p4ppp/1p2pn2/2pp4/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Gligoric System, Exchange Variation",
    fen: "rnbq1rk1/pp3ppp/4pn2/2p5/1bBP4/2N1PN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Gligoric System, Smyslov Variation",
    fen: "rnb2rk1/pp2qppp/4pn2/2p5/1bBP4/2N1PN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Gligoric System, Bronstein Variation",
    fen: "r1bq1rk1/pp1n1ppp/4pn2/2p5/1bBP4/2N1PN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Gligoric System, Bernstein Defense",
    fen: "r1bq1rk1/pp3ppp/2n1pn2/2pp4/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Bernstein Defense, Exchange Line",
    fen: "r1bq1rk1/pp3ppp/2n1pn2/2pp4/2PP4/P1PBPN2/5PPP/R1BQ1RK1",
  },
  {
    name: "Nimzo-Indian Defense: Normal Variation, Bernstein Defense",
    fen: "r1bq1rk1/pp3ppp/2n1pn2/2p5/2BP4/P1P1PN2/5PPP/R1BQ1RK1",
  },
  {
    name: "Grünfeld Defense: Counterthrust Variation",
    fen: "rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/6P1/PP2PPBP/RNBQK1NR",
  },
  {
    name: "Indian Defense: Anti-Grünfeld, Adorjan Gambit",
    fen: "rnbqkb1r/p1pppp1p/5np1/1p1P4/2P5/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Anti-Grünfeld, Advance Variation",
    fen: "rnbqkb1r/pppppp1p/5np1/3P4/2P5/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Anti-Grünfeld, Alekhine Variation",
    fen: "rnbqkb1r/pppppp1p/5np1/8/2PP4/5P2/PP2P1PP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Anti-Grünfeld, Alekhine Variation, Leko Gambit",
    fen: "rnbqkb1r/pppp1p1p/5np1/4p3/2PP4/5P2/PP2P1PP/RNBQKBNR",
  },
  {
    name: "Indian Defense: Anti-Grünfeld, Basman-Williams Attack",
    fen: "rnbqkb1r/pppppp1p/5np1/8/2PP3P/8/PP2PPP1/RNBQKBNR",
  },
  {
    name: "Indian Defense: King's Indian Variation, Fianchetto Variation",
    fen: "rnbqk2r/ppppppbp/5np1/8/2PP4/6P1/PP2PPBP/RNBQK1NR",
  },
  {
    name: "Indian Defense: West Indian Defense",
    fen: "rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Immediate Fianchetto",
    fen: "rnbqkb1r/pppppp1p/5np1/8/2PP4/6P1/PP2PP1P/RNBQKBNR",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Pterodactyl Variation",
    fen: "rnb1k2r/pp1pppbp/5np1/q1p5/2PP4/5NP1/PP2PPBP/RNBQK2R",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Yugoslav System",
    fen: "rnbq1rk1/pp2ppbp/3p1np1/2p5/2PP4/5NP1/PP2PPBP/RNBQ1RK1",
  },
  {
    name: "King's Indian Defense: Normal Variation, King's Knight Variation",
    fen: "rnbqkb1r/pppppp1p/5np1/8/2PP4/5N2/PP2PPPP/RNBQKB1R",
  },
  {
    name: "King's Indian Defense: Santasiere Variation",
    fen: "rnbqk2r/ppppppbp/5np1/8/1PPP4/5N2/P3PPPP/RNBQKB1R",
  },
  {
    name: "King's Indian Defense: Semi-Classical Variation, Benoni Variation",
    fen: "rnbq1rk1/pp2ppbp/2pp1np1/8/2PP4/2N1PN2/PP2BPPP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Semi-Classical Variation, Hollywood Variation",
    fen: "r1bq1rk1/ppp1ppbp/2np1np1/8/2PP4/2N1PN2/PP2BPPP/R1BQK2R",
  },
  {
    name: "Queen's Pawn, Mengarini Attack",
    fen: "rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PPQ1PPPP/RNB1KBNR",
  },
  {
    name: "King's Indian Defense",
    fen: "rnbqkb1r/pppppp1p/5np1/8/2PP4/2N5/PP2PPPP/R1BQKBNR",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Benjamin Defense",
    fen: "rnb2rk1/pp2ppbp/1qpp1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Semi-Classical Variation",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N1PN2/PP2BPPP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Semi-Classical Variation, Exchange Variation",
    fen: "r1bq1rk1/pppn1pbp/5np1/4p3/2P5/2N1PN2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Semi-Classical Variation, Queenside Storm Line",
    fen: "r1bq1rk1/pppn1pbp/3p1np1/4p3/1PPP4/2N1PN2/P3BPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Smyslov Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/6B1/2PP4/2N2N2/PP2PPPP/R2QKB1R",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Delayed Fianchetto",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2PP4/2N2NP1/PP2PP1P/R1BQKB1R",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Karlsbad Variation",
    fen: "r1bq1rk1/ppp1ppbp/2np1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Kavalek Defense",
    fen: "rnb2rk1/pp2ppbp/2pp1np1/q7/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Larsen Defense",
    fen: "rn1q1rk1/pp2ppbp/2pp1np1/5b2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Lesser Simagin (Spassky)",
    fen: "r2q1rk1/ppp1ppbp/2np1np1/5b2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Simagin Variation",
    fen: "r2q1rk1/ppp1ppbp/2np1np1/8/2PP2b1/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Uhlmann-Szabo System",
    fen: "r1bq1rk1/ppp2pbp/2np1np1/4p3/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Panno Variation",
    fen: "r1bq1rk1/1pp1ppbp/p1np1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Panno Variation, Blockade Line",
    fen: "r1bq1rk1/1p3pbp/p2p1np1/n1pPp3/2P5/2N3P1/PPQNPPBP/R1B2RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Panno Variation, Donner Line",
    fen: "1rbq1rk1/4pp1p/p2p1npb/n1pP4/2P5/2N3P1/PBQNPPBP/R4RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Panno Variation, Korchnoi Line",
    fen: "1rbq1rk1/2p1ppbp/p1np1np1/1p6/2PP4/2N1B1PP/PP1NPPB1/R2Q1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Yugoslav Variation, Rare Line",
    fen: "rnbq1rk1/pp2ppbp/3p1np1/2p5/2PP4/2N2NP1/PP2PPBP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Yugoslav Variation",
    fen: "rnbq1rk1/pp2ppbp/3p1np1/2p5/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Yugoslav Variation, Exchange Line",
    fen: "r1bq1rk1/pp2ppbp/2n2np1/2p5/2P5/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Yugoslav Variation, Advance Line",
    fen: "r1bq1rk1/pp2ppbp/2np1np1/2pP4/2P5/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Classical Fianchetto",
    fen: "r1bq1rk1/pppn1pbp/3p1np1/4p3/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Debrecen Defense",
    fen: "r1bq1rk1/pppnppbp/3p1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Double Fianchetto Attack",
    fen: "r1bq1rk1/pppn1pbp/3p1np1/4p3/2PP4/1PN2NP1/P3PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Hungarian Variation",
    fen: "r1bq1rk1/1ppnppbp/p2p1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Classical Variation",
    fen: "r1bq1rk1/pppn1pbp/3p1np1/4p3/2PPP3/2N2NP1/PP3PBP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Long Variation",
    fen: "r1bqr1k1/1pp2pbp/3p1np1/p1n5/2PNP3/2N3PP/PP3PB1/R1BQR1K1",
  },
  {
    name: "King's Indian Defense: Fianchetto Variation, Classical Main Line",
    fen: "r1bq1rk1/pp1n1pbp/2pp1np1/4p3/2PPP3/2N2NPP/PP3PB1/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Accelerated Averbakh Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/6B1/2PPP3/2N5/PP3PPP/R2QKBNR",
  },
  {
    name: "King's Indian Defense: Kramer Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP2NPPP/R1BQKB1R",
  },
  {
    name: "King's Indian Defense: Normal Variation",
    fen: "rnbqk2r/ppppppbp/5np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "King's Indian Defense: Normal Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR",
  },
  {
    name: "King's Indian Defense: Makogonov Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N4P/PP3PP1/R1BQKBNR",
  },
  {
    name: "King's Indian Defense: Normal Variation, Deferred Fianchetto",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N3P1/PP3P1P/R1BQKBNR",
  },
  {
    name: "King's Indian Defense: Pomar System",
    fen: "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N3P1/PP2NPBP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Averbakh Variation",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Averbakh Variation, Flexible Defense",
    fen: "rnbq1rk1/ppp1ppb1/3p1npp/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Averbakh Variation, Geller Defense",
    fen: "r1bq1rk1/pppnppbp/3p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Averbakh Variation, Modern Defense",
    fen: "r1bq1rk1/ppp1ppbp/n2p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Averbakh Variation, Modern Defense, Burgess Line",
    fen: "r1bq1rk1/pp2ppbp/n1pp1np1/6B1/2PPP3/2N5/PP1QBPPP/R3K1NR",
  },
  {
    name: "King's Indian Defense: Averbakh Variation, Nc6 Defense",
    fen: "r1bq1rk1/ppp1ppbp/2np1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Averbakh Variation, Spanish Defense",
    fen: "rnbq1rk1/1pp1ppbp/p2p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Normal Variation, Standard Development",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP2BPPP/R1BQK1NR",
  },
  {
    name: "King's Indian Defense: Semi-Averbakh System",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N1B3/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Averbakh Variation, Benoni Defense",
    fen: "rnbq1rk1/pp2ppbp/3p1np1/2p3B1/2PPP3/2N5/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Averbakh Variation, Benoni Defense, Advance Variation",
    fen: "rnbq1rk1/pp2ppbp/3p1np1/2pP2B1/2P1P3/2N5/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Averbakh Variation, Benoni Defense, Exchange Variation",
    fen: "rnbq1rk1/pp2ppbp/3p1np1/2P3B1/2P1P3/2N5/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Averbakh Variation, Main Line",
    fen: "rnbq1rk1/pp3pbp/3ppnp1/2pP2B1/2P1P3/2N5/PP2BPPP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Four Pawns Attack",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2PPPP2/2N5/PP4PP/R1BQKBNR",
  },
  {
    name: "King's Indian Defense: Four Pawns Attack, Dynamic Attack",
    fen: "rnbq1rk1/pp2ppbp/3p1np1/2pP4/2P1PP2/2N2N2/PP4PP/R1BQKB1R",
  },
  {
    name: "King's Indian Defense: Four Pawns Attack, Modern Defense",
    fen: "r1bqk2r/ppp1ppbp/n2p1np1/8/2PPPP2/2N5/PP4PP/R1BQKBNR",
  },
  {
    name: "King's Indian Defense: Four Pawns Attack",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPPP2/2N5/PP2B1PP/R1BQK1NR",
  },
  {
    name: "King's Indian Defense: Four Pawns Attack, Florentine Gambit",
    fen: "rnbq1rk1/pp3pbp/3p1np1/2ppP3/2P2P2/2N2N2/PP2B1PP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Four Pawns Attack, Normal Attack",
    fen: "rnbq1rk1/pp3pbp/3ppnp1/2pP4/2P1PP2/2N2N2/PP2B1PP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Six Pawns Attack",
    fen: "r1bq1rk1/pp4bp/2nppnp1/2p5/2P1PPPP/2N5/PP2B3/R1BQK1NR",
  },
  {
    name: "King's Indian Defense: Four Pawns Attack, Fluid Attack",
    fen: "rnbq1rk1/pp2ppbp/3p1np1/2p5/2PPPP2/2N2N2/PP2B1PP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Four Pawns Attack, Exchange Variation",
    fen: "r1bq1rk1/pp2ppbp/2np1np1/8/2PNPP2/2N1B3/PP2B1PP/R2QK2R",
  },
  {
    name: "King's Indian Defense: Sämisch Variation",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N2P2/PP4PP/R1BQKBNR",
  },
  {
    name: "King's Indian Defense: Steiner Attack",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/6B1/2PPP3/2N2P2/PP4PP/R2QKBNR",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Bobotsov-Korchnoi-Petrosian Variation",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2P2/PP2N1PP/R1BQKB1R",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Byrne Defense",
    fen: "rnbq1rk1/1p2ppbp/p1pp1np1/8/2PPP3/2NBBP2/PP4PP/R2QK1NR",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Normal Defense",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2P2/PP4PP/R1BQKBNR",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Sämisch Gambit",
    fen: "rnbq1rk1/pp2ppbp/3p1np1/2p5/2PPP3/2N1BP2/PP4PP/R2QKBNR",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Double Fianchetto",
    fen: "rnbq1rk1/p1p1ppbp/1p1p1np1/8/2PPP3/2N1BP2/PP4PP/R2QKBNR",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Panno Formation",
    fen: "r1bq1rk1/1pp1ppbp/p1np1np1/8/2PPP3/2N1BP2/PP2N1PP/R2QKB1R",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Ruban Variation",
    fen: "1rbq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N1BP2/PP2N1PP/R2QKB1R",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Yates Defense",
    fen: "r1bq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N1BP2/PP4PP/R2QKBNR",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Panno Main Line",
    fen: "1rbq1rk1/1pp1ppbp/p1np1np1/8/2PPP3/2N1BP2/PP1QN1PP/R3KB1R",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Orthodox Variation",
    fen: "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N1BP2/PP4PP/R2QKBNR",
  },
  {
    name: "King's Indian Defense: Sämisch Variation",
    fen: "rnbq1rk1/pp3pbp/2pp1np1/4p3/2PPP3/2N1BP2/PP2N1PP/R2QKB1R",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Bronstein Defense",
    fen: "rnb2rk1/ppp2pbp/3p2p1/3Pp3/2P1P2Q/2N1nP2/PP2K2P/R5NR",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Closed Variation",
    fen: "rnbq1rk1/ppp2pbp/3p1np1/3Pp3/2P1P3/2N1BP2/PP4PP/R2QKBNR",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Orthodox Variation, Bronstein Variation",
    fen: "rnb2rk1/ppp2pbp/3p2p1/3Pp3/2n1P2Q/2N2P2/PP2K2P/R5NR",
  },
  {
    name: "King's Indian Defense: Sämisch Variation, Closed Variation, Main Line",
    fen: "rnbq1rk1/pp3pbp/3p1np1/3pp3/2P1P3/2N1BP2/PP2N1PP/R2QKB1R",
  },
  {
    name: "King's Indian Defense: Larsen Variation",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N1BN2/PP3PPP/R2QKB1R",
  },
  {
    name: "King's Indian Defense: Normal Variation, Rare Defenses",
    fen: "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N2N2/PP3PPP/R1BQKB1R",
  },
  {
    name: "King's Indian Defense: Zinnowitz Variation",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/6B1/2PPP3/2N2N2/PP3PPP/R2QKB1R",
  },
  {
    name: "King's Indian Defense: Kazakh Variation",
    fen: "r1bq1rk1/ppp1ppbp/n2p1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Orthodox Variation",
    fen: "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Exchange Variation",
    fen: "rnbq1rk1/ppp2pbp/3p1np1/4P3/2P1P3/2N2N2/PP2BPPP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Orthodox Variation",
    fen: "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Gligoric-Taimanov System",
    fen: "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N1BN2/PP2BPPP/R2QK2R",
  },
  {
    name: "King's Indian Defense: Petrosian Variation",
    fen: "rnbq1rk1/ppp2pbp/3p1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Petrosian Variation, Stein Defense",
    fen: "rnbq1rk1/1pp2pbp/3p1np1/p2Pp3/2P1P3/2N2N2/PP2BPPP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Petrosian Variation, Keres Defense",
    fen: "r1bq1rk1/pppn1pb1/3p3p/3Pp1pn/2P1P2P/2N2NB1/PP2BPP1/R2QK2R",
  },
  {
    name: "King's Indian Defense: Petrosian Variation, Normal Defense",
    fen: "r1bq1rk1/pppn1pbp/3p1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQK2R",
  },
  {
    name: "King's Indian Defense: Orthodox Variation",
    fen: "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Donner Defense",
    fen: "rnbq1rk1/pp3pbp/2pp1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Glek Defense",
    fen: "r1bq1rk1/ppp2pbp/n2p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Positional Defense",
    fen: "r1bq1rk1/pppn1pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Positional Defense, Closed Line",
    fen: "r1bq1rk1/pppn1pbp/3p1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Ukrainian Defense",
    fen: "rnbq1rk1/1pp2pbp/3p1np1/p3p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation",
    fen: "r1bq1rk1/pppn1pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQR1K1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Positional Defense, Main Line",
    fen: "r1bq1rk1/1p1n1pbp/2pp1np1/p3p3/2PPP3/2N2N2/PP3PPP/R1BQRBK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Aronin-Taimanov Defense",
    fen: "r1bq1rk1/ppp2pbp/2np1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Bayonet Attack",
    fen: "r1bq1rk1/ppp1npbp/3p1np1/3Pp3/1PP1P3/2N2N2/P3BPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Bayonet Attack, Sokolov's Line",
    fen: "r1bq1rk1/ppp1npbp/3p2p1/3Pp2n/1PP1P3/2N2N2/P3BPPP/R1BQR1K1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Bayonet Attack, Yepishin's Line",
    fen: "r1bq1rk1/ppp1npbp/3p2p1/3Pp2n/1PP1P3/2N2N2/P1Q1BPPP/R1B2RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Korchnoi Attack",
    fen: "r1bq1rk1/ppp1npbp/3p1np1/3Pp3/2P1P3/2N2N2/PP1BBPPP/R2Q1RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Modern System",
    fen: "r1bq1rk1/ppp1npbp/3p1np1/3Pp3/2P1P3/2N5/PP1NBPPP/R1BQ1RK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Classical System",
    fen: "r1bq1rk1/ppp1npbp/3p1np1/3Pp3/2P1P3/2N5/PP2BPPP/R1BQNRK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Classical System, Kozul Gambit",
    fen: "r1bq1rk1/pppn2bp/3p2n1/2PPp1p1/4Pp2/2N2P2/PP2BBPP/2RQNRK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Classical System, Neo-Classical Line",
    fen: "r1bq1rk1/pppnnpbp/3p2p1/3Pp3/2P1P3/2N1B3/PP2BPPP/R2QNRK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Classical System, Benko Attack",
    fen: "r1bq1rk1/pppnn1bp/3p2p1/3Ppp2/2P1P1P1/2N2P2/PP2B2P/R1BQNRK1",
  },
  {
    name: "King's Indian Defense: Orthodox Variation, Classical System, Traditional Line",
    fen: "r1bq1rk1/pppnn1bp/3p2p1/3Ppp2/2P1P3/2N2P2/PP2B1PP/R1BQNRK1",
  },
];
